/*
    comment THREE import
    comment export default
    change path of texture load in loadMaterial.. function
*/

/* eslint-disable */

// @ts-nochec k
import * as THREE from 'three'
import { newDoorNormalMapsUrls } from './newDoorURLs'
const handlemtl = undefined
const cubMap = undefined
const handleGeos: Record<string, undefined | THREE.BufferGeometry> = {
  arch: undefined,
  DPH465: undefined,
  DPH306: undefined,
  DHP306128: undefined,
  DPH504: undefined,
  DPH180: undefined,
  Knob301: undefined,
  Knob401: undefined,
  Knob501: undefined,
  DHP305MB96: undefined,
  DHP305MB128: undefined,
  BP723812: undefined,
  BP873128: undefined,
  BP7470128: undefined,
}

// THREE will be global var, and also reflectionCubeMap,handlemtl, handleGeo

const fractionDigits = 3

//Types
type ConfigsType = {
  doorConfig: {
    leftReveal: number
    rightReveal: number
    topReveal: number
    bottomReveal: number
    horizontalGap: number
    verticalGap: number
  }
  vGrooveConfig: {
    distance: number
    prof: number
    length: number
  }
  fivePiecesConfig: {
    pieceWidth: number
    centerThicknessDelta: number
  }
  drawerConfig: {
    minimumHeight: number
    minimumDepth: number
    boxBottomMaterialPrice: number
    boxLaborPrice: number[]
    boxDepthMargin: number
    boxDepths: number[]
    boxHeights: {
      value: number
      minimumTopMargin: number
      hardwareId: number
    }[]
    boxHeightBottomMargin: number
    boxWidthMargin: number
    boxSheetThickness: number
    handleRevalFromTop: number
  }

  handleConfig: {
    length: number
    diameter: number
    distFromEdge: number
    distFromVerticalEdge: number
    legDiameter: number
    legDist: number
    legLength: number
  }

  handlePositionFromGround: number

  thickness: number

  standardLegConfig: {
    boxWidth: number
    boxLength: number
    boxHeight: number
    littleCylinderRadius: number
    littleCylinderHeight: number
    bigCylinderRadius: number
    bigCylinderHeight: number
    sideReveal: number
    frontReveal: number
    backReveal: number
  }

  standard2LegConfig: {
    boxWidth: number
    boxLength: number
    boxHeight: number
    bigCylinderRadius: number
    bigCylinderHeight: number
    bigCylinderHeightTall: number
    separateLayerRadius: number
    separateLayerHeight: number
    littleCylinderRadius: number
    littleCylinderHeight: number
    littleSeparateLayerRadius: number
    littleSeparateLayerHeight: number
    littleSeparateLayerPosFromBottom: number
    sideReveal: number
    frontReveal: number
    backReveal: number
  }

  noToeKickLegConfig: {
    height: number
  }

  baseLegConfig: {
    height: number
    cutLength: number
  }

  separateBaseConfig: {
    sideMargin: number
    frontMargin: number
    platformHeight: number
    sheetThickness: number
  }

  minimumNonSplittedTopDepth: number
  minimumNonSplittedTopWidth: number
  splittedTopSheetWidth: number

  hingeBreakpoints: { array: string }
}

type ShelvesPropsType = {
  sectionNumber: number
  count: number
  sectionHeight: number
  sectionY: number
}

type HandlePositionTypes =
  | 'top'
  | 'bottom'
  | 'center'
  | 'fromGround'
  | 'forDrawer'
  | 'forDrawerCenter'

type HandlePositionXTypes = 'left' | 'right' | 'center'

type HandlePropsType = {
  type: 'pull' | 'knob' | 'noPull'
  subtype?:
    | 'standard'
    | 'arch'
    | 'DHP504-76'
    | 'DHP306-96'
    | 'DHP306-128'
    | 'DHP180-128'
    | 'DHP465-192'
    | 'DHK301'
    | 'DHK401'
    | 'DHK501'
    | 'DHP305MB96'
    | 'DHP305MB128'
    | 'BP723812'
    | 'BP873128'
    | 'BP7470128'
  position: HandlePositionTypes | number
  positionFromGroundValue?: number
  positionX: HandlePositionXTypes | number
  orientation: HandleOrientationType
}

type DrawerVisualType =
  | 'standard'
  | 'fivePieces'
  | DoorNewVisualTypes
  | 'shaker_v'
  | 'shaker_h'

type DrawerPropsType = {
  uuid: string
  sectionNumber: number
  sectionHeight: number
  sectionY: number
  handleProps: HandlePropsType
  visualType?: DrawerVisualType
}

type DoorType = 'left' | 'right' | 'double' | 'liftUp'

type DoorPropsType = {
  type: DoorType
  uuid: string
  sectionNumber: number
  sectionHeight: number
  sectionY: number
  handleProps: HandlePropsType
  visualType: DoorVisualType
  normalMapSplitter?: string
}

type HardwareType = {
  id: number
  name: string
  sku: string
  description: string
  type: HardwareTypes
  unitWeight: number
  unitPrice: number
  unitPriceAddon: number
  addonD: number
  addonP: number
  minPrice: number
  markupId: number
  materialsIds: string[]
  defaultMaterialId: number
  childrenIds: number[]
  editable: string //0 or 1
}

type MaterialType = {
  id: number
  name: string
  sku: string //unique
  type: string
  cabinetDoor: string //000
  thumbnail: string
  texture: { url: string; texture?: THREE.Texture }
  length: number
  width: number
  description: string
  weight: number
  price: number
  addon: number
  permissions: string //000
  editable: string //0 or 1
  threeProps: string
}

type MaterialGroupType = {
  id: number
  name: string
  materialsIds: number[]
}

type MarkupType = {
  id: number
  name: string
  value: number
}

type MaterialAPIType = {
  id: number
  name: string
  sku: string
  type: string
  cabinetDoor: string //000
  thumbnail: string
  texture: string
  length: number
  width: number
  description: string
  weight: number
  price: number
  addon: number
  permissions: string //000
  editable: string //0 or 1
  threeProps: string
}

type CabinetPropsValue = {
  min: number
  value: number
  max: number
}

type CabinetProps = {
  width: number
  height: number
  depth: number
  legHeight: number
  sectionProps: SectionProps
}

type CornerCabinetProps = {
  type: 'angled' | '2door'
  height: number
  width1: number
  width2: number
  backWidth1: number
  backWidth2: number
  depth1: number
  depth2: number
  legHeight: number
  thickness: number
  sectionProps: SectionProps
}

const newDoorVisualTypeValues: DoorNewVisualTypes[] = [
  '#B200-R203-S01',
  '#B200-R203-S04',
  '#B200-R401-S01',
  '#B200-R401-S04',
  '#B200-R500-S01',
  '#B200-R500-S04',
  '#B600-R102-S01',
  '#B600-R102-S04',
  '#B600-R100-S01',
  '#B600-R100-S04',
  '#B602-R102-S01',
  '#B602-R102-S04',
  '#B100-R000-S01',
  '#B100-R000-S04',
]

type DoorNewVisualTypes =
  | '#B200-R203-S01'
  | '#B200-R203-S04'
  | '#B200-R401-S01'
  | '#B200-R401-S04'
  | '#B200-R500-S01'
  | '#B200-R500-S04'
  | '#B600-R102-S01'
  | '#B600-R102-S04'
  | '#B600-R100-S01'
  | '#B600-R100-S04'
  | '#B602-R102-S01'
  | '#B602-R102-S04'
  | '#B100-R000-S01'
  | '#B100-R000-S04'

type DoorVisualType =
  | 'vGroove'
  | 'fivePieces'
  | DoorNewVisualTypes
  | 'shaker_v'
  | 'shaker_h'

type LegPropsType = {
  on: boolean
  type:
    | 'standard'
    | 'noToeKick'
    | 'base'
    | 'baseIsland'
    | 'baseIsland2'
    | 'separateBase'
    | 'standard2_1'
    | 'standard2_2'
    | 'noLeg'
  subType?: 'cornerLeft' | 'cornerRight'
  baseSubType?: 'new' | 'old'
}

type DividerPropsType = {
  type: 'none' | 'visible'
  top: number
  uuid: string
  // sections: {
  //     s1: SectionProps,
  //     s2: SectionProps
  // }
}

type SectionProps = {
  name: string
  width: number
  height: number
  y: number
  dividersProps: DividerPropsType[]
  doorsProps: DoorPropsType[]
  drawersProps: DrawerPropsType[]
  shelvesProps: ShelvesPropsType[]
}

type DividerType = {
  type: 'none' | 'visible'
  top: number
  object: THREE.Mesh
  uuid: string
  // sections: {
  //     s1: Section,
  //     s2: Section
  // }
}

type LinkType = {
  hId: string
  hProp: string
  itemProp: string
}

type AddonType = {
  dollar: number
  percentage: number
}

type ShelfItemPropsType = {
  type: 'shelf'
  length: number
  width: number
  thickness?: number
}

type SideSheetBaseLegPropsType = {
  type: 'sideSheetBaseLeg'
  width: number
  cabinetHeight: number
  legHeight: number
  thickness?: number
  cutLength?: number
  backCut?: number
  isNewBase?: boolean
}

type SectionItemPropsType = {
  type: 'section'
  width: number
  height: number
}

type HandleOrientationType = 'vertical' | 'horizontal' | 'double_horizontal'

type HandleItemPropsType = {
  type: 'handle'
  hPosition: 'left' | 'right' | 'center'
  orientation: HandleOrientationType
  subType: 'pull' | 'knob' | 'noPull'
  subType2?:
    | 'standard'
    | 'arch'
    | 'DHP504-76'
    | 'DHP306-96'
    | 'DHP306-128'
    | 'DHP180-128'
    | 'DHP465-192'
    | 'DHK301'
    | 'DHK401'
    | 'DHK501'
    | 'DHP305MB96'
    | 'DHP305MB128'
    | 'BP723812'
    | 'BP873128'
    | 'BP7470128'
  for?: 'door' | 'drawer'
  position:
    | 'top'
    | 'bottom'
    | 'center'
    | 'fromGround'
    | 'forDrawer'
    | 'forDrawerCenter'
    | number
}

type DoorItemPropsType = {
  type: 'door'
  visualType: DoorVisualType
  subType: 'left' | 'right' | 'double' | 'liftUp'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  width: number
  height: number
  thickness?: number
  splitters?: string
  glassHeight?: number
  mirrorHeight?: number
  frostedHeight?: number
  holeWidth?: number
}

type FivePiecesDoorItemPropsType = {
  type: 'fivePiecesDoor'
  visualType: 'fivePieces'
  subType: 'left' | 'right' | 'double' | 'liftUp'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  width: number
  height: number
  thickness?: number
  splitters?: string
  sheetHeight: number
  glassHeight: number
  cleanHeight: number
  mirrorHeight: number
  frostedHeight: number
  holeWidth: number
  piecesLength: number
  piecesWidth: number
}
type NewDoorItemPropsType = {
  type: 'newDoor'
  visualType: DoorNewVisualTypes
  subType: 'left' | 'right' | 'double' | 'liftUp'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  width: number
  height: number
  thickness?: number
  splitters?: string
  glassHeight: number
  cleanHeight: number
  mirrorHeight: number
  frostedHeight: number
  holeWidth: number
}

type NewDoorDefaultItemsType = {
  one: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  two: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  liftUp: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  drawer: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
  corner: {
    B200R203: ItemPropsType
    B200R401: ItemPropsType
    B200R500: ItemPropsType
    B600R102: ItemPropsType
    B600R100: ItemPropsType
    B602R102: ItemPropsType
    B100R000: ItemPropsType
  }
}

type HandleDefaultItemsType = {
  door: {
    pullStandard: ItemPropsType
    pullArch: ItemPropsType
    pullDPH50476: ItemPropsType
    pullDHP30696: ItemPropsType
    pullDHP306128: ItemPropsType
    pullDHP180128: ItemPropsType
    pullDHP465192: ItemPropsType
    pullDHP305MB96: ItemPropsType
    pullDHP305MB128: ItemPropsType
    pullBP723812: ItemPropsType
    pullBP873128: ItemPropsType
    pullBP7470128: ItemPropsType
    knobDHK301: ItemPropsType
    knobDHK401: ItemPropsType
    knobDHK501: ItemPropsType
    noPull: ItemPropsType
  }
  drawer: {
    pullStandard: ItemPropsType
    pullArch: ItemPropsType
    pullDPH50476: ItemPropsType
    pullDHP30696: ItemPropsType
    pullDHP306128: ItemPropsType
    pullDHP180128: ItemPropsType
    pullDHP465192: ItemPropsType
    pullDHP305MB96: ItemPropsType
    pullDHP305MB128: ItemPropsType
    pullBP723812: ItemPropsType
    pullBP873128: ItemPropsType
    pullBP7470128: ItemPropsType
    knobDHK301: ItemPropsType
    knobDHK401: ItemPropsType
    knobDHK501: ItemPropsType
    noPull: ItemPropsType
  }
}

type DrawerItemPropsType = {
  type: 'drawer'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  visualType: DrawerVisualType
  width: number
  height: number
  depth: number
  boxWidth: number
  boxHeight: number
  boxDepth: number
  thickness?: number
  // handleProps: HandleItemPropsType
}

type DrawerSlideType = 'standard' | 'soft' | 'under_mount'

const drawerSlideProps = {
  standard: [
    { value: 25, hardwareId: 176 },
    { value: 30, hardwareId: 177 },
    { value: 35, hardwareId: 178 },
    { value: 40, hardwareId: 179 },
    { value: 45, hardwareId: 180 },
    { value: 50, hardwareId: 181 },
    { value: 55, hardwareId: 182 },
    { value: 60, hardwareId: 183 },
  ],
  soft: [
    { value: 30, hardwareId: 184 },
    { value: 35, hardwareId: 185 },
    { value: 40, hardwareId: 186 },
    { value: 45, hardwareId: 187 },
    { value: 50, hardwareId: 188 },
    { value: 55, hardwareId: 189 },
    { value: 60, hardwareId: 190 },
  ],
  under_mount: [
    { value: 31.9, hardwareId: 191 },
    { value: 38.9, hardwareId: 192 },
    { value: 46.5, hardwareId: 193 },
    { value: 54.1, hardwareId: 194 },
    { value: 61.8, hardwareId: 195 },
  ],
}

const minDepthOfCabByDrawerSlideType = {
  standard: 28.5,
  soft: 33.5,
  under_mount: 35.6,
}

const drawerSlideAllHardwareIds = [
  ...drawerSlideProps.standard.map((v) => v.hardwareId),
  ...drawerSlideProps.soft.map((v) => v.hardwareId),
  ...drawerSlideProps.under_mount.map((v) => v.hardwareId),
]

type FivePiecesDrawerItemPropsType = {
  type: 'fivePiecesDrawer'
  visualType: 'fivePieces'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  width: number
  height: number
  depth: number
  boxWidth: number
  boxHeight: number
  boxDepth: number
  thickness?: number
  piecesArea: number
  centerHeight: number
  centerWidth: number
}

type LegsItemPropsType = {
  type: 'leg'
  subType: 'standard'
  cabinetWidth: number
  cabinetDepth: number
  height: number
}

type Legs2ItemPropsType = {
  type: 'leg2'
  subType: 'short' | 'tall'
  cabinetWidth: number
  cabinetDepth: number
  height: number
}

type SeparateBaseItemPropsType = {
  type: 'separateBase'
  width: number
  depth: number
  height: number
}

type SplittedTopItemPropsType = {
  type: 'splittedTop'
  cabinetWidth: number
  cabinetDepth: number
  sheetWidth: number
}

type CornerOneLegItemPropsType = {
  type: 'cornerOneLeg'
  height: number
  width1: number
  width2: number
  backWidth1: number
  backWidth2: number
  depth1: number
  depth2: number
  thickness: number
}

type CornerLegsItemPropsType = {
  type: 'cornerLegs'
  height: number
  width1: number
  width2: number
  backWidth1: number
  backWidth2: number
  depth1: number
  depth2: number
  thickness: number
}

type CornerLegs2ItemPropsType = {
  type: 'cornerLegs2'
  subType: 'short' | 'tall'
  height: number
  width1: number
  width2: number
  backWidth1: number
  backWidth2: number
  depth1: number
  depth2: number
  thickness: number
}

type CornerHorizontalSheetType = {
  type: 'cornerHorizontalSheet'
  subType: '2door' | 'angled'
  width1: number
  width2: number
  backWidth1: number
  backWidth2: number
  depth1: number
  depth2: number
  thickness: number
}

type CornerTwoDoorItemPropsType = {
  type: 'cornerTwoDoor'
  visualType: DoorVisualType
  subType: 'left' | 'right'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  width1: number
  width2: number
  width: number
  height: number
  thickness: number
  splitters?: string
}

type FivePiecesCornerTwoDoorItemPropsType = {
  type: 'cornerTwoDoorFivePieces'
  visualType: 'fivePieces'
  subType: 'left' | 'right'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  width1: number
  width2: number
  height: number
  thickness: number
  splitters?: string
  sheetHeight: number
  glassHeight: number
  cleanHeight: number
  mirrorHeight: number
  frostedHeight: number
  holeWidth: number
  piecesLength: number
  piecesWidth: number
}

type NewDoorCornerTwoDoorItemPropsType = {
  type: 'cornerNewDoor'
  visualType: DoorNewVisualTypes
  subType: 'left' | 'right'
  sectionType: 'first' | 'last' | 'middle' | 'single'
  width1: number
  width2: number
  width: number
  height: number
  thickness: number
  splitters?: string
  glassHeight: number
  cleanHeight: number
  mirrorHeight: number
  frostedHeight: number
  holeWidth: number
}

type PLengthPropsType = {
  type: 'parametric_length'
  length: { value: number; extra: number }
  formula: 'mult'
}

type PAreaPropsType = {
  type: 'parametric_area'
  width: { value: number; extra: number }
  length: { value: number; extra: number }
  extra: number
  formula: 'mult'
}

type PCornerHorizontalSheetPropsType = {
  type: 'parametric_cornerHorizontalSheet'
  subType: '2door' | 'angle'
  width1: { value: number; extra: number }
  width2: { value: number; extra: number }
  depth1: { value: number; extra: number }
  depth2: { value: number; extra: number }
  backWidth1: { value: number; extra: number }
  backWidth2: { value: number; extra: number }
  thickness: { value: number; extra: number }
  // extra: number
  formula: 'mult'
}

type PCornerTwoDoorPropsType = {
  type: 'parametric_cornerTwoDoor'
  width1: { value: number; extra: number }
  width2: { value: number; extra: number }
  height: { value: number; extra: number }
  // extra: number
  formula: 'mult'
}

type PCountPropsType = {
  type: 'parametric_count'
  count: { value: number; extra: number }
  formula: 'mult'
}

type PDrawerBoxPropsType = {
  type: 'parametric_drawerBox'
  height: { value: number; extra: number }
  width: { value: number; extra: number }
  depth: { value: number; extra: number }
  formula: 'mult'
}
type PHingePropsType = {
  type: 'parametric_hinge'
  count: { value: number; extra: number }
  height: { value: number; extra: number }
  formula: 'mult'
}
type AdditionalItemPropsType = {
  type: 'additional'
  [key: string]: number | string
}

// type ParamsTypes = MeterParamsType | AreaParamsType | CountParamsType
const hardwareParamTypeValues = [
  'length',
  'area',
  'count',
  'drawerBox',
  'cornerHorizontalSheet',
  'cornerTwoDoor',
  'hinge',
]

// type ParametricPropsType = {
//     type: 'parametric',
//     params: ParamsTypes
// }

type StaticPropsType = {
  type: 'static'
}

type HPropsType =
  | StaticPropsType
  | PLengthPropsType
  | PAreaPropsType
  | PCountPropsType
  | PDrawerBoxPropsType
  | PCornerHorizontalSheetPropsType
  | PCornerTwoDoorPropsType
  | PHingePropsType

type ParamType = { [key: string]: { value: number; extra: number } }

type HardwareTypes =
  | 'static'
  | 'parametric_length'
  | 'parametric_area'
  | 'parametric_count'
  | 'parametric_drawerBox'
  | 'parametric_cornerHorizontalSheet'
  | 'parametric_cornerTwoDoor'
  | 'parametric_hinge'

type HardwareProps = {
  name: string
  sku: string
  description: string
  type: HardwareTypes
  unitPrice: number
  unitPriceAddon: number
  addonD: number
  addonP: number
  minPrice: number
  markupId: number
  materialsIds: string[]
  defaultMaterialId: number
  childrenIds: number[]
  editable: string //0 or 1
}

// type ItemTypes = 'shelf' | 'section' | 'leftDoor'

type IPropsType =
  | ShelfItemPropsType
  | SideSheetBaseLegPropsType
  | SeparateBaseItemPropsType
  | SectionItemPropsType
  | DoorItemPropsType
  | NewDoorItemPropsType
  | FivePiecesDoorItemPropsType
  | HandleItemPropsType
  | DrawerItemPropsType
  | FivePiecesDrawerItemPropsType
  | LegsItemPropsType
  | FivePiecesCornerTwoDoorItemPropsType
  | NewDoorCornerTwoDoorItemPropsType
  | Legs2ItemPropsType
  | SplittedTopItemPropsType
  | AdditionalItemPropsType
  | CornerHorizontalSheetType
  | CornerTwoDoorItemPropsType
  | CornerLegsItemPropsType
  | CornerLegs2ItemPropsType
  | CornerOneLegItemPropsType

type ItemPropsType = {
  name: string
  uuid?: string
  props: IPropsType
  matrix: number[] //Matrix4
  hardwaresProps: {
    id: number
    localId: number
    count: number
  }[]
  addon?: AddonType
  links: LinkType[]
  childrenProps: ItemPropsType[]
  render: boolean
}

type SectionLock = {
  number: number
  isLock: boolean
}
type CabinetType = 'base' | 'tall' | 'upper' | 'upperOpen' | 'advanced'

const doorPoolY = 7.62

const newDoorPullX = {
  '#B200-R203-S01': 3.3335,
  '#B200-R203-S04': 2.8575,
  '#B200-R401-S01': 3.3335,
  '#B200-R401-S04': 2.8575,
  '#B200-R500-S01': 3.016,
  '#B200-R500-S04': 2.54,
  '#B600-R102-S01': 3.3335,
  '#B600-R102-S04': 2.8575,
  '#B600-R100-S01': 3.016,
  '#B600-R100-S04': 2.54,
  '#B602-R102-S01': 3.3335,
  '#B602-R102-S04': 2.8575,
  '#B100-R000-S01': 3.3335,
  '#B100-R000-S04': 2.8575,
  fivePieces: 3.175,
  standard: 3.81,
}

//Functions

function clone<T extends object>(obj: T): T {
  if (typeof obj == 'function') {
    return obj
  }
  var result = Array.isArray(obj) ? [] : {}
  for (var key in obj) {
    // include prototype properties
    var value = obj[key]
    var type = {}.toString.call(value).slice(8, -1)
    if (type == 'Array' || type == 'Object') {
      //   @ts-ignore
      result[key] = clone(value)
    } else if (type == 'Date') {
      //   @ts-ignore
      result[key] = new Date(value.getTime())
    } else if (type == 'RegExp') {
      //   @ts-ignore
      result[key] = RegExp(value.source, getRegExpFlags(value))
    } else {
      //   @ts-ignore
      result[key] = value
    }
  }
  //   @ts-ignore
  return result
}

function getRegExpFlags(regExp: any) {
  if (typeof regExp.source.flags == 'string') {
    return regExp.source.flags
  } else {
    var flags = []
    regExp.global && flags.push('g')
    regExp.ignoreCase && flags.push('i')
    regExp.multiline && flags.push('m')
    regExp.sticky && flags.push('y')
    regExp.unicode && flags.push('u')
    return flags.join('')
  }
}

const componentToHex = (c: number) => {
  const hex = c.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
}

const makeSection = (props: SectionProps, thickness: number): Section =>
  new Section(
    props.name,
    props.width,
    props.height,
    props.y,
    props.dividersProps,
    thickness
  )

const getHardwareParams = (hardware: Hardware) => {
  if (hardware.props.type === 'static') {
    return [] as ParamType[]
  } else if (hardware.props.type === 'parametric_length') {
    return [{ length: hardware.props.length }] as ParamType[]
  } else if (hardware.props.type === 'parametric_area') {
    return [
      { length: hardware.props.length },
      { width: hardware.props.width },
    ] as ParamType[]
  } else if (hardware.props.type === 'parametric_count') {
    for (const key in hardware.props) {
      if (key.split('_')[0] === 'count') {
        // @ts-ignore
        return [{ count: hardware.props[key] }] as ParamType[]
      }
    }
    return [{ count: hardware.props.count }] as ParamType[] //this line must never works
  } else if (hardware.props.type === 'parametric_cornerHorizontalSheet') {
    return [
      // { subType: hardware.props.subType },
      { width1: hardware.props.width1 },
      { width2: hardware.props.width2 },
      { depth1: hardware.props.depth1 },
      { depth2: hardware.props.depth2 },
      { backWidth1: hardware.props.backWidth1 },
      { backWidth2: hardware.props.backWidth2 },
      { thickness: hardware.props.thickness },
    ]
  } else if (hardware.props.type === 'parametric_cornerTwoDoor') {
    return [
      { width1: hardware.props.width1 },
      { width2: hardware.props.width2 },
      { height: hardware.props.height },
    ]
  } else if (hardware.props.type === 'parametric_hinge') {
    return [{ count: hardware.props.count }, { height: hardware.props.height }]
  } else {
    //if (hardware.props.type === 'parametric_drawerBox') {
    return [
      { height: hardware.props.height },
      { width: hardware.props.width },
      { depth: hardware.props.depth },
    ] as ParamType[]
  }
}
// @ts-ignore
function _applyBoxUV(geom, transformMatrix, bbox, bbox_max_size) {
  // @ts-ignore
  let coords = []
  coords.length = (2 * geom.attributes.position.array.length) / 3

  // geom.removeAttribute('uv');
  if (geom.attributes.uv === undefined) {
    // @ts-ignore
    geom.addAttribute('uv', new THREE.Float32BufferAttribute(coords, 2))
  }

  //maps 3 verts of 1 face on the better side of the cube
  //side of the cube can be XY, XZ or YZ

  // @ts-ignore
  let makeUVs = function (v0, v1, v2) {
    //pre-rotate the model so that cube sides match world axis
    v0.applyMatrix4(transformMatrix)
    v1.applyMatrix4(transformMatrix)
    v2.applyMatrix4(transformMatrix)

    //get normal of the face, to know into which cube side it maps better
    let n = new THREE.Vector3()
    n.crossVectors(v1.clone().sub(v0), v1.clone().sub(v2)).normalize()

    n.x = Math.abs(n.x)
    n.y = Math.abs(n.y)
    n.z = Math.abs(n.z)

    let uv0 = new THREE.Vector2()
    let uv1 = new THREE.Vector2()
    let uv2 = new THREE.Vector2()
    // xz mapping
    if (n.y > n.x && n.y > n.z) {
      uv0.x = (v0.x - bbox.min.x) / bbox_max_size
      uv0.y = (bbox.max.z - v0.z) / bbox_max_size

      uv1.x = (v1.x - bbox.min.x) / bbox_max_size
      uv1.y = (bbox.max.z - v1.z) / bbox_max_size

      uv2.x = (v2.x - bbox.min.x) / bbox_max_size
      uv2.y = (bbox.max.z - v2.z) / bbox_max_size
    } else if (n.x > n.y && n.x > n.z) {
      uv0.x = (v0.z - bbox.min.z) / bbox_max_size
      uv0.y = (v0.y - bbox.min.y) / bbox_max_size

      uv1.x = (v1.z - bbox.min.z) / bbox_max_size
      uv1.y = (v1.y - bbox.min.y) / bbox_max_size

      uv2.x = (v2.z - bbox.min.z) / bbox_max_size
      uv2.y = (v2.y - bbox.min.y) / bbox_max_size
    } else if (n.z > n.y && n.z > n.x) {
      uv0.x = (v0.x - bbox.min.x) / bbox_max_size
      uv0.y = (v0.y - bbox.min.y) / bbox_max_size

      uv1.x = (v1.x - bbox.min.x) / bbox_max_size
      uv1.y = (v1.y - bbox.min.y) / bbox_max_size

      uv2.x = (v2.x - bbox.min.x) / bbox_max_size
      uv2.y = (v2.y - bbox.min.y) / bbox_max_size
    }

    return {
      uv0: uv0,
      uv1: uv1,
      uv2: uv2,
    }
  }

  if (geom.index) {
    // is it indexed buffer geometry?
    for (let vi = 0; vi < geom.index.array.length; vi += 3) {
      let idx0 = geom.index.array[vi]
      let idx1 = geom.index.array[vi + 1]
      let idx2 = geom.index.array[vi + 2]

      let vx0 = geom.attributes.position.array[3 * idx0]
      let vy0 = geom.attributes.position.array[3 * idx0 + 1]
      let vz0 = geom.attributes.position.array[3 * idx0 + 2]

      let vx1 = geom.attributes.position.array[3 * idx1]
      let vy1 = geom.attributes.position.array[3 * idx1 + 1]
      let vz1 = geom.attributes.position.array[3 * idx1 + 2]

      let vx2 = geom.attributes.position.array[3 * idx2]
      let vy2 = geom.attributes.position.array[3 * idx2 + 1]
      let vz2 = geom.attributes.position.array[3 * idx2 + 2]

      let v0 = new THREE.Vector3(vx0, vy0, vz0)
      let v1 = new THREE.Vector3(vx1, vy1, vz1)
      let v2 = new THREE.Vector3(vx2, vy2, vz2)

      let uvs = makeUVs(v0, v1, v2)

      coords[2 * idx0] = uvs.uv0.x
      coords[2 * idx0 + 1] = uvs.uv0.y

      coords[2 * idx1] = uvs.uv1.x
      coords[2 * idx1 + 1] = uvs.uv1.y

      coords[2 * idx2] = uvs.uv2.x
      coords[2 * idx2 + 1] = uvs.uv2.y
    }
  } else {
    for (let vi = 0; vi < geom.attributes.position.array.length; vi += 9) {
      let vx0 = geom.attributes.position.array[vi]
      let vy0 = geom.attributes.position.array[vi + 1]
      let vz0 = geom.attributes.position.array[vi + 2]

      let vx1 = geom.attributes.position.array[vi + 3]
      let vy1 = geom.attributes.position.array[vi + 4]
      let vz1 = geom.attributes.position.array[vi + 5]

      let vx2 = geom.attributes.position.array[vi + 6]
      let vy2 = geom.attributes.position.array[vi + 7]
      let vz2 = geom.attributes.position.array[vi + 8]

      let v0 = new THREE.Vector3(vx0, vy0, vz0)
      let v1 = new THREE.Vector3(vx1, vy1, vz1)
      let v2 = new THREE.Vector3(vx2, vy2, vz2)

      let uvs = makeUVs(v0, v1, v2)

      let idx0 = vi / 3
      let idx1 = idx0 + 1
      let idx2 = idx0 + 2

      coords[2 * idx0] = uvs.uv0.x
      coords[2 * idx0 + 1] = uvs.uv0.y

      coords[2 * idx1] = uvs.uv1.x
      coords[2 * idx1 + 1] = uvs.uv1.y

      coords[2 * idx2] = uvs.uv2.x
      coords[2 * idx2 + 1] = uvs.uv2.y
    }
  }

  geom.attributes.uv.array = new Float32Array(coords)
}

// @ts-ignore
function applyBoxUV(bufferGeometry, transformMatrix, boxSize) {
  if (transformMatrix === undefined) {
    transformMatrix = new THREE.Matrix4()
  }

  if (boxSize === undefined) {
    let geom = bufferGeometry
    geom.computeBoundingBox()
    let bbox = geom.boundingBox

    let bbox_size_x = bbox.max.x - bbox.min.x
    let bbox_size_z = bbox.max.z - bbox.min.z
    let bbox_size_y = bbox.max.y - bbox.min.y

    boxSize = Math.max(bbox_size_x, bbox_size_y, bbox_size_z)
  }

  let uvBbox = new THREE.Box3(
    new THREE.Vector3(-boxSize / 2, -boxSize / 2, -boxSize / 2),
    new THREE.Vector3(boxSize / 2, boxSize / 2, boxSize / 2)
  )

  _applyBoxUV(bufferGeometry, transformMatrix, uvBbox, boxSize)
}

const cmToIn = (v: number) =>
  parseFloat((v / 2.54).toFixed(3).replace(/[.,]000$/, ''))

const loadTextures = (type: string) => {
  // @ts-ignore
  const maps = newDoorNormalMapsUrls[type]

  return new Promise((res, rej) => {
    const c1 = new Image()
    c1.src = maps[0]
    c1.onload = () => {
      const c2 = new Image()
      c2.src = maps[1]
      c2.onload = () => {
        const c3 = new Image()
        c3.src = maps[2]
        c3.onload = () => {
          const c4 = new Image()
          c4.src = maps[3]
          c4.onload = () => {
            const b1 = new Image()
            b1.src = maps[4]
            b1.onload = () => {
              const b2 = new Image()
              b2.src = maps[5]
              b2.onload = () => {
                const b3 = new Image()
                b3.src = maps[6]
                b3.onload = () => {
                  const b4 = new Image()
                  b4.src = maps[7]
                  b4.onload = () => {
                    if (type === 'B602R102') {
                      const center = new Image()
                      center.src = maps[8]
                      center.onload = () => {
                        res([c1, c2, c3, c4, b1, b2, b3, b4, center])
                      }
                    } else {
                      res([c1, c2, c3, c4, b1, b2, b3, b4])
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  })
}

function drawCorners(
  deltaHeight: number,
  canvasHeight: number,
  canvasWidth: number,
  ctx: CanvasRenderingContext2D,
  imgs: any,
  distX: number,
  distY: number,
  tWidth: any
) {
  const [c1, c2, c3, c4] = imgs

  // console.log(canvasHeight, canvasWidth)

  ctx.drawImage(c1, distX, distY + deltaHeight, tWidth, tWidth)
  ctx.drawImage(
    c2,
    canvasWidth - distX - tWidth,
    distY + deltaHeight,
    tWidth,
    tWidth
  )
  ctx.drawImage(
    c3,
    canvasWidth - distX - tWidth,
    canvasHeight - distY - tWidth + deltaHeight,
    tWidth,
    tWidth
  )

  ctx.drawImage(
    c4,
    distX,
    canvasHeight - distY - tWidth + deltaHeight,
    tWidth,
    tWidth
  )
}

function drawBorders(
  deltaHeight: number,
  canvasHeight: number,
  canvasWidth: number,
  ctx: CanvasRenderingContext2D,
  patterns: any,
  distX: number,
  distY: number,
  tWidth: number
) {
  const [bp1, bp2, bp3, bp4] = patterns
  // ctx.fillStyle = bp1

  // Top
  ctx.drawImage(
    bp1,
    distX + tWidth,
    distY + deltaHeight,
    canvasWidth - distX * 2 - tWidth * 2,
    tWidth
  )

  // Right
  // ctx.fillStyle = bp2

  const rwidth = tWidth
  const rheight = canvasHeight - distY * 2 - tWidth * 2
  ctx.drawImage(
    bp2,
    canvasWidth - distX - tWidth,
    distY + tWidth + deltaHeight,
    rwidth,
    rheight
  )

  // ctx.fillStyle = bp3
  // Bottom
  const bwidth = canvasWidth - distX * 2 - tWidth * 2
  const bheight = tWidth
  ctx.drawImage(
    bp3,
    distX + tWidth,
    canvasHeight - distY - tWidth + deltaHeight,
    bwidth,
    bheight
  )

  // ctx.fillStyle = bp4
  // Left
  const lwidth = tWidth
  const lheight = canvasHeight - distY * 2 - tWidth * 2
  ctx.drawImage(bp4, distX, distY + tWidth + deltaHeight, lwidth, lheight)
}

function drawCenter(
  deltaHeight: number,
  canvasHeight: number,
  canvasWidth: number,
  ctx: CanvasRenderingContext2D,
  center: any,
  distX: number,
  distY: number,
  tWidth: number,
  patternDist: number,
  pixelMult: number
) {
  let count = Math.floor((canvasWidth - distX * 2) / patternDist)

  if (count % 2 === 0) {
    count--
  }

  const gapY = 0.2 * pixelMult

  const lwidth = tWidth
  const lheight = canvasHeight - distY * 2 - gapY

  const remainingSpace = canvasWidth - distX * 2 - count * patternDist

  let xPos = distX + remainingSpace / 2 //- lwidth / 2

  // console.log(canvasWidth, distX, patternDist, count, remainingSpace, xPos)

  for (let i = 0; i <= count; i++) {
    ctx.drawImage(
      center,
      xPos,
      // distX + patternDist * (i + 1),
      distY + deltaHeight + gapY / 2,
      lwidth,
      lheight
    )

    xPos += patternDist
  }
}

const newDoorConfigs = {
  S01: {
    distXY: 0,
    tWidth: 0.325,
    maskDist: 0,
  },
  S04: {
    distXY: 0,
    tWidth: 0.125,
    maskDist: 0,
  },
  B200R203: {
    distXY: 2.25, // 5.715
    tWidth: 1.125,
    maskDist: 0.275, // 0.6985
    drawerDistY: 1.25,
    drawerMaxHeight: 7.5,
  },
  B200R401: {
    distXY: 2.25,
    tWidth: 1.125,
    maskDist: 0.5625,
    drawerDistY: 1.25,
    drawerMaxHeight: 7.5,
  },
  B200R500: {
    distXY: 2,
    tWidth: 1.312,
    maskDist: 0.125,
    drawerDistY: 1,
    drawerMaxHeight: 8,
  },
  B600R100: {
    distXY: 2,
    tWidth: 0.25,
    maskDist: 0.25,
    drawerDistY: 1,
    drawerMaxHeight: 7,
  },
  B600R102: {
    distXY: 2.25,
    tWidth: 0.1, //? not exists in photos
    maskDist: 0.1,
    drawerDistY: 1.25,
    drawerMaxHeight: 6,
  },
  B602R102: {
    distXY: 2.25,
    tWidth: 0.1, //
    maskDist: 0.1,
    drawerDistY: 1.25,
    drawerMaxHeight: 6,
  },
  B100R000: {
    distXY: 2.25, // 5.715
    tWidth: 0,
    maskDist: 0.275, // 0.6985
    drawerDistY: 1.25,
    drawerMaxHeight: 7.5,
  },
  drawerDistY: 1.25,
}

const newHandleConfigs = {
  legDist: {
    'DHP306-96': 9.6,
    'DHP306-128': 12.8,
    'DHP465-192': 19.2,
    'DHP180-128': 12.8,
    'DHP504-192': 7.6,
    DHP305MB96: 9.6,
    DHP305MB128: 12.8,
    BP723812: 12.8,
    BP873128: 12.8,
    BP7470128: 12.8,
  },
  legDiameter: {
    'DHP306-96': 1.7,
    'DHP306-128': 1.7,
    'DHP465-192': 1.1,
    DHP305MB96: 1,
    DHP305MB128: 1.3,
    BP723812: 4.6,
    BP873128: 1,
    BP7470128: 4.6,
    knob301: 2.9, //1.875"
    knob401: 2.5, //1.125"
    knob501: 2.5, //1.125"
  },
  distFromVerticalEdge: {
    standard: 6,
    arch: 6,
    'DHP306-96': 6,
    'DHP306-128': 6,
    'DHP465-192': 6,
    'DHP180-128': 6,
    'DHP504-192': 0,
    DHP305MB96: 6,
    DHP305MB128: 6,
    BP723812: 6,
    BP873128: 6,
    BP7470128: 6,
    knob301: 6,
    knob401: 6,
    knob501: 6,
  },
}

type NewDoorHoleType = 'none' | 'xglass' | 'clean' | 'mirror' | 'frosted'

const getNewDoorHoleSizes = (
  isDouble: boolean,
  type: DoorNewVisualTypes,
  width: number,
  height: number,
  splitters: string
) => {
  const pixelMult = 10

  const doorInnerType = (type as string).replaceAll('-', '').slice(1, 9)
  // @ts-ignore
  const distX = newDoorConfigs[doorInnerType].distXY * 2.54
  // @ts-ignore
  const maskDist = newDoorConfigs[doorInnerType].maskDist * 2.54
  const distY = distX

  // console.log(height, maskDist, distY, '5555555555555555555')

  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  // debugger

  let holeHeight = 0

  let glassHeight = 0
  let cleanHeight = 0
  let mirrorHeight = 0
  let frostedHeight = 0

  if (pieces.length === 1 && pieces[0].whole) {
    if (pieces[0].holeType !== 'none') {
      const holeHeight = height - 2 * distY - 2 * maskDist

      if (pieces[0].holeType === 'clean') {
        cleanHeight = holeHeight
      } else if (pieces[0].holeType === 'mirror') {
        mirrorHeight = holeHeight
      } else if (pieces[0].holeType === 'frosted') {
        frostedHeight = holeHeight
      } else if (pieces[0].holeType === 'xglass') {
        glassHeight = holeHeight
      }
    }
  } else {
    for (let i = 0; i < pieces.length; i++) {
      const piece = pieces[i]

      if (piece.holeType !== 'none') {
        let holeHeight = piece.num

        if (i === 0 || i === pieces.length - 1) {
          holeHeight -= 1.5 * distY + 2 * maskDist
        } else {
          holeHeight -= distY + 2 * maskDist
        }

        if (piece.holeType === 'clean') {
          cleanHeight += holeHeight
        } else if (piece.holeType === 'mirror') {
          mirrorHeight += holeHeight
        } else if (piece.holeType === 'frosted') {
          frostedHeight += holeHeight
        } else if (piece.holeType === 'xglass') {
          glassHeight += holeHeight
        }
      }
    }
  }

  return {
    width: isDouble
      ? (width - (distX + maskDist) * 4) / 2
      : width - (distX + maskDist) * 2,
    glassHeight,
    cleanHeight,
    mirrorHeight,
    frostedHeight,
  }
}

const getFivePiecesDoorProps = (
  isDouble: boolean,
  width: number,
  height: number,
  splitters: string,
  pieceWidth: number,
  doorConfig: ConfigsType['doorConfig']
) => {
  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  // debugger

  // let holeHeight = 0

  let sheetHeight = 0
  let glassHeight = 0
  let cleanHeight = 0
  let mirrorHeight = 0
  let frostedHeight = 0

  if (pieces.length === 1 && pieces[0].whole) {
    const holeHeight = height - 2 * pieceWidth

    if (pieces[0].holeType === 'clean') {
      cleanHeight = holeHeight
    } else if (pieces[0].holeType === 'mirror') {
      mirrorHeight = holeHeight
    } else if (pieces[0].holeType === 'frosted') {
      frostedHeight = holeHeight
    } else if (pieces[0].holeType === 'xglass') {
      glassHeight = holeHeight
    } else {
      sheetHeight += holeHeight
    }
  } else {
    for (let i = 0; i < pieces.length; i++) {
      const piece = pieces[i]

      let holeHeight = piece.num

      if (i === 0 || i === pieces.length - 1) {
        holeHeight -= 1.5 * pieceWidth
      } else {
        holeHeight -= pieceWidth
      }

      if (piece.holeType === 'clean') {
        cleanHeight += holeHeight
      } else if (piece.holeType === 'mirror') {
        mirrorHeight += holeHeight
      } else if (piece.holeType === 'frosted') {
        frostedHeight += holeHeight
      } else if (piece.holeType === 'xglass') {
        glassHeight += holeHeight
      } else {
        sheetHeight += holeHeight
      }
    }
  }

  let holeWidth = width - pieceWidth * 2

  if (isDouble) {
    holeWidth -= doorConfig.verticalGap + pieceWidth * 2
    holeWidth /= 2
    // piecesLength = 4 * height + (pieces.length + 1) * holeWidth * 2
  }
  let piecesLength = 2 * height + (pieces.length + 1) * holeWidth

  return {
    holeWidth,
    glassHeight,
    mirrorHeight,
    cleanHeight,
    frostedHeight,
    sheetHeight,
    piecesLength,
  }
}

const getFivePiecesCornerTwoDoorProps = (
  width1: number,
  width2: number,
  height: number,
  splitters: string,
  pieceWidth: number
) => {
  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  // debugger
  // let holeHeight = 0
  // console.log(width1, width2)
  let sheetHeight = 0
  let glassHeight = 0
  let cleanHeight = 0
  let mirrorHeight = 0
  let frostedHeight = 0
  if (pieces.length === 1 && pieces[0].whole) {
    const holeHeight = height - 2 * pieceWidth
    if (pieces[0].holeType === 'clean') {
      cleanHeight = holeHeight
    } else if (pieces[0].holeType === 'mirror') {
      mirrorHeight = holeHeight
    } else if (pieces[0].holeType === 'frosted') {
      frostedHeight = holeHeight
    } else if (pieces[0].holeType === 'xglass') {
      glassHeight = holeHeight
    } else {
      sheetHeight += holeHeight
    }
  } else {
    for (let i = 0; i < pieces.length; i++) {
      const piece = pieces[i]
      let holeHeight = piece.num
      if (i === 0 || i === pieces.length - 1) {
        holeHeight -= 1.5 * pieceWidth
      } else {
        holeHeight -= pieceWidth
      }
      if (piece.holeType === 'clean') {
        cleanHeight += holeHeight
      } else if (piece.holeType === 'mirror') {
        mirrorHeight += holeHeight
      } else if (piece.holeType === 'frosted') {
        frostedHeight += holeHeight
      } else if (piece.holeType === 'xglass') {
        glassHeight += holeHeight
      } else {
        sheetHeight += holeHeight
      }
    }
  }
  let holeWidth = width1 - pieceWidth * 2 + (width2 - pieceWidth * 2)
  let piecesLength = 4 * height + (pieces.length + 1) * holeWidth * 2
  return {
    holeWidth,
    glassHeight,
    mirrorHeight,
    cleanHeight,
    frostedHeight,
    sheetHeight,
    piecesLength,
  }
}

const getFivePiecesDrawerProps = (
  width: number,
  height: number,
  verticalPieceWidth: number,
  horizontalPieceWidth: number
) => {
  const centerHeight = height - horizontalPieceWidth * 2
  const centerWidth = width - verticalPieceWidth * 2
  const verticalPiecesArea = 2 * height * verticalPieceWidth
  const horizontalPiecesArea =
    2 * (width - 2 * verticalPieceWidth) * horizontalPieceWidth
  return {
    centerHeight,
    centerWidth,
    piecesArea: verticalPiecesArea + horizontalPiecesArea,
  }
}

const getNewDoorPiecesFromSplitters = (
  _splitters: string,
  doorHeight: number,
  unit: 'cm' | 'in'
) => {
  const holeTypeLetters = ['X', 'C', 'M', 'F']

  if (_splitters.length === 0) {
    return [
      {
        holeType: 'none',
        num: 0,
        whole: true,
      },
    ]
  }

  if (_splitters.length === 1) {
    if (_splitters === 'X') {
      return [
        {
          holeType: 'xglass',
          num: 0,
          whole: true,
        },
      ]
    }
    if (_splitters === 'C') {
      return [
        {
          holeType: 'clean',
          num: 0,
          whole: true,
        },
      ]
    }
    if (_splitters === 'M') {
      return [
        {
          holeType: 'mirror',
          num: 0,
          whole: true,
        },
      ]
    }
    if (_splitters === 'F') {
      return [
        {
          holeType: 'frosted',
          num: 0,
          whole: true,
        },
      ]
    }
  }
  // console.log(_splitters, doorHeight)
  let splitters = _splitters
    ? _splitters.split(',').map((n) => {
        if (n === '') {
          return ''
        } else {
          let holeType: NewDoorHoleType = 'none'

          if (n) {
            if (holeTypeLetters.includes(n[0])) {
              if (n[0] === 'X') {
                holeType = 'xglass'
              } else if (n[0] === 'C') {
                holeType = 'clean'
              } else if (n[0] === 'M') {
                holeType = 'mirror'
              } else if (n[0] === 'F') {
                holeType = 'frosted'
              }

              n = n.slice(1)
            }
          }

          const num = parseFloat(parseFloat(n).toFixed(1))
          return isNaN(num) ? -1 : { holeType, num, whole: false }
        }
      })
    : []

  if (splitters.some((s) => s === -1)) {
    // wrong values
    return []
  }

  if (splitters.some((s) => s === '')) {
    const emptyCount = splitters.filter((s) => s === '').length
    const height =
      (doorHeight -
        splitters
          .filter((s) => s !== '' && s !== -1)
          .reduce((acc, v) => acc + v.num, 0)) /
      emptyCount

    splitters = splitters.map((s) =>
      s === ''
        ? { holeType: 'none', num: parseFloat(height.toFixed(1)), whole: false }
        : s
    )
  }

  if (unit === 'in') {
    // console.log(splitters)
    // @ts-ignore
    splitters = splitters
      .filter((s) => s !== '' && s !== -1)
      .map((s) => ({ ...s, num: cmToIn(s.num as number) }))
    // console.log(splitters)
  }

  return splitters.filter((s) => s !== '' && s !== -1)
}

const getNewDoorNormalMap = async (
  type: DoorNewVisualTypes,
  canW = 200,
  canH = 250,
  _splitters: string,
  forDrawer = false
) => {
  const canvas = document.createElement('canvas')

  // canvas.style.width = canW + "px"
  // canvas.style.height = canH + "px"
  // console.log(canW, canH, _splitters)
  const pixelMult = 10
  canvas.width = canW * pixelMult
  canvas.height = canH * pixelMult

  const ctx = canvas.getContext('2d')
  if (!ctx) return new THREE.CanvasTexture(canvas)

  const doorInnerType = (type as string).replaceAll('-', '').slice(1, 9)
  const doorOuterType = (type as string).replaceAll('-', '').slice(9, 12)

  // @ts-ignore
  const outerTWidth = newDoorConfigs[doorOuterType].tWidth * 2.54 * pixelMult

  // @ts-ignore
  const distX = newDoorConfigs[doorInnerType].distXY * 2.54 * pixelMult
  let distY = distX

  if (forDrawer) {
    // @ts-ignore
    const configs = newDoorConfigs[doorInnerType]
    const drawerMaxHeight = configs.drawerMaxHeight * 2.54
    if (canH < drawerMaxHeight) {
      distY = configs.drawerDistY * 2.54 * pixelMult
    }
    // newDoorConfigs.drawerDistY * 2.54 * pixelMult
  }

  // @ts-ignore
  const tWidth = newDoorConfigs[doorInnerType].tWidth * 2.54 * pixelMult

  // @ts-ignore // inner
  const [c1, c2, c3, c4, b1, b2, b3, b4, center] =
    doorInnerType === 'B100R000' ? [] : await loadTextures(doorInnerType)

  // @ts-ignore //outer
  const [oc1, oc2, oc3, oc4, ob1, ob2, ob3, ob4] =
    await loadTextures(doorOuterType)

  ctx.fillStyle = '#bbbbff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  let splitters = getNewDoorPiecesFromSplitters(
    _splitters,
    canvas.height / pixelMult,
    'cm'
  )

  splitters = splitters.length === 1 && splitters[0].whole ? [] : splitters

  if (doorInnerType !== 'B100R000') {
    if (splitters.length === 0) {
      // Inner
      drawCorners(
        0,
        canvas.height,
        canvas.width,
        ctx,
        [c1, c2, c3, c4],
        distX,
        distY,
        tWidth
      )
      drawBorders(
        0,
        canvas.height,
        canvas.width,
        ctx,
        [b1, b2, b3, b4],
        distX,
        distY,
        tWidth
      )

      if (doorInnerType === 'B602R102') {
        drawCenter(
          0,
          canvas.height,
          canvas.width,
          ctx,
          center,
          distX,
          distY,
          // 0.3 * pixelMult,
          1 * pixelMult,
          3.81 * pixelMult,
          pixelMult
        )
      }
    } else {
      const pieces = splitters
        .map((s) => s.num * pixelMult)
        .reverse() as number[]

      let prevPiecesHeight = 0 //splitters.reduce((acc,v) => acc + v)
      let deltaHeight = distY //splitters.reduce((acc,v) => acc + v)

      for (let i = 0; i < pieces.length; i++) {
        const pieceHeight = pieces[i]

        // const deltaHeight = i * pieceHeight - i * distY
        const actualPieceHeight =
          i === 0 || i === pieces.length - 1
            ? pieceHeight - distY * 1.5
            : pieceHeight - distY
        // Inner
        drawCorners(
          deltaHeight,
          actualPieceHeight,
          canvas.width,
          ctx,
          [c1, c2, c3, c4],
          distX,
          // deltaHeight === 0 ? distY : 0,
          0,
          tWidth
        )

        // console.log(
        //   i,
        //   deltaHeight,
        //   pieceHeight,
        //   actualPieceHeight
        //   // deltaHeight === 0 ? pieceHeight : pieceHeight - distY,
        //   // deltaHeight === 0 ? distY : 0
        // )
        drawBorders(
          deltaHeight,
          actualPieceHeight,
          canvas.width,
          ctx,
          [b1, b2, b3, b4],
          distX,
          0,
          tWidth
        )

        if (doorInnerType === 'B602R102') {
          drawCenter(
            deltaHeight - distY,
            actualPieceHeight + distY * 2,
            canvas.width,
            ctx,
            center,
            distX,
            distY,
            // 0.3 * pixelMult,
            1 * pixelMult,
            3.81 * pixelMult,
            pixelMult
          )
        }

        prevPiecesHeight += pieceHeight
        deltaHeight += actualPieceHeight + distY
      }
    }
  }

  // Outer
  drawCorners(
    0,
    canvas.height,
    canvas.width,
    ctx,
    [oc1, oc2, oc3, oc4],
    0,
    0,
    outerTWidth
  )
  drawBorders(
    0,
    canvas.height,
    canvas.width,
    ctx,
    [ob1, ob2, ob3, ob4],
    0,
    0,
    outerTWidth
  )

  return new THREE.CanvasTexture(canvas)
}

const getNewDoorMaskMap = async (
  type: DoorNewVisualTypes,
  canW = 200,
  canH = 250,
  _splitters: string,
  forDrawer = false
) => {
  const canvas = document.createElement('canvas')

  const pixelMult = 10
  canvas.width = canW * pixelMult
  canvas.height = canH * pixelMult

  const ctx = canvas.getContext('2d')
  if (!ctx) return new THREE.CanvasTexture(canvas)

  const doorInnerType = (type as string).replaceAll('-', '').slice(1, 9)
  // @ts-ignore
  const distX = newDoorConfigs[doorInnerType].distXY * 2.54 * pixelMult
  const distY = distX
  //  @ts-ignore
  const tWidth = newDoorConfigs[doorInnerType].tWidth * 2.54 * pixelMult
  //  @ts-ignore
  const maskWidth = newDoorConfigs[doorInnerType].maskDist * 2.54 * pixelMult

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  let splitters = getNewDoorPiecesFromSplitters(
    _splitters,
    canvas.height / pixelMult,
    'cm'
  )

  const maskGap = 0 * 2.54 * pixelMult

  if (
    splitters.length === 0 ||
    (splitters.length === 1 &&
      splitters[0].whole &&
      splitters[0].holeType !== 'none')
  ) {
    const maskDistX = distX + maskWidth + maskGap
    const maskDistY = distY + maskWidth + maskGap

    ctx.fillStyle = '#000000'
    ctx.fillRect(
      maskDistX,
      maskDistY,
      canvas.width - maskDistX * 2,
      canvas.height - maskDistY * 2
    )
  } else {
    const pieces = splitters
      .map((s) => ({ ...s, num: s.num * pixelMult }))
      .reverse()

    let prevPiecesHeight = 0 //splitters.reduce((acc,v) => acc + v)
    let deltaHeight = distY + maskWidth + maskGap //splitters.reduce((acc,v) => acc + v)

    const maskXDist = distX + maskWidth + maskGap

    ctx.fillStyle = '#000000'

    for (let i = 0; i < pieces.length; i++) {
      const pieceHeight = pieces[i].num

      const actualPieceHeight =
        i === 0 || i === pieces.length - 1
          ? pieceHeight - maskGap * 2 - maskWidth * 2 - distY * 1.5
          : pieceHeight - maskGap * 2 - maskWidth * 2 - distY

      if (pieces[i].holeType !== 'none')
        ctx.fillRect(
          maskXDist,
          deltaHeight,
          canvas.width - maskXDist * 2,
          actualPieceHeight
        )

      prevPiecesHeight += pieceHeight
      deltaHeight += actualPieceHeight + distY + maskGap * 2 + maskWidth * 2
    }
  }

  if (false) {
    const link = document.createElement('a')
    link.download = 'filename'
    link.href = canvas.toDataURL('image/png')
    link.click()
  }
  return new THREE.CanvasTexture(canvas)
}

const getNewDoorHoleMaterialProps = (
  splitters: string,
  forFivePiece = false
) => {
  if (splitters.includes('G')) {
    return {
      color: 0x999999,
      metalness: 1,
      roughness: 0.0,
      opacity: 0.3,
    }
  }
  if (splitters.includes('M')) {
    return {
      color: forFivePiece ? 0xffffff : 0xffffff,
      metalness: 1,
      roughness: 0,
      opacity: 1,
    }
  }
  if (splitters.includes('F')) {
    return {
      color: 0xffffff,
      metalness: 0.5,
      roughness: 0.5,
      opacity: 0.5,
    }
  }

  return {
    color: 0xffffff,
    metalness: 1,
    roughness: 0.0,
    opacity: 0.5,
  }
}

const createSheet = (
  length: number,
  width: number,
  thickness: number,
  material: THREE.Material | THREE.Material[] = new THREE.MeshNormalMaterial()
) => new THREE.Mesh(new THREE.BoxGeometry(length, width, thickness), material)

const createSideSheetForBaseLegs = (
  cabinetHeight: number,
  legHeight: number,
  width: number,
  thickness: number,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  baseLegConfig: ConfigsType['baseLegConfig'],
  isNewBase?: boolean,
  _cutLength?: number,
  _backCut?: number
) => {
  // const createSideSheetForBaseLegs = (height: number, width: number, thickness: number, texture: THREE.Texture = new THREE.Texture(), tLength: number, tWidth: number, baseLegConfig: ConfigsType['baseLegConfig']) => {
  const extrudeSettings = {
    steps: 1,
    depth: thickness,
    bevelEnabled: false,
    bevelThickness: 0.05,
    bevelSize: 0.05,
    bevelOffset: -0.1,
    bevelSegments: 1,
  }

  let cutLength = 0
  let backCut = 0

  if (isNewBase) {
    cutLength = (_cutLength ?? baseLegConfig.cutLength) + thickness
    backCut =
      (_backCut || _backCut === 0 ? _backCut + thickness : undefined) || 0
  } else {
    cutLength = _cutLength ?? baseLegConfig.cutLength
    backCut = _backCut || 0
  }
  const shape = new THREE.Shape()

  shape.moveTo(0, 0)
  shape.lineTo(0, cabinetHeight)
  shape.lineTo(backCut, cabinetHeight)
  shape.lineTo(backCut, cabinetHeight + legHeight)
  shape.lineTo(width - cutLength, cabinetHeight + legHeight)
  shape.lineTo(width - cutLength, cabinetHeight)
  shape.lineTo(width, cabinetHeight)
  shape.lineTo(width, 0)
  shape.lineTo(0, 0)

  const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)

  const newTexture = texture.clone()
  newTexture.wrapS = THREE.RepeatWrapping
  newTexture.wrapT = THREE.RepeatWrapping
  newTexture.repeat.set(1, tLength / tWidth)
  newTexture.needsUpdate = true

  applyBoxUV(
    geometry,
    new THREE.Matrix4().fromArray([
      1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
    ]),
    tLength
  )

  geometry.attributes.uv.needsUpdate = true

  return new THREE.Mesh(
    geometry,
    new THREE.MeshStandardMaterial({ map: newTexture })
  )
}

const createSection = (
  width: number,
  height: number,
  material: THREE.Material = new THREE.MeshBasicMaterial({
    color: 'white',
    transparent: true,
    opacity: 0.6,
  })
) => new THREE.Mesh(new THREE.PlaneGeometry(width, height), material)

const createDivider = (
  width: number,
  height: number = 1,
  material: THREE.Material = new THREE.MeshBasicMaterial({ color: 'black' })
) => new THREE.Mesh(new THREE.PlaneGeometry(width, height), material)

const safeDecodeAndParse = (input?: string) => {
  try {
    if (typeof input !== 'string') return {}
    const decoded = decodeURIComponent(input)
    return JSON.parse(decoded) as Object
  } catch (e) {
    return {}
  }
}

const createCylinderHandle = (
  hPosition: 'left' | 'right' | 'center',
  orientation: HandleOrientationType,
  handleConfig: ConfigsType['handleConfig'],
  color?: THREE.Color,
  noPull = false,
  threeProps?: string
) => {
  const length = handleConfig.length
  const diameter = handleConfig.diameter
  const dist = handleConfig.legDist
  const legLength = handleConfig.legLength
  const legDiameter = handleConfig.legDiameter

  const threePropsObj = safeDecodeAndParse(threeProps)

  const material = !noPull
    ? new THREE.MeshPhysicalMaterial({
        metalness: 1,
        roughness: 0,
        // @ts-ignore
        envMap: cubMap,
        color,
        ...threePropsObj,
      })
    : new THREE.MeshBasicMaterial({
        color,
        transparent: true,
        opacity: 0.2,
      })

  // @ts-ignore
  // material = handlemtl || new THREE.MeshBasicMaterial({ color: 'black' })

  const g = new THREE.Group()

  const base = new THREE.Mesh(
    new THREE.CylinderGeometry(diameter / 2, diameter / 2, length, 24),
    material
  )

  const leg1 = new THREE.Mesh(
    new THREE.CylinderGeometry(
      legDiameter / 2 - 0.05,
      legDiameter / 2 - 0.1,
      legLength,
      24
    ),
    material
  )

  const leg2 = new THREE.Mesh(
    new THREE.CylinderGeometry(
      legDiameter / 2 - 0.05,
      legDiameter / 2 - 0.1,
      legLength,
      24
    ),
    material
  )

  g.add(base)
  g.add(leg1)
  g.add(leg2)

  leg1.rotation.x = Math.PI / 2
  leg2.rotation.x = Math.PI / 2
  leg1.position.set(0, -dist / 2, 0)
  leg2.position.set(0, dist / 2, 0)
  base.position.set(0, 0, legLength / 2)

  if (orientation === 'horizontal' && hPosition !== 'center') {
    const g2 = new THREE.Group()
    g2.add(g)
    g.position.set(0, dist / 2, 0)
    g2.rotation.z = (Math.PI / 2) * (hPosition === 'left' ? -1 : 1)
    return g2
  }

  g.userData.subType = 'standard'

  return g
}

const createArchHandle = (
  hPosition: 'left' | 'right' | 'center',
  orientation: HandleOrientationType,
  color?: THREE.Color,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const material = new THREE.MeshPhysicalMaterial({
    metalness: 1,
    roughness: 0,
    envMap: cubMap,
    color,
    ...threePropsObj,
  })

  const handle = new THREE.Mesh(
    handleGeos.arch || new THREE.BufferGeometry(),
    material
  )

  if (orientation === 'horizontal' && hPosition !== 'center') {
    const bbox = new THREE.Box3().setFromObject(handle)
    const height = bbox.max.y - bbox.min.y
    const g = new THREE.Group()
    g.add(handle)
    handle.position.set(0, height / 2, 0)
    g.rotation.z = (Math.PI / 2) * (hPosition === 'left' ? -1 : 1)
    return g
  }

  // handle.add(new BoxHelper(handle, 0xff0000))
  // @ts-ignore
  window.handle = handle
  return handle
}

const createNewHandle = (
  subType: HandlePropsType['subtype'],
  hPosition: 'left' | 'right' | 'center',
  orientation: HandleOrientationType,
  color?: THREE.Color,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const material = new THREE.MeshPhysicalMaterial({
    metalness: 1,
    roughness: 0,
    envMap: cubMap,
    color,
    ...threePropsObj,
  })

  let geo = undefined as undefined | THREE.BufferGeometry

  if (subType === 'DHP306-96') {
    geo = handleGeos.DPH306
  } else if (subType === 'DHP306-128') {
    geo = handleGeos.DHP306128
  } else if (subType === 'DHP465-192') {
    geo = handleGeos.DPH465
  } else if (subType === 'DHP180-128') {
    geo = handleGeos.DPH180
  } else if (subType === 'DHP504-76') {
    geo = handleGeos.DPH504
  } else if (subType === 'DHK301') {
    geo = handleGeos.Knob301
  } else if (subType === 'DHK401') {
    geo = handleGeos.Knob401
  } else if (subType === 'DHK501') {
    geo = handleGeos.Knob501
  } else if (subType === 'DHP305MB96') {
    geo = handleGeos.DHP305MB96
  } else if (subType === 'DHP305MB128') {
    geo = handleGeos.DHP305MB128
  } else if (subType === 'BP723812') {
    geo = handleGeos.BP723812
  } else if (subType === 'BP873128') {
    geo = handleGeos.BP873128
  } else if (subType === 'BP7470128') {
    geo = handleGeos.BP7470128
  }

  const handle = new THREE.Mesh(geo || new THREE.BufferGeometry(), material)

  if (orientation === 'horizontal' && hPosition !== 'center') {
    const bbox = new THREE.Box3().setFromObject(handle)
    const height = bbox.max.y - bbox.min.y

    const g = new THREE.Group()
    g.add(handle)
    handle.position.set(0, height / 2, 0)
    g.rotation.z = (Math.PI / 2) * (hPosition === 'left' ? -1 : 1)

    return g
  }

  if (subType === 'DHP504-76') {
    handle.rotation.x = -Math.PI / 2
    handle.rotation.z = -Math.PI / 2
  }

  // handle.add(new BoxHelper(handle, 0xff0000))
  return handle
}

const createDoorVGroove = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  width: number,
  height: number,
  thickness: number,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  vGrooveConfig: ConfigsType['vGrooveConfig'],
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)
  const extrudeSettings = {
    steps: 1,
    depth: height - 0.1,
    bevelEnabled: false,
    bevelThickness: 0.05,
    bevelSize: 0.05,
    bevelOffset: -0.1,
    bevelSegments: 1,
  }

  const g = new THREE.Group()

  if (type === 'right') {
    const shape = new THREE.Shape()

    shape.moveTo(0, 0)
    shape.lineTo(0, thickness)

    shape.lineTo(vGrooveConfig.distance, thickness)
    shape.lineTo(
      vGrooveConfig.distance + vGrooveConfig.length / 2,
      thickness - vGrooveConfig.prof
    )
    shape.lineTo(vGrooveConfig.distance + vGrooveConfig.length, thickness)
    shape.lineTo(width, thickness)
    shape.lineTo(width, 0)
    shape.lineTo(0, 0)

    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)

    const newTexture = texture.clone()
    newTexture.wrapS = THREE.RepeatWrapping
    newTexture.wrapT = THREE.RepeatWrapping
    newTexture.repeat.set(1, tLength / tWidth)
    newTexture.needsUpdate = true

    applyBoxUV(
      geometry,
      new THREE.Matrix4().fromArray([
        1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
      ]),
      tLength
    )

    geometry.attributes.uv.needsUpdate = true

    const mesh = new THREE.Mesh(
      geometry,
      new THREE.MeshStandardMaterial({
        map: newTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    mesh.rotateX(Math.PI / 2)
    mesh.position.x -= width / 2
    mesh.position.y += height / 2
    mesh.position.z -= thickness / 2

    g.add(mesh)
  } else if (type === 'left') {
    const shape = new THREE.Shape()

    shape.moveTo(0, 0)
    shape.lineTo(0, thickness)

    shape.lineTo(
      width - vGrooveConfig.length - vGrooveConfig.distance,
      thickness
    )
    shape.lineTo(
      width - vGrooveConfig.length / 2 - vGrooveConfig.distance,
      thickness - vGrooveConfig.prof
    )
    shape.lineTo(width - vGrooveConfig.distance, thickness)
    shape.lineTo(width, thickness)
    shape.lineTo(width, 0)
    shape.lineTo(0, 0)

    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)

    const newTexture = texture.clone()
    newTexture.wrapS = THREE.RepeatWrapping
    newTexture.wrapT = THREE.RepeatWrapping
    newTexture.repeat.set(1, tLength / tWidth)
    newTexture.needsUpdate = true

    applyBoxUV(
      geometry,
      new THREE.Matrix4().fromArray([
        1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
      ]),
      tLength
    )

    geometry.attributes.uv.needsUpdate = true

    const mesh = new THREE.Mesh(
      geometry,
      new THREE.MeshStandardMaterial({
        map: newTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    mesh.rotateX(Math.PI / 2)
    mesh.position.x -= width / 2
    mesh.position.y += height / 2
    mesh.position.z -= thickness / 2

    g.add(mesh)
  } else if (type === 'double') {
    const newTexture = texture.clone()
    newTexture.wrapS = THREE.RepeatWrapping
    newTexture.wrapT = THREE.RepeatWrapping
    newTexture.repeat.set(1, tLength / tWidth)
    newTexture.needsUpdate = true

    const leftSheetWidth = width / 2 - doorConfig.verticalGap / 2
    const rightSheetWidth = width / 2 - doorConfig.verticalGap / 2

    const lShape = new THREE.Shape()

    lShape.moveTo(0, 0)
    lShape.lineTo(0, thickness)

    lShape.lineTo(
      leftSheetWidth - vGrooveConfig.length - vGrooveConfig.distance,
      thickness
    )
    lShape.lineTo(
      leftSheetWidth - vGrooveConfig.length / 2 - vGrooveConfig.distance,
      thickness - vGrooveConfig.prof
    )
    lShape.lineTo(leftSheetWidth - vGrooveConfig.distance, thickness)
    lShape.lineTo(leftSheetWidth, thickness)
    lShape.lineTo(leftSheetWidth, 0)
    lShape.lineTo(0, 0)

    const lGeometry = new THREE.ExtrudeGeometry(lShape, extrudeSettings)

    applyBoxUV(
      lGeometry,
      new THREE.Matrix4().fromArray([
        1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
      ]),
      tLength
    )

    lGeometry.attributes.uv.needsUpdate = true

    const leftSheet = new THREE.Mesh(
      lGeometry,
      new THREE.MeshStandardMaterial({
        map: newTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    const rShape = new THREE.Shape()

    rShape.moveTo(0, 0)
    rShape.lineTo(0, thickness)

    rShape.lineTo(vGrooveConfig.distance, thickness)
    rShape.lineTo(
      vGrooveConfig.distance + vGrooveConfig.length / 2,
      thickness - vGrooveConfig.prof
    )
    rShape.lineTo(vGrooveConfig.distance + vGrooveConfig.length, thickness)
    rShape.lineTo(rightSheetWidth, thickness)
    rShape.lineTo(rightSheetWidth, 0)
    rShape.lineTo(0, 0)

    const rGeometry = new THREE.ExtrudeGeometry(rShape, extrudeSettings)
    const rightSheet = new THREE.Mesh(
      rGeometry,
      new THREE.MeshStandardMaterial({
        map: newTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    applyBoxUV(
      rGeometry,
      new THREE.Matrix4().fromArray([
        1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
      ]),
      tLength
    )

    rGeometry.attributes.uv.needsUpdate = true

    g.add(leftSheet)
    g.add(rightSheet)

    leftSheet.rotateX(Math.PI / 2)
    rightSheet.rotateX(Math.PI / 2)

    leftSheet.position.x = -leftSheetWidth / 2 - doorConfig.verticalGap / 2
    rightSheet.position.x = rightSheetWidth / 2 + doorConfig.verticalGap / 2

    leftSheet.position.x -= leftSheetWidth / 2
    rightSheet.position.x -= rightSheetWidth / 2
    leftSheet.position.y += height / 2
    rightSheet.position.y += height / 2
    leftSheet.position.z -= thickness / 2
    rightSheet.position.z -= thickness / 2
  } else if (type === 'liftUp') {
    const sheet = createSheet(
      width,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: texture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    g.add(sheet)
  }
  return g
}

const createShakerDoor = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  isVertical: boolean,
  width: number,
  height: number,
  thickness: number,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)
  const g = new THREE.Group()

  if (type === 'double') {
    const leftSheetWidth = width / 2 - doorConfig.verticalGap / 2
    const rightSheetWidth = width / 2 - doorConfig.verticalGap / 2

    const lNewTexture = texture.clone()
    const rNewTexture = texture.clone()
    rNewTexture.offset.x = Math.random()
    lNewTexture.offset.x = Math.random()

    if (!isVertical) {
      lNewTexture.rotation = Math.PI / 2
      lNewTexture.repeat.set(height / tLength, leftSheetWidth / tWidth)

      rNewTexture.rotation = Math.PI / 2
      rNewTexture.repeat.set(height / tLength, rightSheetWidth / tWidth)
    } else {
      lNewTexture.repeat.set(leftSheetWidth / tLength, height / tWidth)
      rNewTexture.repeat.set(rightSheetWidth / tLength, height / tWidth)
    }
    lNewTexture.needsUpdate = true
    rNewTexture.needsUpdate = true

    const leftSheet = createSheet(
      leftSheetWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: lNewTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    const rightSheet = createSheet(
      rightSheetWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: rNewTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    g.add(leftSheet)
    g.add(rightSheet)

    // leftSheet.rotateX(Math.PI / 2)
    // rightSheet.rotateX(Math.PI / 2)

    leftSheet.position.x = -leftSheetWidth / 2 - doorConfig.verticalGap / 2
    rightSheet.position.x = rightSheetWidth / 2 + doorConfig.verticalGap / 2

    // leftSheet.position.x -= leftSheetWidth / 2
    // rightSheet.position.x -= rightSheetWidth / 2
    // leftSheet.position.y += height / 2
    // rightSheet.position.y += height / 2
    // leftSheet.position.z -= thickness / 2
    // rightSheet.position.z -= thickness / 2
  } else {
    const newTexture = texture.clone()
    newTexture.offset.x = Math.random()

    if (!isVertical) {
      newTexture.rotation = Math.PI / 2
      // console.log(width)
      newTexture.repeat.set(height / tLength, width / tWidth)
    } else {
      newTexture.repeat.set(width / tLength, height / tWidth)
    }
    newTexture.needsUpdate = true

    const sheet = createSheet(
      width,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: newTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    g.add(sheet)
  }
  return g
}

const _createLiftUpDoor = (
  width: number,
  height: number,
  thickness: number,
  material: THREE.Material = new THREE.MeshNormalMaterial()
) => {
  const g = new THREE.Group()

  const sheet = createSheet(width, height, thickness, material)

  g.add(sheet)

  return g
}

const getTextureColor = (texture: THREE.Texture) => {
  const canvas = document.createElement('canvas')
  const pic = texture.image

  if (!pic) return '#FFFFFF'

  canvas.width = pic.width
  canvas.height = pic.height
  const ctx = canvas.getContext('2d')

  if (ctx) {
    ctx.drawImage(pic, 0, 0)
    var p = ctx.getImageData(7, 7, 1, 1).data
    // console.log('=============GGGGGGGGGGGGGGGGGGG=============', p)
    return rgbToHex(p[0], p[1], p[2])
  }

  return '#FFFFFF'
}

// BlendingMaterial.js
// Reusable blending material for Three.js
// Usage: const mat = BlendingMaterial.create({ mtl1Pops, mtl2Pops, maskTexture });
class BlendingMaterial {
  static create({ mtl1Pops, mtl2Pops, maskTexture }: any) {
    // Ensure color is always a THREE.Color object for both materials
    let mat1Color = mtl1Pops.color
    if (typeof mat1Color === 'number') mat1Color = new THREE.Color(mat1Color)
    else if (typeof mat1Color === 'string')
      mat1Color = new THREE.Color(mat1Color)
    let mat2Color = mtl2Pops.color
    if (typeof mat2Color === 'number') mat2Color = new THREE.Color(mat2Color)
    else if (typeof mat2Color === 'string')
      mat2Color = new THREE.Color(mat2Color)
    const material = new THREE.MeshStandardMaterial({
      ...mtl1Pops,
      color: mat1Color,
      transparent: true,
      flatShading: false,
    })
    material.userData.isBlendings = true
    material.userData.maskTexture = maskTexture
    material.userData.mtl2Pops = mtl2Pops
    material.onBeforeCompile = function (shader) {
      shader.uniforms.maskTexture = { value: maskTexture }
      shader.uniforms.material2Color = { value: mat2Color || new THREE.Color() }
      shader.uniforms.material2Metalness = { value: mtl2Pops.metalness || 0 }
      shader.uniforms.material2Roughness = { value: mtl2Pops.roughness || 1 }
      shader.uniforms.material2Opacity = {
        value: mtl2Pops.opacity !== undefined ? mtl2Pops.opacity : 1.0,
      }
      if (mtl2Pops.envMap) {
        shader.uniforms.material2EnvMap = { value: mtl2Pops.envMap }
      }
      if (mtl2Pops.normalMap) {
        shader.uniforms.material2NormalMap = { value: mtl2Pops.normalMap }
        shader.uniforms.material2NormalScale = {
          value: mtl2Pops.normalScale || new THREE.Vector2(1, 1),
        }
      }
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <common>',
        '\n          #include <common>\n          uniform sampler2D maskTexture;\n          uniform vec3 material2Color;\n          uniform float material2Metalness;\n          uniform float material2Roughness;\n          uniform float material2Opacity;\n          '
          .concat(
            mtl2Pops.normalMap ? 'uniform sampler2D material2NormalMap;' : '',
            '\n          '
          )
          .concat(
            mtl2Pops.normalMap ? 'uniform vec2 material2NormalScale;' : '',
            '\n          '
          )
          .concat(
            mtl2Pops.envMap ? 'uniform samplerCube material2EnvMap;' : '',
            '\n        '
          )
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <map_fragment>',
        '\n          #include <map_fragment>\n          float mask = texture2D(maskTexture, vUv).r;\n          // Sharp threshold to eliminate gray values\n          mask = step(0.5, mask);\n        '
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <color_fragment>',
        '\n          #include <color_fragment>\n          diffuseColor.rgb = mix(diffuseColor.rgb, material2Color, mask);\n          diffuseColor.a = mix(opacity, material2Opacity, mask);\n        '
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <roughnessmap_fragment>',
        '\n          #include <roughnessmap_fragment>\n          roughnessFactor = mix(roughnessFactor, material2Roughness, mask);\n        '
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <metalnessmap_fragment>',
        '\n          #include <metalnessmap_fragment>\n          metalnessFactor = mix(metalnessFactor, material2Metalness, mask);\n        '
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <normal_fragment_begin>',
        '\n          // Enhanced normal handling for smooth shading\n          vec3 geometryNormal = normalize(vNormal);\n          vec3 normal = geometryNormal;\n        '
      )
      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <common>',
        '\n          #include <common>\n          #ifndef USE_TANGENT\n            #ifndef FLAT_SHADED\n              float faceDirection = 1.0;\n            #endif\n          #endif\n        '
      )
      if (material.normalMap && mtl2Pops.normalMap) {
        shader.fragmentShader = shader.fragmentShader.replace(
          '#include <normal_fragment_maps>',
          `
            #ifdef USE_NORMALMAP
              vec3 normal1 = texture2D(normalMap, vUv).xyz * 2.0 - 1.0;
              vec3 normal2 = texture2D(material2NormalMap, vUv).xyz * 2.0 - 1.0;
              normal1.xy *= normalScale;
              normal2.xy *= material2NormalScale;
              vec3 blendedNormal = normalize(mix(normal1, normal2, mask));
              #ifdef USE_TANGENT
                normal = perturbNormal2Arb(-vViewPosition, geometryNormal, blendedNormal, faceDirection);
              #else
                normal = normalize(blendedNormal);
              #endif
            #endif
          `
        )
      } else if (material.normalMap && !mtl2Pops.normalMap) {
        // Blend between normalMap and geometry normal based on mask
        shader.fragmentShader = shader.fragmentShader.replace(
          '#include <normal_fragment_maps>',
          `
            #ifdef USE_NORMALMAP
              vec3 normal1 = texture2D(normalMap, vUv).xyz * 2.0 - 1.0;
              normal1.xy *= normalScale;
              vec3 blendedNormal = normalize(mix(normal1, geometryNormal, 1.0 - mask));
              #ifdef USE_TANGENT
                normal = perturbNormal2Arb(-vViewPosition, geometryNormal, blendedNormal, faceDirection);
              #else
                normal = normalize(blendedNormal);
              #endif
            #endif
          `
        )
      } else if (!material.normalMap && mtl2Pops.normalMap) {
        // Blend between geometry normal and material2 normal map based on mask
        shader.fragmentShader = shader.fragmentShader.replace(
          '#include <normal_fragment_maps>',
          `
            #ifdef USE_NORMALMAP
              vec3 normal2 = texture2D(material2NormalMap, vUv).xyz * 2.0 - 1.0;
              normal2.xy *= material2NormalScale;
              vec3 blendedNormal = normalize(mix(geometryNormal, normal2, mask));
              #ifdef USE_TANGENT
                normal = perturbNormal2Arb(-vViewPosition, geometryNormal, blendedNormal, faceDirection);
              #else
                normal = normalize(blendedNormal);
              #endif
            #endif
          `
        )
      } else {
        // Neither material has a normal map, use geometry normal
        shader.fragmentShader = shader.fragmentShader.replace(
          '#include <normal_fragment_maps>',
          `
            // No normal maps, use geometry normal
            normal = geometryNormal;
          `
        )
      }
      if (mtl2Pops.envMap) {
        shader.fragmentShader = shader.fragmentShader.replace(
          '#include <envmap_fragment>',
          `
          #ifdef USE_ENVMAP
            vec3 reflectVec1 = reflect(-vViewPosition, normal);
            vec3 envColor1 = textureCube(envMap, vec3(flipEnvMap * reflectVec1.x, reflectVec1.yz)).rgb;
            vec3 envColor2 = textureCube(material2EnvMap, vec3(flipEnvMap * reflectVec1.x, reflectVec1.yz)).rgb;
            vec3 blendedEnvColor = mix(envColor1, envColor2, mask);
            #ifdef ENVMAP_BLENDING_MULTIPLY
              outgoingLight = outgoingLight * blendedEnvColor;
            #elif defined( ENVMAP_BLENDING_MIX )
              outgoingLight = mix( outgoingLight, blendedEnvColor, specularStrength * reflectivity );
            #elif defined( ENVMAP_BLENDING_ADD )
              outgoingLight += blendedEnvColor * specularStrength * reflectivity;
            #endif
          #endif
        `
        )
      }
    }
    return material
  }
}

const getNewBlendingMaterial = (g: THREE.Object3D, color: string) => {
  const material1 = g.userData._m1
  const material2 = { ...g.userData._m2, color }
  const mask = g.userData._mask

  if (!material1 || !material2 || !mask) return

  return BlendingMaterial.create({
    mtl1Pops: material1,
    mtl2Pops: material2,
    maskTexture: mask,
  })
}

const _getNewBlendingMaterial = (g: THREE.Object3D, obj: Object) => {
  const material1 = g.userData._m1
  const material2 = { ...g.userData._m2, ...obj }
  const mask = g.userData._mask

  if (!material1 || !material2 || !mask) return

  return BlendingMaterial.create({
    mtl1Pops: material1,
    mtl2Pops: material2,
    maskTexture: mask,
  })
}

const createNewDoors = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  subtype: DoorNewVisualTypes,
  splitters: string,
  width: number,
  height: number,
  thickness: number,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  forDrawer = false,
  threeProps?: string
) => {
  // console.log(splitters)
  const threePropsObj = safeDecodeAndParse(threeProps)

  const sheetWidth =
    type !== 'double' ? width : width / 2 - doorConfig.verticalGap / 2

  const newTexture = texture.clone()

  newTexture.repeat.set(width / tLength, height / tWidth)
  newTexture.needsUpdate = true
  const material = new THREE.MeshStandardMaterial({
    map: texture,
    ...threePropsObj,
  })
  // @ts-ignore
  material.map.needsUpdate = true
  const textureColor = getTextureColor(texture)

  const materials = [material, material, material, material, material, material]

  const g = new THREE.Group()

  if (type === 'double') {
    const lSheet = createSheet(sheetWidth, height, thickness, materials)
    const rSheet = createSheet(sheetWidth, height, thickness, materials)

    lSheet.position.x = -sheetWidth / 2 - doorConfig.verticalGap / 2
    rSheet.position.x = sheetWidth / 2 + doorConfig.verticalGap / 2

    g.add(lSheet)
    g.add(rSheet)
  } else {
    const sheet = createSheet(width, height, thickness, materials)

    g.add(sheet)
  }

  const mat = new THREE.ShaderMaterial()
  getNewDoorNormalMap(subtype, sheetWidth, height, splitters, forDrawer).then(
    (map) => {
      getNewDoorMaskMap(subtype, sheetWidth, height, splitters, forDrawer).then(
        (mask) => {
          // Material 1: Red, metallic
          const material2 = {
            color: textureColor,
            metalness: 0,
            roughness: 0.2,
            envMap: cubMap,
            normalMap: map,
            transparent: true,
            opacity: 1, // Fully opaque
            ...threePropsObj,
          }

          const matProps = getNewDoorHoleMaterialProps(splitters)

          // Material 2: Blue, non-metallic with transparency
          const material1 = {
            color: matProps.color,
            metalness: matProps.metalness,
            roughness: matProps.roughness,
            envMap: cubMap,
            transparent: true,
            opacity: matProps.opacity, // Fully transparent
          }

          const _m1 = {
            color: material1.color,
            metalness: material1.metalness,
            roughness: material1.roughness,
            envMap: material2.envMap,
            normalMap: map,
            opacity: material1.opacity,
          }
          const _m2 = {
            color: material2.color,
            metalness: material2.metalness,
            roughness: material2.roughness,
            envMap: material2.envMap,
            // normalMap: map,
            transparent: true,
          }

          g.userData._m1 = _m1
          g.userData._m2 = _m2
          g.userData._mask = mask
          // mat.normalMap = map
          // mat.normalScale.set(3, 3)
          // mat.needsUpdate = true

          //   mat.needsUpdate = true
          const lightColor = new THREE.Color(1, 1, 1)
          const lightDirection = new THREE.Vector3(5, 10, 7.5).normalize()
          const ambientLight = new THREE.Color(0.4, 0.4, 0.4)

          const blendingMaterial = BlendingMaterial.create({
            mtl1Pops: _m1,
            mtl2Pops: _m2,
            maskTexture: mask,
          })
          //       const blendingMaterial = new THREE.ShaderMaterial({
          //         uniforms: {
          //           material1Color: { value: material1.color },
          //           material1Metalness: { value: material1.metalness },
          //           material1Roughness: { value: material1.roughness },
          //           material1Opacity: { value: material1.opacity },
          //           material1NormalMap: { value: map },
          //           hasMaterial1NormalMap: { value: true },

          //           material2Color: { value: material2.color },
          //           material2Metalness: { value: material2.metalness },
          //           material2Roughness: { value: material2.roughness },
          //           material2Opacity: { value: material2.opacity },
          //           material2NormalMap: { value: null }, // Placeholder for optional second normal map
          //           hasMaterial2NormalMap: { value: false },

          //           maskTexture: { value: mask },
          //           envMap: { value: material2.envMap },

          //           // Lighting uniforms
          //           lightColor: { value: lightColor },
          //           lightDirection: { value: lightDirection },
          //           ambientLight: { value: ambientLight },
          //         },
          //         vertexShader: `
          //         varying vec2 vUv;
          //         varying vec3 vNormal;
          //         varying vec3 vPosition;

          //         void main() {
          //           vUv = uv;
          //           vNormal = normalMatrix * normal;
          //           vPosition = (modelViewMatrix * vec4(position, 1.0)).xyz;
          //           gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
          //         }
          //       `,
          //         fragmentShader: `
          //   uniform vec3 material1Color;
          //   uniform float material1Metalness;
          //   uniform float material1Roughness;
          //   uniform float material1Opacity;
          //   uniform sampler2D material1NormalMap;
          //   uniform bool hasMaterial1NormalMap;

          //   uniform vec3 material2Color;
          //   uniform float material2Metalness;
          //   uniform float material2Roughness;
          //   uniform float material2Opacity;
          //   uniform sampler2D material2NormalMap;
          //   uniform bool hasMaterial2NormalMap;

          //   uniform sampler2D maskTexture;
          //   uniform samplerCube envMap;

          //   uniform vec3 lightColor;  // Light color (optional)
          //   uniform vec3 lightDirection;  // Directional light direction
          //   uniform vec3 ambientLight;  // Ambient light

          //   varying vec2 vUv;
          //   varying vec3 vNormal;
          //   varying vec3 vPosition;

          //   vec3 getReflection(vec3 color, float metalness, float roughness, vec3 normal) {
          //     vec3 viewDir = normalize(-vPosition);
          //     vec3 reflectDir = reflect(viewDir, normal);
          //     return textureCube(envMap, reflectDir).rgb * metalness * (1.0 - roughness);
          //   }

          //   vec3 applyNormalMap(sampler2D normalMap, vec3 defaultNormal) {
          //     vec3 normalTex = texture2D(normalMap, vUv).xyz * 2.0 - 1.0;
          //     return normalize(mix(defaultNormal, normalTex, length(normalTex)));
          //   }

          //   vec3 getDiffuseLighting(vec3 normal, vec3 lightDir, vec3 lightCol, vec3 ambientCol) {
          //     // Diffuse light calculation
          //     float diffuse = max(dot(normal, lightDir), 0.0);
          //     return lightCol * diffuse + ambientCol;  // Combine diffuse and ambient light
          //   }

          //   void main() {
          //     // Get grayscale value from mask texture
          //     vec4 mask = texture2D(maskTexture, vUv);
          //     float grayscale = dot(mask.rgb, vec3(0.299, 0.587, 0.114)); // Convert to grayscale

          //     // Blend colors, metalness, roughness, and opacity based on mask
          //     vec3 blendedColor = mix(material1Color, material2Color, grayscale);
          //     float blendedMetalness = mix(material1Metalness, material2Metalness, grayscale);
          //     float blendedRoughness = mix(material1Roughness, material2Roughness, grayscale);
          //     float blendedOpacity = mix(material1Opacity, material2Opacity, grayscale);

          //     // Default normal (from geometry)
          //     vec3 blendedNormal = normalize(vNormal);

          //     // Apply and blend normal maps
          //     if (hasMaterial1NormalMap && hasMaterial2NormalMap) {
          //       vec3 normal1 = texture2D(material1NormalMap, vUv).xyz * 2.0 - 1.0;
          //       vec3 normal2 = texture2D(material2NormalMap, vUv).xyz * 2.0 - 1.0;
          //       blendedNormal = normalize(mix(normal1, normal2, grayscale));
          //     } else if (hasMaterial1NormalMap) {
          //       vec3 normal1 = texture2D(material1NormalMap, vUv).xyz * 2.0 - 1.0;
          //       blendedNormal = normalize(mix(vNormal, normal1, grayscale));
          //     } else if (hasMaterial2NormalMap) {
          //       vec3 normal2 = texture2D(material2NormalMap, vUv).xyz * 2.0 - 1.0;
          //       blendedNormal = normalize(mix(vNormal, normal2, grayscale));
          //     }

          //     // Calculate diffuse lighting
          //     vec3 diffuseLighting = getDiffuseLighting(blendedNormal, normalize(lightDirection), lightColor, ambientLight);

          //     // Calculate environment reflection using the blended normal
          //     vec3 reflection = mix(
          //       getReflection(material1Color, material1Metalness, material1Roughness, blendedNormal),
          //       getReflection(material2Color, material2Metalness, material2Roughness, blendedNormal),
          //       grayscale
          //     );

          //     // Final output color with diffuse lighting, reflection, and transparency blending
          //     gl_FragColor = vec4((blendedColor * diffuseLighting) + reflection, blendedOpacity);
          //   }
          // `,
          //         transparent: true,
          //       })

          if (g.children.length === 0) {
            // wrong case
          } else if (type === 'double') {
            // @ts-ignore
            g.children[0].material[4] = blendingMaterial
            // @ts-ignore
            g.children[0].needsUpdate = true
            // @ts-ignore
            g.children[1].material[4] = blendingMaterial
            // @ts-ignore
            g.children[1].needsUpdate = true
          } else {
            // @ts-ignore
            g.children[0].material[4] = blendingMaterial
            // @ts-ignore
            g.children[0].needsUpdate = true
          }

          // @ts-ignore
          if (window.renderScene) {
            // @ts-ignore
            window.renderScene()
          }
        }
      )
    }
  )

  return g
}

const createDoorFivePieces = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  splitters: string,
  width: number,
  height: number,
  thickness: number,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  fivePiecesConfig: ConfigsType['fivePiecesConfig'],
  isForDrawer?: boolean,
  isForSmallDrawer?: boolean,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const g = new THREE.Group()

  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  // console.log(pieces)

  if (type === 'left' || type === 'right' || type === 'liftUp') {
    const fivePieces = new THREE.Group()

    const horizontalPieceWidth = isForSmallDrawer
      ? fivePiecesConfig.pieceWidth / 2
      : fivePiecesConfig.pieceWidth
    const verticalPieceWidth = fivePiecesConfig.pieceWidth

    const lTexture = texture.clone()
    lTexture.repeat.set(verticalPieceWidth / tLength, height / tWidth)
    lTexture.offset.x = Math.random()
    lTexture.needsUpdate = true

    const rTexture = texture.clone()
    rTexture.repeat.set(verticalPieceWidth / tLength, height / tWidth)
    rTexture.offset.x = Math.random()
    rTexture.needsUpdate = true

    const tTexture = texture.clone()
    tTexture.repeat.set(
      horizontalPieceWidth / tLength,
      (width - verticalPieceWidth * 2) / tWidth
    )
    tTexture.offset.x = Math.random()
    tTexture.needsUpdate = true

    const bTexture = texture.clone()
    bTexture.repeat.set(
      horizontalPieceWidth / tLength,
      (width - verticalPieceWidth * 2) / tWidth
    )
    bTexture.offset.x = Math.random()
    bTexture.needsUpdate = true

    const leftPiece = createSheet(
      verticalPieceWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: lTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const rightPiece = createSheet(
      verticalPieceWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: rTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    const centerPieceWidth = width - verticalPieceWidth * 2
    const centerPieceHeight = height - horizontalPieceWidth * 2
    const centerPieceThickness =
      thickness - fivePiecesConfig.centerThicknessDelta

    const cTexture = texture.clone()
    cTexture.repeat.set(centerPieceWidth / tLength, centerPieceHeight / tWidth)
    cTexture.offset.x = Math.random()
    cTexture.needsUpdate = true

    let centerPiece = createSheet(
      centerPieceWidth,
      centerPieceHeight,
      centerPieceThickness,
      new THREE.MeshStandardMaterial({
        map: cTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    if (isForDrawer) {
      cTexture.repeat.set(
        centerPieceHeight / tLength,
        centerPieceWidth / tWidth
      )
      cTexture.offset.x = Math.random()
      cTexture.needsUpdate = true

      centerPiece = createSheet(
        centerPieceHeight,
        centerPieceWidth,
        centerPieceThickness,
        new THREE.MeshStandardMaterial({
          map: cTexture,
          envMap: cubMap,
          ...threePropsObj,
        })
      )

      centerPiece.rotateZ(Math.PI / 2)
    }

    centerPiece.name = 'centerPiece'
    leftPiece.name = 'verticalPiece'
    rightPiece.name = 'verticalPiece'

    fivePieces.add(centerPiece)
    fivePieces.add(leftPiece)
    fivePieces.add(rightPiece)

    centerPiece.position.z = -centerPieceThickness / 2
    leftPiece.position.x = -(centerPieceWidth + verticalPieceWidth) / 2
    rightPiece.position.x = (centerPieceWidth + verticalPieceWidth) / 2

    leftPiece.rotateZ(Math.PI)

    const topPiece = createSheet(
      horizontalPieceWidth,
      width - verticalPieceWidth * 2,
      thickness,
      new THREE.MeshStandardMaterial({
        map: tTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const bottomPiece = createSheet(
      horizontalPieceWidth,
      width - verticalPieceWidth * 2,
      thickness,
      new THREE.MeshStandardMaterial({
        map: bTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    topPiece.name = 'horizontalPiece'
    bottomPiece.name = 'horizontalPiece'

    fivePieces.add(topPiece)
    fivePieces.add(bottomPiece)
    topPiece.position.y = (centerPieceHeight + horizontalPieceWidth) / 2
    bottomPiece.position.y = -(centerPieceHeight + horizontalPieceWidth) / 2
    topPiece.rotateZ(-Math.PI / 2)
    bottomPiece.rotateZ(Math.PI / 2)

    const holeBoxDepth = 0.2

    if (!isForSmallDrawer && pieces.length === 1 && pieces[0].whole) {
      fivePieces.remove(centerPiece)
      const piece = pieces[0]
      const actualHoleHeight = height - fivePiecesConfig.pieceWidth * 2
      // if (piece.holeType !== 'none') {
      const matProps = getNewDoorHoleMaterialProps(splitters, true)

      const cTexture = texture.clone()
      cTexture.repeat.set(
        (width - fivePiecesConfig.pieceWidth * 2) / tLength,
        actualHoleHeight / tWidth
      )
      cTexture.offset.x = Math.random()
      cTexture.needsUpdate = true

      let centerGeo = new THREE.BoxGeometry(
        width - fivePiecesConfig.pieceWidth * 2,
        actualHoleHeight,
        holeBoxDepth
      )

      if (isForDrawer) {
        centerGeo = new THREE.BoxGeometry(
          actualHoleHeight,
          width - fivePiecesConfig.pieceWidth * 2,
          holeBoxDepth
        )

        centerGeo.rotateZ(Math.PI / 2)

        cTexture.repeat.set(
          actualHoleHeight / tLength,
          (width - fivePiecesConfig.pieceWidth * 2) / tWidth
        )
        cTexture.offset.x = Math.random()
        cTexture.needsUpdate = true
      }

      const hole = new THREE.Mesh(
        centerGeo,
        piece.holeType === 'none'
          ? new THREE.MeshStandardMaterial({
              map: cTexture,
              envMap: cubMap,
              ...threePropsObj,
            })
          : new THREE.MeshStandardMaterial({
              color: matProps.color,
              metalness: matProps.metalness,
              roughness: matProps.roughness,
              envMap: cubMap,
              transparent: true,
              opacity: matProps.opacity, // Fully transparent
            })
      )

      hole.position.z = -holeBoxDepth / 2 + 0.1
      hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

      fivePieces.add(hole)
      // }
    } else if (!isForSmallDrawer && pieces.length > 1) {
      let temp = (centerPieceHeight + fivePiecesConfig.pieceWidth * 2) / 2
      fivePieces.remove(centerPiece)
      for (let i = 0; i < pieces.length; i++) {
        const piece = [...pieces].reverse()[i]

        if (i !== pieces.length - 1) {
          const verticalCenterPiece = createSheet(
            fivePiecesConfig.pieceWidth,
            width - fivePiecesConfig.pieceWidth * 2,
            thickness,
            new THREE.MeshStandardMaterial({
              map: tTexture,
              envMap: cubMap,
              ...threePropsObj,
            })
          )

          verticalCenterPiece.position.y = temp
          verticalCenterPiece.position.y -= piece.num
          temp = verticalCenterPiece.position.y

          verticalCenterPiece.rotateZ(-Math.PI / 2)
          verticalCenterPiece.name = 'horizontalPiece'
          fivePieces.add(verticalCenterPiece)
        }

        const actualHoleHeight =
          piece.num -
          fivePiecesConfig.pieceWidth *
            (i === 0 || i === pieces.length - 1 ? 1.5 : 1)
        const actualHoleWidth = width - fivePiecesConfig.pieceWidth * 2 //+ 30

        const cTexture = texture.clone()
        cTexture.repeat.set(
          actualHoleWidth / tLength,
          actualHoleHeight / tWidth
        )
        cTexture.offset.x = Math.random()
        cTexture.needsUpdate = true

        const matProps = getNewDoorHoleMaterialProps(splitters, true)

        const hole = new THREE.Mesh(
          new THREE.BoxGeometry(
            actualHoleWidth,
            actualHoleHeight,
            centerPieceThickness
          ),
          piece.holeType === 'none'
            ? new THREE.MeshStandardMaterial({
                map: cTexture,
                ...threePropsObj,
              })
            : new THREE.MeshStandardMaterial({
                color: matProps.color,
                metalness: matProps.metalness,
                roughness: matProps.roughness,
                envMap: cubMap,
                transparent: true,
                opacity: matProps.opacity, // Fully transparent
              })
        )

        if (i !== pieces.length - 1) {
          hole.position.y =
            temp + (actualHoleHeight + fivePiecesConfig.pieceWidth) / 2
        } else {
          hole.position.y =
            temp -
            piece.num +
            actualHoleHeight / 2 +
            fivePiecesConfig.pieceWidth
        }
        hole.position.z = centerPiece.position.z // + 10.5
        hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

        fivePieces.add(hole)
      }
    }

    g.add(fivePieces)
  } else {
    const leftSheetWidth = width / 2 - doorConfig.verticalGap / 2
    const rightSheetWidth = width / 2 - doorConfig.verticalGap / 2

    const lFivePieces = new THREE.Group()
    const rFivePieces = new THREE.Group()

    const lTexture = texture.clone()
    lTexture.repeat.set(fivePiecesConfig.pieceWidth / tLength, height / tWidth)
    lTexture.offset.x = Math.random()
    lTexture.needsUpdate = true

    const rTexture = texture.clone()
    rTexture.repeat.set(fivePiecesConfig.pieceWidth / tLength, height / tWidth)
    rTexture.offset.x = Math.random()
    rTexture.needsUpdate = true

    const tTexture = texture.clone()
    tTexture.repeat.set(
      fivePiecesConfig.pieceWidth / tLength,
      (leftSheetWidth - fivePiecesConfig.pieceWidth * 2) / tWidth
    )
    tTexture.offset.x = Math.random()
    tTexture.needsUpdate = true

    const bTexture = texture.clone()
    bTexture.repeat.set(
      fivePiecesConfig.pieceWidth / tLength,
      (leftSheetWidth - fivePiecesConfig.pieceWidth * 2) / tWidth
    )
    bTexture.offset.x = Math.random()
    bTexture.needsUpdate = true

    const lLeftPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: lTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const lRightPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: rTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const lTopPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new THREE.MeshStandardMaterial({
        map: tTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const lBottomPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new THREE.MeshStandardMaterial({
        map: bTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    const lCenterPieceWidth = leftSheetWidth - fivePiecesConfig.pieceWidth * 2
    const lCenterPieceHeight = height - fivePiecesConfig.pieceWidth * 2
    const lCenterPieceThickness =
      thickness - fivePiecesConfig.centerThicknessDelta

    const cTexture = texture.clone()
    cTexture.repeat.set(
      lCenterPieceWidth / tLength,
      lCenterPieceHeight / tWidth
    )
    cTexture.offset.x = Math.random()
    cTexture.needsUpdate = true

    const lCenterPiece = createSheet(
      lCenterPieceWidth,
      lCenterPieceHeight,
      lCenterPieceThickness,
      new THREE.MeshStandardMaterial({
        map: cTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    lCenterPiece.name = 'centerPiece'
    lLeftPiece.name = 'verticalPiece'
    lRightPiece.name = 'verticalPiece'
    lTopPiece.name = 'horizontalPiece'
    lBottomPiece.name = 'horizontalPiece'

    lFivePieces.add(lCenterPiece)
    lFivePieces.add(lLeftPiece)
    lFivePieces.add(lRightPiece)
    lFivePieces.add(lTopPiece)
    lFivePieces.add(lBottomPiece)

    lCenterPiece.position.z = -lCenterPieceThickness / 2
    lLeftPiece.position.x =
      -(lCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    lRightPiece.position.x =
      (lCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    lTopPiece.position.y =
      (lCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2
    lBottomPiece.position.y =
      -(lCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2

    lLeftPiece.rotateZ(Math.PI)
    lTopPiece.rotateZ(-Math.PI / 2)
    lBottomPiece.rotateZ(Math.PI / 2)

    const rlTexture = lTexture.clone()
    const rrTexture = rTexture.clone()
    const rtTexture = tTexture.clone()
    const rbTexture = bTexture.clone()
    const rcTexture = bTexture.clone()
    rlTexture.offset.x = Math.random()
    rrTexture.offset.x = Math.random()
    rtTexture.offset.x = Math.random()
    rbTexture.offset.x = Math.random()
    rcTexture.offset.x = Math.random()
    rlTexture.needsUpdate = true
    rrTexture.needsUpdate = true
    rtTexture.needsUpdate = true
    rbTexture.needsUpdate = true
    rcTexture.needsUpdate = true

    const rLeftPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: rlTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const rRightPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new THREE.MeshStandardMaterial({
        map: rrTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const rTopPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      rightSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new THREE.MeshStandardMaterial({
        map: rtTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )
    const rBottomPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      rightSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new THREE.MeshStandardMaterial({
        map: rbTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    const rCenterPieceWidth = rightSheetWidth - fivePiecesConfig.pieceWidth * 2
    const rCenterPieceHeight = height - fivePiecesConfig.pieceWidth * 2
    const rCenterPieceThickness =
      thickness - fivePiecesConfig.centerThicknessDelta
    const rCenterPiece = createSheet(
      rCenterPieceWidth,
      rCenterPieceHeight,
      rCenterPieceThickness,
      new THREE.MeshStandardMaterial({
        map: cTexture,
        envMap: cubMap,
        ...threePropsObj,
      })
    )

    rCenterPiece.name = 'centerPiece'
    rLeftPiece.name = 'verticalPiece'
    rRightPiece.name = 'verticalPiece'
    rTopPiece.name = 'horizontalPiece'
    rBottomPiece.name = 'horizontalPiece'

    rFivePieces.add(rCenterPiece)
    rFivePieces.add(rLeftPiece)
    rFivePieces.add(rRightPiece)
    rFivePieces.add(rTopPiece)
    rFivePieces.add(rBottomPiece)

    rCenterPiece.position.z = -rCenterPieceThickness / 2
    rLeftPiece.position.x =
      -(rCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    rRightPiece.position.x =
      (rCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    rTopPiece.position.y =
      (rCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2
    rBottomPiece.position.y =
      -(rCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2

    rLeftPiece.rotateZ(Math.PI)
    rTopPiece.rotateZ(-Math.PI / 2)
    rBottomPiece.rotateZ(Math.PI / 2)

    g.add(lFivePieces)
    g.add(rFivePieces)

    lFivePieces.position.x = -leftSheetWidth / 2 - doorConfig.verticalGap / 2
    rFivePieces.position.x = rightSheetWidth / 2 + doorConfig.verticalGap / 2

    const holeBoxDepth = 0.2

    if (pieces.length === 1 && pieces[0].whole) {
      lFivePieces.remove(lCenterPiece)
      rFivePieces.remove(rCenterPiece)

      const piece = pieces[0]
      const actualHoleHeight = height - fivePiecesConfig.pieceWidth * 2
      // if (piece.holeType !== 'none') {
      const matProps = getNewDoorHoleMaterialProps(splitters, true)

      const cTexture = texture.clone()
      cTexture.repeat.set(
        (leftSheetWidth - fivePiecesConfig.pieceWidth * 2) / tLength,
        actualHoleHeight / tWidth
      )
      cTexture.offset.x = Math.random()
      cTexture.needsUpdate = true

      const hole = new THREE.Mesh(
        new THREE.BoxGeometry(
          leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
          actualHoleHeight,
          holeBoxDepth
        ),
        piece.holeType === 'none'
          ? new THREE.MeshStandardMaterial({
              map: cTexture,
              envMap: cubMap,
              ...threePropsObj,
            })
          : new THREE.MeshStandardMaterial({
              color: matProps.color,
              metalness: matProps.metalness,
              roughness: matProps.roughness,
              envMap: cubMap,
              transparent: true,
              opacity: matProps.opacity, // Fully transparent
            })
      )

      hole.position.z = -holeBoxDepth / 2 + 0.1
      hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

      lFivePieces.add(hole)

      if (piece.holeType === 'none') {
        const rcTexture = cTexture.clone()
        rcTexture.offset.x = Math.random()
        rcTexture.needsUpdate = true

        const rHole = hole.clone()
        rHole.material = rHole.material.clone()
        rHole.material.map = rcTexture
        rHole.material.needsUpdate = true
        rFivePieces.add(rHole)
      } else {
        rFivePieces.add(hole.clone())
      }
      // }
    } else if (pieces.length > 1) {
      let temp = (lCenterPieceHeight + fivePiecesConfig.pieceWidth * 2) / 2
      lFivePieces.remove(lCenterPiece)
      rFivePieces.remove(rCenterPiece)
      for (let i = 0; i < pieces.length; i++) {
        const piece = [...pieces].reverse()[i]

        if (i !== pieces.length - 1) {
          const ltTexture = tTexture.clone()
          const rtTexture = tTexture.clone()
          ltTexture.offset.x = Math.random()
          ltTexture.needsUpdate = true
          rtTexture.offset.x = Math.random()
          rtTexture.needsUpdate = true

          const verticalCenterPiece = createSheet(
            fivePiecesConfig.pieceWidth,
            leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
            thickness,
            new THREE.MeshStandardMaterial({
              map: ltTexture,
              envMap: cubMap,
              ...threePropsObj,
            })
          )

          const rVerticalCenterPiece = createSheet(
            fivePiecesConfig.pieceWidth,
            leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
            thickness,
            new THREE.MeshStandardMaterial({
              map: rtTexture,
              envMap: cubMap,
              ...threePropsObj,
            })
          )

          verticalCenterPiece.position.y = temp
          verticalCenterPiece.position.y -= piece.num
          temp = verticalCenterPiece.position.y

          verticalCenterPiece.rotateZ(-Math.PI / 2)
          verticalCenterPiece.name = 'horizontalPiece'

          rVerticalCenterPiece.position.x = verticalCenterPiece.position.x
          rVerticalCenterPiece.position.y = verticalCenterPiece.position.y
          rVerticalCenterPiece.position.z = verticalCenterPiece.position.z
          rVerticalCenterPiece.rotation.x = verticalCenterPiece.rotation.x
          rVerticalCenterPiece.rotation.y = verticalCenterPiece.rotation.y
          rVerticalCenterPiece.rotation.z = verticalCenterPiece.rotation.z
          rVerticalCenterPiece.name = 'horizontalPiece'

          lFivePieces.add(verticalCenterPiece)
          rFivePieces.add(rVerticalCenterPiece)
        }

        const actualHoleHeight =
          piece.num -
          fivePiecesConfig.pieceWidth *
            (i === 0 || i === pieces.length - 1 ? 1.5 : 1)
        const actualHoleWidth = leftSheetWidth - fivePiecesConfig.pieceWidth * 2 //+ 30

        const cTexture = texture.clone()
        cTexture.repeat.set(
          actualHoleWidth / tLength,
          actualHoleHeight / tWidth
        )
        cTexture.offset.x = Math.random()
        cTexture.needsUpdate = true

        const matProps = getNewDoorHoleMaterialProps(splitters, true)

        const hole = new THREE.Mesh(
          new THREE.BoxGeometry(
            actualHoleWidth,
            actualHoleHeight,
            lCenterPieceThickness
          ),
          piece.holeType === 'none'
            ? new THREE.MeshStandardMaterial({
                map: cTexture,
                ...threePropsObj,
              })
            : new THREE.MeshStandardMaterial({
                color: matProps.color,
                metalness: matProps.metalness,
                roughness: matProps.roughness,
                envMap: cubMap,
                transparent: true,
                opacity: matProps.opacity, // Fully transparent
              })
        )

        if (i !== pieces.length - 1) {
          hole.position.y =
            temp + (actualHoleHeight + fivePiecesConfig.pieceWidth) / 2
        } else {
          hole.position.y =
            temp -
            piece.num +
            actualHoleHeight / 2 +
            fivePiecesConfig.pieceWidth
        }
        hole.position.z = lCenterPiece.position.z // + 10.5
        hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

        lFivePieces.add(hole)

        if (piece.holeType === 'none') {
          const rcTexture = cTexture.clone()
          rcTexture.offset.x = Math.random()
          rcTexture.needsUpdate = true

          const rHole = hole.clone()
          rHole.material = rHole.material.clone()
          rHole.material.map = rcTexture
          rHole.material.needsUpdate = true
          rFivePieces.add(rHole)
        } else {
          rFivePieces.add(hole.clone())
        }
      }
    }
  }
  return g
}

const createDrawer = (
  visualType: DrawerVisualType,
  width: number,
  height: number,
  depth: number,
  boxWidth: number,
  boxHeight: number,
  boxDepth: number,
  thickness: number,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  boxTexture: THREE.Texture = new THREE.Texture(),
  btLength: number,
  btWidth: number,
  drawerConfig: ConfigsType['drawerConfig'],
  doorConfig: ConfigsType['doorConfig'],
  fivePiecesConfig: ConfigsType['fivePiecesConfig'],
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)
  const g = new THREE.Group()

  const drawerMaxHeight = 7.25 * 2.54
  let isSmall = false
  if (height < drawerMaxHeight) {
    isSmall = true
  }

  const sheet =
    visualType === 'fivePieces'
      ? createDoorFivePieces(
          'left',
          '',
          width,
          height,
          thickness,
          texture,
          tLength,
          tWidth,
          doorConfig,
          fivePiecesConfig,
          true,
          isSmall,
          threeProps
        )
      : visualType.startsWith('#')
        ? createNewDoors(
            'left',
            visualType as DoorNewVisualTypes,
            '',
            width,
            height,
            thickness,
            texture,
            tLength,
            tWidth,
            // @ts-ignore
            drawerConfig,
            true,
            threeProps
          )
        : visualType.startsWith('shaker')
          ? createShakerDoor(
              'left',
              visualType === 'shaker_v',
              width,
              height,
              thickness,
              texture,
              tLength,
              tWidth,
              doorConfig,
              threeProps
            )
          : createSheet(
              width,
              height,
              thickness,
              new THREE.MeshStandardMaterial({
                map: texture,
                envMap: cubMap,
                ...threePropsObj,
              })
            )

  g.add(sheet)

  const boxSheetThickness = drawerConfig.boxSheetThickness

  const backFrontTexture = boxTexture.clone()
  backFrontTexture.repeat.set(boxWidth / btLength, boxHeight / btWidth)
  backFrontTexture.needsUpdate = true

  const boxBackSheet = createSheet(
    boxWidth,
    boxHeight,
    boxSheetThickness,
    new THREE.MeshStandardMaterial({ map: backFrontTexture })
  )

  const boxFrontSheet = createSheet(
    boxWidth,
    boxHeight,
    boxSheetThickness,
    new THREE.MeshStandardMaterial({ map: backFrontTexture })
  )

  const bottomTexture = boxTexture.clone()
  bottomTexture.repeat.set(boxWidth / btLength, boxDepth / btWidth)
  bottomTexture.needsUpdate = true

  const boxBottomSheet = createSheet(
    boxWidth,
    boxSheetThickness,
    boxDepth - boxSheetThickness * 2,
    new THREE.MeshStandardMaterial({ map: bottomTexture })
  )

  const sideTexture = boxTexture.clone()
  sideTexture.repeat.set(boxDepth / btLength, boxHeight / btWidth)
  sideTexture.needsUpdate = true

  const boxLeftSheet = createSheet(
    boxSheetThickness,
    boxHeight,
    boxDepth - boxSheetThickness * 2,
    new THREE.MeshStandardMaterial({ map: sideTexture })
  )

  const boxRightSheet = createSheet(
    boxSheetThickness,
    boxHeight,
    boxDepth - boxSheetThickness * 2,
    new THREE.MeshStandardMaterial({ map: sideTexture })
  )

  g.add(boxBackSheet)
  g.add(boxFrontSheet)
  g.add(boxLeftSheet)
  g.add(boxRightSheet)
  g.add(boxBottomSheet)

  boxFrontSheet.position.z = -thickness / 2 - boxSheetThickness / 2
  boxBackSheet.position.z = -thickness / 2 - boxDepth + boxSheetThickness / 2
  boxBottomSheet.position.set(
    0,
    (-boxHeight + boxSheetThickness) / 2,
    -thickness / 2 - boxDepth / 2
  )
  boxLeftSheet.position.set(
    (-boxWidth + boxSheetThickness) / 2,
    0,
    -thickness / 2 - boxDepth / 2
  )
  boxRightSheet.position.set(
    (boxWidth - boxSheetThickness) / 2,
    0,
    -thickness / 2 - boxDepth / 2
  )

  for (let i = 1; i < 6; i++) {
    g.children[i].position.y -= height / 2
    g.children[i].position.y += boxHeight / 2
    g.children[i].position.y += drawerConfig.boxHeightBottomMargin
  }

  g.userData.drawerHeight = height
  if (visualType.startsWith('#')) {
    const drawerInnerType = visualType.replaceAll('-', '').slice(1, 9)
    // @ts-ignore
    const configs = newDoorConfigs[drawerInnerType]
    const drawerMaxHeight = configs.drawerMaxHeight * 2.54
    g.userData.isSmall = height < drawerMaxHeight
  } else {
    g.userData.isSmall = isSmall
  }

  return g
}

const createStandardLeg = (
  height: number,
  standardLegConfig: ConfigsType['standardLegConfig'],
  material: THREE.Material = new THREE.MeshBasicMaterial({ color: 'black' })
) => {
  const leg = new THREE.Group()

  const box = new THREE.Mesh(
    new THREE.BoxGeometry(
      standardLegConfig.boxLength,
      standardLegConfig.boxHeight,
      standardLegConfig.boxWidth
    ),
    material
  )

  const littleCylinderHeight =
    height - standardLegConfig.boxHeight - standardLegConfig.bigCylinderHeight

  const littleCylinder = new THREE.Mesh(
    new THREE.CylinderGeometry(
      standardLegConfig.littleCylinderRadius,
      standardLegConfig.littleCylinderRadius,
      littleCylinderHeight,
      24
    ),
    material
  )

  const bigCylinder = new THREE.Mesh(
    new THREE.CylinderGeometry(
      standardLegConfig.bigCylinderRadius,
      standardLegConfig.bigCylinderRadius,
      standardLegConfig.bigCylinderHeight,
      24
    ),
    material
  )

  leg.add(box)
  leg.add(littleCylinder)
  leg.add(bigCylinder)

  box.position.y -= standardLegConfig.boxHeight / 2
  littleCylinder.position.y -=
    standardLegConfig.boxHeight + littleCylinderHeight / 2
  bigCylinder.position.y -=
    standardLegConfig.boxHeight +
    littleCylinderHeight +
    standardLegConfig.bigCylinderHeight / 2

  return leg
}

const createStandard2Leg = (
  subType: 'short' | 'tall',
  height: number,
  standard2LegConfig: ConfigsType['standard2LegConfig'],
  material: THREE.Material = new THREE.MeshBasicMaterial({ color: 'black' })
) => {
  const leg = new THREE.Group()

  const box = new THREE.Mesh(
    new THREE.BoxGeometry(
      standard2LegConfig.boxLength,
      standard2LegConfig.boxHeight,
      standard2LegConfig.boxWidth
    ),
    material
  )

  const bigCylinderHeight =
    subType === 'tall'
      ? standard2LegConfig.bigCylinderHeightTall
      : standard2LegConfig.bigCylinderHeight

  const littleCylinderHeight =
    height -
    standard2LegConfig.boxHeight -
    bigCylinderHeight -
    standard2LegConfig.separateLayerHeight

  const littleCylinder = new THREE.Mesh(
    new THREE.CylinderGeometry(
      standard2LegConfig.littleCylinderRadius,
      standard2LegConfig.littleCylinderRadius,
      littleCylinderHeight,
      24
    ),
    material
  )

  const bigCylinder = new THREE.Mesh(
    new THREE.CylinderGeometry(
      standard2LegConfig.bigCylinderRadius,
      standard2LegConfig.bigCylinderRadius,
      bigCylinderHeight,
      24
    ),
    material
  )

  const separateCylinder = new THREE.Mesh(
    new THREE.CylinderGeometry(
      standard2LegConfig.separateLayerRadius,
      standard2LegConfig.separateLayerRadius,
      standard2LegConfig.separateLayerHeight,
      24
    ),
    material
  )

  const littleSeparateCylinder = new THREE.Mesh(
    new THREE.CylinderGeometry(
      standard2LegConfig.littleSeparateLayerRadius,
      standard2LegConfig.littleSeparateLayerRadius,
      standard2LegConfig.littleSeparateLayerHeight,
      24
    ),
    material
  )

  leg.add(box)
  leg.add(bigCylinder)
  leg.add(separateCylinder)
  leg.add(littleCylinder)
  leg.add(littleSeparateCylinder)

  box.position.y -= standard2LegConfig.boxHeight / 2
  bigCylinder.position.y -= standard2LegConfig.boxHeight + bigCylinderHeight / 2
  separateCylinder.position.y -=
    standard2LegConfig.boxHeight +
    bigCylinderHeight +
    standard2LegConfig.separateLayerHeight / 2

  littleCylinder.position.y -=
    standard2LegConfig.boxHeight +
    bigCylinderHeight +
    standard2LegConfig.separateLayerHeight +
    littleCylinderHeight / 2
  littleSeparateCylinder.position.y -=
    standard2LegConfig.boxHeight +
    bigCylinderHeight +
    standard2LegConfig.separateLayerHeight +
    littleCylinderHeight -
    standard2LegConfig.littleSeparateLayerPosFromBottom

  return leg
}

const createStandardLegs = (
  height: number,
  cabinetWidth: number,
  cabinetDepth: number,
  standardLegConfig: ConfigsType['standardLegConfig'],
  material: THREE.Material = new THREE.MeshBasicMaterial({ color: 'black' })
) => {
  const g = new THREE.Group()

  for (let i = 0; i < 4; i++) {
    g.add(createStandardLeg(height, standardLegConfig, material))
  }

  g.children[0].position.x =
    -cabinetWidth / 2 +
    standardLegConfig.sideReveal +
    standardLegConfig.boxLength / 2
  g.children[0].position.z =
    cabinetDepth / 2 -
    standardLegConfig.frontReveal -
    standardLegConfig.boxLength / 2

  g.children[1].position.x =
    -cabinetWidth / 2 +
    standardLegConfig.sideReveal +
    standardLegConfig.boxLength / 2
  g.children[1].position.z =
    -cabinetDepth / 2 +
    standardLegConfig.backReveal +
    standardLegConfig.boxLength / 2

  g.children[2].position.x =
    cabinetWidth / 2 -
    standardLegConfig.sideReveal -
    standardLegConfig.boxLength / 2
  g.children[2].position.z =
    -cabinetDepth / 2 +
    standardLegConfig.backReveal +
    standardLegConfig.boxLength / 2

  g.children[3].position.x =
    cabinetWidth / 2 -
    standardLegConfig.sideReveal -
    standardLegConfig.boxLength / 2
  g.children[3].position.z =
    cabinetDepth / 2 -
    standardLegConfig.frontReveal -
    standardLegConfig.boxLength / 2

  return g
}

const createStandard2Legs = (
  subType: 'short' | 'tall',
  height: number,
  cabinetWidth: number,
  cabinetDepth: number,
  standard2LegConfig: ConfigsType['standard2LegConfig'],
  material: THREE.Material = new THREE.MeshBasicMaterial({ color: 'black' })
) => {
  const g = new THREE.Group()

  for (let i = 0; i < 4; i++) {
    g.add(createStandard2Leg(subType, height, standard2LegConfig, material))
  }

  g.children[0].position.x =
    -cabinetWidth / 2 +
    standard2LegConfig.sideReveal +
    standard2LegConfig.boxLength / 2
  g.children[0].position.z =
    cabinetDepth / 2 -
    standard2LegConfig.frontReveal -
    standard2LegConfig.boxLength / 2

  g.children[1].position.x =
    -cabinetWidth / 2 +
    standard2LegConfig.sideReveal +
    standard2LegConfig.boxLength / 2
  g.children[1].position.z =
    -cabinetDepth / 2 +
    standard2LegConfig.backReveal +
    standard2LegConfig.boxLength / 2

  g.children[2].position.x =
    cabinetWidth / 2 -
    standard2LegConfig.sideReveal -
    standard2LegConfig.boxLength / 2
  g.children[2].position.z =
    -cabinetDepth / 2 +
    standard2LegConfig.backReveal +
    standard2LegConfig.boxLength / 2

  g.children[3].position.x =
    cabinetWidth / 2 -
    standard2LegConfig.sideReveal -
    standard2LegConfig.boxLength / 2
  g.children[3].position.z =
    cabinetDepth / 2 -
    standard2LegConfig.frontReveal -
    standard2LegConfig.boxLength / 2

  return g
}

const createSplittedTop = (
  cabinetWidth: number,
  cabinetDepth: number,
  sheetWidth: number,
  thickness: number,
  material: THREE.Material | THREE.Material[] = new THREE.MeshNormalMaterial()
) => {
  const g = new THREE.Group()

  const sheet1 = createSheet(sheetWidth, thickness, cabinetWidth, material)
  const sheet2 = createSheet(sheetWidth, thickness, cabinetWidth, material)

  g.add(sheet1)
  g.add(sheet2)

  sheet1.position.z = (cabinetDepth - sheetWidth) / 2
  sheet1.rotation.y = Math.PI / 2
  sheet2.position.z = -(cabinetDepth - sheetWidth) / 2
  sheet2.rotation.y = Math.PI / 2

  return g
}

const createSeparateBasePlatform = (
  width: number,
  depth: number,
  height: number,
  texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  separateBaseConfig: ConfigsType['separateBaseConfig']
) => {
  const thickness = separateBaseConfig.sheetThickness
  const g = new THREE.Group()

  const backFrontTexture = texture.clone()
  backFrontTexture.repeat.set(width / tLength, height / tWidth)
  backFrontTexture.needsUpdate = true

  const backSheet = createSheet(
    width,
    height,
    thickness,
    new THREE.MeshStandardMaterial({ map: backFrontTexture })
  )

  const frontSheet = createSheet(
    width,
    height,
    thickness,
    new THREE.MeshStandardMaterial({ map: backFrontTexture })
  )

  const sideTexture = texture.clone()
  sideTexture.repeat.set(depth / tLength, height / tWidth)
  sideTexture.needsUpdate = true

  const leftSheet = createSheet(
    depth - 2 * thickness,
    height,
    thickness,
    new THREE.MeshStandardMaterial({ map: sideTexture })
  )

  const centerSheet = createSheet(
    depth - 2 * thickness,
    height,
    thickness,
    new THREE.MeshStandardMaterial({ map: sideTexture })
  )

  const rightSheet = createSheet(
    depth - 2 * thickness,
    height,
    thickness,
    new THREE.MeshStandardMaterial({ map: sideTexture })
  )

  g.add(backSheet)
  g.add(frontSheet)
  g.add(leftSheet)
  g.add(centerSheet)
  g.add(rightSheet)

  leftSheet.rotation.y = Math.PI / 2
  centerSheet.rotation.y = Math.PI / 2
  rightSheet.rotation.y = Math.PI / 2

  leftSheet.position.x = (thickness - width) / 2
  rightSheet.position.x = (-thickness + width) / 2

  backSheet.position.z = (thickness - depth) / 2
  frontSheet.position.z = (-thickness + depth) / 2

  leftSheet.position.z -= separateBaseConfig.frontMargin / 2
  rightSheet.position.z -= separateBaseConfig.frontMargin / 2
  centerSheet.position.z -= separateBaseConfig.frontMargin / 2
  backSheet.position.z -= separateBaseConfig.frontMargin / 2
  frontSheet.position.z -= separateBaseConfig.frontMargin / 2

  return g
}

const createCornerHorizontalSheet = (
  type: '2door' | 'angled',
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  backWidth1: number,
  backWidth2: number,
  thickness: number,
  temp: boolean,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  isPewter = false
) => {
  // console.log(isPewter)
  const extrudeSettings = {
    steps: 1,
    depth: thickness,
    bevelEnabled: false,
    bevelThickness: 0.05,
    bevelSize: 0.05,
    bevelOffset: -0.1,
    bevelSegments: 1,
  }
  // https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing
  const e1 = backWidth1 - thickness
  const e2 = backWidth2 - thickness
  const hyp = (e1 ** 2 + e2 ** 2) ** 0.5
  const x1 = (thickness * hyp) / e2
  const x2 = (thickness * hyp) / e1
  // const g = new Group()

  const shape = new THREE.Shape()

  shape.moveTo(backWidth2 + x2, thickness)
  shape.lineTo(width2 - thickness, thickness)
  shape.lineTo(width2 - thickness, depth2)

  if (type === '2door') shape.lineTo(depth1, depth2)

  shape.lineTo(depth1, width1 - thickness)
  shape.lineTo(thickness, width1 - thickness)
  shape.lineTo(thickness, backWidth1 + x1)

  const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)

  const newTexture = texture.clone()
  newTexture.wrapS = THREE.RepeatWrapping
  newTexture.wrapT = THREE.RepeatWrapping
  newTexture.repeat.set(1, tLength / tWidth)
  // newTexture.rotation = Math.PI / 4
  newTexture.needsUpdate = true

  if (!temp) {
    applyBoxUV(
      geometry,
      new THREE.Matrix4().fromArray([
        1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
      ]),
      tLength
    )

    geometry.attributes.uv.needsUpdate = true
  }

  const material = new THREE.MeshStandardMaterial({ map: newTexture })
  const bMat = new THREE.MeshBasicMaterial({ color: 'black' })

  const mesh = new THREE.Mesh(
    geometry,
    temp
      ? new THREE.MeshNormalMaterial()
      : isPewter
        ? [material, bMat]
        : material
  )

  // mesh.rotation.x = Math.PI / 2

  // g.add(mesh)

  return mesh //origin of object is not in center because it is  extruded shape
}

const createCornerTwoDoor = (
  visualType: DoorVisualType,
  splitters: string,
  type: CornerTwoDoorItemPropsType['subType'],
  width1: number,
  width2: number,
  height: number,
  thickness: number,
  texture: THREE.Texture = new THREE.Texture(),
  tLength: number,
  tWidth: number,
  configs: ConfigsType,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const g = new THREE.Group()
  // console.log(visualType)

  if (type === 'right') {
    const panelTexture = texture.clone()
    panelTexture.repeat.set(width2 / tLength, height / tWidth)
    panelTexture.needsUpdate = true

    let firstPanel = new THREE.Object3D()
    let secondPanel = new THREE.Object3D()

    if (visualType === 'vGroove') {
      firstPanel = createDoorVGroove(
        type,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.vGrooveConfig
      ).children[0] as THREE.Mesh
      secondPanel = createSheet(
        width2,
        height,
        thickness,
        new THREE.MeshStandardMaterial({
          map: panelTexture,
          envMap: cubMap,
          ...threePropsObj,
        })
      )

      firstPanel.rotateZ(-Math.PI / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
      firstPanel.position.set(
        -width2 / 2 - thickness / 2,
        height / 2,
        width1 + thickness - (width1 / 2 + thickness / 2)
      )
    } else if (visualType === 'fivePieces') {
      firstPanel = createDoorFivePieces(
        type,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      ).children[0] as THREE.Mesh
      secondPanel = createDoorFivePieces(
        type,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    } else if (visualType.startsWith('#')) {
      firstPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )
      secondPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )

      firstPanel.rotateY(Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    } else if (visualType.startsWith('shaker')) {
      firstPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      ).children[0] as THREE.Mesh
      secondPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    }

    g.add(firstPanel)
    g.add(secondPanel)
  } else {
    const panelTexture = texture.clone()
    panelTexture.repeat.set(width1 / tLength, height / tWidth)
    panelTexture.needsUpdate = true

    let firstPanel = new THREE.Object3D()
    let secondPanel = new THREE.Object3D()

    if (visualType === 'vGroove') {
      firstPanel = createSheet(
        width1,
        height,
        thickness,
        new THREE.MeshStandardMaterial({
          map: panelTexture,
          envMap: cubMap,
          ...threePropsObj,
        })
      )
      secondPanel = createDoorVGroove(
        type,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.vGrooveConfig,
        threeProps
      ).children[0] as THREE.Mesh

      firstPanel.rotateY(-Math.PI / 2)

      firstPanel.position.set(-width2 / 2, 0, thickness / 2)
      secondPanel.position.x += thickness / 2
      secondPanel.position.z -= width1 / 2
    } else if (visualType === 'fivePieces') {
      firstPanel = createDoorFivePieces(
        type,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      ).children[0] as THREE.Mesh
      secondPanel = createDoorFivePieces(
        type,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    } else if (visualType.startsWith('#')) {
      firstPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )
      secondPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )
      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
      g.add(secondPanel)

      firstPanel.rotateY(Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)
    } else if (visualType.startsWith('shaker')) {
      firstPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      ).children[0] as THREE.Mesh
      secondPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    }

    g.add(firstPanel)
    g.add(secondPanel)
  }
  return g
}

const createCornerLegs = (
  height: number,
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  backWidth1: number,
  backWidth2: number,
  thickness: number,
  standardLegConfig: ConfigsType['standardLegConfig'],
  material: THREE.Material = new THREE.MeshBasicMaterial({ color: 'black' })
) => {
  const g = new THREE.Group()

  for (let i = 0; i < 7; i++) {
    g.add(createStandardLeg(height, standardLegConfig, material))
  }

  const e1 = backWidth1 - thickness //edge
  const e2 = backWidth2 - thickness
  const hyp = (e1 ** 2 + e2 ** 2) ** 0.5 //hypotenuse

  const x1 = (thickness * hyp) / e2
  const x2 = (thickness * hyp) / e1

  g.children[0].position.x =
    thickness + e2 + 0.5026 + standardLegConfig.boxLength / 2
  g.children[0].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[1].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[1].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[2].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[2].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[3].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[3].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[4].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[4].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[5].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[5].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[6].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[6].position.z = thickness + e1 + standardLegConfig.boxWidth / 2

  return g
}

const createCornerLegs2 = (
  subType: 'short' | 'tall',
  height: number,
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  backWidth1: number,
  backWidth2: number,
  thickness: number,
  standardLegConfig: ConfigsType['standard2LegConfig'],
  material: THREE.Material = new THREE.MeshBasicMaterial({ color: 'black' })
) => {
  const g = new THREE.Group()

  for (let i = 0; i < 7; i++) {
    g.add(createStandard2Leg(subType, height, standardLegConfig, material))
  }

  const e1 = backWidth1 - thickness //edge
  const e2 = backWidth2 - thickness
  // const hyp = (e1 ** 2 + e2 ** 2) ** .5 //hypotenuse

  // const x1 = (thickness) * hyp / e2
  // const x2 = (thickness) * hyp / e1

  g.children[0].position.x =
    thickness + e2 + 0.5026 + standardLegConfig.boxLength / 2
  g.children[0].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[1].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[1].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[2].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[2].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[3].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[3].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[4].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[4].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[5].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[5].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[6].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[6].position.z = thickness + e1 + standardLegConfig.boxWidth / 2

  return g
}

const calculateCornerSectionSize = (
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  thickness: number
) => {
  //https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing

  const e1 = width2 - depth1 - thickness
  const e2 = width1 - depth2 - thickness
  const hyp = (e1 ** 2 + e2 ** 2) ** 0.5

  return hyp
}

const calculateCornerSectionTransform = (
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  thickness: number,
  forDoor = false,
  gap = 0.31369
) => {
  //https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing

  const e1 = width2 - depth1 - thickness
  const e2 = width1 - depth2 - thickness
  const hyp = (e1 ** 2 + e2 ** 2) ** 0.5

  const angle = Math.asin(e2 / hyp)

  const x1 = (thickness * e1) / e2
  const x2 = (thickness * e2) / e1

  const _e1 = e1 + x1 + thickness
  const _e2 = e2 + x2 + thickness
  const _hyp = (_e1 * hyp) / e1 // _hyp/hyp = _e1/e1

  const h = (_e1 * _e2) / _hyp
  const z = (h * _e1) / _e2 // z/e1 = h / e2
  const y1 = (x1 * hyp) / e1 //y1/hyp = x1/e1

  const obj = new THREE.Object3D()
  obj.position.x = width2
  obj.position.z = width1
  obj.rotation.y = angle

  obj.translateZ(-h)
  obj.translateX(hyp / 2 - (z - y1))

  if (forDoor) obj.translateZ(thickness / 2 + gap)

  return {
    x: obj.position.x,
    z: obj.position.z,
    angle,
  }
}

//Classes

class Hardware {
  id: number
  localId: number
  name: string
  type: HardwareTypes
  unitWeight: number
  unitPrice: number
  unitPriceAddon: number
  addonD: number
  addonP: number
  minPrice: number
  markupValue: number

  materialBased: boolean
  drawerConfig: ConfigsType['drawerConfig']
  hingeBreakpoints: ConfigsType['hingeBreakpoints']

  props: HPropsType

  count = 1
  weight = 0
  price = 0
  clearPrice = 0
  nonMarkupPrice = 0

  material: Material | undefined
  children: Hardware[]

  constructor(
    hProp: { id: number; localId: number; count: number },
    name: string,
    type: HardwareTypes,
    unitWeight: number,
    unitPrice: number,
    unitPriceAddon: number,
    addonD: number,
    addonP: number,
    minPrice: number,
    markupValue: number,
    material: Material | undefined = undefined,
    children: Hardware[] = [],
    drawerConfig: ConfigsType['drawerConfig'],
    hingeBreakpoints: ConfigsType['hingeBreakpoints']
  ) {
    this.id = hProp.id
    this.localId = hProp.localId
    this.count = hProp.count
    this.name = name
    this.type = type
    this.unitWeight = unitWeight
    this.unitPrice = unitPrice
    this.unitPriceAddon = unitPriceAddon
    this.addonD = addonD
    this.addonP = addonP
    this.minPrice = minPrice
    this.markupValue = markupValue
    this.material = material
    this.children = children
    this.drawerConfig = drawerConfig
    this.hingeBreakpoints = hingeBreakpoints

    //better conditioning must be
    if (this.unitPrice === -1) this.materialBased = true
    else this.materialBased = false

    this.props = this.generateProps()
    this.calculatePrice()
  }

  generateProps = (): HPropsType => {
    if (this.type === 'static') {
      return {
        type: this.type,
      } as StaticPropsType
    } else if (this.type === 'parametric_length') {
      return {
        type: this.type,
        length: { value: 1, extra: 0 },
        formula: 'mult',
      } as PLengthPropsType
    } else if (this.type === 'parametric_area') {
      return {
        type: this.type,
        width: { value: 1, extra: 0 },
        length: { value: 1, extra: 0 },
        extra: 0,
        formula: 'mult',
      } as PAreaPropsType
    } else if (this.type === 'parametric_count') {
      return {
        type: this.type,
        count: { value: 1, extra: 0 },
        formula: 'mult',
      } as PCountPropsType
    } else if (this.type === 'parametric_cornerHorizontalSheet') {
      return {
        type: this.type,
        subType: 'angle',
        width1: { value: 1, extra: 0 },
        width2: { value: 1, extra: 0 },
        depth1: { value: 1, extra: 0 },
        depth2: { value: 1, extra: 0 },
        backWidth1: { value: 1, extra: 0 },
        backWidth2: { value: 1, extra: 0 },
        thickness: { value: 1, extra: 0 },
        // extra: number
        formula: 'mult',
      } as PCornerHorizontalSheetPropsType
    } else if (this.type === 'parametric_cornerTwoDoor') {
      return {
        type: this.type,
        width1: { value: 1, extra: 0 },
        width2: { value: 1, extra: 0 },
        height: { value: 1, extra: 0 },
        // extra: number
        formula: 'mult',
      } as PCornerTwoDoorPropsType
    } else if (this.type === 'parametric_hinge') {
      return {
        type: this.type,
        height: { value: 1, extra: 0 },
        count: { value: 1, extra: 0 },
        // extra: number
        formula: 'mult',
      }
    } else {
      // if (this.type === 'parametric_drawerBox') {
      return {
        type: this.type,
        height: { value: 10.16, extra: 0 },
        width: { value: 58.42, extra: 0 },
        depth: { value: 50.165, extra: 0 },
        formula: 'mult',
      } as PDrawerBoxPropsType
    }
  }

  calculatePrice = () => {
    const unitPrice =
      this.materialBased && this.material
        ? this.material.price + this.material.addon
        : this.unitPrice
    const clearUnitPrice =
      this.materialBased && this.material ? this.material.price : this.unitPrice
    const unitWeight =
      this.materialBased && this.material
        ? this.material.weight
        : this.unitWeight

    if (this.props.type === 'static') {
      this.price = unitPrice //* this.count
      this.clearPrice = clearUnitPrice //* this.count
      this.weight = unitWeight
    } else if (this.props.type === 'parametric_length') {
      const length = this.props.length

      this.price = unitPrice * (length.value + length.extra)
      this.clearPrice = clearUnitPrice * (length.value + length.extra)
      this.weight = unitWeight * (length.value + length.extra)
    } else if (this.props.type === 'parametric_area') {
      const height = this.props.length
      const width = this.props.width
      const extraArea = this.props.extra

      const area =
        (height.value + height.extra) * (width.value + width.extra) + extraArea

      if (area === 0) {
        this.clearPrice = 0
        this.weight = 0
        this.price = 0
      } else {
        this.clearPrice = clearUnitPrice * area

        this.weight = unitWeight * area

        this.price = unitPrice * area
        const machiningCost =
          (this.unitPriceAddon * area + this.addonD) * (1 + 0.01 * this.addonP)
        this.price = Math.max(this.minPrice, this.price + machiningCost)
      }
    } else if (this.props.type === 'parametric_count') {
      let count = { value: 0, extra: 0 }

      for (const key in this.props) {
        if (key.split('_')[0] === 'count') {
          // @ts-ignore
          count = this.props[key]
        }
      }

      this.price = unitPrice * (count.value + count.extra)
      this.clearPrice = clearUnitPrice * (count.value + count.extra)
      this.weight = unitWeight * (count.value + count.extra)
    } else if (this.props.type === 'parametric_cornerHorizontalSheet') {
      const e1 = this.props.backWidth1.value - this.props.thickness.value
      const e2 = this.props.backWidth2.value - this.props.thickness.value
      const hyp = (e1 ** 2 + e2 ** 2) ** 0.5
      const x1 = (this.props.thickness.value * hyp) / e2
      const x2 = (this.props.thickness.value * hyp) / e1

      const points = []

      points.push(
        new THREE.Vector2(
          this.props.backWidth2.value + x2,
          this.props.thickness.value
        )
      )
      points.push(
        new THREE.Vector2(
          this.props.width2.value - this.props.thickness.value,
          this.props.thickness.value
        )
      )
      points.push(
        new THREE.Vector2(
          this.props.width2.value - this.props.thickness.value,
          this.props.depth2.value
        )
      )

      if (this.props.subType === '2door')
        points.push(
          new THREE.Vector2(this.props.depth1.value, this.props.depth2.value)
        )

      points.push(
        new THREE.Vector2(
          this.props.depth1.value,
          this.props.width1.value - this.props.thickness.value
        )
      )
      points.push(
        new THREE.Vector2(
          this.props.thickness.value,
          this.props.width1.value - this.props.thickness.value
        )
      )
      points.push(
        new THREE.Vector2(
          this.props.thickness.value,
          this.props.backWidth1.value + x1
        )
      )

      const area = THREE.ShapeUtils.area(points)

      this.weight = area * unitWeight
      this.clearPrice = area * clearUnitPrice

      this.price = area * unitPrice
      const machiningCost =
        (this.unitPriceAddon * area + this.addonD) * (1 + 0.01 * this.addonP)
      this.price = Math.max(this.minPrice, this.price + machiningCost)
    } else if (this.props.type === 'parametric_cornerTwoDoor') {
      const area =
        (this.props.width1.value + this.props.width2.value) *
        this.props.height.value

      this.weight = area * unitWeight
      this.clearPrice = area * clearUnitPrice

      this.price = area * unitPrice
      const machiningCost =
        (this.unitPriceAddon * area + this.addonD) * (1 + 0.01 * this.addonP)
      this.price = Math.max(this.minPrice, this.price + machiningCost)
    } else if (this.props.type === 'parametric_hinge') {
      const breakpoints = this.hingeBreakpoints.array
        .split(',')
        .map((num) => parseFloat(num.trim()))
        .sort((a, b) => a - b)
      let count = 2

      for (const bp of breakpoints) {
        if (this.props.height.value > bp) count++
        else break
      }

      this.props.count.value = count

      this.price = unitPrice * this.props.count.value
      this.clearPrice = clearUnitPrice * this.props.count.value
      this.weight = unitWeight * this.props.count.value
    } else if (this.props.type === 'parametric_drawerBox') {
      const sidesCost =
        2 * (this.props.depth.value + this.props.depth.extra) * unitPrice
      const frontAndBackCost =
        2 * (this.props.width.value + this.props.width.extra) * unitPrice
      const bottomCost =
        (this.props.depth.value + this.props.depth.extra) *
        (this.props.width.value + this.props.width.extra) *
        this.drawerConfig.boxBottomMaterialPrice
      const labor = [5.08, 7.62, 10.16].includes(
        this.props.height.value + this.props.height.extra
      )
        ? this.drawerConfig.boxLaborPrice[0]
        : this.drawerConfig.boxLaborPrice[1]

      const clearSidesCost =
        2 * (this.props.depth.value + this.props.depth.extra) * clearUnitPrice
      const clearFrontAndBackCost =
        2 * (this.props.width.value + this.props.width.extra) * clearUnitPrice
      const clearBottomCost =
        (this.props.depth.value + this.props.depth.extra) *
        (this.props.width.value + this.props.width.extra) *
        this.drawerConfig.boxBottomMaterialPrice

      this.price = sidesCost + frontAndBackCost + bottomCost + labor
      this.clearPrice =
        clearSidesCost + clearFrontAndBackCost + clearBottomCost + labor

      //Calculate sum of sheets' areas
      const width = this.props.width.value + this.props.width.extra
      const height = this.props.height.value + this.props.height.extra
      const depth = this.props.depth.value + this.props.depth.extra

      const area = depth * width + 2 * (depth * height) + 2 * (width * height)

      this.weight = unitWeight * area
    }

    this.nonMarkupPrice = this.price

    //Multiply price by markup
    this.price = this.price * this.markupValue

    //Sum prices of children
    if (this.children.length > 0) {
      this.children.forEach((child) => {
        child.calculatePrice()
        this.price += child.price
        this.clearPrice += child.clearPrice
        this.nonMarkupPrice += child.nonMarkupPrice
      })
    }

    //Multiply price by count
    this.price *= this.count
    this.clearPrice *= this.count
    this.nonMarkupPrice *= this.count
    this.weight *= this.count

    //Fix js problem of float numbers
    this.price = parseFloat(this.price.toFixed(fractionDigits))
    this.clearPrice = parseFloat(this.clearPrice.toFixed(fractionDigits))
    this.nonMarkupPrice = parseFloat(
      this.nonMarkupPrice.toFixed(fractionDigits)
    )
    this.weight = parseFloat(this.weight.toFixed(fractionDigits))
  }

  updateProps = (props: HPropsType) => {
    this.props = props
    this.calculatePrice()
  }

  // changeCount = (count: number) => {
  //     this.count = count
  //     this.calculatePrice()
  // }
}

const cabinetBoxSheetsNames = [
  'Top',
  'Bottom',
  'Back',
  'Right Side',
  'Left Side',
  'Right Side Base Leg',
  'Left Side Base Leg',
  'Splitted Top',
  'Front Left Side',
  'Front Right Side',
  'Back Left Side',
  'Back Right Side',
]

const cabinetShelfSheetsStartNames = ['Fixed Shelf', 'Shelf']

class Item {
  name: string
  object3D: THREE.Object3D
  props: IPropsType

  hardwares: Hardware[]
  addon: AddonType
  links: LinkType[]
  children: Item[] = []

  parent: Item | undefined

  configs: ConfigsType
  // setItemsPropsList: (arr: ItemPropsType[]) => void

  constructor(
    name: string,
    props: IPropsType,
    hardwares: Array<Hardware> = [],
    links: LinkType[] = [],
    addon: AddonType = { dollar: 0, percentage: 0 },
    configs: ConfigsType,
    parent?: Item
  ) {
    this.name = name
    this.props = props
    this.hardwares = hardwares
    this.links = links
    this.addon = addon
    this.configs = configs
    // this.setItemsPropsList = setItemsPropsList

    this.parent = parent

    this.name += this.parent ? `$$${this.parent.name}` : ''

    this.object3D = this.generateObject3D()
    this.updateHardwareProps()
  }

  generateObject3D = () => {
    let texture = undefined
    let tLength = 1
    let tWidth = 1
    let materialId = -1
    let materialThreeProps = ''

    for (const hardware of this.hardwares) {
      if (hardware.materialBased && hardware.material) {
        // debugger
        // console.log('texture need to be used ' + hardware.material.name)
        texture = hardware.material.texture.clone()
        tLength = hardware.material.tLength
        tWidth = hardware.material.tWidth
        materialId = hardware.material.id
        materialThreeProps = hardware.material.threeProps

        break
      }
    }

    const material = texture
      ? new THREE.MeshStandardMaterial({ map: texture })
      : undefined

    if (this.props.type === 'shelf') {
      if (texture) {
        texture.repeat.set(
          this.props.length / tLength,
          this.props.width / tWidth
        )
        texture.needsUpdate = true
      }

      let isPewterMat = false
      let materials: THREE.Material[] = []

      if (materialId === 76 && material) {
        //Pewter Brush
        if (
          cabinetBoxSheetsNames.includes(this.name) ||
          cabinetShelfSheetsStartNames.some((n) => this.name.includes(n))
        ) {
          const blackMat = new THREE.MeshBasicMaterial({ color: 'black' })
          isPewterMat = true
          materials = [
            blackMat,
            blackMat,
            blackMat,
            blackMat,
            material,
            material,
          ]
        }
      }

      const mesh = createSheet(
        this.props.length,
        this.props.width,
        this.configs.thickness,
        isPewterMat ? materials : material
      )

      mesh.name = this.name
      return mesh
    } else if (this.props.type === 'sideSheetBaseLeg') {
      const mesh = createSideSheetForBaseLegs(
        this.props.cabinetHeight,
        this.props.legHeight,
        this.props.width,
        this.configs.thickness,
        texture,
        tLength,
        tWidth,
        this.configs.baseLegConfig,
        this.props.isNewBase,
        this.props.cutLength,
        this.props.backCut
      )
      // const mesh = createSideSheetForBaseLegs(this.props.width, this.props.length, this.configs.thickness, texture, tLength, tWidth, this.configs.baseLegConfig)

      mesh.name = this.name
      return mesh
    } else if (this.props.type === 'door') {
      if (texture) {
        texture.repeat.set(
          this.props.width / tLength,
          this.props.height / tWidth
        )
        texture.needsUpdate = true
      }

      const door = this.props.visualType.startsWith('shaker')
        ? createShakerDoor(
            this.props.subType,
            this.props.visualType === 'shaker_v',
            this.props.width,
            this.props.height,
            this.configs.thickness,
            texture,
            tLength,
            tWidth,
            this.configs.doorConfig,
            materialThreeProps
          )
        : createDoorVGroove(
            this.props.subType,
            this.props.width,
            this.props.height,
            this.configs.thickness,
            texture,
            tLength,
            tWidth,
            this.configs.doorConfig,
            this.configs.vGrooveConfig,
            materialThreeProps
          )

      door.name = this.name
      door.userData.type = this.props.subType
      door.userData.isDoor = true

      return door
    } else if (this.props.type === 'newDoor') {
      if (texture) {
        texture.repeat.set(
          this.props.width / tLength,
          this.props.height / tWidth
        )
        texture.needsUpdate = true
      }
      // if (this.props.subType === 'liftUp' && material) {
      //   // nMap.wrapS = nMap.wrapT = ClampToEdgeWrapping
      //   // nMap.repeat.set(1, 1)
      //   nMap.needsUpdate = true
      //   material.normalMap = nMap
      //   material.needsUpdate = true
      // }

      // console.log(this.props.visualType)

      const door = createNewDoors(
        this.props.subType,
        this.props.visualType as DoorNewVisualTypes,
        this.props.splitters || '',
        this.props.width,
        this.props.height,
        this.configs.thickness,
        texture,
        tLength,
        tWidth,
        this.configs.doorConfig,
        false,
        materialThreeProps
      )

      door.name = this.name
      door.userData.type = this.props.subType
      door.userData.isDoor = true

      return door
    } else if (this.props.type === 'fivePiecesDoor') {
      if (texture) {
        texture.repeat.set(
          this.props.width / tLength,
          this.props.height / tWidth
        )
        texture.needsUpdate = true
      }
      // if (this.props.subType === 'liftUp' && material) {
      //   // nMap.wrapS = nMap.wrapT = ClampToEdgeWrapping
      //   // nMap.repeat.set(1, 1)
      //   nMap.needsUpdate = true
      //   material.normalMap = nMap
      //   material.needsUpdate = true
      // }

      // console.log(this.props.visualType)

      const door = createDoorFivePieces(
        this.props.subType,
        this.props.splitters || '',
        this.props.width,
        this.props.height,
        this.configs.thickness,
        texture,
        tLength,
        tWidth,
        this.configs.doorConfig,
        this.configs.fivePiecesConfig,
        false,
        false,
        materialThreeProps
      )
      door.name = this.name
      door.userData.type = this.props.subType
      door.userData.isDoor = true

      return door
    } else if (
      this.props.type === 'drawer' ||
      this.props.type === 'fivePiecesDrawer'
    ) {
      if (texture) {
        texture.repeat.set(
          this.props.width / tLength,
          this.props.height / tWidth
        )
        texture.needsUpdate = true
      }

      let boxTexture = undefined
      let btLength = 0
      let btWidth = 1
      const boxHardware = this.hardwares.find((h) =>
        h.name.startsWith('Drawer Box')
      )

      if (boxHardware && boxHardware.materialBased && boxHardware.material) {
        boxTexture = boxHardware.material.texture.clone()
        btLength = boxHardware.material.tLength
        btWidth = boxHardware.material.tWidth
      }

      const drawer = createDrawer(
        this.props.visualType || 'standard',
        this.props.width,
        this.props.height,
        this.props.depth,
        this.props.boxWidth,
        this.props.boxHeight,
        this.props.boxDepth,
        this.configs.thickness,
        texture,
        tLength,
        tWidth,
        boxTexture,
        btLength,
        btWidth,
        this.configs.drawerConfig,
        this.configs.doorConfig,
        this.configs.fivePiecesConfig,
        materialThreeProps
      )

      drawer.name = this.name
      // door.userData.type = this.props.subType
      drawer.userData.isDrawer = true

      return drawer
    } else if (this.props.type === 'handle') {
      let color = undefined

      if (texture && texture.name.startsWith('color||')) {
        color = new THREE.Color(texture.name.slice(7))
      }

      // const handle = createCylinderHandle(this.configs.handleConfig, color)
      let handle = new THREE.Object3D()
      if (this.props.subType === 'noPull') {
        // console.log('handle', this.props)
        handle = createCylinderHandle(
          this.props.hPosition,
          this.props.orientation,
          this.configs.handleConfig,
          color,
          true,
          materialThreeProps
        )
      } else if (this.props.subType === 'pull') {
        if (this.props.subType2 === 'standard') {
          handle = createCylinderHandle(
            this.props.hPosition,
            this.props.orientation,
            this.configs.handleConfig,
            color,
            false,
            materialThreeProps
          )
        } else if (this.props.subType2 === 'arch') {
          handle = createArchHandle(
            this.props.hPosition,
            this.props.orientation,
            color,
            materialThreeProps
          )
        } else {
          handle = createNewHandle(
            this.props.subType2,
            this.props.hPosition,
            this.props.orientation,
            color,
            materialThreeProps
          )
        }
      } else {
        handle = createNewHandle(
          this.props.subType2 || 'DHK301',
          this.props.hPosition,
          this.props.orientation,
          color,
          materialThreeProps
        )
      }

      handle.name = this.name
      return handle
    } else if (this.props.type === 'leg') {
      if (this.props.subType === 'standard') {
        // const legs = createStandardLegs(this.props.cabinetWidth, this.props.cabinetDepth, this.configs.standardLegConfig)
        const legs = createStandardLegs(
          this.props.height,
          this.props.cabinetWidth,
          this.props.cabinetDepth,
          this.configs.standardLegConfig
        )

        legs.name = 'Standard Legs'
        return legs
      }
    } else if (this.props.type === 'leg2') {
      const legs = createStandard2Legs(
        this.props.subType,
        this.props.height,
        this.props.cabinetWidth,
        this.props.cabinetDepth,
        this.configs.standard2LegConfig
      )

      legs.name =
        'Standard Legs 2 ' + (this.props.subType === 'short' ? 'Short' : 'Tall')
      return legs
    } else if (this.props.type === 'splittedTop') {
      if (texture) {
        texture.repeat.set(
          this.props.sheetWidth / tLength,
          this.props.cabinetWidth / tWidth
        )
        texture.needsUpdate = true
      }

      let isPewterMat = false
      let materials: THREE.Material[] = []

      if (materialId === 76 && material) {
        //Pewter Brush
        if (
          cabinetBoxSheetsNames.includes(this.name) ||
          cabinetShelfSheetsStartNames.some((n) => this.name.includes(n))
        ) {
          const blackMat = new THREE.MeshBasicMaterial({ color: 'black' })
          isPewterMat = true
          materials = [
            blackMat,
            blackMat,
            material,
            material,
            blackMat,
            blackMat,
          ]
        }
      }

      const splittedTop = createSplittedTop(
        this.props.cabinetWidth,
        this.props.cabinetDepth,
        this.props.sheetWidth,
        this.configs.thickness,
        isPewterMat ? materials : material
      )

      splittedTop.name = this.name
      return splittedTop
    } else if (this.props.type === 'separateBase') {
      const platform = createSeparateBasePlatform(
        this.props.width,
        this.props.depth,
        this.props.height,
        texture,
        tLength,
        tWidth,
        this.configs.separateBaseConfig
      )

      platform.name = this.name
      return platform
    } else if (this.props.type === 'cornerHorizontalSheet') {
      let isPewterMat = false

      if (materialId === 76 && material) {
        //Pewter Brush
        isPewterMat = true
      }

      const sheet = createCornerHorizontalSheet(
        this.props.subType,
        this.props.width1,
        this.props.width2,
        this.props.depth1,
        this.props.depth2,
        this.props.backWidth1,
        this.props.backWidth2,
        this.props.thickness,
        false,
        texture,
        tLength,
        tWidth,
        isPewterMat
      )

      sheet.name = this.name
      return sheet
    } else if (
      this.props.type === 'cornerTwoDoor' ||
      this.props.type === 'cornerTwoDoorFivePieces' ||
      this.props.type === 'cornerNewDoor'
    ) {
      // const door = this.props.visualType === 'fivePieces'
      // ? createDoorFivePieces(this.props.subType, this.props.width, this.props.height, this.configs.thickness, texture, tLength, tWidth, this.configs.doorConfig, this.configs.fivePiecesConfig)
      // : createDoorVGroove(this.props.subType, this.props.width, this.props.height, this.configs.thickness, texture, tLength, tWidth, this.configs.doorConfig, this.configs.vGrooveConfig)
      const door = createCornerTwoDoor(
        this.props.visualType,
        this.props.splitters || '',
        this.props.subType,
        this.props.width1,
        this.props.width2,
        this.props.height,
        this.props.thickness,
        texture,
        tLength,
        tWidth,
        this.configs,
        materialThreeProps
      )

      door.name = this.name
      door.userData.type = this.props.subType
      door.userData.isDoor = true

      return door
    } else if (this.props.type === 'cornerOneLeg') {
      const g = createStandard2Leg(
        'short',
        this.props.height,
        this.configs.standard2LegConfig
      )
      g.position.x = this.props.backWidth2 / 2 + 5
      g.position.z = this.props.backWidth1 / 2 + 5
      g.name = this.name
      return g
    } else if (this.props.type === 'cornerLegs') {
      const legs = createCornerLegs(
        this.props.height,
        this.props.width1,
        this.props.width2,
        this.props.depth1,
        this.props.depth2,
        this.props.backWidth1,
        this.props.backWidth2,
        this.props.thickness,
        this.configs.standardLegConfig
      )
      legs.name = 'Corner Standard Legs'

      return legs
    } else if (this.props.type === 'cornerLegs2') {
      const legs = createCornerLegs2(
        this.props.subType,
        this.props.height,
        this.props.width1,
        this.props.width2,
        this.props.depth1,
        this.props.depth2,
        this.props.backWidth1,
        this.props.backWidth2,
        this.props.thickness,
        this.configs.standard2LegConfig
      )
      legs.name =
        'Corner Standard Legs 2 ' +
        (this.props.subType === 'short' ? 'Short' : 'Tall')

      return legs
    }

    return new THREE.Object3D()
  }

  updateHardwareProps = () => {
    for (const link of this.links) {
      let hardware = undefined as undefined | Hardware

      if (link.hId.split('_').length > 1) {
        const ids = link.hId
          .split('_')
          .map((id) => parseInt(id))
          .reverse()

        hardware = this.hardwares.find((h) => h.localId === ids[0])

        for (let i = 1; i < ids.length; i++) {
          hardware = hardware?.children.find((h) => h.localId === ids[i])
        }
      } else {
        const id = parseInt(link.hId)

        hardware = this.hardwares.find((h) => h.localId === id)
      }

      if (hardware) {
        const newProps = { ...hardware.props }

        if (link.hProp.split('_')[0] === 'count') {
          const perCM = link.hProp.split('_')[1] ? link.hProp.split('_')[1] : 1

          for (const key in newProps) {
            if (key.split('_')[0] === 'count') {
              // @ts-ignore
              delete newProps[key]
            }
          }

          // @ts-ignore
          newProps[link.hProp] = {
            // @ts-ignore
            value: Math.floor(this.props[link.itemProp] / perCM),
            extra: 0,
          }
        } else if (link.hProp === 'subType') {
          // @ts-ignore
          newProps[link.hProp] = this.props[link.itemProp]
        } else {
          // @ts-ignore
          newProps[link.hProp].value = this.props[link.itemProp]
        }
        hardware.updateProps(newProps)
      }
    }
  }

  // updateProps = (props: IPropsType, itemsProps: ItemPropsType[]) => {

  //     const item = itemsProps.find(item => item.name === this.name)

  //     if (item) {
  //         item.props = props
  //     }

  //     this.setItemsPropsList(itemsProps)
  //     // this.props = props
  //     // this.object3D = this.generateObject3D()
  //     // this.updateHardwareProps()
  // }

  addChild = (child: Item) => {
    this.children.push(child)
  }

  getPrice = () => {
    let sum = 0

    this.hardwares.forEach((h) => {
      h.calculatePrice()
      sum += h.price
    })

    for (const child of this.children) {
      sum += parseFloat(child.getPrice())
    }

    return (
      (sum + this.addon.dollar) *
      (1 + this.addon.percentage / 100)
    ).toFixed(fractionDigits)
  }

  getClearPrice = () => {
    let sum = 0

    this.hardwares.forEach((h) => {
      h.calculatePrice()
      sum += h.clearPrice
    })

    for (const child of this.children) {
      sum += parseFloat(child.getClearPrice())
    }

    return sum.toFixed(fractionDigits)
  }

  getWeight = () => {
    let sum = 0
    this.hardwares.forEach((h) => {
      h.calculatePrice()
      sum += h.weight
    })
    for (const child of this.children) {
      sum += parseFloat(child.getWeight())
    }
    return sum.toFixed(fractionDigits)
  }

  getNonMarkupPrice = () => {
    let sum = 0

    this.hardwares.forEach((h) => {
      h.calculatePrice()
      sum += h.nonMarkupPrice
    })

    for (const child of this.children) {
      sum += parseFloat(child.getNonMarkupPrice())
    }

    return (
      (sum + this.addon.dollar) *
      (1 + this.addon.percentage / 100)
    ).toFixed(fractionDigits)
  }
}

class Section {
  name: string
  width: number
  height: number
  y: number
  object: THREE.Object3D

  dividersProps: DividerPropsType[]
  dividers: DividerType[] = []

  sections: Section[] = []

  thickness: number
  // setSectionProps: (props: SectionProps) => void

  constructor(
    name: string,
    width: number,
    height: number,
    y: number,
    dividerProps: DividerPropsType[] = [],
    thickness: number
  ) {
    this.name = name
    this.width = width
    this.height = height
    this.y = y
    this.thickness = thickness

    this.dividersProps = dividerProps.sort((a, b) => a.top - b.top) //sort by top

    // this.setSectionProps = setSectionProps

    this.object = createSection(width, height)
    this.object.userData.type = 'section'
    this.object.name = name
    this.object.position.y = y
    // mesh.name = this.name

    this.splitSections()
    this.makeDividers()
    // if (dividerProps) {
    //     this.divider = this.setDivider(dividerProps.type, dividerProps.top)

    //     // if (this.divider){
    //     //     this.sc.add(this.divider.object)

    //     // }

    //     // this.splitSection()
    // }
  }

  makeDividers = () => {
    for (let i = 0; i < this.dividersProps.length; i++) {
      if (this.dividersProps[i].type === 'none')
        this.dividers.push({
          type: 'none',
          top: this.dividersProps[i].top,
          object: createDivider(this.width),
          uuid: this.dividersProps[i].uuid,
        })
      else
        this.dividers.push({
          type: 'visible',
          top: this.dividersProps[i].top,
          object: createDivider(this.width, this.thickness),
          uuid: this.dividersProps[i].uuid,
        })
    }

    for (let i = 0; i < this.dividers.length; i++) {
      this.dividers[i].object.name =
        (this.dividers[i].type === 'visible' ? 'v' : '') + `divider_${i + 1}` //_${i + 2}`
      this.dividers[i].object.position.y =
        this.height / 2 - this.dividers[i].top
    }
  }

  // setDivider = (type: 'none' | 'visible', top: number) => {

  //     if (this.dividerProps) {
  //         const s1Props = this.dividerProps.sections.s1
  //         const s2Props = this.dividerProps.sections.s2

  //         const divider = {
  //             type,
  //             top,
  //             object: createDivider(this.width),
  //             sections: {
  //                 s1: new Section(s1Props.name, s1Props.width, s1Props.height, s1Props.y, s1Props.dividerProps, this.setSectionProps),
  //                 s2: new Section(s2Props.name, s2Props.width, s2Props.height, s2Props.y, s2Props.dividerProps, this.setSectionProps),
  //             }
  //         }

  //         divider.object.name = this.name + '_divider'
  //         divider.object.position.y = this.y + this.height / 2 - top//this.height / 2 - top
  //         divider.object.position.z += .01

  //         // divider.sections.s1.object.position.z = this.object.position.z
  //         // divider.sections.s2.object.position.z = this.object.position.z

  //         // divider.sections.s1.object.position.y = this.object.position.y + this.height / 2 - divider.sections.s1.height / 2
  //         // divider.sections.s2.object.position.y = divider.sections.s1.object.position.y - divider.sections.s2.height / 2 - divider.sections.s1.height / 2

  //         return divider
  //     }

  // }

  splitSections = () => {
    // const tops = this.dividersProps.map(d => d.top)

    if (this.dividersProps.length > 0) {
      //Calculating sections heights
      const sHeights = [
        this.dividersProps[0].type === 'none'
          ? this.dividersProps[0].top
          : this.dividersProps[0].top - this.thickness / 2,
      ]

      for (let i = 1; i < this.dividersProps.length; i++) {
        const div = this.dividersProps[i]
        const prevDiv = this.dividersProps[i - 1]

        sHeights.push(
          (div.type === 'none' ? div.top : div.top - this.thickness / 2) -
            (prevDiv.type === 'none'
              ? prevDiv.top
              : prevDiv.top + this.thickness / 2)
        )

        // sHeights.push(tops[i] - tops[i - 1])
      }

      sHeights.push(
        this.height -
          (this.dividersProps[this.dividersProps.length - 1].type === 'none'
            ? this.dividersProps[this.dividersProps.length - 1].top
            : this.dividersProps[this.dividersProps.length - 1].top +
              this.thickness / 2)
      )

      //Calculating sections position
      let sYs = [sHeights[0] / 2]

      for (let i = 1; i < this.dividersProps.length; i++) {
        sYs.push(
          (this.dividersProps[i - 1].type === 'none'
            ? this.dividersProps[i - 1].top
            : this.dividersProps[i - 1].top + this.thickness / 2) +
            sHeights[i] / 2
        )
      }

      sYs.push(
        (this.dividersProps[this.dividersProps.length - 1].type === 'none'
          ? this.dividersProps[this.dividersProps.length - 1].top
          : this.dividersProps[this.dividersProps.length - 1].top +
            this.thickness / 2) +
          sHeights[sHeights.length - 1] / 2
      )

      sYs = sYs.map((y) => this.height / 2 - y)

      for (let i = 0; i < sHeights.length; i++) {
        this.sections.push(
          new Section(
            'section_' + (i + 1),
            this.width,
            sHeights[i],
            sYs[i],
            undefined,
            this.thickness
          )
        )
      }
    }
  }

  hideSection = (sectionNumber: number) => {
    let obj
    if (sectionNumber === 1 && this.sections.length === 0) obj = this.object
    else
      obj = this.sections.find(
        (s) => s.name.split('_')[1] === sectionNumber.toString()
      )?.object

    // @ts-ignore
    obj.material.opacity = 0
    // @ts-ignore
    obj.material.userData.hidden = true
  }

  showSection = (sectionNumber: number) => {
    let obj
    if (sectionNumber === 1 && this.sections.length === 1) obj = this.object
    else
      obj = this.sections.find(
        (s) => s.name.split('_')[1] === sectionNumber.toString()
      )?.object

    // @ts-ignore
    obj.material.opacity = 0.6
    // @ts-ignore
    obj.material.userData.hidden = false
  }
}

class Material {
  id: number
  name: string
  weight: number
  price: number
  addon: number

  texture: THREE.Texture
  tLength: number
  tWidth: number

  threeProps: string

  constructor(
    id: number,
    name: string,
    weight: number,
    price: number,
    addon: number,
    texture: THREE.Texture = new THREE.Texture(),
    tLength: number = 1,
    tWidth: number = 1,
    threeProps = ''
  ) {
    this.id = id
    this.name = name
    this.weight = weight
    this.price = price
    this.addon = addon

    texture.wrapS = THREE.RepeatWrapping
    texture.wrapT = THREE.RepeatWrapping
    texture.repeat.set(2, 1)

    this.texture = texture
    this.tLength = tLength
    this.tWidth = tWidth

    this.threeProps = threeProps
  }

  // getTexture = async () => {
  //     const textureLoader = new TextureLoader()
  //     // textureLoader.crossOrigin = "Anonymous"
  //     return await textureLoader.load(this.texture)
  // }
}

const loadMaterialTextures = async (materialsProps: MaterialAPIType[]) => {
  const materials = [] as MaterialType[]

  for (const mProps of materialsProps) {
    const getTexture = () =>
      new Promise<THREE.Texture | undefined>((resolve, reject) => {
        if (mProps.texture) {
          const manager = new THREE.LoadingManager()
          const loader = new THREE.TextureLoader(manager)
          const texture = loader.load(
            import.meta.env.BASE_URL + '/textures/' + mProps.texture
          )
          //  var texture_1 = loader.load(env.CABINET_TEXTURES_PATH + mProps.texture);
          manager.onLoad = () => {
            let colorText = mProps.description.split('}')[0]

            if (mProps.description.includes('}') && colorText[0] === '{') {
              colorText = colorText.slice(1).trim()
              texture.name = 'color||' + colorText
            }

            resolve(texture)
          }
        } else resolve(undefined)
      })

    const texture = await getTexture()

    materials.push({
      ...mProps,
      texture: {
        url: mProps.texture,
        texture,
      },
    })
  }

  return materials
}

export default class Cabinet {
  type: CabinetType

  hardwaresList: HardwareType[]
  materialsList: MaterialType[] = []
  materialGroups: MaterialGroupType[] = []
  markupsList: MarkupType[]

  itemsPropsList: ItemPropsType[]
  defaultItemsProps: ItemPropsType[]

  cabinetProps = {
    width: 0,
    height: 0,
    depth: 0,
    legHeight: 0,
    sectionProps: {
      name: 'section',
      width: 0,
      height: 0,
      y: 0,
      dividersProps: [],
      doorsProps: [],
      drawersProps: [],
      shelvesProps: [],
    },
  } as CabinetProps

  cornerCabinetProps = {
    type: 'angled',
    height: 0,
    width1: 0,
    width2: 0,
    depth1: 0,
    depth2: 0,
    backWidth1: 0,
    backWidth2: 0,
    legHeight: 0,
    thickness: 0,
    sectionProps: {
      name: 'section',
      width: 0,
      height: 0,
      y: 0,
      dividersProps: [],
      doorsProps: [],
      drawersProps: [],
      shelvesProps: [],
    },
  } as CornerCabinetProps

  isCorner = false

  splittedTop: boolean
  doorVisualType: DoorVisualType
  legProps: LegPropsType
  drawerSlideType: DrawerSlideType = 'standard'
  baseLegCut: number
  sectionLocks: SectionLock[]
  modifiableSection = -1

  items = [] as Item[]
  section: Section

  object = new THREE.Group()

  cabinetSheetHardwareId = 0
  panelSheetHardwareId = 0
  cabinetSheetDefaultMaterialId = 0
  panelSheetDefaultMaterialId = 0

  categoryId = undefined as string | undefined
  microvellumName = undefined as string | undefined

  configs: ConfigsType
  thickness: number

  addonD = 0
  addonP = 0

  forOffice = false

  makeRender: () => void

  constructor(
    type: CabinetType,
    hardwaresList: HardwareType[],
    materialsProps: MaterialAPIType[],
    materialGroups: MaterialGroupType[],
    markupsList: MarkupType[],
    itemsPropsList: ItemPropsType[],
    defaultItemsProps: ItemPropsType[],
    splittedTop: boolean,
    doorVisualType: DoorVisualType,
    legProps: LegPropsType,
    sectionLocks: SectionLock[],
    configs: ConfigsType,
    makeRender: () => void,
    forOffice = false
  ) {
    this.makeRender = makeRender

    this.type = type
    this.configs = configs
    this.thickness = configs.thickness

    this.hardwaresList = hardwaresList
    this.materialGroups = materialGroups
    this.markupsList = markupsList
    this.itemsPropsList = itemsPropsList
    this.defaultItemsProps = defaultItemsProps

    this.splittedTop = splittedTop
    this.doorVisualType = doorVisualType
    this.legProps = legProps
    this.baseLegCut = this.configs.baseLegConfig.cutLength
    this.sectionLocks = sectionLocks

    this.forOffice = forOffice

    this.section = new Section('section', 0, 0, 0, undefined, this.thickness)

    this.object.name = 'Cabinet'

    loadMaterialTextures(materialsProps).then((materials) => {
      this.materialsList = materials

      this.setStartValues()

      this.visualizeItems()
      this.visualizeCabinetProps()

      this.setMaterialChangeableHardwareIds()
    })

    // this.materialsList = materialsProps;
    // this.setStartValues();
    // this.visualizeItems();
    // this.visualizeCabinetProps();
    // this.setMaterialChangeableHardwareIds();
  }

  getSectionHeightFromName = (name_: string, sectionNumber: string) => {
    const [_name, microvellumName] = name_.split('#')
    const [name, categoryId] = _name.split('$')
    const props = name.split('|')

    const dividerProps =
      props[3] === ''
        ? []
        : (props[3].split(';').map((d) => ({
            type: d[0] === 't' ? 'visible' : 'none',
            top: parseFloat(d.slice(1)),
            uuid: THREE.MathUtils.generateUUID(),
          })) as DividerPropsType[])

    const actualDividers = dividerProps.sort((a, b) => a.top - b.top)

    const isCorner = name[0] !== '0'
    const cabinetHeight = isCorner
      ? props[2].split(';').map((v) => parseFloat(v))[0]
      : props[2].split(';').map((v) => parseFloat(v))[1]

    let sectionsHeights: number[] = []

    if (actualDividers.length === 0) {
      const sectionHeight = cabinetHeight - this.thickness * 2

      sectionsHeights = [sectionHeight]
    } else if (actualDividers.length === 1) {
      const section1TopY = cabinetHeight / 2 - this.thickness
      const section2TopY =
        section1TopY -
        (actualDividers[0].type === 'none'
          ? actualDividers[0].top
          : actualDividers[0].top + this.thickness / 2)

      const section1Height =
        actualDividers[0].type === 'none'
          ? actualDividers[0].top
          : actualDividers[0].top - this.thickness / 2
      const section2Height =
        cabinetHeight -
        section1Height -
        this.thickness * 2 -
        (actualDividers[0].type === 'none' ? 0 : this.thickness)

      sectionsHeights = [section1Height, section2Height]
    } else {
      const section1Height =
        actualDividers[0].type === 'none'
          ? actualDividers[0].top
          : actualDividers[0].top - this.thickness / 2

      sectionsHeights.push(section1Height)

      for (let i = 1; i < actualDividers.length; i++) {
        const sectionHeight =
          actualDividers[i].top -
          actualDividers[i - 1].top -
          (actualDividers[i].type === 'none' ? 0 : 0.5 * this.thickness) -
          (actualDividers[i - 1].type === 'none' ? 0 : 0.5 * this.thickness)

        sectionsHeights.push(sectionHeight)
      }

      const lastSectionHeight =
        cabinetHeight -
        this.thickness * 2 -
        (actualDividers[actualDividers.length - 1].type === 'none'
          ? actualDividers[actualDividers.length - 1].top
          : actualDividers[actualDividers.length - 1].top + this.thickness / 2)

      sectionsHeights.push(lastSectionHeight)
    }

    return sectionsHeights[parseFloat(sectionNumber) - 1]
  }

  getDoorPropsFromNamePiece = (doorName: string) => {
    let [d, _visualType] = doorName.split('%')

    _visualType = _visualType ? _visualType : '0'

    let visualType: DoorVisualType = 'vGroove'
    let splitters = ''

    if (_visualType[0] === '1') {
      visualType = 'fivePieces'
      const [_, __, _splitters] = _visualType.split(':')
      splitters = _splitters || ''
    } else if (_visualType[0] === '2') {
      const [_, newDoorType, _splitters] = _visualType.split(':')

      let newDoorTypeIndex = parseInt(newDoorType)
      newDoorTypeIndex =
        isNaN(newDoorTypeIndex) || newDoorTypeIndex > 13 ? 0 : newDoorTypeIndex
      visualType = newDoorVisualTypeValues[newDoorTypeIndex]

      splitters = _splitters || ''
    }

    const { type: handleType, subType: handleSubType } =
      this.getHandleTypesFromName(d.split('_')[3] || '')

    const handleOrientation =
      d.split('_').length >= 5
        ? d.split('_')[4] === 'h'
          ? 'horizontal'
          : 'vertical'
        : 'vertical'

    let [handlePosY, handlePosX] = d.split('_')[2].split(',')

    if (!handlePosX) {
      handlePosX =
        d.split('_')[0] === 'l' ? 'r' : d.split('_')[0] === 'r' ? 'l' : 'c'
    }

    return {
      type:
        d.split('_')[0] === 'l'
          ? 'left'
          : d.split('_')[0] === 'r'
            ? 'right'
            : d.split('_')[0] === 'd'
              ? 'double'
              : 'liftUp',
      visualType,
      normalMapSplitter: splitters,
      sectionNumber: parseInt(d.split('_')[1]),
      sectionHeight: 0,
      sectionY: 0,
      handleProps: {
        type: handleType,
        subtype: handleSubType,
        position:
          handlePosY[0] === 't'
            ? 'top'
            : handlePosY[0] === 'c'
              ? 'center'
              : handlePosY[0] === 'b'
                ? 'bottom'
                : handlePosY[0] === 'f'
                  ? 'fromGround'
                  : (parseFloat(handlePosY) as HandlePropsType['position']),
        positionFromGroundValue:
          handlePosY[0] === 'f' && handlePosY.length > 1
            ? parseFloat(handlePosY.slice(1))
            : undefined,
        positionX:
          handlePosX[0] === 'l'
            ? 'left'
            : handlePosX[0] === 'c'
              ? 'center'
              : handlePosX[0] === 'r'
                ? 'right'
                : (parseFloat(handlePosX) as HandlePropsType['positionX']),
        orientation: handleOrientation,
      } as HandlePropsType,
      uuid: THREE.MathUtils.generateUUID(),
    }
  }

  getCabinetWidthFromName = (name: string) => {
    const props = name.split('|')

    const isCorner = props[0] !== '0'

    if (isCorner) {
      const [h, w1, w2, d1, d2, bw1, bw2] = props[2]
        .split(';')
        .map((v) => parseFloat(v))

      return calculateCornerSectionSize(w1, w2, d1, d2, this.configs.thickness)
    } else {
      const [w] = props[2].split(';')
      return parseFloat(w)
    }
  }

  getCabinetHeightsFromName = (name: string) => {
    const props = name.split('|')

    const isCorner = props[0] !== '0'

    let cabHeight = 0
    let legHeight = parseFloat(props[10]) || 0

    if (isCorner) {
      const [h] = props[2].split(';').map((v) => parseFloat(v))

      cabHeight = h
    } else {
      const [w, h] = props[2].split(';')
      cabHeight = parseFloat(h)
    }

    return { cabHeight, legHeight }
  }

  validateCabinetNameForPullPositions = (name: string) => {
    const props = name.split('|')

    const doorsProps = props[4]

    const cabinetWidth = parseFloat(props[2].split(';')[0])

    if (doorsProps) {
      let result = ''

      for (const d of doorsProps.split(';')) {
        const _doorProps = d.split('_')
        const sectionNumber = _doorProps[1]
        const sectionHeight = this.getSectionHeightFromName(name, sectionNumber)

        const props = this.getDoorPropsFromNamePiece(d)
        const cabWidth = this.getCabinetWidthFromName(name)
        const { cabHeight, legHeight } = this.getCabinetHeightsFromName(name)

        const res = this.getDoorHandlePositions(
          props as DoorPropsType,
          cabWidth,
          cabHeight,
          legHeight,
          sectionHeight,
          this.configs.doorConfig,
          this.configs.handleConfig
        )

        _doorProps[2] = res.y + ',' + res.x

        result += _doorProps.join('_') + ';'
      }

      props[4] = result.slice(0, result.length - 1)
    }
    return props.join('|')
  }

  validateCabinetName = (name: string) => {
    //0|t|150;191;60.4|t25.95;t126.91;f147.00;f167.10|d_2_c|3;4;5|2_3|2|0_0|0|0|1_10
    const sectionsRightCount = 12
    const props = name.split('|')

    const neededSectionsCount = sectionsRightCount - props.length

    for (let i = 0; i < neededSectionsCount; i++) {
      props.push('')
    }

    const doorsProps = props[4]

    const cabWidth = this.getCabinetWidthFromName(name)

    if (doorsProps) {
      let result = ''

      for (const d of doorsProps.split(';')) {
        const _doorProps = d.split('_')
        const sectionNumber = _doorProps[1]
        const sectionHeight = this.getSectionHeightFromName(name, sectionNumber)

        const props = this.getDoorPropsFromNamePiece(d)
        const { cabHeight, legHeight } = this.getCabinetHeightsFromName(name)

        const res = this.getDoorHandlePositions(
          props as DoorPropsType,
          cabWidth,
          cabHeight,
          legHeight,
          sectionHeight,
          this.configs.doorConfig,
          this.configs.handleConfig
        )

        _doorProps[2] = res.y + ',' + res.x

        result += _doorProps.join('_') + ';'
      }

      props[4] = result.slice(0, result.length - 1)
    }

    if (props[7] === '') {
      //non locked section number default - 1
      props[7] =
        '0' +
        (props[3].split(';').length > 0 ? ';' : '') +
        props[3]
          .split(';')
          .map((d) => '0')
          .join(';')
    }

    if (props[7].length === 1) {
      const modifiableSection = props[7]
      props[7] = modifiableSection === '1' ? '*0' : '0'

      const dividersCount = props[3] === '' ? 0 : props[3].split(';').length
      if (dividersCount > 0) {
        for (let i = 2; i < dividersCount + 2; i++) {
          props[7] += ';' + (i.toString() === modifiableSection ? '*0' : '0')
        }
      }
    }

    if (props[8] === '') {
      //materials ids
      props[8] = '0_0'
    }

    if (props[9] === '') {
      // leg type
      props[9] = '0'
    }

    if (props[10] === '') {
      //leg height
      props[10] = props[1].startsWith('u') ? '0' : '12'
    }

    if (props[11] === '') {
      // addons
      props[11] = '0_0'
    }

    return props.join('|')
  }

  updatesPropsFromString = (_props: string) => {
    const [_name, microvellumName] = _props.split('#')
    const [name, categoryId] = _name.split('$')
    const props = this.validateCabinetName(name).split('|')
    // if (props.length === 9 || props.length === 11) {
    this.isCorner = props[0] === '0' ? false : true
    this.type =
      props[1] === 'u'
        ? 'upper'
        : props[1] === 'uo'
          ? 'upperOpen'
          : props[1] === 'b'
            ? 'base'
            : 'tall'
    this.splittedTop = this.type === 'base'

    const dividerProps =
      props[3] === ''
        ? []
        : (props[3].split(';').map((d) => ({
            type: d[0] === 't' ? 'visible' : 'none',
            top: parseFloat(d.slice(1)),
            uuid: THREE.MathUtils.generateUUID(),
          })) as DividerPropsType[])

    const doorsProps =
      props[4] === ''
        ? []
        : (props[4].split(';').map((door) => {
            let [d, _visualType] = door.split('%')

            _visualType = _visualType ? _visualType : '0'

            let visualType: DoorVisualType = 'vGroove'
            let splitters = ''

            if (_visualType[0] === '1') {
              visualType = 'fivePieces'
              const [_, __, _splitters] = _visualType.split(':')
              splitters = _splitters || ''
            } else if (_visualType[0] === '2') {
              const [_, newDoorType, _splitters] = _visualType.split(':')

              let newDoorTypeIndex = parseInt(newDoorType)
              newDoorTypeIndex =
                isNaN(newDoorTypeIndex) || newDoorTypeIndex > 13
                  ? 0
                  : newDoorTypeIndex
              visualType = newDoorVisualTypeValues[newDoorTypeIndex]

              splitters = _splitters || ''
            } else if (_visualType[0] === '3') {
              const [_, direction] = _visualType.split(':')

              visualType = direction === '0' ? 'shaker_h' : 'shaker_v'
            }

            const { type: handleType, subType: handleSubType } =
              this.getHandleTypesFromName(d.split('_')[3] || '')

            let handleOrientation: HandleOrientationType = 'vertical'

            if (d.split('_')[0] === 'lu') {
              handleOrientation =
                d.split('_').length >= 5
                  ? d.split('_')[4] === 'd'
                    ? 'double_horizontal'
                    : 'horizontal'
                  : 'horizontal'
            } else {
              handleOrientation =
                d.split('_').length >= 5
                  ? d.split('_')[4] === 'h'
                    ? 'horizontal'
                    : 'vertical'
                  : 'vertical'
            }

            let [handlePosY, handlePosX] = d.split('_')[2].split(',')

            if (!handlePosX) {
              handlePosX =
                d.split('_')[0] === 'l'
                  ? 'r'
                  : d.split('_')[0] === 'r'
                    ? 'l'
                    : 'c'
            }

            return {
              type:
                d.split('_')[0] === 'l'
                  ? 'left'
                  : d.split('_')[0] === 'r'
                    ? 'right'
                    : d.split('_')[0] === 'd'
                      ? 'double'
                      : 'liftUp',
              visualType,
              normalMapSplitter: splitters,
              sectionNumber: parseInt(d.split('_')[1]),
              sectionHeight: 0,
              sectionY: 0,
              handleProps: {
                type: handleType,
                subtype: handleSubType,
                position:
                  handlePosY[0] === 't'
                    ? 'top'
                    : handlePosY[0] === 'c'
                      ? 'center'
                      : handlePosY[0] === 'b'
                        ? 'bottom'
                        : handlePosY[0] === 'f'
                          ? 'fromGround'
                          : (parseFloat(
                              handlePosY
                            ) as HandlePropsType['position']),
                positionFromGroundValue:
                  handlePosY[0] === 'f' && handlePosY.length > 1
                    ? parseFloat(handlePosY.slice(1)) > 0
                      ? parseFloat(handlePosY.slice(1))
                      : undefined
                    : undefined,
                positionX:
                  handlePosX[0] === 'l'
                    ? 'left'
                    : handlePosX[0] === 'c'
                      ? 'center'
                      : handlePosX[0] === 'r'
                        ? 'right'
                        : (parseFloat(
                            handlePosX
                          ) as HandlePropsType['positionX']),
                orientation: handleOrientation,
              } as HandlePropsType,
              uuid: THREE.MathUtils.generateUUID(),
            }
          }) as DoorPropsType[])

    let drawerSlideType: DrawerSlideType = 'standard'

    const [drawerPropsStr, drawerSlideStr] = props[5].split('@')

    drawerSlideType =
      drawerSlideStr === '2'
        ? 'under_mount'
        : drawerSlideStr === '1'
          ? 'soft'
          : 'standard'

    this.drawerSlideType = drawerSlideType

    const drawersProps =
      drawerPropsStr === ''
        ? []
        : (drawerPropsStr.split(';').map((drawer) => {
            let [d, _visualType] = drawer.split('%')

            _visualType = _visualType ? _visualType : '0'

            let visualType: DrawerVisualType = 'standard'

            if (_visualType[0] === '1') {
              visualType = 'fivePieces'
            } else if (_visualType[0] === '2') {
              const [_, newDoorType] = _visualType.split(':')

              let newDoorTypeIndex = parseInt(newDoorType)
              newDoorTypeIndex =
                isNaN(newDoorTypeIndex) || newDoorTypeIndex > 13
                  ? 0
                  : newDoorTypeIndex
              visualType = newDoorVisualTypeValues[newDoorTypeIndex]
            } else if (_visualType[0] === '3') {
              const [_, direction] = _visualType.split(':')
              visualType = direction === '0' ? 'shaker_h' : 'shaker_v'
            }

            const { type: handleType, subType: handleSubType } =
              this.getHandleTypesFromName(d.split('_')[1] || '')

            const handleOrientation: HandleOrientationType =
              d.split('_').length >= 3
                ? d.split('_')[3] === 'd'
                  ? 'double_horizontal'
                  : 'horizontal'
                : 'horizontal'

            let [handlePosY, handlePosX] =
              d.split('_').length > 2 ? d.split('_')[2].split(',') : ['', '']

            if (!handlePosY) handlePosY = 't'

            if (!handlePosX) handlePosX = 'c'

            return {
              sectionNumber: parseInt(d.split('_')[0]),
              sectionHeight: 0,
              sectionY: 0,
              visualType,
              handleProps: {
                type: handleType,
                subtype: handleSubType,
                orientation: handleOrientation,
                position:
                  handlePosY[0] === 't'
                    ? 'forDrawer'
                    : handlePosY[0] === 'c'
                      ? 'forDrawerCenter'
                      : parseFloat(handlePosY),
                positionX:
                  handlePosX[0] === 'l'
                    ? 'left'
                    : handlePosX[0] === 'c'
                      ? 'center'
                      : handlePosX[0] === 'r'
                        ? 'right'
                        : parseFloat(handlePosX),
              } as HandlePropsType,
              uuid: THREE.MathUtils.generateUUID(),
            }
          }) as DrawerPropsType[])

    const shelvesProps =
      props[6] === ''
        ? []
        : (props[6].split(';').map((d) => ({
            sectionNumber: parseInt(d.split('_')[0]),
            count: parseInt(d.split('_')[1]),
            sectionHeight: 0,
            sectionY: 0,
          })) as ShelvesPropsType[])

    const sectionLocks = [] as SectionLock[]

    const sectionsInfo = props[7].split(';')
    this.modifiableSection = -1

    for (let i = 0; i < sectionsInfo.length; i++) {
      if (sectionsInfo[i][0] === '*') {
        this.modifiableSection = i + 1
        sectionLocks.push({
          number: i + 1,
          isLock: sectionsInfo[i][1] === '1' ? true : false,
        })
      } else {
        sectionLocks.push({
          number: i + 1,
          isLock: sectionsInfo[i][0] === '1' ? true : false,
        })
      }
    }

    this.cabinetProps.legHeight = 0
    this.cornerCabinetProps.legHeight = 0

    let baseLegCut = this.configs.baseLegConfig.cutLength

    this.legProps = {
      on: true,
      type: props[9].startsWith('0')
        ? 'base'
        : props[9] === '1'
          ? 'noToeKick'
          : props[9] === '2'
            ? 'standard'
            : props[9] === '4_1'
              ? 'standard2_1'
              : props[9] === '4_2'
                ? 'standard2_2'
                : props[9] === '9'
                  ? 'noLeg'
                  : 'separateBase',
    }
    this.cabinetProps.legHeight = parseFloat(props[10])
    this.cornerCabinetProps.legHeight = parseFloat(props[10])

    if (this.legProps.type === 'base') {
      const [_, cutLength, _subType, islandSubtype] = props[9].split('_')
      baseLegCut = cutLength ? parseFloat(cutLength) : baseLegCut

      const [subType, baseSubtype] = (_subType || '').split(':')

      this.legProps.baseSubType = baseSubtype === '1' ? 'old' : 'new'

      if (subType === '1') {
        this.legProps.type = 'baseIsland'
      } else if (subType === '2') {
        this.legProps.type = 'baseIsland2'
      }

      if (islandSubtype === '0') {
        this.legProps.subType = 'cornerLeft'
      } else if (islandSubtype === '1') {
        this.legProps.subType = 'cornerRight'
      }
    }
    this.baseLegCut = baseLegCut

    this.legProps.on = this.type.startsWith('upper') ? false : true

    this.sectionLocks = sectionLocks

    if (!this.isCorner) {
      const [w, h, d] = props[2].split(';').map((v) => parseFloat(v))
      this.cabinetProps.width = w
      this.cabinetProps.height = h
      this.cabinetProps.depth = d
      this.cabinetProps.sectionProps.dividersProps = dividerProps
    } else {
      const type = props[0] === '1' ? 'angled' : '2door'
      const [h, w1, w2, d1, d2, bw1, bw2] = props[2]
        .split(';')
        .map((v) => parseFloat(v))

      this.cornerCabinetProps = {
        ...this.cornerCabinetProps,
        type,
        height: h,
        width1: w1,
        width2: w2,
        depth1: d1,
        depth2: d2,
        backWidth1: bw1,
        backWidth2: bw2,
        thickness: this.configs.thickness,
      }
      this.cornerCabinetProps.sectionProps.dividersProps = dividerProps
    }

    const [addonD, addonP] = props[11].split('_').map((n) => parseFloat(n))
    this.addonD = addonD
    this.addonP = addonP

    this.recalculateAllShelvesAndDoorsPositions(
      clone(dividerProps).sort((a, b) => a.top - b.top),
      !this.isCorner
        ? this.cabinetProps.height
        : this.cornerCabinetProps.height,
      shelvesProps,
      doorsProps,
      drawersProps
    )

    this.visualizeItems()
    this.visualizeCabinetProps()

    const [cMatId, dMatId] = props[8].split('_').map((v) => parseFloat(v))

    if (cMatId !== 0) this.setMaterialId(cMatId)

    if (dMatId) this.setMaterialId(dMatId, false)

    this.categoryId = categoryId
    this.microvellumName = microvellumName

    this.makeRender()
    // }
  }

  loadCabinetFromLS = () => {
    const cabinet = localStorage.getItem('cabinet')
      ? JSON.parse(localStorage.getItem('cabinet') || '')
      : undefined

    if (cabinet) {
      this.loadCabinet(cabinet.name, JSON.parse(cabinet.additional))
    }
  }

  loadCabinet = (
    name: string,
    additional: { hardwareProps: any[]; links: any[] } = {
      hardwareProps: [],
      links: [],
    }
  ) => {
    this.deleteCabinetFromScene()
    this.itemsPropsList = clone(this.defaultItemsProps)

    this.updatesPropsFromString(name)

    const addItionalItem = this.itemsPropsList.find(
      (i) => i.name === 'Additional Item'
    )

    if (addItionalItem) {
      addItionalItem.hardwaresProps = additional.hardwareProps
      addItionalItem.links = additional.links
    }

    this.visualizeItems()
    this.visualizeCabinetProps()
  }

  exportCabinet = () => {
    const addItionalItem = this.itemsPropsList.find(
      (i) => i.name === 'Additional Item'
    )

    return {
      name: this.exportCabinetName(),
      additional: JSON.stringify({
        hardwareProps: addItionalItem ? addItionalItem.hardwaresProps : [],
        links: addItionalItem ? addItionalItem.links : [],
      }),
    }
  }

  _exportCabinet = () => {
    let isDefault = true
    let reason = ''

    const itemsList = this.itemsPropsList.filter((i) => i.render)

    const vGrooveOneItem = this.defaultItemsProps.find(
      (props) => props.name === 'vGrooveOne'
    )
    const vGrooveTwoItem = this.defaultItemsProps.find(
      (props) => props.name === 'vGrooveTwo'
    )
    const fivePiecesOneItem = this.defaultItemsProps.find(
      (props) => props.name === 'fivePiecesOne'
    )
    const fivePiecesTwoItem = this.defaultItemsProps.find(
      (props) => props.name === 'fivePiecesTwo'
    )
    const handleItem = this.defaultItemsProps.find(
      (props) => props.name === 'handle'
    )
    const drawerItem = this.defaultItemsProps.find(
      (props) => props.name === 'drawer'
    )
    const legsItem = this.defaultItemsProps.find(
      (props) => props.name === 'legs'
    )
    const sheetItem = this.defaultItemsProps.find(
      (props) => props.name === 'shelf'
    )
    const separateBaseItem = this.defaultItemsProps.find(
      (props) => props.props.type === 'separateBase'
    )
    const shelfItem = this.defaultItemsProps.find(
      (props) => props.name === 'shelf'
    )
    const fixedShelfItem = this.defaultItemsProps.find(
      (props) => props.name === 'fixed'
    )

    for (const iProps of itemsList) {
      if (iProps.props.type === 'door') {
        if (iProps.props.visualType === 'vGroove') {
          if (iProps.props.subType === 'double') {
            if (
              JSON.stringify(
                iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
              ) !==
              JSON.stringify(
                vGrooveTwoItem?.hardwaresProps.sort(
                  (a, b) => a.localId - b.localId
                )
              )
            ) {
              isDefault = false
              reason = 'vGroove double door hardware props'
              break
            }

            if (
              JSON.stringify(iProps.links) !==
              JSON.stringify(vGrooveTwoItem?.links)
            ) {
              isDefault = false
              reason = 'vGroove double door links'
              break
            }

            if (
              !(
                JSON.stringify(iProps.childrenProps[0].hardwaresProps) ===
                  JSON.stringify(handleItem?.hardwaresProps) &&
                JSON.stringify(iProps.childrenProps[1].hardwaresProps) ===
                  JSON.stringify(handleItem?.hardwaresProps)
              )
            ) {
              isDefault = false
              reason = 'vGroove double door children hardware props'
              break
            }

            if (
              !(
                JSON.stringify(iProps.childrenProps[0].links) ===
                  JSON.stringify(handleItem?.links) &&
                JSON.stringify(iProps.childrenProps[1].links) ===
                  JSON.stringify(handleItem?.links)
              )
            ) {
              isDefault = false
              reason = 'vGroove double door children links'
              break
            }
          } else {
            if (
              JSON.stringify(
                iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
              ) !==
              JSON.stringify(
                vGrooveOneItem?.hardwaresProps.sort(
                  (a, b) => a.localId - b.localId
                )
              )
            ) {
              isDefault = false
              reason = 'vGroove one door hardware props'
              break
            }

            if (
              JSON.stringify(iProps.links) !==
              JSON.stringify(vGrooveOneItem?.links)
            ) {
              isDefault = false
              reason = 'vGroove one door links'
              break
            }

            if (
              JSON.stringify(iProps.childrenProps[0].hardwaresProps) !==
              JSON.stringify(handleItem?.hardwaresProps)
            ) {
              isDefault = false
              reason = 'vGroove one door children hardware props'
              break
            }

            if (
              JSON.stringify(iProps.childrenProps[0].links) !==
              JSON.stringify(handleItem?.links)
            ) {
              isDefault = false
              reason = 'vGroove one door children links'
              break
            }
          }
        } else {
          if (iProps.props.subType === 'double') {
            if (
              JSON.stringify(
                iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
              ) !==
              JSON.stringify(
                fivePiecesTwoItem?.hardwaresProps.sort(
                  (a, b) => a.localId - b.localId
                )
              )
            ) {
              isDefault = false
              reason = 'fivePieces double door hardware props'
              break
            }

            if (
              JSON.stringify(iProps.links) !==
              JSON.stringify(fivePiecesTwoItem?.links)
            ) {
              isDefault = false
              reason = 'fivePieces double door links'
              break
            }

            if (
              !(
                JSON.stringify(iProps.childrenProps[0].hardwaresProps) ===
                  JSON.stringify(handleItem?.hardwaresProps) &&
                JSON.stringify(iProps.childrenProps[1].hardwaresProps) ===
                  JSON.stringify(handleItem?.hardwaresProps)
              )
            ) {
              isDefault = false
              reason = 'fivePieces double door children hardware props'
              break
            }

            if (
              !(
                JSON.stringify(iProps.childrenProps[0].links) ===
                  JSON.stringify(handleItem?.links) &&
                JSON.stringify(iProps.childrenProps[1].links) ===
                  JSON.stringify(handleItem?.links)
              )
            ) {
              isDefault = false
              reason = 'fivePieces double door children links'
              break
            }
          } else {
            if (
              JSON.stringify(
                iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
              ) !==
              JSON.stringify(
                fivePiecesOneItem?.hardwaresProps.sort(
                  (a, b) => a.localId - b.localId
                )
              )
            ) {
              isDefault = false
              reason = 'fivePieces one door hardware props'
              break
            }

            if (
              JSON.stringify(iProps.links) !==
              JSON.stringify(fivePiecesOneItem?.links)
            ) {
              isDefault = false
              reason = 'fivePieces one door links'
              break
            }

            if (
              JSON.stringify(iProps.childrenProps[0].hardwaresProps) !==
              JSON.stringify(handleItem?.hardwaresProps)
            ) {
              isDefault = false
              reason = 'fivePieces one door children hardware props'
              break
            }

            if (
              JSON.stringify(iProps.childrenProps[0].links) !==
              JSON.stringify(handleItem?.links)
            ) {
              isDefault = false
              reason = 'fivePieces one door children links'
              break
            }
          }
        }
      } else if (iProps.props.type === 'drawer') {
        const boxHeight = iProps.props.boxHeight
        const drawerBoxHardwareId =
          this.configs.drawerConfig.boxHeights.find(
            (b) => b.value === boxHeight
          )?.hardwareId || 0

        if (
          JSON.stringify(
            iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
          ) !==
          JSON.stringify(
            [
              ...(drawerItem ? drawerItem.hardwaresProps : []),
              { id: drawerBoxHardwareId, localId: 2, count: 1 },
            ].sort((a, b) => a.localId - b.localId)
          )
        ) {
          isDefault = false
          reason = iProps.name + ' hardware props'
          break
        }

        if (
          JSON.stringify(iProps.links) !==
          JSON.stringify([
            ...(drawerItem ? drawerItem.links : []),
            ...[
              {
                hId: '2',
                hProp: 'height',
                itemProp: 'boxHeight',
              },
              {
                hId: '2',
                hProp: 'width',
                itemProp: 'boxWidth',
              },
              {
                hId: '2',
                hProp: 'depth',
                itemProp: 'boxDepth',
              },
            ],
          ])
        ) {
          isDefault = false
          reason = iProps.name + ' links'
          break
        }

        if (
          !(
            JSON.stringify(iProps.childrenProps[0].hardwaresProps) ===
            JSON.stringify(handleItem?.hardwaresProps)
          )
        ) {
          isDefault = false
          reason = iProps.name + ' children hardware props'
          break
        }
      } else if (iProps.props.type === 'leg') {
        // Leg - 2
        if (
          JSON.stringify(iProps.hardwaresProps) !==
          JSON.stringify(legsItem?.hardwaresProps)
        ) {
          isDefault = false
          reason = 'standard legs hardware props'
          break
        }

        if (JSON.stringify(iProps.links) !== JSON.stringify(legsItem?.links)) {
          isDefault = false
          reason = 'standard legs door links'
          break
        }
      } else if (iProps.props.type === 'separateBase') {
        // Leg - 3
        if (
          JSON.stringify(
            iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
          ) !==
          JSON.stringify(
            separateBaseItem?.hardwaresProps.sort(
              (a, b) => a.localId - b.localId
            )
          )
        ) {
          isDefault = false
          reason = 'separate base hardware props'
          break
        }

        if (
          JSON.stringify(iProps.links) !==
          JSON.stringify(separateBaseItem?.links)
        ) {
          isDefault = false
          reason = 'separate base links'
          break
        }
      } else if (iProps.name.slice(0, 5) === 'Shelf') {
        //Adj Shelves
        if (
          JSON.stringify(
            iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
          ) !==
          JSON.stringify(
            shelfItem?.hardwaresProps.sort((a, b) => a.localId - b.localId)
          )
        ) {
          isDefault = false
          reason = iProps.name + ' hardware props'
          break
        }

        if (JSON.stringify(iProps.links) !== JSON.stringify(shelfItem?.links)) {
          isDefault = false
          reason = iProps.name + ' links'
          break
        }
      } else if (iProps.name.slice(0, 11) === 'Fixed Shelf') {
        //Fixed Shelves
        if (
          JSON.stringify(
            iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
          ) !==
          JSON.stringify(
            fixedShelfItem?.hardwaresProps.sort((a, b) => a.localId - b.localId)
          )
        ) {
          isDefault = false
          reason = iProps.name + ' hardware props'
          break
        }

        if (
          JSON.stringify(iProps.links) !== JSON.stringify(fixedShelfItem?.links)
        ) {
          isDefault = false
          reason = iProps.name + ' links'
          break
        }
      } else {
        //Left Side (Base Leg),Right Side (Base Leg), Top, Splitted Top, Bottom, Back, Leg - 0,1
        const defaultItem = this.defaultItemsProps.find(
          (d) => d.name === iProps.name
        )

        if (defaultItem) {
          if (
            JSON.stringify(
              iProps.hardwaresProps.sort((a, b) => a.localId - b.localId)
            ) !==
            JSON.stringify(
              defaultItem.hardwaresProps.sort((a, b) => a.localId - b.localId)
            )
          ) {
            isDefault = false
            reason = iProps.name + ' hardware props'
            break
          }

          if (
            JSON.stringify(iProps.links) !== JSON.stringify(defaultItem.links)
          ) {
            isDefault = false
            reason = iProps.name + ' links'
            break
          }
        } else {
          isDefault = false
          reason = iProps.name + ' cant find default item'
          break
        }
      }
    }

    // console.log(isDefault, reason)
  }

  getPanelHeight = (
    dividersProps: DividerPropsType[],
    sectionHeight: number,
    sectionNumber: number,
    thickness: number,
    doorConfig: ConfigsType['doorConfig']
  ) => {
    let doorHeight =
      sectionHeight +
      (sectionNumber === 1
        ? dividersProps.length === 0
          ? thickness
          : dividersProps[0].type === 'visible' //if first divider is fixed shelf
            ? thickness * 1.5
            : thickness
        : 0) + //If section is the first
      (sectionNumber === dividersProps.length + 1
        ? dividersProps.length === 0
          ? thickness
          : dividersProps[dividersProps.length - 1].type === 'visible' //if last divider is fixed shelf
            ? thickness * 1.5
            : thickness
        : 0) + //If section is the last
      (sectionNumber !== 1 && sectionNumber !== dividersProps.length + 1
        ? dividersProps[sectionNumber - 2].type === 'visible' //if top divider is fixed shelf
          ? thickness / 2
          : 0
        : 0) + //If section is not first or last
      (sectionNumber !== 1 && sectionNumber !== dividersProps.length + 1
        ? dividersProps[sectionNumber - 1].type === 'visible' //if bottom divider is fixed shelf
          ? thickness / 2
          : 0
        : 0) //If section is not first or last
    const sectionType =
      sectionNumber !== 1
        ? sectionNumber === dividersProps.length + 1
          ? 'last'
          : 'middle'
        : dividersProps.length === 0
          ? 'single'
          : 'first'
    const doorActualHeight =
      doorHeight -
      (sectionType !== 'middle'
        ? sectionType === 'single'
          ? doorConfig.topReveal + doorConfig.bottomReveal
          : sectionType === 'first'
            ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
            : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
        : doorConfig.horizontalGap) //middle
    return doorActualHeight
  }

  getDoorHandlePositions = (
    d: DoorPropsType,
    cabinetWidth: number,
    cabinetHeight: number,
    legHeight: number,
    doorHeight: number,
    doorConfig: ConfigsType['doorConfig'],
    handleConfig: ConfigsType['handleConfig'],
    isAngled = false
  ) => {
    const doorWidth =
      cabinetWidth -
      (isAngled ? 0 : doorConfig.leftReveal + doorConfig.rightReveal)

    const isVertical = d.handleProps.orientation === 'vertical'

    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (
      d.visualType !== 'vGroove' &&
      d.visualType !== 'shaker_v' &&
      d.visualType !== 'shaker_h'
    ) {
      distX = newDoorPullX[d.visualType]
    }

    let handlePosY = 0
    const isHandlePosYNumber = ![
      'top',
      'center',
      'bottom',
      'fromGround',
    ].includes(d.handleProps.position.toString())

    if (isHandlePosYNumber) {
      handlePosY = d.handleProps.position as number
    } else {
      if (d.handleProps.position === 'top') {
        handlePosY = isVertical ? distY : distX
      } else if (d.handleProps.position === 'bottom') {
        handlePosY =
          doorHeight - (!isVertical || d.type === 'liftUp' ? distX : distY)
      } else if (d.handleProps.position === 'center') {
        handlePosY =
          doorHeight / 2 + (isVertical ? handleConfig.legDist / 2 : 0)
      } else if (d.handleProps.position === 'fromGround') {
        const handleY =
          this.configs.handlePositionFromGround - legHeight - cabinetHeight / 2
        const doorTopY = d.sectionY + doorHeight / 2

        handlePosY = doorTopY - handleY + handleConfig.legDist / 2
      }
    }

    // ? d.handleProps.position.toString()[0]
    // : d.handleProps.position.toString()

    let handlePosX = 0

    const isHandlePosXNumber = !['left', 'center', 'right'].includes(
      d.handleProps.positionX.toString()
    )
    // ? d.handleProps.positionX.toString()[0]
    // : d.handleProps.positionX.toString()

    if (isHandlePosXNumber) {
      handlePosX = d.handleProps.positionX as number
    } else {
      if (d.handleProps.orientation === 'double_horizontal') {
        const distFromEdge = 15
        handlePosX = distFromEdge - handleConfig.legDist / 2
      } else if (d.type === 'double') {
        handlePosX =
          (doorWidth - doorConfig.verticalGap) / 2 -
          (isVertical ? distX : distY)
      } else if (d.handleProps.positionX === 'right') {
        handlePosX = doorWidth - (isVertical ? distX : distY)
      } else if (d.handleProps.positionX === 'left') {
        handlePosX = isVertical ? distX : distY
      } else if (d.handleProps.positionX === 'center') {
        handlePosX = doorWidth / 2 - (isVertical ? 0 : handleConfig.legDist / 2)
      }
    }

    const yPrefix = isHandlePosYNumber
      ? null
      : (d.handleProps.position as string)[0]
    const yStr = isHandlePosYNumber
      ? handlePosY.toString()
      : yPrefix === 'f'
        ? d.handleProps.positionFromGroundValue !== undefined
          ? 'f' + d.handleProps.positionFromGroundValue.toFixed(2)
          : 'f'
        : yPrefix + handlePosY.toFixed(2)

    return {
      x: isHandlePosXNumber
        ? handlePosX.toString()
        : (d.handleProps.positionX as string)[0] + handlePosX.toFixed(2),
      y: yStr,
    }
  }

  getCorner2DoorHandlePositions = (
    d: DoorPropsType,
    doorHeight: number,
    cabinetHeight: number,
    legHeight: number,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const isVertical = d.handleProps.orientation === 'vertical'
    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (
      d.visualType !== 'vGroove' &&
      d.visualType !== 'shaker_v' &&
      d.visualType !== 'shaker_h'
    ) {
      distX = newDoorPullX[d.visualType]
    }

    let handlePosY = 0
    const isHandlePosYNumber = ![
      'top',
      'center',
      'bottom',
      'fromGround',
    ].includes(d.handleProps.position.toString())
    if (isHandlePosYNumber) {
      handlePosY = d.handleProps.position as number
    } else {
      if (d.handleProps.position === 'top') {
        handlePosY = isVertical ? distY : distX
      } else if (d.handleProps.position === 'bottom') {
        handlePosY =
          doorHeight - (!isVertical || d.type === 'liftUp' ? distX : distY)
      } else if (d.handleProps.position === 'center') {
        handlePosY =
          doorHeight / 2 + (isVertical ? handleConfig.legDist / 2 : 0)
      } else if (d.handleProps.position === 'fromGround') {
        const handleY =
          this.configs.handlePositionFromGround - legHeight - cabinetHeight / 2
        const doorTopY = d.sectionY + doorHeight / 2

        handlePosY = doorTopY - handleY + handleConfig.legDist / 2
      }
    }
    // ? d.handleProps.position.toString()[0]
    // : d.handleProps.position.toString()
    let handlePosX = 0
    const isHandlePosXNumber = !['left', 'center', 'right'].includes(
      d.handleProps.positionX.toString()
    )
    // ? d.handleProps.positionX.toString()[0]
    // : d.handleProps.positionX.toString()
    if (isHandlePosXNumber) {
      handlePosX = d.handleProps.positionX as number
    } else {
      let distFromEdge = handleConfig.distFromEdge
      if (
        d.visualType !== 'vGroove' &&
        d.visualType !== 'shaker_v' &&
        d.visualType !== 'shaker_h'
      ) {
        distFromEdge = newDoorPullX[d.visualType]
      }
      if (d.handleProps.positionX === 'right') {
        handlePosX = distFromEdge
      } else if (d.handleProps.positionX === 'left') {
        handlePosX = distFromEdge
      }
    }
    return {
      x: isHandlePosXNumber
        ? handlePosX.toString()
        : (d.handleProps.positionX as string)[0] + handlePosX.toFixed(2),
      y: isHandlePosYNumber
        ? handlePosY.toString()
        : (d.handleProps.position as string)[0] + handlePosY.toFixed(2),
    }
  }

  getHandleTypeName = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype']
  ) => {
    if (type === 'pull') {
      switch (subType) {
        case 'standard':
          return '0'
        case 'arch':
          return '1'
        case 'DHP465-192':
          return '2'
        case 'DHP306-96':
          return '3'
        case 'DHP180-128':
          return '4'
        case 'DHP504-76':
          return '5'
        case 'DHP305MB96':
          return '8'
        case 'DHP305MB128':
          return '9'
        case 'BP723812':
          return '10'
        case 'BP873128':
          return '11'
        case 'BP7470128':
          return '12'
        case 'DHP306-128':
          return '13'
        default:
          return '0'
      }
    } else if (type === 'knob') {
      if (subType === 'DHK401') return '7'
      else if (subType === 'DHK501') return '14'
      else return '6' //DHK301
    } else if (type === 'noPull') return '99'

    return '0'
  }

  getHandleTypesFromName = (
    value: string
  ): { type: HandlePropsType['type']; subType: HandlePropsType['subtype'] } => {
    switch (value) {
      case '0':
        return {
          type: 'pull',
          subType: 'standard',
        }
      case '1':
        return {
          type: 'pull',
          subType: 'arch',
        }
      case '2':
        return {
          type: 'pull',
          subType: 'DHP465-192',
        }
      case '3':
        return {
          type: 'pull',
          subType: 'DHP306-96',
        }
      case '4':
        return {
          type: 'pull',
          subType: 'DHP180-128',
        }
      case '5':
        return {
          type: 'pull',
          subType: 'DHP504-76',
        }
      case '6':
        return {
          type: 'knob',
          subType: 'DHK301',
        }
      case '7':
        return {
          type: 'knob',
          subType: 'DHK401',
        }
      case '8':
        return {
          type: 'pull',
          subType: 'DHP305MB96',
        }
      case '9':
        return {
          type: 'pull',
          subType: 'DHP305MB128',
        }
      case '10':
        return {
          type: 'pull',
          subType: 'BP723812',
        }
      case '11':
        return {
          type: 'pull',
          subType: 'BP873128',
        }
      case '12':
        return {
          type: 'pull',
          subType: 'BP7470128',
        }
      case '13':
        return {
          type: 'pull',
          subType: 'DHP306-128',
        }
      case '14':
        return {
          type: 'knob',
          subType: 'DHK501',
        }
      case '99':
        return {
          type: 'noPull',
          subType: undefined,
        }
      default:
        return {
          type: 'pull',
          subType: 'standard',
        }
    }
  }

  getDoorNameFromProps = (
    d: DoorPropsType,
    cabinetWidth: number,
    cabinetHeight: number,
    legHeight: number,
    dividersProps: DividerPropsType[],
    thickness: number,
    doorConfig: ConfigsType['doorConfig'],
    handleConfig: ConfigsType['handleConfig'],
    isAngled = false
  ) => {
    const doorType = d.type === 'liftUp' ? 'lu' : d.type[0]
    const doorHeight = this.getPanelHeight(
      dividersProps,
      d.sectionHeight,
      d.sectionNumber,
      thickness,
      doorConfig
    )
    // console.log(doorHeight, 'doorHeight')

    const handlePos = this.getDoorHandlePositions(
      d,
      cabinetWidth,
      cabinetHeight,
      legHeight,
      doorHeight,
      doorConfig,
      handleConfig,
      isAngled
    )

    const handleType = this.getHandleTypeName(
      d.handleProps.type,
      d.handleProps.subtype
    )

    const handleOrientation =
      doorType === 'lu'
        ? d.handleProps.orientation === 'double_horizontal'
          ? 'd'
          : 's'
        : d.handleProps.orientation === 'horizontal'
          ? 'h'
          : 'v'

    const visualType =
      d.visualType === 'vGroove'
        ? '0'
        : d.visualType === 'fivePieces'
          ? '1'
          : d.visualType.startsWith('#')
            ? '2'
            : d.visualType.startsWith('shaker')
              ? '3'
              : ''

    let newDoorInfo = ''

    if (visualType === '2') {
      if (d.visualType === '#B200-R203-S01') {
        newDoorInfo += '0'
      } else if (d.visualType === '#B200-R203-S04') {
        newDoorInfo += '1'
      } else if (d.visualType === '#B200-R401-S01') {
        newDoorInfo += '2'
      } else if (d.visualType === '#B200-R401-S04') {
        newDoorInfo += '3'
      } else if (d.visualType === '#B200-R500-S01') {
        newDoorInfo += '4'
      } else if (d.visualType === '#B200-R500-S04') {
        newDoorInfo += '5'
      } else if (d.visualType === '#B600-R102-S01') {
        newDoorInfo += '6'
      } else if (d.visualType === '#B600-R102-S04') {
        newDoorInfo += '7'
      } else if (d.visualType === '#B600-R100-S01') {
        newDoorInfo += '8'
      } else if (d.visualType === '#B600-R100-S04') {
        newDoorInfo += '9'
      } else if (d.visualType === '#B602-R102-S01') {
        newDoorInfo += '10'
      } else if (d.visualType === '#B602-R102-S04') {
        newDoorInfo += '11'
      } else if (d.visualType === '#B100-R000-S01') {
        newDoorInfo += '12'
      } else if (d.visualType === '#B100-R000-S04') {
        newDoorInfo += '13'
      }

      if (newDoorInfo && d.normalMapSplitter) {
        newDoorInfo += ':' + d.normalMapSplitter
      }
    }

    if (visualType === '1' && d.normalMapSplitter) {
      newDoorInfo = '0:' + d.normalMapSplitter
    }

    if (visualType === '3') {
      newDoorInfo = d.visualType === 'shaker_h' ? '0' : '1'
    }

    let doorName = `${doorType}_${d.sectionNumber}_${handlePos.y},${handlePos.x}_${handleType}_${handleOrientation}%${visualType}`

    if (newDoorInfo) {
      doorName += ':' + newDoorInfo
    }

    return doorName
  }

  get2doorCornerDoorNameFromProps = (
    d: DoorPropsType,
    cabinetHeight: number,
    legHeight: number,
    dividersProps: DividerPropsType[],
    thickness: number,
    doorConfig: ConfigsType['doorConfig'],
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const doorType = d.type === 'liftUp' ? 'lu' : d.type[0]
    const doorHeight = this.getPanelHeight(
      dividersProps,
      d.sectionHeight,
      d.sectionNumber,
      thickness,
      doorConfig
    )
    // console.log(doorHeight, 'doorHeight')

    const handlePos = this.getCorner2DoorHandlePositions(
      d,
      doorHeight,
      cabinetHeight,
      legHeight,
      handleConfig
    )

    const handleType = this.getHandleTypeName(
      d.handleProps.type,
      d.handleProps.subtype
    )
    const handleOrientation =
      d.handleProps.orientation === 'horizontal' ? 'h' : 'v'

    const visualType =
      d.visualType === 'vGroove'
        ? '0'
        : d.visualType === 'fivePieces'
          ? '1'
          : d.visualType.startsWith('#')
            ? '2'
            : d.visualType.startsWith('shaker')
              ? '3'
              : ''

    let newDoorInfo = ''

    if (visualType === '2') {
      if (d.visualType === '#B200-R203-S01') {
        newDoorInfo += '0'
      } else if (d.visualType === '#B200-R203-S04') {
        newDoorInfo += '1'
      } else if (d.visualType === '#B200-R401-S01') {
        newDoorInfo += '2'
      } else if (d.visualType === '#B200-R401-S04') {
        newDoorInfo += '3'
      } else if (d.visualType === '#B200-R500-S01') {
        newDoorInfo += '4'
      } else if (d.visualType === '#B200-R500-S04') {
        newDoorInfo += '5'
      } else if (d.visualType === '#B600-R102-S01') {
        newDoorInfo += '6'
      } else if (d.visualType === '#B600-R102-S04') {
        newDoorInfo += '7'
      } else if (d.visualType === '#B600-R100-S01') {
        newDoorInfo += '8'
      } else if (d.visualType === '#B600-R100-S04') {
        newDoorInfo += '9'
      } else if (d.visualType === '#B602-R102-S01') {
        newDoorInfo += '10'
      } else if (d.visualType === '#B602-R102-S04') {
        newDoorInfo += '11'
      } else if (d.visualType === '#B100-R000-S01') {
        newDoorInfo += '12'
      } else if (d.visualType === '#B100-R000-S04') {
        newDoorInfo += '13'
      }

      if (newDoorInfo && d.normalMapSplitter) {
        newDoorInfo += ':' + d.normalMapSplitter
      }
    }

    if (visualType === '1' && d.normalMapSplitter) {
      newDoorInfo = '0:' + d.normalMapSplitter
    }

    if (visualType === '3') {
      newDoorInfo = d.visualType === 'shaker_h' ? '0' : '1'
    }

    let doorName = `${doorType}_${d.sectionNumber}_${handlePos.y},${handlePos.x}_${handleType}_${handleOrientation}%${visualType}`

    if (newDoorInfo) {
      doorName += ':' + newDoorInfo
    }

    return doorName
  }

  getDrawerHandlePositions = (
    d: DrawerPropsType,
    cabinetWidth: number,
    drawerHeight: number,
    doorConfig: ConfigsType['doorConfig'],
    drawerConfig: ConfigsType['drawerConfig'],
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const drawerWidth =
      cabinetWidth - doorConfig.leftReveal - doorConfig.rightReveal

    let handlePosY = 0
    const isHandlePosYNumber = !['forDrawer', 'forDrawerCenter'].includes(
      d.handleProps.position.toString()
    )

    let handleRevalFromTop = drawerConfig.handleRevalFromTop

    if (
      d.visualType &&
      d.visualType !== 'standard' &&
      d.visualType !== 'shaker_v' &&
      d.visualType !== 'shaker_h'
    ) {
      handleRevalFromTop = newDoorPullX[d.visualType]
    }

    if (isHandlePosYNumber) {
      handlePosY = d.handleProps.position as number
    } else {
      if (d.handleProps.position === 'forDrawer') {
        handlePosY = handleRevalFromTop
      } else if (d.handleProps.position === 'forDrawerCenter') {
        handlePosY = drawerHeight / 2
      } else {
        // handlePosY = '0'
      }
    }

    let handlePosX = 0

    // debugger
    const isHandlePosXNumber =
      d.handleProps.positionX &&
      !['left', 'center', 'right'].includes(d.handleProps.positionX.toString())

    if (isHandlePosXNumber) {
      handlePosX = d.handleProps.positionX as number
    } else {
      let distFromEdge = handleConfig.distFromEdge

      if (d.handleProps.orientation === 'double_horizontal') {
        const distFromEdge = 15
        handlePosX = distFromEdge - handleConfig.legDist / 2
      } else if (d.handleProps.positionX === 'right') {
        handlePosX = drawerWidth - distFromEdge
      } else if (d.handleProps.positionX === 'left') {
        handlePosX = distFromEdge
      } else if (d.handleProps.positionX === 'center') {
        handlePosX = drawerWidth / 2 - handleConfig.legDist / 2
      }
    }

    return {
      x: isHandlePosXNumber
        ? handlePosX.toString()
        : (d.handleProps.positionX as string)[0] + handlePosX.toFixed(2),
      y: isHandlePosYNumber
        ? handlePosY.toString()
        : (d.handleProps.position === 'forDrawerCenter' ? 'c' : 't') +
          handlePosY.toFixed(2),
    }
  }

  getDrawerNameFromProps = (
    d: DrawerPropsType,
    cabinetWidth: number,
    dividersProps: DividerPropsType[],
    thickness: number,
    doorConfig: ConfigsType['doorConfig'],
    drawerConfig: ConfigsType['drawerConfig'],
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const isDouble = d.handleProps.orientation === 'double_horizontal'

    const drawerHeight = this.getPanelHeight(
      dividersProps,
      d.sectionHeight,
      d.sectionNumber,
      thickness,
      doorConfig
    )

    const handlePos = this.getDrawerHandlePositions(
      d,
      cabinetWidth,
      drawerHeight,
      doorConfig,
      drawerConfig,
      handleConfig
    )

    const handleType = this.getHandleTypeName(
      d.handleProps.type,
      d.handleProps.subtype
    )

    const visualType =
      !d.visualType || d.visualType === 'standard'
        ? '0'
        : d.visualType === 'fivePieces'
          ? '1'
          : d.visualType.startsWith('#')
            ? '2'
            : d.visualType.startsWith('shaker')
              ? '3'
              : ''

    let newDoorInfo = ''

    if (visualType === '2') {
      if (d.visualType === '#B200-R203-S01') {
        newDoorInfo += '0'
      } else if (d.visualType === '#B200-R203-S04') {
        newDoorInfo += '1'
      } else if (d.visualType === '#B200-R401-S01') {
        newDoorInfo += '2'
      } else if (d.visualType === '#B200-R401-S04') {
        newDoorInfo += '3'
      } else if (d.visualType === '#B200-R500-S01') {
        newDoorInfo += '4'
      } else if (d.visualType === '#B200-R500-S04') {
        newDoorInfo += '5'
      } else if (d.visualType === '#B600-R102-S01') {
        newDoorInfo += '6'
      } else if (d.visualType === '#B600-R102-S04') {
        newDoorInfo += '7'
      } else if (d.visualType === '#B600-R100-S01') {
        newDoorInfo += '8'
      } else if (d.visualType === '#B600-R100-S04') {
        newDoorInfo += '9'
      } else if (d.visualType === '#B602-R102-S01') {
        newDoorInfo += '10'
      } else if (d.visualType === '#B602-R102-S04') {
        newDoorInfo += '11'
      } else if (d.visualType === '#B100-R000-S01') {
        newDoorInfo += '12'
      } else if (d.visualType === '#B100-R000-S04') {
        newDoorInfo += '13'
      }
    }

    if (visualType === '3') {
      newDoorInfo = d.visualType === 'shaker_h' ? '0' : '1'
    }

    let drawerName = `${d.sectionNumber}_${handleType}_${handlePos.y},${
      handlePos.x
    }_${isDouble ? 'd' : 's'}%${visualType}`

    if (newDoorInfo) {
      drawerName += ':' + newDoorInfo
    }

    return drawerName
  }

  getDrawerSlideName = () => {
    return (
      '@' +
      (this.drawerSlideType === 'under_mount'
        ? 2
        : this.drawerSlideType === 'soft'
          ? 1
          : 0)
    )
  }

  exportCabinetName = () => {
    const cabinetType = this.type.startsWith('u')
      ? this.type === 'upperOpen'
        ? 'uo'
        : 'u'
      : this.type[0]

    return !this.isCorner
      ? `0|${cabinetType}|${parseFloat(
          this.cabinetProps.width.toFixed(fractionDigits)
        )};${parseFloat(
          this.cabinetProps.height.toFixed(fractionDigits)
        )};${parseFloat(
          this.cabinetProps.depth.toFixed(fractionDigits)
        )}|${this.cabinetProps.sectionProps.dividersProps
          .map((d) =>
            d.type === 'none'
              ? 'f' + d.top.toFixed(fractionDigits)
              : 't' + d.top.toFixed(fractionDigits)
          )
          .join(';')}|${this.cabinetProps.sectionProps.doorsProps
          .sort((a, b) => a.sectionNumber - b.sectionNumber)
          .map((d) =>
            this.getDoorNameFromProps(
              d,
              this.cabinetProps.width,
              this.cabinetProps.height,
              this.cabinetProps.legHeight,
              this.cabinetProps.sectionProps.dividersProps,
              this.configs.thickness,
              this.configs.doorConfig,
              this.configs.handleConfig
            )
          )
          .join(';')}|${
          this.cabinetProps.sectionProps.drawersProps
            .sort((a, b) => a.sectionNumber - b.sectionNumber)
            .map((d) =>
              this.getDrawerNameFromProps(
                d,
                this.cabinetProps.width,
                this.cabinetProps.sectionProps.dividersProps,
                this.configs.thickness,
                this.configs.doorConfig,
                this.configs.drawerConfig,
                this.configs.handleConfig
              )
            )
            .join(';') + this.getDrawerSlideName()
        }|${this.cabinetProps.sectionProps.shelvesProps
          .sort((a, b) => a.sectionNumber - b.sectionNumber)
          .map((sh) => '' + sh.sectionNumber + '_' + sh.count)
          .join(';')}|${this.sectionLocks
          .map(
            (s) =>
              (s.number === this.modifiableSection ? '*' : '') +
              (s.isLock ? '1' : '0')
          )
          .join(';')}|${
          this.cabinetSheetDefaultMaterialId +
          '_' +
          this.panelSheetDefaultMaterialId
        }|${
          this.legProps.type === 'base'
            ? '0_' +
              (this.baseLegCut ?? this.configs.baseLegConfig.cutLength) +
              '_0:' +
              (this.legProps.baseSubType === 'old' ? '1' : '0')
            : this.legProps.type === 'baseIsland'
              ? '0_' +
                (this.baseLegCut ?? this.configs.baseLegConfig.cutLength) +
                '_1:' +
                (this.legProps.baseSubType === 'old' ? '1' : '0')
              : this.legProps.type === 'baseIsland2'
                ? '0_' +
                  (this.baseLegCut ?? this.configs.baseLegConfig.cutLength) +
                  '_2:' +
                  (this.legProps.baseSubType === 'old' ? '1' : '0')
                : this.legProps.type === 'noToeKick'
                  ? '1'
                  : this.legProps.type === 'standard'
                    ? '2'
                    : this.legProps.type === 'standard2_1'
                      ? '4_1'
                      : this.legProps.type === 'standard2_2'
                        ? '4_2'
                        : this.legProps.type === 'noLeg'
                          ? '9'
                          : '3'
        }|${this.cabinetProps.legHeight}|${this.addonD + '_' + this.addonP}${
          this.categoryId ? '$' + this.categoryId : ''
        }${this.microvellumName ? '#' + this.microvellumName : ''}`
      : `${this.cornerCabinetProps.type === 'angled' ? 1 : 2}|${
          cabinetType
        }|${parseFloat(
          this.cornerCabinetProps.height.toFixed(fractionDigits)
        )};${parseFloat(
          this.cornerCabinetProps.width1.toFixed(fractionDigits)
        )};${parseFloat(
          this.cornerCabinetProps.width2.toFixed(fractionDigits)
        )};${parseFloat(
          this.cornerCabinetProps.depth1.toFixed(fractionDigits)
        )};${parseFloat(
          this.cornerCabinetProps.depth2.toFixed(fractionDigits)
        )};${parseFloat(
          this.cornerCabinetProps.backWidth1.toFixed(fractionDigits)
        )};${parseFloat(
          this.cornerCabinetProps.backWidth2.toFixed(fractionDigits)
        )}|${this.cornerCabinetProps.sectionProps.dividersProps
          .map((d) =>
            d.type === 'none'
              ? 'f' + d.top.toFixed(fractionDigits)
              : 't' + d.top.toFixed(fractionDigits)
          )
          .join(';')}|${this.cornerCabinetProps.sectionProps.doorsProps
          .sort((a, b) => a.sectionNumber - b.sectionNumber)
          .map((d) => {
            if (this.cornerCabinetProps.type === 'angled') {
              const width = calculateCornerSectionSize(
                this.cornerCabinetProps.width1,
                this.cornerCabinetProps.width2,
                this.cornerCabinetProps.depth1,
                this.cornerCabinetProps.depth2,
                this.cornerCabinetProps.thickness
              )

              return this.getDoorNameFromProps(
                d,
                width,
                this.cornerCabinetProps.height,
                this.cornerCabinetProps.legHeight,
                this.cornerCabinetProps.sectionProps.dividersProps,
                this.configs.thickness,
                this.configs.doorConfig,
                this.configs.handleConfig,
                true
              )
            } else {
              return this.get2doorCornerDoorNameFromProps(
                d,
                this.cornerCabinetProps.height,
                this.cornerCabinetProps.legHeight,
                this.cornerCabinetProps.sectionProps.dividersProps,
                this.configs.thickness,
                this.configs.doorConfig,
                this.configs.handleConfig
              )
            }
          })
          .join(';')}|${this.cornerCabinetProps.sectionProps.drawersProps
          .sort((a, b) => a.sectionNumber - b.sectionNumber)
          .map(
            (d) =>
              d.sectionNumber.toString() +
              '_' +
              this.getHandleTypeName(d.handleProps.type, d.handleProps.subtype)
          )
          .join(';')}|${this.cornerCabinetProps.sectionProps.shelvesProps
          .sort((a, b) => a.sectionNumber - b.sectionNumber)
          .map((sh) => '' + sh.sectionNumber + '_' + sh.count)
          .join(';')}|${this.sectionLocks
          .map(
            (s) =>
              (s.number === this.modifiableSection ? '*' : '') +
              (s.isLock ? '1' : '0')
          )
          .join(';')}|${
          this.cabinetSheetDefaultMaterialId +
          '_' +
          this.panelSheetDefaultMaterialId
        }|${
          this.legProps.type === 'standard2_1'
            ? '4_1'
            : this.legProps.type === 'standard2_2'
              ? '4_2'
              : this.legProps.type === 'base'
                ? '0_' +
                  (this.baseLegCut ?? this.configs.baseLegConfig.cutLength) +
                  '_0:' +
                  (this.legProps.baseSubType === 'old' ? '1' : '0')
                : this.legProps.type === 'baseIsland'
                  ? '0_' +
                    (this.baseLegCut ?? this.configs.baseLegConfig.cutLength) +
                    '_1:' +
                    (this.legProps.baseSubType === 'old' ? '1' : '0') +
                    (this.legProps.subType === 'cornerLeft'
                      ? '_0'
                      : this.legProps.subType === 'cornerRight'
                        ? '_1'
                        : '')
                  : this.legProps.type === 'noLeg'
                    ? '9'
                    : '2'
        }|${this.cornerCabinetProps.legHeight}|${
          this.addonD + '_' + this.addonP
        }${this.categoryId ? '$' + this.categoryId : ''}${
          this.microvellumName ? '#' + this.microvellumName : ''
        }`
  }

  setStartValues = () => {
    this.cabinetProps = {
      width: 80, //41.91,
      height: 88.9,
      depth: 57.15,
      legHeight: 12,
      sectionProps: {
        name: 'section',
        width: 41.91 - this.thickness * 2,
        height: 88.9 - this.thickness * 2,
        y: 0,
        dividersProps: [
          {
            type: 'none',
            top: 17.785,
            uuid: '9415a9b0-994b-4f18-89e6-b0185b3e34b6',
          },
        ],
        doorsProps: [
          {
            type: 'double',
            uuid: '97F71A3D-51DA-4CA2-BF2B-250055B87C88',
            sectionNumber: 2,
            sectionY: -8.892499999999998,
            sectionHeight: 67.305,
            handleProps: {
              type: 'pull',
              subtype: 'standard',
              position: 'center',
              orientation: 'vertical',
              positionX: 'center',
            },
            visualType: 'vGroove',
          },
        ],
        drawersProps: [
          {
            uuid: '0EBCF2DE-DA0B-465D-91C2-9BEA78AF870B',
            sectionNumber: 1,
            sectionY: 33.6525,
            sectionHeight: 17.785,
            handleProps: {
              type: 'pull',
              subtype: 'standard',
              position: 'forDrawer',
              orientation: 'horizontal',
              positionX: 'center',
            },
          },
        ],
        shelvesProps: [
          {
            sectionNumber: 2,
            sectionY: -8.892499999999998,
            sectionHeight: 67.305,
            count: 2,
          },
        ],
      },
    }
  }

  getPrice = () => {
    const p = this.items.reduce(
      (sum, current) => sum + parseFloat(current.getPrice()),
      0
    )
    return (p + this.addonD + ((p + this.addonD) * this.addonP) / 100).toFixed(
      fractionDigits
    )
  }

  getNonMarkupPrice = () => {
    const p = this.items.reduce(
      (sum, current) => sum + parseFloat(current.getNonMarkupPrice()),
      0
    )
    return p.toFixed(fractionDigits)
  }

  getWeight = (lbs = false) => {
    let weight = this.items.reduce(
      (sum, current) => sum + parseFloat(current.getWeight()),
      0
    )

    if (lbs) {
      weight *= 2.20462
    }

    return weight.toFixed(fractionDigits)
  }

  changeCabinetMaterialOnly = (
    changedHardwaresIds: number[],
    isPewter = false
  ) => {
    const needMaterialChangeItems = [] as { item: Item; hardware: Hardware }[]

    this.items.forEach((item, i) => {
      item.hardwares.forEach((hardware, j) => {
        if (changedHardwaresIds.includes(hardware.id)) {
          // item.hardwares[0] = this.createHardwares([{ id: hProps.id, localId: 1, count: 1 }])[0];
          const newHardware = this.createHardwares([
            {
              id: hardware.id,
              localId: hardware.localId,
              count: hardware.count,
            },
          ])[0]
          this.items[i].hardwares[j] = newHardware
          this.items[i].updateHardwareProps()

          if (
            needMaterialChangeItems.every((obj) => obj.item.name !== item.name)
          )
            needMaterialChangeItems.push({ item, hardware: newHardware })
        }
      })
    })

    for (const obj of needMaterialChangeItems) {
      const item = obj.item
      const material = obj.hardware.material

      if (item.name === 'Splitted Top') {
        const texture = material?.texture.clone()
        // @ts-ignore
        texture.repeat.set(
          // @ts-ignore
          item.props.cabinetWidth / material.tLength,
          // @ts-ignore
          item.props.sheetWidth / material.tWidth
        )
        // @ts-ignore
        texture.needsUpdate = true

        const _material = new THREE.MeshStandardMaterial({
          map: texture,
        })

        if (isPewter) {
          const blackMat = new THREE.MeshBasicMaterial({ color: 'black' })

          const materials = [
            blackMat,
            blackMat,
            _material,
            _material,
            blackMat,
            blackMat,
          ]

          // @ts-ignore
          item.object3D.children[0].material = materials
          // @ts-ignore
          item.object3D.children[1].material = materials
        } else {
          // @ts-ignore
          item.object3D.children[0].material = _material
          // @ts-ignore
          item.object3D.children[1].material = _material
        }
      } else if (item.props.type === 'drawer') {
        if (item.props.visualType === 'standard') {
          const texture = material?.texture.clone()
          // @ts-ignore
          texture.repeat.set(
            // @ts-ignore
            item.props.width / material.tLength,
            // @ts-ignore
            item.props.height / material.tWidth
          )
          // @ts-ignore
          texture.needsUpdate = true

          // @ts-ignore
          item.object3D.children[0].material.map = texture
          // @ts-ignore
          item.object3D.children[0].material.needsUpdate = true
        } else if (
          item.props.visualType === 'shaker_h' ||
          item.props.visualType === 'shaker_v'
        ) {
          const texture = material?.texture.clone()

          if (item.props.visualType === 'shaker_v') {
            // @ts-ignore
            texture.rotation = Math.PI / 2
          }

          // @ts-ignore
          texture.repeat.set(
            // @ts-ignore
            item.props.width / material.tLength,
            // @ts-ignore
            item.props.height / material.tWidth
          )
          // @ts-ignore
          texture.needsUpdate = true

          // @ts-ignore
          item.object3D.children[0].children[0].material.map = texture
          // @ts-ignore
          item.object3D.children[0].children[0].material.needsUpdate = true
        } else if (item.props.visualType.startsWith('#')) {
          const height = item.props.height
          const width = item.props.width

          const material = obj.hardware.material

          const newTexture = material?.texture.clone() || new THREE.Texture()
          newTexture.wrapS = THREE.RepeatWrapping
          newTexture.wrapT = THREE.RepeatWrapping

          newTexture.repeat.set(
            height / (material?.tLength || 1),
            width / (material?.tWidth || 1)
          )
          newTexture.needsUpdate = true

          const newMaterial = new THREE.MeshStandardMaterial({
            map: newTexture,
          })
          const textureColor = getTextureColor(newTexture)
          const blendingMaterial = getNewBlendingMaterial(
            item.object3D.children[0],
            textureColor
          )

          // @ts-ignore
          item.object3D.children[0].children[0].material[0] = newMaterial
          // @ts-ignore
          item.object3D.children[0].children[0].material[1] = newMaterial
          // @ts-ignore
          item.object3D.children[0].children[0].material[2] = newMaterial
          // @ts-ignore
          item.object3D.children[0].children[0].material[3] = newMaterial
          // @ts-ignore
          item.object3D.children[0].children[0].material[4] = blendingMaterial

          // if (item.object3D.children[0].children[0].material[4].uniforms) {
          //   // @ts-ignore
          //   item.object3D.children[0].children[0].material[4].uniforms.material2Color.value =
          //     new THREE.Color(textureColor)
          // }

          // @ts-ignore
          item.object3D.children[0].children[0].material[5] = newMaterial
          // @ts-ignore
          item.object3D.children[0].children[0].needsUpdate = true
        }
      } else if (item.props.type === 'door') {
        if (item.props.visualType === 'vGroove') {
          const newTexture = material?.texture.clone() || new THREE.Texture()
          newTexture.wrapS = THREE.RepeatWrapping
          newTexture.wrapT = THREE.RepeatWrapping
          // @ts-ignore
          newTexture.repeat.set(1, material.tLength / material.tWidth)
          newTexture.needsUpdate = true

          // @ts-ignore
          applyBoxUV(
            // @ts-ignore
            item.object3D.children[0].geometry,
            new THREE.Matrix4().fromArray([
              1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
            ]),
            // @ts-ignore
            material.tLength
          )
          // @ts-ignore
          item.object3D.children[0].geometry.attributes.uv.needsUpdate = true
          // @ts-ignore
          item.object3D.children[0].material.map = newTexture
          // @ts-ignore
          item.object3D.children[0].material.needsUpdate = true

          if (item.props.subType === 'double') {
            // @ts-ignore
            applyBoxUV(
              // @ts-ignore
              item.object3D.children[1].geometry,
              new THREE.Matrix4().fromArray([
                1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
              ]),
              // @ts-ignore
              material.tLength
            )
            // @ts-ignore
            item.object3D.children[1].geometry.attributes.uv.needsUpdate = true
            // @ts-ignore
            item.object3D.children[1].material.map = newTexture
            // @ts-ignore
            item.object3D.children[1].material.needsUpdate = true
          }
        } else if (
          item.props.visualType === 'shaker_h' ||
          item.props.visualType === 'shaker_v'
        ) {
          const height = item.props.height
          const width = item.props.width
          const doubleSheetWidth =
            width / 2 - this.configs.doorConfig.verticalGap / 2

          const material = obj.hardware.material

          const newTexture = material?.texture.clone() || new THREE.Texture()
          newTexture.wrapS = THREE.RepeatWrapping
          newTexture.wrapT = THREE.RepeatWrapping

          if (item.props.visualType === 'shaker_v') {
            newTexture.rotation = Math.PI / 2
            newTexture.repeat.set(
              height / (material?.tLength || 1),
              (item.props.subType === 'double' ? doubleSheetWidth : width) /
                (material?.tWidth || 1)
            )
            newTexture.needsUpdate = true
          } else {
            newTexture.repeat.set(
              height / (material?.tLength || 1),
              (item.props.subType === 'double' ? doubleSheetWidth : width) /
                (material?.tWidth || 1)
            )
            newTexture.needsUpdate = true
          }

          // @ts-ignore0
          item.object3D.children[0].material.map = newTexture
          // @ts-ignore
          item.object3D.children[0].material.needsUpdate = true

          if (item.props.subType === 'double') {
            // @ts-ignore
            item.object3D.children[1].material.map = newTexture
            // @ts-ignore
            item.object3D.children[1].material.needsUpdate = true
          }
        }
      } else if (
        item.props.type === 'fivePiecesDoor' ||
        item.props.type === 'fivePiecesDrawer'
      ) {
        //fivePieces
        const fivePiecesConfig = this.configs.fivePiecesConfig
        const height = item.props.height
        const width = item.props.width

        // @ts-ignore
        const tWidth = material.tWidth
        // @ts-ignore
        const tLength = material.tLength
        // console.log('item.props.visualType', tLength, tWidth)

        if (
          item.props.type === 'fivePiecesDoor' &&
          item.props.subType === 'double'
        ) {
          const leftSheetWidth =
            width / 2 - this.configs.doorConfig.verticalGap / 2

          const verticalTexture =
            material?.texture.clone() || new THREE.Texture()
          verticalTexture.wrapS = verticalTexture.wrapT = THREE.RepeatWrapping
          verticalTexture.repeat.set(
            fivePiecesConfig.pieceWidth / tLength,
            height / tWidth
          )
          verticalTexture.needsUpdate = true

          const horizontalTexture = verticalTexture.clone()
          horizontalTexture.repeat.set(
            fivePiecesConfig.pieceWidth / tLength,
            (leftSheetWidth - fivePiecesConfig.pieceWidth * 2) / tWidth
          )
          horizontalTexture.needsUpdate = true

          for (const _child of [
            ...item.object3D.children[0].children,
            ...item.object3D.children[1].children,
          ]) {
            const child = _child as THREE.Mesh<
              THREE.BoxBufferGeometry,
              THREE.MeshStandardMaterial
            >
            if (child.name === 'horizontalPiece') {
              child.material.map = horizontalTexture
            } else if (child.name === 'verticalPiece') {
              child.material.map = verticalTexture
            } else if (child.name === 'centerPiece') {
              const texture = verticalTexture.clone()
              texture.repeat.set(
                child.geometry.parameters.width / tLength,
                child.geometry.parameters.height / tWidth
              )
              texture.needsUpdate = true

              child.material.map = texture
            }

            child.material.needsUpdate = true
          }
        } else {
          const verticalTexture =
            material?.texture.clone() || new THREE.Texture()
          verticalTexture.wrapS = verticalTexture.wrapT = THREE.RepeatWrapping
          verticalTexture.repeat.set(
            fivePiecesConfig.pieceWidth / tLength,
            height / tWidth
          )
          verticalTexture.needsUpdate = true

          const horizontalTexture = verticalTexture.clone()
          horizontalTexture.repeat.set(
            fivePiecesConfig.pieceWidth / tLength,
            (width - fivePiecesConfig.pieceWidth * 2) / tWidth
          )
          horizontalTexture.needsUpdate = true

          for (const _child of item.props.type === 'fivePiecesDoor'
            ? item.object3D.children[0].children
            : item.object3D.children[0].children[0].children) {
            const child = _child as THREE.Mesh<
              THREE.BoxBufferGeometry,
              THREE.MeshStandardMaterial
            >
            if (child.name === 'horizontalPiece') {
              child.material.map = horizontalTexture
            } else if (child.name === 'verticalPiece') {
              child.material.map = verticalTexture
            } else if (child.name === 'centerPiece') {
              const texture = verticalTexture.clone()
              texture.repeat.set(
                child.geometry.parameters.width / tLength,
                child.geometry.parameters.height / tWidth
              )
              texture.needsUpdate = true

              child.material.map = texture
            }

            child.material.needsUpdate = true
          }
        }
      } else if (item.props.type === 'newDoor') {
        const height = item.props.height
        const width = item.props.width
        const doubleSheetWidth =
          width / 2 - this.configs.doorConfig.verticalGap / 2

        const material = obj.hardware.material

        const newTexture = material?.texture.clone() || new THREE.Texture()
        newTexture.wrapS = THREE.RepeatWrapping
        newTexture.wrapT = THREE.RepeatWrapping

        newTexture.repeat.set(
          height / (material?.tLength || 1),
          (item.props.subType === 'double' ? doubleSheetWidth : width) /
            (material?.tWidth || 1)
        )
        newTexture.needsUpdate = true

        const newMaterial = new THREE.MeshStandardMaterial({ map: newTexture })
        const textureColor = getTextureColor(newTexture)
        const blendingMaterial = getNewBlendingMaterial(
          item.object3D,
          textureColor
        )

        // @ts-ignore
        item.object3D.children[0].material[0] = newMaterial
        // @ts-ignore
        item.object3D.children[0].material[1] = newMaterial
        // @ts-ignore
        item.object3D.children[0].material[2] = newMaterial
        // @ts-ignore
        item.object3D.children[0].material[3] = newMaterial
        // @ts-ignore
        item.object3D.children[0].material[4] = blendingMaterial
        // if (item.object3D.children[0].material[4].uniforms) {
        //   // @ts-ignore
        //   item.object3D.children[0].material[4].uniforms.material2Color.value =
        //     new THREE.Color(textureColor)
        // }
        // @ts-ignore
        item.object3D.children[0].material[5] = newMaterial
        // @ts-ignore
        item.object3D.children[0].needsUpdate = true

        if (item.props.subType === 'double') {
          // @ts-ignore
          item.object3D.children[1].material[0] = newMaterial
          // @ts-ignore
          item.object3D.children[1].material[1] = newMaterial
          // @ts-ignore
          item.object3D.children[1].material[2] = newMaterial
          // @ts-ignore
          item.object3D.children[1].material[3] = newMaterial
          // @ts-ignore
          item.object3D.children[1].material[4] = blendingMaterial
          // if (item.object3D.children[1].material[4].uniforms) {
          //   // @ts-ignore

          //   item.object3D.children[1].material[4].uniforms.material2Color.value =
          //     new THREE.Color(textureColor)
          // }
          // @ts-ignore
          item.object3D.children[1].material[5] = newMaterial
          // @ts-ignore
          item.object3D.children[1].needsUpdate = true
        }
      } else if (item.props.type === 'cornerTwoDoor') {
        if (
          item.props.visualType === 'shaker_h' ||
          item.props.visualType === 'shaker_v'
        ) {
          const height = item.props.height
          const width1 = item.props.width1
          const width2 = item.props.width2

          const material = obj.hardware.material

          const newTexture = material?.texture.clone() || new THREE.Texture()
          newTexture.wrapS = THREE.RepeatWrapping
          newTexture.wrapT = THREE.RepeatWrapping
          const newTexture2 = newTexture.clone()

          if (item.props.visualType === 'shaker_v') {
            newTexture.rotation = Math.PI / 2
            newTexture.repeat.set(
              height / (material?.tLength || 1),
              width1 / (material?.tWidth || 1)
            )
            newTexture.needsUpdate = true

            newTexture2.rotation = Math.PI / 2
            newTexture2.repeat.set(
              height / (material?.tLength || 1),
              width2 / (material?.tWidth || 1)
            )
            newTexture2.needsUpdate = true
          } else {
            newTexture.repeat.set(
              height / (material?.tLength || 1),
              width1 / (material?.tWidth || 1)
            )
            newTexture.needsUpdate = true

            newTexture2.repeat.set(
              height / (material?.tLength || 1),
              width2 / (material?.tWidth || 1)
            )
            newTexture2.needsUpdate = true
          }

          // @ts-ignore0
          item.object3D.children[0].material.map = newTexture
          // @ts-ignore
          item.object3D.children[0].material.needsUpdate = true

          // @ts-ignore0
          item.object3D.children[1].children[0].material.map = newTexture2
          // @ts-ignore
          item.object3D.children[1].children[0].material.needsUpdate = true
        } else {
          const newTexture1 = material?.texture.clone() || new THREE.Texture()
          newTexture1.wrapS = THREE.RepeatWrapping
          newTexture1.wrapT = THREE.RepeatWrapping
          const newTexture2 = newTexture1.clone()

          if (item.props.subType === 'right') {
            // @ts-ignore
            newTexture1.repeat.set(1, material.tLength / material.tWidth)
            newTexture1.needsUpdate = true

            // @ts-ignore
            newTexture2.repeat.set(
              // @ts-ignore
              item.props.width2 / material.tLength,
              // @ts-ignore
              item.props.height / material.tWidth
            )
            newTexture2.needsUpdate = true

            // @ts-ignore
            applyBoxUV(
              // @ts-ignore
              item.object3D.children[0].geometry,
              new THREE.Matrix4().fromArray([
                1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
              ]),
              // @ts-ignore
              material.tLength
            )
            // @ts-ignore
            item.object3D.children[0].geometry.attributes.uv.needsUpdate = true
            // @ts-ignore
            item.object3D.children[0].material.map = newTexture1
            // @ts-ignore
            item.object3D.children[0].material.needsUpdate = true

            // @ts-ignore
            item.object3D.children[1].material.map = newTexture2
            // @ts-ignore
            item.object3D.children[1].material.needsUpdate = true
          } else {
            // @ts-ignore
            newTexture1.repeat.set(
              // @ts-ignore
              item.props.width1 / material.tLength,
              // @ts-ignore
              item.props.height / material.tWidth
            )
            newTexture1.needsUpdate = true

            // @ts-ignore
            newTexture2.repeat.set(1, material.tLength / material.tWidth)
            newTexture2.needsUpdate = true

            // @ts-ignore
            item.object3D.children[0].material.map = newTexture1
            // @ts-ignore
            item.object3D.children[0].material.needsUpdate = true

            // @ts-ignore
            applyBoxUV(
              // @ts-ignore
              item.object3D.children[1].geometry,
              new THREE.Matrix4().fromArray([
                1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
              ]),
              // @ts-ignore
              material.tLength
            )
            // @ts-ignore
            item.object3D.children[1].geometry.attributes.uv.needsUpdate = true
            // @ts-ignore
            item.object3D.children[1].material.map = newTexture2
            // @ts-ignore
            item.object3D.children[1].material.needsUpdate = true
          }
        }
      } else if (item.props.type === 'cornerTwoDoorFivePieces') {
        const fivePiecesConfig = this.configs.fivePiecesConfig
        const height = item.props.height
        const width1 = item.props.width1
        const width2 = item.props.width2

        // @ts-ignore
        const tWidth = material.tWidth
        // @ts-ignore
        const tLength = material.tLength

        const lTexture1 = material?.texture.clone() || new THREE.Texture()
        lTexture1.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          height / tWidth
        )
        lTexture1.needsUpdate = true

        const rTexture1 = lTexture1.clone()
        rTexture1.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          height / tWidth
        )
        rTexture1.needsUpdate = true

        const tTexture1 = lTexture1.clone()
        tTexture1.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          (width1 - fivePiecesConfig.pieceWidth * 2) / tWidth
        )
        tTexture1.needsUpdate = true

        const bTexture1 = lTexture1.clone()
        bTexture1.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          (width1 - fivePiecesConfig.pieceWidth * 2) / tWidth
        )
        bTexture1.needsUpdate = true

        const centerPieceWidth1 = width1 - fivePiecesConfig.pieceWidth * 2
        const centerPieceHeight = height - fivePiecesConfig.pieceWidth * 2

        const cTexture1 = lTexture1.clone()
        cTexture1.repeat.set(
          centerPieceWidth1 / tLength,
          centerPieceHeight / tWidth
        )
        cTexture1.needsUpdate = true

        // @ts-ignore
        item.object3D.children[0].children[0].material.map = cTexture1
        // @ts-ignore
        item.object3D.children[0].children[1].material.map = lTexture1
        // @ts-ignore
        item.object3D.children[0].children[2].material.map = rTexture1
        // @ts-ignore
        item.object3D.children[0].children[3].material.map = tTexture1
        // @ts-ignore
        item.object3D.children[0].children[4].material.map = bTexture1

        // @ts-ignore
        item.object3D.children[0].children[0].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[0].children[1].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[0].children[2].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[0].children[3].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[0].children[4].material.needsUpdate = true

        const lTexture2 = material?.texture.clone() || new THREE.Texture()
        lTexture2.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          height / tWidth
        )
        lTexture2.needsUpdate = true

        const rTexture2 = lTexture2.clone()
        rTexture2.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          height / tWidth
        )
        rTexture2.needsUpdate = true

        const tTexture2 = lTexture2.clone()
        tTexture2.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          (width2 - fivePiecesConfig.pieceWidth * 2) / tWidth
        )
        tTexture2.needsUpdate = true

        const bTexture2 = lTexture2.clone()
        bTexture2.repeat.set(
          fivePiecesConfig.pieceWidth / tLength,
          (width2 - fivePiecesConfig.pieceWidth * 2) / tWidth
        )
        bTexture2.needsUpdate = true

        const centerPieceWidth2 = width2 - fivePiecesConfig.pieceWidth * 2

        const cTexture2 = lTexture2.clone()
        cTexture2.repeat.set(
          centerPieceWidth2 / tLength,
          centerPieceHeight / tWidth
        )
        cTexture2.needsUpdate = true

        // @ts-ignore
        item.object3D.children[1].children[0].children[0].material.map =
          cTexture2
        // @ts-ignore
        item.object3D.children[1].children[0].children[1].material.map =
          lTexture2
        // @ts-ignore
        item.object3D.children[1].children[0].children[2].material.map =
          rTexture2
        // @ts-ignore
        item.object3D.children[1].children[0].children[3].material.map =
          tTexture2
        // @ts-ignore
        item.object3D.children[1].children[0].children[4].material.map =
          bTexture2

        // @ts-ignore
        item.object3D.children[1].children[0].children[0].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[1].children[0].children[1].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[1].children[0].children[2].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[1].children[0].children[3].material.needsUpdate = true
        // @ts-ignore
        item.object3D.children[1].children[0].children[4].material.needsUpdate = true
      } else if (item.props.type === 'cornerNewDoor') {
        const height = item.props.height
        const width = item.props.width1

        const material = obj.hardware.material

        const newTexture = material?.texture.clone() || new THREE.Texture()
        newTexture.wrapS = THREE.RepeatWrapping
        newTexture.wrapT = THREE.RepeatWrapping

        newTexture.repeat.set(
          height / (material?.tLength || 1),
          width / (material?.tWidth || 1)
        )
        newTexture.needsUpdate = true

        const newMaterial = new THREE.MeshStandardMaterial({ map: newTexture })
        const textureColor = getTextureColor(newTexture)
        const blendingMaterial1 = getNewBlendingMaterial(
          item.object3D.children[0],
          textureColor
        )
        const blendingMaterial2 = getNewBlendingMaterial(
          item.object3D.children[1],
          textureColor
        )

        // @ts-ignore
        item.object3D.children[0].children[0].material[0] = newMaterial
        // @ts-ignore
        item.object3D.children[0].children[0].material[1] = newMaterial
        // @ts-ignore
        item.object3D.children[0].children[0].material[2] = newMaterial
        // @ts-ignore
        item.object3D.children[0].children[0].material[3] = newMaterial
        // @ts-ignore
        item.object3D.children[0].children[0].material[4] = blendingMaterial1

        // if (item.object3D.children[0].children[0].material[4].uniforms) {
        //   // @ts-ignore
        //   item.object3D.children[0].children[0].material[4].uniforms.material2Color.value =
        //     new THREE.Color(textureColor)
        // }
        // @ts-ignore
        item.object3D.children[0].children[0].material[5] = newMaterial
        // @ts-ignore
        item.object3D.children[0].children[0].needsUpdate = true

        // @ts-ignore
        item.object3D.children[1].children[0].material[0] = newMaterial
        // @ts-ignore
        item.object3D.children[1].children[0].material[1] = newMaterial
        // @ts-ignore
        item.object3D.children[1].children[0].material[2] = newMaterial
        // @ts-ignore
        item.object3D.children[1].children[0].material[3] = newMaterial
        // @ts-ignore
        item.object3D.children[1].children[0].material[4] = blendingMaterial2
        // if (item.object3D.children[1].children[0].material[4].uniforms) {
        //   // @ts-ignore
        //   item.object3D.children[1].children[0].material[4].uniforms.material2Color.value =
        //     new THREE.Color(textureColor)
        // }
        // @ts-ignore
        item.object3D.children[1].children[0].material[5] = newMaterial
        // @ts-ignore
        item.object3D.children[1].children[0].needsUpdate = true
      } else if (item.props.type === 'cornerHorizontalSheet') {
        const newTexture = material?.texture.clone() || new THREE.Texture()
        newTexture.wrapS = THREE.RepeatWrapping
        newTexture.wrapT = THREE.RepeatWrapping

        // @ts-ignore
        newTexture.repeat.set(1, material.tLength / material.tWidth)
        newTexture.needsUpdate = true

        // @ts-ignore
        applyBoxUV(
          // @ts-ignore
          item.object3D.geometry,
          new THREE.Matrix4().fromArray([
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
          ]),
          // @ts-ignore
          material.tLength
        )

        const _material = new THREE.MeshStandardMaterial({
          map: newTexture,
        })
        const bMat = new THREE.MeshBasicMaterial({ color: 'black' })

        // @ts-ignore
        item.object3D.geometry.attributes.uv.needsUpdate = true
        // @ts-ignore
        item.object3D.material = isPewter ? [_material, bMat] : _material
        // @ts-ignore
        item.object3D.material.needsUpdate = true
      } else {
        const needBlackEdgeBanding =
          cabinetBoxSheetsNames.includes(item.name) ||
          cabinetShelfSheetsStartNames.some((n) => item.name.startsWith(n))

        if (!(isPewter && needBlackEdgeBanding)) {
          // @ts-ignore
          item.object3D.material = new THREE.MeshStandardMaterial({
            map: material?.texture.clone(),
          })
          // @ts-ignore
          item.object3D.material.map.repeat.set(
            // @ts-ignore
            item.props.length / material.tLength,
            // @ts-ignore
            item.props.width / material.tWidth
          )
          // @ts-ignore
          item.object3D.material.map.needsUpdate = true
          // @ts-ignore
          item.object3D.material.needsUpdate = true
        } else {
          // @ts-ignore
          const _material = new THREE.MeshStandardMaterial({
            // @ts-ignore
            map: material?.texture.clone(),
          })
          // @ts-ignore
          _material.map.repeat.set(
            // @ts-ignore
            item.props.length / material.tLength,
            // @ts-ignore
            item.props.width / material.tWidth
          )
          // @ts-ignore
          _material.map.needsUpdate = true
          // @ts-ignore
          _material.needsUpdate = true

          const blackMat = new THREE.MeshBasicMaterial({ color: 'black' })
          // @ts-ignore
          item.object3D.material = [
            blackMat,
            blackMat,
            blackMat,
            blackMat,
            _material,
            _material,
          ]
        }
      }
    }

    this.makeRender()
  }

  setMaterialId = (id: number, forCabinet = true, mode = 1) => {
    // const hProps = this.hardwaresList.find(h => h.id === (forCabinet ? this.cabinetSheetHardwareId : this.panelSheetHardwareId))

    // if (hProps) {
    //     const materialsIds = hProps.materialsIds.filter(mId => mId[0] !== 'g')

    //     for (const mId of hProps.materialsIds) {
    //         if (mId[0] === 'g') {
    //             const mGroup = this.materialGroups.find(m => m.id.toString() === mId.slice(1))

    //             if (mGroup) {
    //                 for (const id of mGroup.materialsIds) {
    //                     if (!materialsIds.includes(id.toString()))
    //                         materialsIds.push(id.toString())
    //                 }
    //             }
    //         }
    //     }

    //     // if (materialsIds.includes(id.toString())) {
    //     hProps.defaultMaterialId = id

    if (forCabinet) this.cabinetSheetDefaultMaterialId = id
    else this.panelSheetDefaultMaterialId = id

    const isPewter = forCabinet && id === 76
    //     if (mode === 0)
    //         this.visualizeItems()
    //     else
    //         this.changeCabinetMaterialOnly(hProps, forCabinet)
    //     this.makeRender()
    //     // }
    // }

    const cabinetGroupId = 'g10'
    const panelGroupIds = ['g9', 'g24', 'g21', 'g25']

    const changedHardwaresIds = []

    for (const hProps of this.hardwaresList) {
      if (
        (forCabinet && hProps.materialsIds.includes(cabinetGroupId)) ||
        (!forCabinet &&
          hProps.materialsIds.some((id) => panelGroupIds.includes(id)))
      ) {
        hProps.defaultMaterialId = id
        changedHardwaresIds.push(hProps.id)
      }
    }

    if (mode === 1) this.visualizeCabinetProps()
    else this.changeCabinetMaterialOnly(changedHardwaresIds, isPewter)
    this.makeRender()
  }

  getMaterialIds = (forCabinet = true) => {
    // const hProps = this.hardwaresList.find(h => h.id === (forCabinet ? this.cabinetSheetHardwareId : this.panelSheetHardwareId))

    // if (hProps) {
    //     const materialsIds = hProps.materialsIds.filter(mId => mId[0] !== 'g')

    //     for (const mId of hProps.materialsIds) {
    //         if (mId[0] === 'g') {
    //             const mGroup = this.materialGroups.find(m => m.id.toString() === mId.slice(1))

    //             if (mGroup) {
    //                 for (const id of mGroup.materialsIds) {
    //                     if (!materialsIds.includes(id.toString()))
    //                         materialsIds.push(id.toString())
    //                 }
    //             }
    //         }
    //     }

    //     return materialsIds.join(',')
    // }
    // else return ''

    const materialGroup = this.materialGroups.find(
      (m) => m.id === (forCabinet ? 10 : 9)
    )

    if (materialGroup) {
      return materialGroup.materialsIds.join(',')
    }
    return ''
  }

  getExtraMaterialIds = (type: 'hinge' | 'drawerSlide' | 'pull') => {
    const hingeMGId = 13
    const drawerSlideMGId = 17
    const doorPullMGId = 14
    const drawerPullMGId = 15

    if (type === 'hinge') {
      const mGroup = this.materialGroups.find((m) => m.id === hingeMGId)

      if (mGroup) return mGroup.materialsIds.join(',')
      else return "Can't find material group with id " + hingeMGId
    } else if (type === 'drawerSlide') {
      const mGroup = this.materialGroups.find((m) => m.id === drawerSlideMGId)

      if (mGroup) return mGroup.materialsIds.join(',')
      else return "Can't find material group with id " + drawerSlideMGId
    } else if (type === 'pull') {
      const mGroup = this.materialGroups.find((m) => m.id === doorPullMGId)

      if (mGroup) return mGroup.materialsIds.join(',')
      else return "Can't find material group with id " + doorPullMGId
    }
    return 'Wrong type'
  }

  setExtraMaterialIds = (
    type: 'hinge' | 'drawerSlide' | 'pull',
    id: number,
    changeable: undefined | 'both' | 'door' | 'drawer' = 'both'
  ) => {
    const hingeMGId = 13
    const drawerSlideMGId = 17
    // const doorPullMGId = 14
    // const drawerPullMGId = 15
    // const drawerArchPullMGId = 29
    // const archPullMGId = 20
    const handlesHardwareIds = [
      174, 81, 149, 169, 170, 171, 173, 167, 168, 210, 211, 212, 213, 214, 215,
      216,
    ]

    const materialGroupIds = [] as number[]

    if (type === 'hinge') {
      materialGroupIds.push(hingeMGId)
    } else if (type === 'drawerSlide') {
      materialGroupIds.push(drawerSlideMGId)
    } else if (type === 'pull') {
      materialGroupIds.push(9999)
    }
    // else if (type === 'pull') {
    //   if (changeable !== 'drawer') {
    //     materialGroupIds.push(doorPullMGId)
    //     materialGroupIds.push(archPullMGId)
    //   }

    //   if (changeable !== 'door') {
    //     materialGroupIds.push(drawerPullMGId)
    //     materialGroupIds.push(drawerArchPullMGId)
    //   }
    // }

    const needMaterialChangeItems = [] as { item: Item; hardware: Hardware }[]

    for (const mgId of materialGroupIds) {
      const changedHardwaresIds = [] as number[]

      for (const hProps of this.hardwaresList) {
        if (type === 'pull') {
          if (handlesHardwareIds.includes(hProps.id)) {
            hProps.defaultMaterialId = id
            changedHardwaresIds.push(hProps.id)
          }
        } else {
          if (hProps.materialsIds.includes('g' + mgId.toString())) {
            hProps.defaultMaterialId = id
            changedHardwaresIds.push(hProps.id)
          }
        }
      }

      this.items.forEach((item, i) => {
        item.hardwares.forEach((hardware, j) => {
          if (changedHardwaresIds.includes(hardware.id)) {
            // item.hardwares[0] = this.createHardwares([{ id: hProps.id, localId: 1, count: 1 }])[0];
            const newHardware = this.createHardwares([
              {
                id: hardware.id,
                localId: hardware.localId,
                count: hardware.count,
              },
            ])[0]
            this.items[i].hardwares[j] = newHardware
            this.items[i].updateHardwareProps()

            if (
              needMaterialChangeItems.every(
                (obj) => obj.item.name !== item.name
              )
            )
              needMaterialChangeItems.push({ item, hardware: newHardware })
          }
        })

        if (item.children) {
          item.children.forEach((item1, i1) => {
            item1.hardwares.forEach((hardware, j1) => {
              if (changedHardwaresIds.includes(hardware.id)) {
                // item.hardwares[0] = this.createHardwares([{ id: hProps.id, localId: 1, count: 1 }])[0];
                const newHardware = this.createHardwares([
                  {
                    id: hardware.id,
                    localId: hardware.localId,
                    count: hardware.count,
                  },
                ])[0]
                item.children[i1].hardwares[j1] = newHardware
                item.children[i1].updateHardwareProps()

                if (
                  needMaterialChangeItems.every(
                    (obj) => obj.item.name !== item.name
                  )
                )
                  needMaterialChangeItems.push({ item, hardware: newHardware })
              }
            })
          })
        }
      })
    }

    for (const obj of needMaterialChangeItems) {
      const { item, hardware } = obj

      if (changeable !== 'both') {
        if (!item.props.type.toLowerCase().includes(changeable)) continue
      }

      if (type === 'pull') {
        let material = hardware?.material

        const threePropsObj = safeDecodeAndParse(material?.threeProps || '')

        const newMaterial = new THREE.MeshPhysicalMaterial({
          metalness: 1,
          roughness: 0,
          envMap: cubMap,
          ...threePropsObj,
        })

        if (
          item.props.type === 'drawer' ||
          item.props.type === 'fivePiecesDrawer' ||
          item.props.type === 'cornerTwoDoor' ||
          item.props.type === 'cornerTwoDoorFivePieces' ||
          item.props.type === 'cornerNewDoor'
        ) {
          const handleGroup =
            item.object3D.children[item.object3D.children.length - 1]

          if (handleGroup.userData.subType !== 'standard') {
            // @ts-ignore
            handleGroup.material = newMaterial
          } else {
            // @ts-ignore
            handleGroup.children[0].material = newMaterial
          }
        } else if (
          item.props.type === 'door' ||
          item.props.type === 'newDoor' ||
          item.props.type === 'fivePiecesDoor'
        ) {
          if (item.props.subType === 'double') {
            const leftHandleGroup = item.object3D.children[2]
            const rightHandleGroup = item.object3D.children[3]

            if (leftHandleGroup.userData.subType !== 'standard') {
              // @ts-ignore
              leftHandleGroup.material = newMaterial
              // @ts-ignore
              rightHandleGroup.material = newMaterial
            } else {
              // @ts-ignore
              leftHandleGroup.children[0].material = newMaterial
              // @ts-ignore
              rightHandleGroup.children[0].material = newMaterial
            }
          } else {
            const handleGroup = item.object3D.children[1]

            if (handleGroup.userData.subType !== 'standard') {
              // @ts-ignore
              handleGroup.material = newMaterial
            } else {
              // @ts-ignore
              handleGroup.children[0].material = newMaterial
            }
          }
        }
      } else {
        let color = undefined

        let texture = hardware?.material?.texture
        if (texture && texture.name.startsWith('color||')) {
          color = new THREE.Color(texture.name.slice(7))
        }

        if (!color) continue

        if (
          item.props.type === 'drawer' ||
          item.props.type === 'fivePiecesDrawer' ||
          item.props.type === 'cornerTwoDoor'
        ) {
          const handleGroup =
            item.object3D.children[item.object3D.children.length - 1]

          if (handleGroup.userData.subType !== 'standard') {
            // @ts-ignore
            handleGroup.material.color = color
          } else {
            // @ts-ignore
            handleGroup.children[0].material.color = color
          }
        } else if (
          item.props.type === 'door' ||
          item.props.type === 'newDoor' ||
          item.props.type === 'fivePiecesDoor'
        ) {
          if (item.props.subType === 'double') {
            const leftHandleGroup = item.object3D.children[2]
            const rightHandleGroup = item.object3D.children[3]

            if (leftHandleGroup.userData.subType !== 'standard') {
              // @ts-ignore
              leftHandleGroup.material.color = color
              // @ts-ignore
              rightHandleGroup.material.color = color
            } else {
              // @ts-ignore
              leftHandleGroup.children[0].material.color = color
              // @ts-ignore
              rightHandleGroup.children[0].material.color = color
            }
          } else {
            const handleGroup = item.object3D.children[1]

            if (handleGroup.userData.subType !== 'standard') {
              // @ts-ignore
              handleGroup.material.color = color
            } else {
              // @ts-ignore
              handleGroup.children[0].material.color = color
            }
          }
        }
      }
    }
  }

  setMaterialChangeableHardwareIds = () => {
    const itemProps = this.itemsPropsList.find((i) => i.name === 'Bottom')

    if (itemProps) {
      for (const hId of itemProps.hardwaresProps) {
        const hProps = this.hardwaresList.find((h) => h.id === hId.id)
        if (hProps && hProps.unitPrice === -1) {
          this.cabinetSheetHardwareId = hId.id
        }
      }
    }

    // const panelItemProps = this.itemsPropsList.find(i => i.name === 'drawer')

    // if (panelItemProps) {
    //     for (const hId of panelItemProps.hardwaresProps) {
    //         const hProps = this.hardwaresList.find(h => h.id === hId.id)
    //         if (hProps && hProps.unitPrice === -1)
    //             this.panelSheetHardwareId = hId.id
    //     }
    // }
    this.panelSheetHardwareId = this.doorVisualType === 'vGroove' ? 107 : 106
  }

  isHaveMultipleSingeDoors = () => {
    const props = this.isCorner ? this.cornerCabinetProps : this.cabinetProps
    return (
      props.sectionProps.doorsProps.filter(
        (d) => d.type === 'left' || d.type === 'right'
      ).length > 1
    )
  }

  changeDoor = (
    isThere: boolean,
    type: DoorPropsType['type'],
    forAllSingleDoors = false
  ) => {
    const sectionIndex = this.modifiableSection - 1

    if (forAllSingleDoors) {
      const newCabinetProps = clone(
        !this.isCorner ? this.cabinetProps : this.cornerCabinetProps
      )
      newCabinetProps.sectionProps.doorsProps
        .filter((d) => d.type === 'left' || d.type === 'right')
        .forEach((dProps) => {
          dProps.type = type
          dProps.handleProps.positionX =
            type === 'left' ? 'right' : type === 'right' ? 'left' : 'center'
          dProps.uuid = THREE.MathUtils.generateUUID()
        })
      this.updateCabinetProps(newCabinetProps)
    } else if (sectionIndex !== -2) {
      const newCabinetProps = clone(
        !this.isCorner ? this.cabinetProps : this.cornerCabinetProps
      )

      if (isThere) {
        if (
          newCabinetProps.sectionProps.doorsProps.filter(
            (dProps) =>
              dProps.sectionNumber === this.sectionLocks[sectionIndex].number
          ).length > 0
        ) {
          newCabinetProps.sectionProps.doorsProps.forEach((dProps) => {
            if (
              dProps.sectionNumber === this.sectionLocks[sectionIndex].number
            ) {
              dProps.type = type
              dProps.handleProps.positionX =
                type === 'left' ? 'right' : type === 'right' ? 'left' : 'center'
              dProps.uuid = THREE.MathUtils.generateUUID()
            }
          })
        } else {
          newCabinetProps.sectionProps.doorsProps.push({
            type,
            uuid: THREE.MathUtils.generateUUID(),
            sectionNumber: this.sectionLocks[sectionIndex].number,
            sectionY:
              this.section.sections.length > 0
                ? this.section.sections.find(
                    (s) =>
                      s.name.split('_')[1] ===
                      this.sectionLocks[sectionIndex].number.toString()
                  )?.y || 0
                : 0,
            sectionHeight:
              this.section.sections.length > 0
                ? this.section.sections.find(
                    (s) =>
                      s.name.split('_')[1] ===
                      this.sectionLocks[sectionIndex].number.toString()
                  )?.height || 0
                : this.section.height,
            handleProps: {
              type: 'pull',
              subtype: 'standard',
              position:
                this.type === 'base'
                  ? 'top'
                  : this.type === 'upper' || this.type === 'upperOpen'
                    ? 'bottom'
                    : 'fromGround',
              orientation: 'vertical',
              positionX:
                type === 'left'
                  ? 'right'
                  : type === 'right'
                    ? 'left'
                    : 'center',
            },
            visualType: this.doorVisualType,
          })
        }
      } else {
        newCabinetProps.sectionProps.doorsProps =
          newCabinetProps.sectionProps.doorsProps.filter(
            (dProps) =>
              dProps.sectionNumber !== this.sectionLocks[sectionIndex].number
          )
      }

      this.updateCabinetProps(newCabinetProps)
    }
  }

  validateDrawerVisualType = (
    visualType: DrawerVisualType
  ): DrawerVisualType => {
    if (visualType.startsWith('#')) {
      const isS01 = visualType.split('-').pop() === 'S01'

      return isS01 ? '#B100-R000-S01' : '#B100-R000-S04'
    }

    return visualType
  }

  getRaisedPanelFlatType = (visualType: DrawerVisualType): DrawerVisualType => {
    if (visualType.startsWith('#')) {
      const isS01 = visualType.split('-').pop() === 'S01'

      return isS01 ? '#B100-R000-S01' : '#B100-R000-S04'
    }

    return visualType
  }

  changePanelsVisualType = (
    _visualType: DoorVisualType | 'shaker_melamine',
    changeable = 'both',
    mode = 0,
    drawerHandlePos?: 'center' | 'top',
    forAll = false
  ) => {
    const newCabinetProps = clone(
      !this.isCorner ? this.cabinetProps : this.cornerCabinetProps
    )
    const visualType =
      _visualType === 'shaker_melamine' ? 'shaker_v' : _visualType

    if (changeable !== 'drawer') {
      for (const doorProps of newCabinetProps.sectionProps.doorsProps) {
        doorProps.visualType = visualType
        doorProps.uuid = THREE.MathUtils.generateUUID()
      }
    }

    if (changeable !== 'door') {
      for (const drawerProps of newCabinetProps.sectionProps.drawersProps) {
        const name = `Drawer ${drawerProps.sectionNumber}`

        const obj = this.items.find((i) => i.name === name)?.object3D

        let isSmall = false // !!obj?.userData?.isSmall
        const height = obj?.userData?.drawerHeight || 0

        if (visualType === 'fivePieces') {
          const drawerMaxHeight = 7.25 * 2.54
          if (height < drawerMaxHeight) {
            isSmall = true
          }
        } else if (visualType.startsWith('#')) {
          const drawerInnerType = visualType.replaceAll('-', '').slice(1, 9)
          // @ts-ignore
          const configs = newDoorConfigs[drawerInnerType]
          const drawerMaxHeight = configs.drawerMaxHeight * 2.54
          isSmall = height < drawerMaxHeight
        }

        if (mode === 1) {
          // Doors + all drawers
          drawerProps.visualType =
            visualType === 'vGroove' ? 'standard' : visualType

          if (_visualType === 'shaker_melamine') {
            drawerProps.handleProps.position =
              drawerHandlePos === 'center' ? 'forDrawerCenter' : 'forDrawer'
          } else {
            drawerProps.handleProps.position = isSmall
              ? 'forDrawerCenter'
              : 'forDrawer'
          }
        } else if (mode === 2) {
          // Only Doors
          drawerProps.visualType = this.getRaisedPanelFlatType(
            visualType === 'vGroove' ? 'standard' : visualType
          )

          if (_visualType === 'shaker_melamine' || visualType.startsWith('#')) {
            drawerProps.handleProps.position =
              drawerHandlePos === 'center' ? 'forDrawerCenter' : 'forDrawer'
          } else {
            drawerProps.handleProps.position = 'forDrawer'
          }
        } else {
          // Doors + big drawers
          if (isSmall) {
            drawerProps.visualType = this.getRaisedPanelFlatType(
              visualType === 'vGroove' ? 'standard' : visualType
            )
          } else {
            drawerProps.visualType =
              visualType === 'vGroove' ? 'standard' : visualType
          }

          if (
            _visualType === 'shaker_melamine' ||
            (isSmall && visualType.startsWith('#'))
          ) {
            drawerProps.handleProps.position =
              drawerHandlePos === 'center' ? 'forDrawerCenter' : 'forDrawer'
          } else {
            drawerProps.handleProps.position = 'forDrawer'
          }
        }

        if (_visualType !== 'shaker_melamine' && !visualType.startsWith('#')) {
          if (isSmall) {
            if (visualType === 'fivePieces') {
              drawerProps.handleProps.position = 'forDrawerCenter'
            } else {
              drawerProps.handleProps.position = 'forDrawer'
            }
          }
        }

        if (forAll && !(visualType.startsWith('#') && isSmall)) {
          drawerProps.handleProps.position =
            drawerHandlePos === 'center' ? 'forDrawerCenter' : 'forDrawer'
        }

        drawerProps.uuid = THREE.MathUtils.generateUUID()
      }
    }

    this.updateCabinetProps(newCabinetProps)
  }

  changeFivePieceMode = (
    mode: number,
    drawerHandlePos?: 'center' | 'top',
    forAll = false
  ) => {
    const newCabinetProps = clone(
      !this.isCorner ? this.cabinetProps : this.cornerCabinetProps
    )

    for (const doorProps of newCabinetProps.sectionProps.doorsProps) {
      doorProps.visualType = 'fivePieces'
      doorProps.uuid = THREE.MathUtils.generateUUID()
    }

    for (const drawerProps of newCabinetProps.sectionProps.drawersProps) {
      const name = `Drawer ${drawerProps.sectionNumber}`
      const obj = this.items.find((i) => i.name === name)?.object3D
      let isSmall = false // !!obj?.userData?.isSmall
      const height = obj?.userData?.drawerHeight || 0
      const drawerMaxHeight = 7.25 * 2.54

      if (height < drawerMaxHeight) {
        isSmall = true
      }

      // if (mode === 1) {
      //   // Doors + all drawers
      //   drawerProps.visualType = 'fivePieces'
      //   drawerProps.handleProps.position = isSmall
      //     ? 'forDrawerCenter'
      //     : 'forDrawer'
      // } else
      if (mode === 2) {
        // Only Doors
        drawerProps.visualType = 'shaker_h'
        drawerProps.handleProps.position =
          drawerHandlePos === 'center' ? 'forDrawerCenter' : 'forDrawer'
      } else {
        // Doors + big drawers
        if (isSmall) {
          drawerProps.visualType = 'shaker_h'
          drawerProps.handleProps.position =
            drawerHandlePos === 'center' ? 'forDrawerCenter' : 'forDrawer'
        } else {
          drawerProps.visualType = 'fivePieces'
          drawerProps.handleProps.position = isSmall
            ? 'forDrawerCenter'
            : 'forDrawer'
        }
      }

      if (forAll) {
        drawerProps.handleProps.position =
          drawerHandlePos === 'center' ? 'forDrawerCenter' : 'forDrawer'
      }

      drawerProps.uuid = THREE.MathUtils.generateUUID()
    }

    this.updateCabinetProps(newCabinetProps)
  }

  changeShelfCount = (count: number) => {
    const sectionIndex = this.modifiableSection - 1

    if (sectionIndex !== -2) {
      const newCabinetProps = clone(
        !this.isCorner ? this.cabinetProps : this.cornerCabinetProps
      )

      if (
        newCabinetProps.sectionProps.shelvesProps.find(
          (shProps) =>
            shProps.sectionNumber === this.sectionLocks[sectionIndex].number
        )
      )
        newCabinetProps.sectionProps.shelvesProps.forEach((shProps) => {
          if (
            shProps.sectionNumber === this.sectionLocks[sectionIndex].number
          ) {
            shProps.count = count
          }
        })
      else {
        newCabinetProps.sectionProps.shelvesProps.push({
          sectionNumber: this.sectionLocks[sectionIndex].number,
          sectionY:
            this.section.sections.length > 0
              ? this.section.sections.find(
                  (s) =>
                    s.name.split('_')[1] ===
                    this.sectionLocks[sectionIndex].number.toString()
                )?.y || 0
              : 0,
          sectionHeight:
            this.section.sections.length > 0
              ? this.section.sections.find(
                  (s) =>
                    s.name.split('_')[1] ===
                    this.sectionLocks[sectionIndex].number.toString()
                )?.height || 0
              : this.section.height,
          count,
        })
      }

      this.updateCabinetProps(newCabinetProps)
    }
  }

  changeHandleType = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    changeable = 'both'
  ) => {
    if (!this.isCorner) {
      if (changeable !== 'drawer')
        for (const dp of this.cabinetProps.sectionProps.doorsProps) {
          dp.handleProps.type = type
          dp.handleProps.subtype = subType
        }
      if (changeable !== 'door')
        for (const dp of this.cabinetProps.sectionProps.drawersProps) {
          dp.handleProps.type = type
          dp.handleProps.subtype = subType
        }
    } else {
      if (changeable !== 'drawer')
        for (const dp of this.cornerCabinetProps.sectionProps.doorsProps) {
          dp.handleProps.type = type
          dp.handleProps.subtype = subType
        }
    }

    this.visualizeCabinetProps()
  }

  changeLegType = (
    type: LegPropsType['type'],
    height = -1,
    subType?: LegPropsType['subType'],
    baseSubType?: LegPropsType['baseSubType']
  ) => {
    this.legProps.type = type
    this.legProps.subType = subType
    this.legProps.baseSubType = baseSubType

    if (height !== -1) {
      if (!this.isCorner) {
        this.cabinetProps.legHeight = height
      } else {
        this.cornerCabinetProps.legHeight = height
      }
    }

    this.visualizeCabinetProps()
  }

  changeToeKickProps = (
    cutValue: number,
    type: 'notched' | 'inset',
    height: number
  ) => {
    this.legProps.baseSubType = type === 'inset' ? 'old' : 'new'
    this.baseLegCut = cutValue

    if (!this.isCorner) {
      this.cabinetProps.legHeight = height
    } else {
      this.cornerCabinetProps.legHeight = height
    }

    this.visualizeCabinetProps()
  }

  changeDrawerSlideType = (v: DrawerSlideType) => {
    this.drawerSlideType = v
    this.visualizeCabinetProps()
  }

  updateCabinetProps = (newCabinetProps: CabinetProps | CornerCabinetProps) => {
    if (this.cabinetProps.height !== newCabinetProps.height) {
      const prevHeight = !this.isCorner
        ? this.cabinetProps.height
        : this.cornerCabinetProps.height

      if (!this.isCorner) this.cabinetProps = newCabinetProps as CabinetProps
      else this.cornerCabinetProps = newCabinetProps as CornerCabinetProps

      this.handleCabinetHeightChange(prevHeight)
    } else {
      if (!this.isCorner) this.cabinetProps = newCabinetProps as CabinetProps
      else this.cornerCabinetProps = newCabinetProps as CornerCabinetProps
    }

    this.visualizeCabinetProps()

    this.makeRender()
  }

  officeMarkupIds = {
    from: 1,
    to: 11,
  }

  createHardwares = (hProps: ItemPropsType['hardwaresProps']) => {
    const hardwares = [] as Array<Hardware>
    // let lastLocalId = Math.max(...ids.map(id => id.localId), 0)

    for (const id of hProps) {
      const hProps = this.hardwaresList.find((h) => h.id === id.id)

      if (!hProps) continue

      if (this.forOffice && hProps.markupId === this.officeMarkupIds.from) {
        hProps.markupId = this.officeMarkupIds.to
      }

      const markupValue = this.markupsList.find(
        (m) => m.id === hProps?.markupId
      )?.value

      if (hProps !== undefined && markupValue !== undefined) {
        const childrenIds = [] as {
          id: number
          localId: number
          count: number
        }[]
        let lastLocalId = 0

        hProps.childrenIds.forEach((id) => {
          lastLocalId++
          childrenIds.push({ id, localId: lastLocalId, count: 1 })
        })

        // const materialsProps = this.props.materials.filter(m => hProps.materialsIds.includes(m.id))
        // const materials = materialsProps.map(m => new Material(m.id, m.name, m.price, m.addon, m.texture))
        const materialProps = this.materialsList.find(
          (m) => m.id === hProps.defaultMaterialId
        )
        let material
        if (materialProps)
          material = new Material(
            materialProps.id,
            materialProps.name,
            materialProps.weight,
            materialProps.price,
            materialProps.addon,
            materialProps.texture.texture,
            materialProps.length,
            materialProps.width,
            materialProps.threeProps
          )

        hardwares.push(
          new Hardware(
            id,
            hProps.name,
            hProps.type,
            hProps.unitWeight,
            hProps.unitPrice,
            hProps.unitPriceAddon,
            hProps.addonD,
            hProps.addonP,
            hProps.minPrice,
            markupValue,
            material,
            this.createHardwares(childrenIds),
            this.configs.drawerConfig,
            this.configs.hingeBreakpoints
          )
        )
      }
    }

    return hardwares
  }

  visualizeItems = () => {
    this.isPanelsOpen = false
    this.animatingPanels = false

    const items = function makeItems(
      this: Cabinet,
      itemsProps: ItemPropsType[],
      parentItem?: Item
    ) {
      const items = [] as Item[]
      for (const itemProps of itemsProps) {
        if (itemProps.render) {
          const item = new Item(
            itemProps.name,
            itemProps.props,
            this.createHardwares(itemProps.hardwaresProps),
            itemProps.links,
            itemProps.addon,
            this.configs,
            parentItem
          )

          item.object3D.applyMatrix4(
            new THREE.Matrix4().fromArray(itemProps.matrix)
          )

          if (parentItem) {
            const index = parentItem.object3D.children.findIndex(
              (child) => child.name === item.name
            )
            if (index === -1) parentItem.object3D.add(item.object3D)
            else parentItem.object3D.children[index] = item.object3D
          } else {
            const index = this.object.children.findIndex(
              (child) => child.name === item.name
            )
            if (index === -1) this.object.add(item.object3D)
            else this.object.children[index] = item.object3D
          }

          if (itemProps.childrenProps.length > 0)
            item.children = makeItems.call(this, itemProps.childrenProps, item)

          items.push(item)
        }
      }

      return items
    }.call(this, this.itemsPropsList)

    this.items = items
  }

  recalculateDividers = (
    dividers: DividerPropsType[],
    deltaHeight: number,
    locks: SectionLock[]
  ) => {
    if (dividers.length === 0) return []

    const lockedSectionNumber = locks.filter(
      (lock) => lock.isLock === true
    ).length

    if (lockedSectionNumber === locks.length) return dividers

    const sectionDeltaHeight =
      deltaHeight / (locks.length - lockedSectionNumber)

    const newDividers = clone(dividers)

    if (!locks[0].isLock) {
      newDividers[0].top += sectionDeltaHeight
    }

    for (let i = 1; i < locks.length - 1; i++) {
      if (locks[i].isLock) {
        newDividers[i].top =
          newDividers[i - 1].top + (dividers[i].top - dividers[i - 1].top)
      } else {
        newDividers[i].top =
          newDividers[i - 1].top +
          (dividers[i].top - dividers[i - 1].top) +
          sectionDeltaHeight
      }
    }

    return newDividers
  }

  handleCabinetHeightChange = (prevHeight: number) => {
    if (this.sectionLocks.every((lock) => lock.isLock === true)) {
      this.cabinetProps.height = prevHeight
      this.cornerCabinetProps.height = prevHeight
    } else {
      let newHeight = !this.isCorner
        ? this.cabinetProps.height
        : this.cornerCabinetProps.height

      if (prevHeight > newHeight) {
        const delta = prevHeight - newHeight

        let sumOfNonLockedHeights = 0
        let countOfNonLocked = 0

        if (this.sectionLocks.length > 1)
          for (const lock of this.sectionLocks.filter((l) => !l.isLock)) {
            countOfNonLocked++
            sumOfNonLockedHeights +=
              this.section.sections.find(
                (s) => s.name.split('_')[1] === lock.number.toString()
              )?.height || 0
          }
        else {
          countOfNonLocked = this.sectionLocks[0].isLock ? 0 : 1
          sumOfNonLockedHeights = this.sectionLocks[0].isLock
            ? 0
            : this.section.height
        }

        if (delta > sumOfNonLockedHeights - countOfNonLocked * 5) {
          newHeight =
            prevHeight - (sumOfNonLockedHeights - countOfNonLocked * 5)
          this.cabinetProps.height = newHeight
          this.cornerCabinetProps.height = newHeight
        }
      }

      const newDividers = this.recalculateDividers(
        !this.isCorner
          ? this.cabinetProps.sectionProps.dividersProps
          : this.cornerCabinetProps.sectionProps.dividersProps,
        newHeight - prevHeight,
        this.sectionLocks
      )
      this.cabinetProps.sectionProps.dividersProps = newDividers
      this.cornerCabinetProps.sectionProps.dividersProps = newDividers

      const props = !this.isCorner ? this.cabinetProps : this.cornerCabinetProps

      this.recalculateAllShelvesAndDoorsPositions(
        clone(newDividers).sort((a, b) => a.top - b.top),
        props.height,
        props.sectionProps.shelvesProps,
        props.sectionProps.doorsProps,
        props.sectionProps.drawersProps
      )
    }
  }

  getHandleConfigs = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    defaultConfigs: ConfigsType['handleConfig']
  ) => {
    let legDist = defaultConfigs.legDist
    let legDiameter = defaultConfigs.legDiameter
    let distFromVerticalEdge =
      newHandleConfigs.distFromVerticalEdge.standard + legDist / 2

    if (type === 'knob') {
      if (subType === 'DHK401') {
        distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob401']
        legDiameter = newHandleConfigs.legDiameter['knob401']
      } else if (subType === 'DHK501') {
        distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob501']
        legDiameter = newHandleConfigs.legDiameter['knob501']
      } else {
        distFromVerticalEdge = newHandleConfigs.distFromVerticalEdge['knob301']
        legDiameter = newHandleConfigs.legDiameter['knob301']
      }
    } else if (type === 'pull') {
      if (subType === 'DHP306-96') {
        legDist = newHandleConfigs.legDist['DHP306-96']
        legDiameter = newHandleConfigs.legDiameter['DHP306-96']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP306-96'] + legDist / 2
      } else if (subType === 'DHP306-128') {
        legDist = newHandleConfigs.legDist['DHP306-128']
        legDiameter = newHandleConfigs.legDiameter['DHP306-128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP306-128'] + legDist / 2
      } else if (subType === 'DHP465-192') {
        legDist = newHandleConfigs.legDist['DHP465-192']
        legDiameter = newHandleConfigs.legDiameter['DHP465-192']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP465-192'] + legDist / 2
      } else if (subType === 'DHP504-76') {
        legDist = newHandleConfigs.legDist['DHP504-192']
        // legDiameter = newHandleConfigs.legDiameter['DHP504-192']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP504-192'] + legDist / 2
      } else if (subType === 'DHP180-128') {
        legDist = newHandleConfigs.legDist['DHP180-128']
        // legDiameter = newHandleConfigs.legDiameter['DHP180-128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP180-128'] + legDist / 2
      } else if (subType === 'DHP305MB96') {
        legDist = newHandleConfigs.legDist['DHP305MB96']
        legDiameter = newHandleConfigs.legDiameter['DHP305MB96']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP305MB96'] + legDist / 2
      } else if (subType === 'DHP305MB128') {
        legDist = newHandleConfigs.legDist['DHP305MB128']
        legDiameter = newHandleConfigs.legDiameter['DHP305MB128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['DHP305MB128'] + legDist / 2
      } else if (subType === 'BP723812') {
        legDist = newHandleConfigs.legDist['BP723812']
        legDiameter = newHandleConfigs.legDiameter['BP723812']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['BP723812'] + legDist / 2
      } else if (subType === 'BP873128') {
        legDist = newHandleConfigs.legDist['BP873128']
        legDiameter = newHandleConfigs.legDiameter['BP873128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['BP873128'] + legDist / 2
      } else if (subType === 'BP7470128') {
        legDist = newHandleConfigs.legDist['BP7470128']
        legDiameter = newHandleConfigs.legDiameter['BP7470128']
        distFromVerticalEdge =
          newHandleConfigs.distFromVerticalEdge['BP7470128'] + legDist / 2
      }
    }

    return { legDist, legDiameter, distFromVerticalEdge }
  }

  calculateDrawerHandleMatrix = (
    visualType: DrawerVisualType,
    handlePos: HandlePropsType['position'],
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    drawerHeight: number,
    handlePosX: HandlePropsType['positionX'],
    drawerWidth: number,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    const { legDist, distFromVerticalEdge, legDiameter } =
      this.getHandleConfigs(type, subType, handleConfig)

    if (handlePosX === 'left') {
      matrix[12] = -drawerWidth / 2 + distFromVerticalEdge
    } else if (handlePosX === 'right') {
      matrix[12] = drawerWidth / 2 - distFromVerticalEdge
    } else if (typeof handlePosX === 'number') {
      matrix[12] = -drawerWidth / 2 + legDist / 2 + handlePosX
    }

    let distY = this.configs.drawerConfig.handleRevalFromTop
    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'forDrawer') {
      matrix[13] = drawerHeight / 2 - distY
    } else if (handlePos === 'forDrawerCenter') {
      matrix[13] = 0
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(drawerHeight / 2 - handlePos) + legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.configs.thickness
        : this.configs.thickness / 2

    return matrix
  }

  calculateDrawerDoubleHandleMatrix = (
    visualType: DrawerVisualType,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    drawerHeight: number,
    drawerWidth: number,
    isLeft: boolean,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const distFromEdge = 15

    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    let legDist = handleConfig.legDist

    if (type === 'knob') {
      legDist = 0
    } else if (type === 'pull') {
      if (subType === 'DHP306-96') {
        legDist = newHandleConfigs.legDist['DHP306-96']
      } else if (subType === 'DHP306-128') {
        legDist = newHandleConfigs.legDist['DHP306-128']
      } else if (subType === 'DHP465-192') {
        legDist = newHandleConfigs.legDist['DHP465-192']
      } else if (subType === 'DHP504-76') {
        legDist = newHandleConfigs.legDist['DHP504-192']
      } else if (subType === 'DHP180-128') {
        legDist = newHandleConfigs.legDist['DHP180-128']
      } else if (subType === 'DHP305MB96') {
        legDist = newHandleConfigs.legDist['DHP305MB96']
      } else if (subType === 'DHP305MB128') {
        legDist = newHandleConfigs.legDist['DHP305MB128']
      } else if (subType === 'BP723812') {
        legDist = newHandleConfigs.legDist['BP723812']
      } else if (subType === 'BP873128') {
        legDist = newHandleConfigs.legDist['BP873128']
      } else if (subType === 'BP7470128') {
        legDist = newHandleConfigs.legDist['BP7470128']
      }
    }

    const { distFromVerticalEdge } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    if (typeof handlePosX === 'number') {
      // if (isLeft) {
      //     matrix[12] = handlePosX
      // } else if (!isLeft) {
      //     matrix[12] = -handlePosX
      // }
      matrix[12] =
        (isLeft ? 1 : -1) * (-drawerWidth / 2 + handlePosX + legDist / 2)
    } else {
      matrix[12] = (isLeft ? 1 : -1) * (-drawerWidth / 2 + distFromVerticalEdge)
    }

    let distY = this.configs.drawerConfig.handleRevalFromTop
    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'forDrawer') {
      matrix[13] = drawerHeight / 2 - distY
    } else if (handlePos === 'forDrawerCenter') {
      matrix[13] = 0
    } else if (typeof handlePos === 'number') {
      matrix[13] =
        -(drawerHeight / 2 - handlePos) + handleConfig.legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.configs.thickness
        : this.configs.thickness / 2

    return matrix
  }

  calculateLiftUpDoubleHandleMatrix = (
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    visualType: DoorVisualType,
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    doorHeight: number,
    doorWidth: number,
    isLeft: boolean,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const distFromEdge = 15

    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    let legDist = handleConfig.legDist

    if (type === 'pull') {
      if (subType === 'DHP306-96') {
        legDist = newHandleConfigs.legDist['DHP306-96']
      } else if (subType === 'DHP306-128') {
        legDist = newHandleConfigs.legDist['DHP306-128']
      } else if (subType === 'DHP465-192') {
        legDist = newHandleConfigs.legDist['DHP465-192']
      } else if (subType === 'DHP504-76') {
        legDist = newHandleConfigs.legDist['DHP504-192']
      } else if (subType === 'DHP180-128') {
        legDist = newHandleConfigs.legDist['DHP180-128']
      } else if (subType === 'DHP305MB96') {
        legDist = newHandleConfigs.legDist['DHP305MB96']
      } else if (subType === 'DHP305MB128') {
        legDist = newHandleConfigs.legDist['DHP305MB128']
      } else if (subType === 'BP723812') {
        legDist = newHandleConfigs.legDist['BP723812']
      } else if (subType === 'BP873128') {
        legDist = newHandleConfigs.legDist['BP873128']
      } else if (subType === 'BP7470128') {
        legDist = newHandleConfigs.legDist['BP7470128']
      }
    }

    const { distFromVerticalEdge } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    if (typeof handlePosX === 'number') {
      // if (isLeft) {
      //     matrix[12] = handlePosX
      // } else if (!isLeft) {
      //     matrix[12] = -handlePosX
      // }
      matrix[12] =
        (isLeft ? 1 : -1) * (-doorWidth / 2 + handlePosX + legDist / 2)
    } else {
      matrix[12] = (isLeft ? 1 : -1) * (-doorWidth / 2 + distFromVerticalEdge)
    }

    let distY = handleConfig.distFromEdge

    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'bottom') {
      matrix[13] = -(doorHeight / 2 - distY) //+ handleConfig.legDiameter / 2
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(doorHeight / 2 - handlePos) //+ handleConfig.legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.configs.thickness
        : this.configs.thickness / 2

    return matrix
  }

  calculateLiftUpDoorHandleMatrix = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    panelHeight: number,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    visualType: DoorVisualType,
    doorWidth: number,
    handleConfig: ConfigsType['handleConfig']
  ) => {
    const matrix =
      subType === 'DHP504-76'
        ? [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]
        : [
            2.220446049250313e-16, 1, 0, 0, -1, 2.220446049250313e-16, 0, 0, 0,
            0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/, 0 /*14 - z*/, 1,
          ]

    const { legDist, distFromVerticalEdge } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    if (handlePosX === 'left') {
      matrix[12] = -doorWidth / 2 + distFromVerticalEdge
    } else if (handlePosX === 'right') {
      matrix[12] = doorWidth / 2 - distFromVerticalEdge
    } else if (typeof handlePosX === 'number') {
      matrix[12] = -doorWidth / 2 + legDist / 2 + handlePosX
    }

    let distY = handleConfig.distFromEdge

    if (visualType.startsWith('#')) {
      // @ts-ignore
      distY = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distY = newDoorPullX['fivePieces']
    }

    if (handlePos === 'bottom') {
      matrix[13] = -(panelHeight / 2 - distY) //+ handleConfig.legDiameter / 2
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(panelHeight / 2 - handlePos) // + handleConfig.legDiameter / 2
    }

    matrix[14] =
      type === 'pull' && subType === 'standard'
        ? this.configs.thickness
        : this.configs.thickness / 2

    return matrix
  }

  calculateHandlePosition = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    isVertical: boolean,
    doorItemProps:
      | DoorItemPropsType
      | NewDoorItemPropsType
      | FivePiecesDoorItemPropsType,
    doorY: number,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    doubleHandleXPos?: 'left' | 'right',
    positionFromGroundValue?: number
  ) => {
    const matrix = [
      1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
      0 /*14 - z*/, 1,
    ]

    const doorWidth = doorItemProps.width
    const doorHeight = doorItemProps.height

    const handleConfig = this.configs.handleConfig
    const thickness = this.configs.thickness

    const { legDist, legDiameter } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    let distFromLegCenterToCenter = (legDist + legDiameter) / 2

    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (
      doorItemProps.type === 'newDoor' ||
      doorItemProps.type === 'fivePiecesDoor'
    ) {
      distX = newDoorPullX[doorItemProps.visualType]
    }

    if (doorItemProps.subType === 'double') {
      if (typeof handlePosX === 'number') {
        if (doubleHandleXPos === 'left') {
          if (isVertical) {
            matrix[12] = -handlePosX
          } else {
            matrix[12] = handlePosX
          }
        } else if (doubleHandleXPos === 'right') {
          if (isVertical) {
            matrix[12] = handlePosX
          } else {
            matrix[12] = -handlePosX
          }
        }
      } else {
        if (doubleHandleXPos === 'left') {
          if (isVertical) {
            matrix[12] = -distX
          } else {
            matrix[12] = distY
          }
        } else if (doubleHandleXPos === 'right') {
          if (isVertical) {
            matrix[12] = distX
          } else {
            matrix[12] = -distY
          }
        }
      }
    } else if (handlePosX === 'left') {
      //right door
      if (isVertical) {
        matrix[12] = -doorWidth / 2 + distX
      } else {
        matrix[12] = -doorWidth / 2 + (handlePos === 'center' ? distX : distY)
      }
    } else if (handlePosX === 'right') {
      //left door
      if (isVertical) {
        matrix[12] = doorWidth / 2 - distX
      } else {
        matrix[12] = doorWidth / 2 - (handlePos === 'center' ? distX : distY)
      }
    } else if (handlePosX === 'center') {
      if (isVertical) {
        matrix[12] = 0 //doorWidth / 2 - distFromEdge
      } else {
        matrix[12] = legDist / 2 //0 //doorWidth / 2 - handleConfig.distFromVerticalEdge
      }
    } else if (typeof handlePosX === 'number') {
      if (doorItemProps.subType === 'right') {
        matrix[12] = -doorWidth / 2 + handlePosX
      } else {
        matrix[12] = -doorWidth / 2 + (isVertical ? 0 : legDist) + handlePosX
      }
    }

    matrix[14] =
      type === 'pull' && subType === 'standard' ? thickness : thickness / 2

    if (handlePos === 'top') {
      if (isVertical) {
        matrix[13] = doorHeight / 2 - distY
        matrix[13] -= isVertical ? distFromLegCenterToCenter : legDiameter / 2
      } else {
        matrix[13] = doorHeight / 2 - distX
      }
    } else if (handlePos === 'bottom') {
      if (isVertical) {
        matrix[13] = -(doorHeight / 2 - distY)
        matrix[13] += isVertical ? distFromLegCenterToCenter : legDiameter / 2
      } else {
        matrix[13] = -doorHeight / 2 + distX
      }
    } else if (handlePos === 'center') {
      matrix[13] = 0
    } else if (handlePos === 'fromGround') {
      const height = !this.isCorner
        ? this.cabinetProps.height
        : this.cornerCabinetProps.height
      const legHeight = !this.isCorner
        ? this.cabinetProps.legHeight
        : this.cornerCabinetProps.legHeight

      const fromGroundValue =
        positionFromGroundValue ?? this.configs.handlePositionFromGround

      matrix[13] = -doorY + (fromGroundValue - legHeight) - height / 2 //+ handleConfig.legDist / 2 + handleConfig.legDiameter / 2
      // console.log(doorY, matrix[13])
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(doorHeight / 2 - handlePos) + distFromLegCenterToCenter
    }

    // if (!isVertical) {
    //   const temp = matrix[12]
    //   matrix[12] = -matrix[13]
    //   matrix[13] = -temp
    // }

    return matrix
  }

  calculateCornerTwoDoorHandlePosition = (
    type: HandlePropsType['type'],
    subType: HandlePropsType['subtype'],
    visualType: DoorVisualType,
    doorItemProps: CornerTwoDoorItemPropsType,
    doorPos: THREE.Vector3,
    handlePos: HandlePropsType['position'],
    handlePosX: HandlePropsType['positionX'],
    isVertical: boolean
  ) => {
    const matrix =
      doorItemProps.subType === 'right'
        ? [
            2.220446049250313e-16, -0, -1, 0, 0, 1, -0, 0, 1, 0,
            2.220446049250313e-16, 0, 0, 0, 0, 1,
          ]
        : [
            1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0 /*12 - x*/, 0 /*13 - y*/,
            0 /*14 - z*/, 1,
          ]

    const doorHeight = doorItemProps.height

    const handleConfig = this.configs.handleConfig

    const { legDist, legDiameter } = this.getHandleConfigs(
      type,
      subType,
      handleConfig
    )

    let distX = newDoorPullX['standard']
    const distY = doorPoolY

    if (visualType.startsWith('#')) {
      // @ts-ignore
      distX = newDoorPullX[visualType]
    } else if (visualType === 'fivePieces') {
      distX = newDoorPullX['fivePieces']
    }

    if (doorItemProps.subType === 'right') {
      matrix[12] =
        -(doorItemProps.width2 + doorItemProps.thickness) / 2 +
        doorItemProps.thickness / 2 +
        (handleConfig.legLength + handleConfig.diameter) / 2

      if (typeof handlePosX === 'number') {
        matrix[14] =
          (doorItemProps.width1 + doorItemProps.thickness) / 2 - handlePosX
      } else {
        if (isVertical) {
          matrix[14] =
            (doorItemProps.width1 + doorItemProps.thickness) / 2 - distX
        } else {
          matrix[14] =
            (doorItemProps.width1 + doorItemProps.thickness) / 2 -
            (handlePos === 'center' ? distX : distY)
        }
      }
    } else {
      // if (doorItemProps.subType === 'left') {

      if (typeof handlePosX === 'number') {
        matrix[12] =
          (doorItemProps.width2 + doorItemProps.thickness) / 2 - handlePosX
      } else {
        if (isVertical) {
          matrix[12] =
            (doorItemProps.width2 + doorItemProps.thickness) / 2 - distX
        } else {
          matrix[12] =
            (doorItemProps.width2 + doorItemProps.thickness) / 2 -
            (handlePos === 'center' ? distX : distY)
        }
      }
      matrix[14] =
        -(doorItemProps.width1 + doorItemProps.thickness) / 2 +
        doorItemProps.thickness / 2 +
        (handleConfig.legLength + handleConfig.diameter) / 2
    }

    if (handlePos === 'top') {
      if (isVertical) {
        matrix[13] = doorHeight / 2 - legDist / 2 - distY
      } else {
        matrix[13] = doorHeight / 2 - distX
      }
    } else if (handlePos === 'bottom') {
      if (isVertical) {
        matrix[13] = -(doorHeight / 2) + legDist / 2 + distY
      } else {
        matrix[13] = -(doorHeight / 2) + distX
      }
    } else if (handlePos === 'center') {
      matrix[13] = 0
    } else if (handlePos === 'fromGround') {
      // matrix[13] = -doorY - (this.props.cabinetProps.height / 2 - this.props.configs.handlePositionFromGround) + handleConfig.legDist / 2 + handleConfig.legDiameter / 2
      matrix[13] =
        -doorPos.y +
        (this.configs.handlePositionFromGround -
          this.cornerCabinetProps.legHeight) -
        this.cornerCabinetProps.height / 2 //+ handleConfig.legDist / 2 + handleConfig.legDiameter / 2
      // console.log(doorPos.y, matrix[13])
    } else if (typeof handlePos === 'number') {
      matrix[13] = -(doorHeight / 2 - handlePos) + legDist / 2 + legDiameter / 2
    }

    return matrix
  }

  recalculateAllShelvesAndDoorsPositions = (
    actualDividers: DividerPropsType[],
    cabinetHeight: number,
    shelvesProps: ShelvesPropsType[],
    doorsProps: DoorPropsType[],
    drawersProps: DrawerPropsType[]
  ) => {
    if (actualDividers.length === 0) {
      const sectionTopY = cabinetHeight / 2 - this.thickness
      const sectionHeight = cabinetHeight - this.thickness * 2

      let newShelvesProps = clone(shelvesProps)

      newShelvesProps.forEach((shProps) => {
        if (shProps.sectionNumber === 1) {
          shProps.sectionHeight = sectionHeight
          shProps.sectionY = sectionTopY - sectionHeight / 2
        }
      })

      let newDoorsProps = clone(doorsProps)

      newDoorsProps.forEach((dProps) => {
        if (dProps.sectionNumber === 1) {
          dProps.sectionHeight = sectionHeight
          dProps.sectionY = sectionTopY - sectionHeight / 2
        }
      })

      let newDrawersProps = clone(drawersProps)

      newDrawersProps.forEach((dProps) => {
        if (dProps.sectionNumber === 1) {
          dProps.sectionHeight = sectionHeight
          dProps.sectionY = sectionTopY - sectionHeight / 2
        }
      })

      if (!this.isCorner)
        this.cabinetProps.sectionProps = {
          ...this.cabinetProps.sectionProps,
          shelvesProps: newShelvesProps,
          doorsProps: newDoorsProps,
          drawersProps: newDrawersProps,
        }
      else
        this.cornerCabinetProps.sectionProps = {
          ...this.cornerCabinetProps.sectionProps,
          shelvesProps: newShelvesProps,
          doorsProps: newDoorsProps,
          drawersProps: newDrawersProps,
        }

      return
    }

    const sectionsProps = [] as {
      height: number
      topY: number
      number: number
    }[]
    const newShelvesProps = clone(shelvesProps)
    const newDoorsProps = clone(doorsProps)
    const newDrawersProps = clone(drawersProps)

    if (actualDividers.length === 1) {
      const section1TopY = cabinetHeight / 2 - this.thickness
      const section2TopY =
        section1TopY -
        (actualDividers[0].type === 'none'
          ? actualDividers[0].top
          : actualDividers[0].top + this.thickness / 2)

      const section1Height =
        actualDividers[0].type === 'none'
          ? actualDividers[0].top
          : actualDividers[0].top - this.thickness / 2
      const section2Height =
        cabinetHeight -
        section1Height -
        this.thickness * 2 -
        (actualDividers[0].type === 'none' ? 0 : this.thickness)

      sectionsProps.push({
        height: section1Height,
        topY: section1TopY,
        number: 1,
      })
      sectionsProps.push({
        height: section2Height,
        topY: section2TopY,
        number: 2,
      })
    } else {
      const section1TopY = cabinetHeight / 2 - this.thickness
      const section1Height =
        actualDividers[0].type === 'none'
          ? actualDividers[0].top
          : actualDividers[0].top - this.thickness / 2

      sectionsProps.push({
        height: section1Height,
        topY: section1TopY,
        number: 1,
      })

      for (let i = 1; i < actualDividers.length; i++) {
        const sectionTopY =
          section1TopY -
          (actualDividers[i - 1].type === 'none'
            ? actualDividers[i - 1].top
            : actualDividers[i - 1].top + this.thickness / 2)

        const sectionHeight =
          actualDividers[i].top -
          actualDividers[i - 1].top -
          (actualDividers[i].type === 'none' ? 0 : 0.5 * this.thickness) -
          (actualDividers[i - 1].type === 'none' ? 0 : 0.5 * this.thickness)

        sectionsProps.push({
          height: sectionHeight,
          topY: sectionTopY,
          number: i + 1,
        })
      }

      const lastSectionTopY =
        section1TopY -
        (actualDividers[actualDividers.length - 1].type === 'none'
          ? actualDividers[actualDividers.length - 1].top
          : actualDividers[actualDividers.length - 1].top + this.thickness / 2)
      const lastSectionHeight =
        cabinetHeight -
        this.thickness * 2 -
        (actualDividers[actualDividers.length - 1].type === 'none'
          ? actualDividers[actualDividers.length - 1].top
          : actualDividers[actualDividers.length - 1].top + this.thickness / 2)

      sectionsProps.push({
        height: lastSectionHeight,
        topY: lastSectionTopY,
        number: actualDividers.length + 1,
      })
    }

    for (const sProps of sectionsProps) {
      newShelvesProps.forEach((shProps) => {
        if (shProps.sectionNumber === sProps.number) {
          shProps.sectionHeight = sProps.height
          shProps.sectionY = sProps.topY - sProps.height / 2
        }
      })

      newDoorsProps.forEach((dProps) => {
        if (dProps.sectionNumber === sProps.number) {
          dProps.sectionHeight = sProps.height
          dProps.sectionY = sProps.topY - sProps.height / 2
        }
      })

      newDrawersProps.forEach((dProps) => {
        if (dProps.sectionNumber === sProps.number) {
          dProps.sectionHeight = sProps.height
          dProps.sectionY = sProps.topY - sProps.height / 2
        }
      })
    }

    if (!this.isCorner)
      this.cabinetProps.sectionProps = {
        ...this.cabinetProps.sectionProps,
        shelvesProps: newShelvesProps,
        doorsProps: newDoorsProps,
        drawersProps: newDrawersProps,
      }
    else
      this.cornerCabinetProps.sectionProps = {
        ...this.cornerCabinetProps.sectionProps,
        shelvesProps: newShelvesProps,
        doorsProps: newDoorsProps,
        drawersProps: newDrawersProps,
      }
  }

  deleteCabinetFromScene = () => {
    // const removableChildrenNames = ['Right Side', 'Left Side', 'Right Side Base Leg', 'Left Side Base Leg', 'Back', 'Bottom', 'Top', 'Splitted Top', 'No Toe Kick Front', 'Base Leg Front', "Front Right Side", "Back Right Side", "Front Left Side", "Back Left Side"]

    // const itemPropsTypesNeedToRemove = ['door', 'drawer', 'leg', 'separateBase', 'cornerTwoDoor', 'cornerLegs']

    // for (const itemProps of this.itemsPropsList) {
    //     if (itemPropsTypesNeedToRemove.includes(itemProps.props.type) && itemProps.render)
    //         removableChildrenNames.push(itemProps.name)
    // }

    // const removableChildren = []

    // for (const child of this.object.children) {

    //     if (removableChildrenNames.includes(child.name))
    //         removableChildren.push(child)
    //     else if (child.name.slice(0, 5) === 'Shelf')
    //         removableChildren.push(child)
    //     else if (child.name.includes('Fixed Shelf'))
    //         removableChildren.push(child)
    // }

    // for (const child of removableChildren) {
    //     this.object.remove(child)
    // }

    const removableChildren = []
    for (const child of this.object.children) removableChildren.push(child)

    for (const child of removableChildren) this.object.remove(child)
  }

  removeUnusedItems = () => {
    const removableItems = []

    for (const itemProps of this.itemsPropsList) {
      if (itemProps.name.includes('Fixed Shelf')) removableItems.push(itemProps)
    }

    for (const itemProps of this.itemsPropsList) {
      if (itemProps.name.slice(0, 5) === 'Shelf') removableItems.push(itemProps)
    }

    for (const itemProps of this.itemsPropsList) {
      if (
        (itemProps.props.type === 'door' ||
          itemProps.props.type === 'cornerTwoDoor' ||
          itemProps.props.type === 'cornerTwoDoorFivePieces' ||
          itemProps.props.type === 'cornerNewDoor' ||
          itemProps.props.type === 'fivePiecesDoor' ||
          itemProps.props.type === 'newDoor') &&
        itemProps.render
      )
        removableItems.push(itemProps)
    }

    for (const itemProps of this.itemsPropsList) {
      if (
        (itemProps.props.type === 'drawer' ||
          itemProps.props.type === 'fivePiecesDrawer') &&
        itemProps.render
      )
        removableItems.push(itemProps)
    }

    for (const itemProps of this.itemsPropsList) {
      if (
        ['leg', 'leg2', 'cornerLegs', 'cornerLegs2', 'cornerOneLeg'].includes(
          itemProps.props.type
        ) &&
        itemProps.render
      )
        removableItems.push(itemProps)
    }

    for (const itemProps of removableItems) {
      const index = this.itemsPropsList.indexOf(itemProps)
      if (index !== -1) {
        this.itemsPropsList.splice(index, 1)
      }
    }

    //clear legs
    // let index = this.itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'leg' && itemProps.render))
    // if (index !== -1) {
    //     this.itemsPropsList.splice(index, 1)
    // }

    // index = this.itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'cornerLegs' && itemProps.render))
    // if (index !== -1) {
    //     this.itemsPropsList.splice(index, 1)
    // }

    let index = this.itemsPropsList.findIndex(
      (itemProps) => itemProps.props.type === 'separateBase' && itemProps.render
    )
    if (index !== -1) {
      this.itemsPropsList.splice(index, 1)
    }

    return removableItems
  }

  visualizeCabinetProps = () => {
    this.deleteCabinetFromScene()
    const removableItems = this.removeUnusedItems()

    const normalCabinetSheetNames = [
      'Right Side',
      'Left Side',
      'Right Side Base Leg',
      'Left Side Base Leg',
      'Splitted Top',
      'No Toe Kick Front',
      'Base Leg Front',
      'Base Leg Back',
      'Standard Legs',
      'Standard Legs 2 Short',
      'Standard Legs 2 Tall',
    ]

    const cornerCabinetSheetNames = [
      'Front Right Side',
      'Back Right Side',
      'Front Left Side',
      'Back Left Side',
      'Corner Standard Legs',
      'Corner Standard Legs 2 Short',
      'Corner Standard Legs 2 Tall',
      'Front Left Side Base Leg',
      'Front Right Side Base Leg',
      'Base Leg Front',
      'Base Leg Front 1',
      'Base Leg Front 2',
    ]

    for (const itemProps of this.itemsPropsList) {
      if (normalCabinetSheetNames.includes(itemProps.name))
        itemProps.render = !this.isCorner
      else if (cornerCabinetSheetNames.includes(itemProps.name))
        itemProps.render = this.isCorner

      if (itemProps.name === 'Bottom' || itemProps.name === 'Top') {
        if (itemProps.props.type === 'cornerHorizontalSheet') {
          itemProps.render = this.isCorner
        } else {
          itemProps.render = !this.isCorner
        }
      }

      if (itemProps.name.slice(0, 5) === 'Shelf') {
        if (itemProps.props.type === 'cornerHorizontalSheet') {
          itemProps.render = this.isCorner
        } else {
          itemProps.render = !this.isCorner
        }
      }

      if (itemProps.name.includes('Fixed Shelf')) {
        if (itemProps.props.type === 'cornerHorizontalSheet') {
          itemProps.render = this.isCorner
        } else {
          itemProps.render = !this.isCorner
        }
      }
    }

    if (!this.isCorner) {
      this.visualizeNormalCabinetProps(removableItems)
    } else {
      this.visualizeCornerCabinetProps(removableItems)
    }
  }

  getNewDoorDefaultItems = (
    itemsPropsList: ItemPropsType[]
  ): NewDoorDefaultItemsType | false => {
    const B200R203One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000One = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorOne' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000Two = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorTwo' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000LiftUp = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorLiftUp' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorDrawer' &&
        i.props.type === 'drawer' &&
        (i.props.visualType as string) === 'B100R000'
    )

    const B200R203Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R203'
    )
    const B200R401Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R401'
    )
    const B200R500Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B200R500'
    )
    const B600R102Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R102'
    )
    const B600R100Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B600R100'
    )
    const B602R102Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B602R102'
    )
    const B100R000Corner = itemsPropsList.find(
      (i) =>
        i.name === 'newDoorCorner' &&
        i.props.type === 'newDoor' &&
        (i.props.visualType as string) === 'B100R000'
    )

    if (
      B200R203One &&
      B200R401One &&
      B200R500One &&
      B600R102One &&
      B600R100One &&
      B602R102One &&
      B100R000One &&
      B200R203Two &&
      B200R401Two &&
      B200R500Two &&
      B600R102Two &&
      B600R100Two &&
      B602R102Two &&
      B100R000Two &&
      B200R203LiftUp &&
      B200R401LiftUp &&
      B200R500LiftUp &&
      B600R102LiftUp &&
      B600R100LiftUp &&
      B602R102LiftUp &&
      B100R000LiftUp &&
      B200R203Drawer &&
      B200R401Drawer &&
      B200R500Drawer &&
      B600R102Drawer &&
      B600R100Drawer &&
      B602R102Drawer &&
      B100R000Drawer &&
      B200R203Corner &&
      B200R401Corner &&
      B200R500Corner &&
      B600R102Corner &&
      B600R100Corner &&
      B602R102Corner &&
      B100R000Corner
    ) {
      B200R203One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000One.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000Two.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000LiftUp.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000Drawer.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R401Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B200R500Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R102Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B600R100Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B602R102Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      B100R000Corner.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]

      B200R203One.childrenProps = []
      B200R401One.childrenProps = []
      B200R500One.childrenProps = []
      B600R102One.childrenProps = []
      B600R100One.childrenProps = []
      B602R102One.childrenProps = []
      B100R000One.childrenProps = []

      B200R203Two.childrenProps = []
      B200R401Two.childrenProps = []
      B200R500Two.childrenProps = []
      B600R102Two.childrenProps = []
      B600R100Two.childrenProps = []
      B602R102Two.childrenProps = []
      B100R000Two.childrenProps = []

      B200R203LiftUp.childrenProps = []
      B200R401LiftUp.childrenProps = []
      B200R500LiftUp.childrenProps = []
      B600R102LiftUp.childrenProps = []
      B600R100LiftUp.childrenProps = []
      B602R102LiftUp.childrenProps = []
      B100R000LiftUp.childrenProps = []

      B200R203Drawer.childrenProps = []
      B200R401Drawer.childrenProps = []
      B200R500Drawer.childrenProps = []
      B600R102Drawer.childrenProps = []
      B600R100Drawer.childrenProps = []
      B602R102Drawer.childrenProps = []
      B100R000Drawer.childrenProps = []

      B200R203Corner.childrenProps = []
      B200R401Corner.childrenProps = []
      B200R500Corner.childrenProps = []
      B600R102Corner.childrenProps = []
      B600R100Corner.childrenProps = []
      B602R102Corner.childrenProps = []
      B100R000Corner.childrenProps = []

      return {
        one: {
          B200R203: B200R203One,
          B200R401: B200R401One,
          B200R500: B200R500One,
          B600R102: B600R102One,
          B600R100: B600R100One,
          B602R102: B602R102One,
          B100R000: B100R000One,
        },
        two: {
          B200R203: B200R203Two,
          B200R401: B200R401Two,
          B200R500: B200R500Two,
          B600R102: B600R102Two,
          B600R100: B600R100Two,
          B602R102: B602R102Two,
          B100R000: B100R000Two,
        },
        liftUp: {
          B200R203: B200R203LiftUp,
          B200R401: B200R401LiftUp,
          B200R500: B200R500LiftUp,
          B600R102: B600R102LiftUp,
          B600R100: B600R100LiftUp,
          B602R102: B602R102LiftUp,
          B100R000: B100R000LiftUp,
        },
        drawer: {
          B200R203: B200R203Drawer,
          B200R401: B200R401Drawer,
          B200R500: B200R500Drawer,
          B600R102: B600R102Drawer,
          B600R100: B600R100Drawer,
          B602R102: B602R102Drawer,
          B100R000: B100R000Drawer,
        },
        corner: {
          B200R203: B200R203Corner,
          B200R401: B200R401Corner,
          B200R500: B200R500Corner,
          B600R102: B600R102Corner,
          B600R100: B600R100Corner,
          B602R102: B602R102Corner,
          B100R000: B100R000Corner,
        },
      }
    } else return false
  }

  chooseNewDoorDefaultItem = (
    items: NewDoorDefaultItemsType,
    visualType: DoorNewVisualTypes,
    doorType: DoorType | 'drawer' | 'cornerTwoDoor'
  ): ItemPropsType => {
    const [B, R, S] = visualType.slice(1).split('-')

    if (doorType === 'double') {
      // @ts-ignore
      return items.two[B + R]
    }

    if (doorType === 'liftUp') {
      // @ts-ignore
      return items.liftUp[B + R]
    }

    if (doorType === 'drawer') {
      // @ts-ignore
      return items.drawer[B + R]
    }

    if (doorType === 'cornerTwoDoor') {
      // @ts-ignore
      return items.corner[B + R]
    }

    // @ts-ignore
    return items.one[B + R]
  }

  getHandleDefaultItems = (
    itemsPropsList: ItemPropsType[]
  ): HandleDefaultItemsType | false => {
    const pullStandardDoor = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'standard' &&
        i.props.for === 'door'
    )

    const pullStandardDrawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'standard' &&
        i.props.for === 'drawer'
    )

    const pullArchDoor = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'arch' &&
        i.props.for === 'door'
    )

    const pullArchDrawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'arch' &&
        i.props.for === 'drawer'
    )

    const pullDPH50476Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP504-76' &&
        i.props.for === 'door'
    )

    const pullDPH50476Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP504-76' &&
        i.props.for === 'drawer'
    )

    const pullDHP30696Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-96' &&
        i.props.for === 'door'
    )

    const pullDHP30696Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-96' &&
        i.props.for === 'drawer'
    )

    const pullDHP306128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-128' &&
        i.props.for === 'door'
    )

    const pullDHP306128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP306-128' &&
        i.props.for === 'drawer'
    )

    const pullDHP180128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP180-128' &&
        i.props.for === 'door'
    )

    const pullDHP180128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP180-128' &&
        i.props.for === 'drawer'
    )

    const pullDHP465192Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP465-192' &&
        i.props.for === 'door'
    )

    const pullDHP465192Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP465-192' &&
        i.props.for === 'drawer'
    )

    const pullDHP305MB96Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB96' &&
        i.props.for === 'door'
    )

    const pullDHP305MB96Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB96' &&
        i.props.for === 'drawer'
    )

    const pullDHP305MB128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB128' &&
        i.props.for === 'door'
    )

    const pullDHP305MB128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'DHP305MB128' &&
        i.props.for === 'drawer'
    )

    const pullBP723812Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP723812' &&
        i.props.for === 'door'
    )

    const pullBP723812Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP723812' &&
        i.props.for === 'drawer'
    )

    const pullBP873128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP873128' &&
        i.props.for === 'door'
    )

    const pullBP873128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP873128' &&
        i.props.for === 'drawer'
    )

    const pullBP7470128Door = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP7470128' &&
        i.props.for === 'door'
    )

    const pullBP7470128Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'pullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'pull' &&
        i.props.subType2 === 'BP7470128' &&
        i.props.for === 'drawer'
    )

    const knobDHK301Door = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK301' &&
        i.props.for === 'door'
    )

    const knobDHK301Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK301' &&
        i.props.for === 'drawer'
    )

    const knobDHK401Door = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK401' &&
        i.props.for === 'door'
    )

    const knobDHK401Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK401' &&
        i.props.for === 'drawer'
    )

    const knobDHK501Door = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK501' &&
        i.props.for === 'door'
    )

    const knobDHK501Drawer = itemsPropsList.find(
      (i) =>
        i.name === 'knobHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'knob' &&
        i.props.subType2 === 'DHK501' &&
        i.props.for === 'drawer'
    )

    const noPullDoor = itemsPropsList.find(
      (i) =>
        i.name === 'noPullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'noPull' &&
        i.props.for === 'door'
    )

    const noPullDrawer = itemsPropsList.find(
      (i) =>
        i.name === 'noPullHandle' &&
        i.props.type === 'handle' &&
        i.props.subType === 'noPull' &&
        i.props.for === 'drawer'
    )

    if (
      pullStandardDoor &&
      pullStandardDrawer &&
      pullArchDoor &&
      pullArchDrawer &&
      pullDPH50476Door &&
      pullDPH50476Drawer &&
      pullDHP30696Door &&
      pullDHP30696Drawer &&
      pullDHP306128Door &&
      pullDHP306128Drawer &&
      pullDHP180128Door &&
      pullDHP180128Drawer &&
      pullDHP465192Door &&
      pullDHP465192Drawer &&
      pullDHP305MB96Door &&
      pullDHP305MB96Drawer &&
      pullDHP305MB128Door &&
      pullDHP305MB128Drawer &&
      pullBP723812Door &&
      pullBP723812Drawer &&
      pullBP873128Door &&
      pullBP873128Drawer &&
      pullBP7470128Door &&
      pullBP7470128Drawer &&
      knobDHK301Door &&
      knobDHK301Drawer &&
      knobDHK401Door &&
      knobDHK401Drawer &&
      knobDHK501Door &&
      knobDHK501Drawer &&
      noPullDoor &&
      noPullDrawer
    ) {
      return {
        door: {
          pullStandard: pullStandardDoor,
          pullArch: pullArchDoor,
          pullDPH50476: pullDPH50476Door,
          pullDHP30696: pullDHP30696Door,
          pullDHP306128: pullDHP306128Door,
          pullDHP180128: pullDHP180128Door,
          pullDHP465192: pullDHP465192Door,
          pullDHP305MB96: pullDHP305MB96Door,
          pullDHP305MB128: pullDHP305MB128Door,
          pullBP723812: pullBP723812Door,
          pullBP873128: pullBP873128Door,
          pullBP7470128: pullBP7470128Door,
          knobDHK301: knobDHK301Door,
          knobDHK401: knobDHK401Door,
          knobDHK501: knobDHK501Door,
          noPull: noPullDoor,
        },
        drawer: {
          pullStandard: pullStandardDrawer,
          pullArch: pullArchDrawer,
          pullDPH50476: pullDPH50476Drawer,
          pullDHP30696: pullDHP30696Drawer,
          pullDHP306128: pullDHP306128Drawer,
          pullDHP180128: pullDHP180128Drawer,
          pullDHP465192: pullDHP465192Drawer,
          pullDHP305MB96: pullDHP305MB96Drawer,
          pullDHP305MB128: pullDHP305MB128Drawer,
          pullBP723812: pullBP723812Drawer,
          pullBP873128: pullBP873128Drawer,
          pullBP7470128: pullBP7470128Drawer,
          knobDHK301: knobDHK301Drawer,
          knobDHK401: knobDHK401Drawer,
          knobDHK501: knobDHK501Drawer,
          noPull: noPullDrawer,
        },
      }
    } else return false
  }

  chooseHandleDefaultItem = (
    items: HandleDefaultItemsType,
    type: HandlePropsType['type'],
    subtype: HandlePropsType['subtype'],
    for_: 'door' | 'drawer'
  ): ItemPropsType => {
    if (type === 'noPull') return items[for_].noPull

    if (type === 'pull') {
      switch (subtype) {
        case 'standard':
          return items[for_].pullStandard
        case 'arch':
          return items[for_].pullArch
        case 'DHP180-128':
          return items[for_].pullDHP180128
        case 'DHP306-96':
          return items[for_].pullDHP30696
        case 'DHP306-128':
          return items[for_].pullDHP306128
        case 'DHP465-192':
          return items[for_].pullDHP465192
        case 'DHP504-76':
          return items[for_].pullDPH50476
        case 'DHP305MB96':
          return items[for_].pullDHP305MB96
        case 'DHP305MB128':
          return items[for_].pullDHP305MB128
        case 'BP723812':
          return items[for_].pullBP723812
        case 'BP873128':
          return items[for_].pullBP873128
        case 'BP7470128':
          return items[for_].pullBP7470128

        default:
          return items[for_].pullStandard
      }
    } else if (type === 'knob') {
      if (subtype === 'DHK401') return items[for_].knobDHK401
      else if (subtype === 'DHK501') return items[for_].knobDHK501

      return items[for_].knobDHK301
    }

    return items[for_].pullStandard
  }

  getPanelHoleType = (): NewDoorHoleType => {
    const doorsProps = this.isCorner
      ? this.cornerCabinetProps.sectionProps.doorsProps
      : this.cabinetProps.sectionProps.doorsProps

    let type: NewDoorHoleType = 'none'

    if (
      doorsProps.some((dp) =>
        dp.normalMapSplitter?.toLocaleLowerCase().includes('m')
      )
    )
      type = 'mirror'
    else if (
      doorsProps.some((dp) =>
        dp.normalMapSplitter?.toLocaleLowerCase().includes('f')
      )
    )
      type = 'frosted'
    else if (
      doorsProps.some((dp) =>
        dp.normalMapSplitter?.toLocaleLowerCase().includes('c')
      )
    )
      type = 'clean'
    else if (
      doorsProps.some((dp) =>
        dp.normalMapSplitter?.toLocaleLowerCase().includes('x')
      )
    )
      type = 'xglass'

    return type
  }

  getPanelHoleTypeLetter = (type: NewDoorHoleType) => {
    switch (type) {
      case 'mirror':
        return 'M'
      case 'frosted':
        return 'F'
      case 'clean':
        return 'C'
      case 'xglass':
        return 'X'
      default:
        return ''
    }
  }

  setPanelHoleType = (type: NewDoorHoleType) => {
    const typeLetter = this.getPanelHoleTypeLetter(type).toUpperCase()

    const doorsProps = this.isCorner
      ? this.cornerCabinetProps.sectionProps.doorsProps
      : this.cabinetProps.sectionProps.doorsProps

    // Pre-check: does any eligible door already have a hole?
    // If yes, restrict changes to only those doors (skip solid siblings).
    // If no door has a hole yet, apply to all (original first-time behavior).
    const eligibleDoors = doorsProps.filter(
      (dp) => dp.visualType.startsWith('#') || dp.visualType === 'fivePieces'
    )

    const anyHasHole = eligibleDoors.some(
      (dp) => dp.normalMapSplitter && /[MFCXmfcx]/.test(dp.normalMapSplitter)
    )

    for (const doorProps of eligibleDoors) {
      // If some doors already have holes, skip the ones that don't
      if (
        anyHasHole &&
        !(
          doorProps.normalMapSplitter &&
          /[MFCXmfcx]/.test(doorProps.normalMapSplitter)
        )
      ) {
        continue
      }

      if (!doorProps.normalMapSplitter) {
        doorProps.normalMapSplitter = typeLetter
      } else {
        const isGFormat = doorProps.normalMapSplitter.match(
          /^[gG]([0-9.]+)(?:_([a-zA-Z]))?(?:_([a-zA-Z]))?$/
        )
        if (isGFormat) {
          const val = isGFormat[1]
          const bot = isGFormat[2] ? isGFormat[2].toUpperCase() : 'N'
          const top = isGFormat[3] ? isGFormat[3].toUpperCase() : 'N'
          const newLetter = typeLetter === '' ? 'N' : typeLetter

          let newBot = bot
          let newTop = top

          if (bot === 'N' && top === 'N') {
            newBot = newLetter
            newTop = newLetter
          } else {
            if (bot !== 'N') newBot = newLetter
            if (top !== 'N') newTop = newLetter
          }

          doorProps.normalMapSplitter = `G${val}_${newBot}_${newTop}`
        } else {
          const replaced = doorProps.normalMapSplitter.replace(
            /[MFCX]/g,
            typeLetter
          )

          if (replaced === doorProps.normalMapSplitter && typeLetter !== '') {
            // No existing hole letter found — inject typeLetter into each segment
            doorProps.normalMapSplitter = doorProps.normalMapSplitter
              .split(',')
              .map((seg) => (seg.trim() ? typeLetter + seg.trim() : seg))
              .join(',')
          } else {
            doorProps.normalMapSplitter = replaced
          }
        }
      }
    }

    this.visualizeCabinetProps()
  }

  resolveSplitter = (
    splitter: string | undefined,
    panelHeight: number,
    sectionY: number,
    cabinetHeight: number,
    legHeight: number
  ) => {
    if (!splitter) return ''
    const match = splitter.match(
      /^[gG]([0-9.]+)(?:_([a-zA-Z]))?(?:_([a-zA-Z]))?$/
    )
    if (match) {
      const fromGroundValue = parseFloat(match[1])
      const bottomLetter =
        match[2] && match[2].toUpperCase() !== 'N' ? match[2].toUpperCase() : ''
      const topLetter =
        match[3] && match[3].toUpperCase() !== 'N' ? match[3].toUpperCase() : ''
      if (!isNaN(fromGroundValue)) {
        const sectionBottomFromGround =
          legHeight + cabinetHeight / 2 + sectionY - panelHeight / 2
        const bottomSegment = fromGroundValue - sectionBottomFromGround
        const topSegment = panelHeight - bottomSegment
        return `${bottomLetter}${bottomSegment.toFixed(2)},${topLetter}${topSegment.toFixed(2)}`
      }
    }
    return splitter
  }

  visualizeNormalCabinetProps = (removableItems: ItemPropsType[]) => {
    // console.time('createCabinet')

    const doorConfig = this.configs.doorConfig
    const drawerConfig = this.configs.drawerConfig
    const thickness = this.configs.thickness
    const isNewBase = this.legProps.baseSubType !== 'old'

    if (this.cabinetProps.sectionProps.drawersProps.length) {
      //Checking drawer minimum sizes
      // if (drawerConfig.minimumDepth > this.cabinetProps.depth) {
      //   console.warn('Drawers removed!')
      //   this.updateCabinetProps({
      //     ...this.cabinetProps,
      //     sectionProps: { ...this.cabinetProps.sectionProps, drawersProps: [] },
      //   })
      //   return
      // }

      const filteredDrawersProps =
        this.cabinetProps.sectionProps.drawersProps.filter(
          (dp) => dp.sectionHeight >= drawerConfig.minimumHeight
        )

      if (
        filteredDrawersProps.length <
        this.cabinetProps.sectionProps.drawersProps.length
      ) {
        console.warn('Drawers removed!')
        this.updateCabinetProps({
          ...this.cabinetProps,
          sectionProps: {
            ...this.cabinetProps.sectionProps,
            drawersProps: filteredDrawersProps,
          },
        })
        return
      }
    }

    for (const itemProps of this.itemsPropsList) {
      if (itemProps.name === 'Right Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            this.cabinetProps.height +
            (this.legProps.on && this.legProps.type === 'noToeKick'
              ? this.cabinetProps.legHeight
              : 0),
          length: this.cabinetProps.depth,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          (this.cabinetProps.width - thickness) / 2,
          this.legProps.on && this.legProps.type === 'noToeKick'
            ? -this.cabinetProps.legHeight / 2
            : 0, //y
          0,
          1,
        ]

        if (this.legProps.on) {
          itemProps.render =
            this.legProps.type !== 'base' &&
            this.legProps.type !== 'baseIsland' &&
            this.legProps.type !== 'baseIsland2'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Left Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            this.cabinetProps.height +
            (this.legProps.on && this.legProps.type === 'noToeKick'
              ? this.cabinetProps.legHeight
              : 0),
          length: this.cabinetProps.depth,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          (-this.cabinetProps.width + thickness) / 2,
          this.legProps.on && this.legProps.type === 'noToeKick'
            ? -this.cabinetProps.legHeight / 2
            : 0, //y
          0,
          1,
        ]

        if (this.legProps.on) {
          itemProps.render =
            this.legProps.type !== 'base' &&
            this.legProps.type !== 'baseIsland' &&
            this.legProps.type !== 'baseIsland2'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Left Side Base Leg') {
        const cut = this.legProps.baseSubType === 'old' ? 0 : this.baseLegCut
        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: this.cabinetProps.height,
          legHeight: this.cabinetProps.legHeight,
          width: this.cabinetProps.depth,
          cutLength: cut,
          backCut: this.legProps.type === 'baseIsland' ? cut : undefined,
          isNewBase: this.legProps.baseSubType !== 'old',
        }

        itemProps.matrix = [
          -2.220446049250313e-16,
          1.2246467991473532e-16,
          1,
          0,
          -2.465190328815662e-32,
          -1,
          1.2246467991473532e-16,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          -this.cabinetProps.width / 2,
          this.cabinetProps.height / 2,
          -this.cabinetProps.depth / 2,
          1,
        ]

        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' ||
            this.legProps.type === 'baseIsland' ||
            this.legProps.type === 'baseIsland2')
      } else if (itemProps.name === 'Right Side Base Leg') {
        const cut = this.legProps.baseSubType === 'old' ? 0 : this.baseLegCut

        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: this.cabinetProps.height,
          legHeight: this.cabinetProps.legHeight,
          width: this.cabinetProps.depth,
          cutLength: cut,
          backCut: this.legProps.type === 'baseIsland' ? cut : undefined,
          isNewBase: this.legProps.baseSubType !== 'old',
        }

        itemProps.matrix = [
          -2.220446049250313e-16,
          1.2246467991473532e-16,
          1,
          0,
          -2.465190328815662e-32,
          -1,
          1.2246467991473532e-16,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          this.cabinetProps.width / 2 - thickness,
          this.cabinetProps.height / 2,
          -this.cabinetProps.depth / 2,
          1,
        ]

        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' ||
            this.legProps.type === 'baseIsland' ||
            this.legProps.type === 'baseIsland2')
      } else if (itemProps.name === 'Top' && itemProps.props.type === 'shelf') {
        const gapForBack =
          this.legProps.type === 'baseIsland' ||
          this.legProps.type === 'baseIsland2'
            ? thickness
            : 0

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: this.cabinetProps.width - thickness * 2,
          length: this.cabinetProps.depth - gapForBack,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          2.220446049250313e-16,
          1,
          0,
          -1,
          0,
          2.220446049250313e-16,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          (this.cabinetProps.height - thickness) / 2,
          gapForBack / 2,
          1,
        ]
      } else if (itemProps.name === 'Splitted Top') {
        itemProps.props = {
          ...itemProps.props,
          type: 'splittedTop',
          cabinetWidth: this.cabinetProps.width - thickness * 2,
          cabinetDepth: this.cabinetProps.depth,
          sheetWidth: this.configs.splittedTopSheetWidth,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (this.cabinetProps.height - thickness) / 2,
          0,
          1,
        ]
      } else if (
        itemProps.name === 'Bottom' &&
        itemProps.props.type === 'shelf'
      ) {
        itemProps.render = this.type !== 'upperOpen'
        const gapForBack =
          this.legProps.type === 'baseIsland' ||
          this.legProps.type === 'baseIsland2'
            ? thickness
            : 0

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: this.cabinetProps.width - thickness * 2,
          length: this.cabinetProps.depth - gapForBack,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          2.220446049250313e-16,
          1,
          0,
          -1,
          0,
          2.220446049250313e-16,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          (-this.cabinetProps.height + thickness) / 2,
          gapForBack / 2,
          1,
        ]
      } else if (itemProps.name === 'Back') {
        const extendForBottom =
          this.legProps.type === 'baseIsland' || this.type === 'upperOpen'
            ? thickness
            : this.legProps.type === 'baseIsland2'
              ? thickness + this.cabinetProps.legHeight
              : 0

        const extendForTop =
          this.legProps.type === 'baseIsland' ||
          this.legProps.type === 'baseIsland2'
            ? thickness
            : 0

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            this.cabinetProps.height -
            thickness * 2 +
            extendForBottom +
            extendForTop,
          length: this.cabinetProps.width - thickness * 2,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          -extendForBottom / 2 + extendForTop / 2,
          (-this.cabinetProps.depth + thickness) / 2,
          1,
        ]
      } else if (itemProps.name.slice(0, 5) === 'Shelf') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: this.cabinetProps.depth - thickness,
          length: this.cabinetProps.width - thickness * 2,
        }
      }
      // else if (itemProps.name === 'Standard Legs') {
      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'leg',
      //         subType: 'standard',
      //         cabinetWidth: this.cabinetProps.width,
      //         cabinetDepth: this.cabinetProps.depth
      //     }

      //     itemProps.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -this.cabinetProps.height / 2, 0, 1]
      // }
      else if (itemProps.name === 'No Toe Kick Front') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: this.cabinetProps.legHeight,
          length: this.cabinetProps.width,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-this.cabinetProps.height - this.cabinetProps.legHeight) / 2,
          (this.cabinetProps.depth + thickness) / 2,
          1,
        ]
        itemProps.render =
          this.legProps.type === 'noToeKick' && this.legProps.on
      } else if (itemProps.name === 'Base Leg Front') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: this.cabinetProps.legHeight,
          width: this.cabinetProps.width - (isNewBase ? 0 : 2 * thickness),
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-this.cabinetProps.height - this.cabinetProps.legHeight) / 2,
          (this.cabinetProps.depth + thickness) / 2 -
            (this.baseLegCut ?? this.configs.baseLegConfig.cutLength) -
            thickness,
          1,
        ]
        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' ||
            this.legProps.type === 'baseIsland' ||
            this.legProps.type === 'baseIsland2')
      } else if (itemProps.name === 'Base Leg Back') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: this.cabinetProps.legHeight, //this.props.configs.baseLegConfig.height,
          width: this.cabinetProps.width - (isNewBase ? 0 : 2 * thickness),
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-this.cabinetProps.height - this.cabinetProps.legHeight) / 2,
          -(
            (this.cabinetProps.depth + thickness) / 2 -
            (this.baseLegCut ?? this.configs.baseLegConfig.cutLength) -
            thickness
          ),
          1,
        ]
        itemProps.render =
          this.legProps.on && this.legProps.type === 'baseIsland'
      }
    }

    this.cabinetProps.sectionProps.height =
      this.cabinetProps.height - this.thickness * 2
    this.cabinetProps.sectionProps.width =
      this.cabinetProps.width - this.thickness * 2
    this.section = makeSection(this.cabinetProps.sectionProps, this.thickness)

    // tops

    const tIndex = this.itemsPropsList.findIndex(
      (item) => item.name === 'Top' && item.props.type === 'shelf'
    )
    const stIndex = this.itemsPropsList.findIndex(
      (item) => item.name === 'Splitted Top'
    )

    if (tIndex !== -1 && stIndex !== -1) {
      let index = this.object.children.findIndex((ch) => ch.name === 'Top')

      if (index !== -1) this.object.remove(this.object.children[index])
      index = this.object.children.findIndex((ch) => ch.name === 'Splitted Top')

      if (index !== -1) this.object.remove(this.object.children[index])

      if (this.splittedTop) {
        if (
          this.cabinetProps.depth > this.configs.minimumNonSplittedTopDepth &&
          this.cabinetProps.width > this.configs.minimumNonSplittedTopWidth
        ) {
          this.itemsPropsList[tIndex].render = false
          this.itemsPropsList[stIndex].render = true
        } else {
          this.itemsPropsList[tIndex].render = true
          this.itemsPropsList[stIndex].render = false
        }
      } else {
        this.itemsPropsList[tIndex].render = true
        this.itemsPropsList[stIndex].render = false
      }
    }

    const fixedShelfItem = this.itemsPropsList.find(
      (props) => props.name === 'fixed'
    )

    if (fixedShelfItem)
      for (const divider of this.section.dividers) {
        if (divider.type === 'visible') {
          const oldItem = removableItems.find(
            (item) => item.uuid === divider.uuid
          )

          const itemProps = oldItem ? clone(oldItem) : clone(fixedShelfItem)

          itemProps.uuid = divider.uuid
          itemProps.name = 'Fixed Shelf ' + divider.object.name.split('_')[1]
          itemProps.props = {
            type: 'shelf',
            length: this.cabinetProps.depth - thickness,
            width: this.cabinetProps.width - thickness * 2,
          }

          itemProps.matrix = [
            2.220446049250313e-16,
            2.220446049250313e-16,
            1,
            0,
            -1,
            0,
            2.220446049250313e-16,
            0,
            0,
            -1,
            2.220446049250313e-16,
            0,
            0,
            divider.object.position.y,
            thickness / 2,
            1,
          ]

          // itemProps.matrix[13] = divider.object.position.y
          // itemProps.matrix[14] = thickness / 2
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      }

    // =================Adjustable Shelves==================

    const shelfItemProps = this.itemsPropsList.find(
      (props) => props.name === 'shelf'
    )

    if (shelfItemProps) {
      // const ys = []

      // let temp = centerY - sectionHeight / 2
      // for (let i = 0; i < count; i++) {
      //     temp += sectionHeight / (count + 1)
      //     ys.push(temp)
      // }

      // this.removeTempDividers()

      // ys.reverse().forEach((y, i) => {
      // const shelf = createSheet(
      //     this.props.cabinetProps.width - 2 * thickness,
      //     this.props.cabinetProps.depth - thickness,
      //     // 1
      // )

      // shelf.name = 'tempShelf'
      // shelf.position.y = y
      // shelf.position.z += thickness / 2 - .01
      // shelf.rotation.x += Math.PI / 2

      // shelf.userData.names = sectionName === 'section' ? '1_' + (i + 1).toString() : sectionName.split('_')[1] + '_' + (i + 1).toString()

      // this.object.add(shelf)
      // })

      for (const shelfProps of this.cabinetProps.sectionProps.shelvesProps) {
        // debugger
        const ys = []

        let temp = shelfProps.sectionY - shelfProps.sectionHeight / 2
        for (let i = 0; i < shelfProps.count; i++) {
          temp += shelfProps.sectionHeight / (shelfProps.count + 1)
          ys.push(temp)
        }

        ys.reverse().forEach((y, i) => {
          const itemProps = clone(shelfItemProps)

          itemProps.name = `Shelf_${shelfProps.sectionNumber}_${i + 1}`

          itemProps.props = {
            type: 'shelf',
            length: this.cabinetProps.depth - thickness,
            width: this.cabinetProps.width - thickness * 2,
          }

          itemProps.matrix = [
            2.220446049250313e-16,
            2.220446049250313e-16,
            1,
            0,
            -1,
            0,
            2.220446049250313e-16,
            0,
            0,
            -1,
            2.220446049250313e-16,
            0,
            0,
            y,
            thickness / 2 - 0.01,
            1,
          ]

          // const matrix = new THREE.Matrix4()
          // matrix.makeRotationX(Math.PI / 2)
          // matrix.setPosition(0, y, thickness / 2 - 0.01)

          // itemProps.matrix = matrix.elements
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        })
      }
    }

    // =================Doors==================

    //clear doors

    const vGrooveOneItem = this.itemsPropsList.find(
      (props) => props.name === 'vGrooveOne'
    )
    const vGrooveTwoItem = this.itemsPropsList.find(
      (props) => props.name === 'vGrooveTwo'
    )
    const fivePiecesOneItem = this.itemsPropsList.find(
      (props) => props.name === 'fivePiecesOne'
    )
    const fivePiecesTwoItem = this.itemsPropsList.find(
      (props) => props.name === 'fivePiecesTwo'
    )

    const fivePiecesLiftUp = this.itemsPropsList.find(
      (props) => props.name === 'fivePiecesLiftUp'
    )
    const vGrooveLiftUpItem = this.itemsPropsList.find(
      (props) => props.name === 'vGrooveLiftUp'
    )

    const shakerOneItem = this.itemsPropsList.find(
      (props) => props.name === 'shakerOne'
    )
    const shakerTwoItem = this.itemsPropsList.find(
      (props) => props.name === 'shakerTwo'
    )

    const shakerLiftUpItem = this.itemsPropsList.find(
      (props) => props.name === 'shakerLiftUp'
    )

    const newDoorOneItems = this.getNewDoorDefaultItems(this.itemsPropsList)
    const handleItems = this.getHandleDefaultItems(this.itemsPropsList)

    if (
      vGrooveOneItem &&
      vGrooveTwoItem &&
      fivePiecesOneItem &&
      fivePiecesTwoItem &&
      vGrooveLiftUpItem &&
      fivePiecesLiftUp &&
      shakerOneItem &&
      shakerTwoItem &&
      shakerLiftUpItem &&
      newDoorOneItems &&
      handleItems
    )
      for (const doorProps of this.cabinetProps.sectionProps.doorsProps) {
        //left <-> right
        const oldItem = removableItems.find(
          (item) => item.uuid === doorProps.uuid
        )

        const itemProps = oldItem
          ? clone(oldItem)
          : clone(
              doorProps.type === 'liftUp'
                ? doorProps.visualType === 'vGroove'
                  ? vGrooveLiftUpItem
                  : doorProps.visualType.startsWith('shaker')
                    ? shakerLiftUpItem
                    : doorProps.visualType.startsWith('#')
                      ? this.chooseNewDoorDefaultItem(
                          newDoorOneItems,
                          doorProps.visualType as DoorNewVisualTypes,
                          'liftUp'
                        )
                      : fivePiecesLiftUp
                : doorProps.type === 'double'
                  ? doorProps.visualType === 'vGroove'
                    ? vGrooveTwoItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerTwoItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'double'
                          )
                        : fivePiecesTwoItem
                  : doorProps.visualType === 'vGroove'
                    ? vGrooveOneItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerOneItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'left'
                          )
                        : fivePiecesOneItem
            )

        itemProps.uuid = doorProps.uuid

        const sectionType =
          doorProps.sectionNumber !== 1
            ? doorProps.sectionNumber ===
              this.cabinetProps.sectionProps.dividersProps.length + 1
              ? 'last'
              : 'middle'
            : this.cabinetProps.sectionProps.dividersProps.length === 0
              ? 'single'
              : 'first'

        let doorHeight =
          doorProps.sectionHeight +
          (doorProps.sectionNumber === 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? thickness
              : this.cabinetProps.sectionProps.dividersProps[0].type ===
                  'visible' //if first divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? thickness
              : this.cabinetProps.sectionProps.dividersProps[
                    this.cabinetProps.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 2
              ].type === 'visible' //if top divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 1
              ].type === 'visible' //if bottom divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) //If section is not first or last

        const doorActualHeight =
          doorHeight -
          (sectionType !== 'middle'
            ? sectionType === 'single'
              ? doorConfig.topReveal + doorConfig.bottomReveal
              : sectionType === 'first'
                ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
                : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
            : doorConfig.horizontalGap) //middle

        itemProps.name = `${
          doorProps.type === 'right'
            ? 'Right'
            : doorProps.type === 'left'
              ? 'Left'
              : 'Double'
        } Door ${doorProps.sectionNumber}`

        const resolvedSplitter =
          this.resolveSplitter(
            doorProps.normalMapSplitter,
            doorActualHeight,
            doorProps.sectionY,
            this.cabinetProps.height,
            this.cabinetProps.legHeight
          ) || ''

        if (doorProps.visualType.startsWith('#')) {
          const vType = doorProps.visualType as DoorNewVisualTypes
          const dWidth =
            this.cabinetProps.width -
            doorConfig.leftReveal -
            doorConfig.rightReveal
          const holeSizes = getNewDoorHoleSizes(
            doorProps.type === 'double',
            vType,
            dWidth,
            doorActualHeight,
            resolvedSplitter
          )
          // console.log(holeSizes)

          itemProps.props = {
            type: 'newDoor',
            visualType: vType,
            subType: doorProps.type,
            sectionType,
            width: dWidth,
            height: doorActualHeight,
            splitters: resolvedSplitter,
            holeWidth: holeSizes.width,
            glassHeight: holeSizes.glassHeight,
            cleanHeight: holeSizes.cleanHeight,
            mirrorHeight: holeSizes.mirrorHeight,
            frostedHeight: holeSizes.frostedHeight,
          }
        } else {
          if (doorProps.visualType === 'fivePieces') {
            const dWidth =
              this.cabinetProps.width -
              doorConfig.leftReveal -
              doorConfig.rightReveal

            const _props = getFivePiecesDoorProps(
              doorProps.type === 'double',
              dWidth,
              doorActualHeight,
              resolvedSplitter,
              this.configs.fivePiecesConfig.pieceWidth,
              this.configs.doorConfig
            )

            itemProps.props = {
              type: 'fivePiecesDoor',
              visualType: doorProps.visualType || this.doorVisualType,
              subType: doorProps.type,
              sectionType,
              width:
                this.cabinetProps.width -
                doorConfig.leftReveal -
                doorConfig.rightReveal,
              height: doorActualHeight,
              splitters: resolvedSplitter,
              holeWidth: _props.holeWidth,
              cleanHeight: _props.cleanHeight,
              glassHeight: _props.glassHeight,
              mirrorHeight: _props.mirrorHeight,
              frostedHeight: _props.frostedHeight,
              sheetHeight: _props.sheetHeight,
              piecesLength: _props.piecesLength,
              piecesWidth: this.configs.fivePiecesConfig.pieceWidth,
            }
          } else {
            itemProps.props = {
              type: 'door',
              visualType: doorProps.visualType || this.doorVisualType,
              subType: doorProps.type,
              sectionType,
              width:
                this.cabinetProps.width -
                doorConfig.leftReveal -
                doorConfig.rightReveal,
              height: doorActualHeight,
              // splitters: doorProps.normalMapSplitter || '',
            }

            // itemProps.props.splitters =
            //   itemProps.props.visualType === 'fivePieces'
            //     ? doorProps.normalMapSplitter
            //     : undefined
          }
        }

        itemProps.matrix[13] =
          doorProps.sectionY +
          (doorProps.sectionNumber === 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? 0
              : this.cabinetProps.sectionProps.dividersProps[0].type ===
                  'visible' //if first divider is fixed shelf
                ? thickness / 4
                : thickness / 2
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? 0
              : this.cabinetProps.sectionProps.dividersProps[
                    this.cabinetProps.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? -thickness / 4
                : -thickness / 2
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 2
              ].type === 'visible' //if top divider is fixed shelf
              ? thickness / 4
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 1
              ].type === 'visible' //if bottom divider is fixed shelf
              ? -thickness / 4
              : 0
            : 0) //If section is not first or last

        if (sectionType === 'first') {
          const deltaY =
            doorHeight / 2 - (doorConfig.topReveal + doorActualHeight / 2)
          itemProps.matrix[13] += deltaY
        } else if (sectionType === 'last') {
          const deltaY =
            doorConfig.bottomReveal + doorActualHeight / 2 - doorHeight / 2
          itemProps.matrix[13] += deltaY
        }

        itemProps.matrix[14] = this.cabinetProps.depth / 2 + thickness / 2
        itemProps.matrix[12] = doorConfig.leftReveal - doorConfig.rightReveal
        itemProps.render = true

        if (doorProps.type === 'liftUp') {
          if (doorProps.handleProps.orientation === 'double_horizontal') {
            const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Left Handle`
            const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Right Handle`

            const rOldItem = itemProps.childrenProps.find(
              (item) => item.name === rName
            )
            const lOldItem = itemProps.childrenProps.find(
              (item) => item.name === lName
            )

            const lHandleItemProps = lOldItem
              ? clone(lOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            const rHandleItemProps = rOldItem
              ? clone(rOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            lHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'left',
            }
            rHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'right',
            }

            lHandleItemProps.name = lName
            rHandleItemProps.name = rName

            lHandleItemProps.render = true
            rHandleItemProps.render = true

            lHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              itemProps.props.width,
              true,
              this.configs.handleConfig
            )

            rHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              itemProps.props.width,
              false,
              this.configs.handleConfig
            )

            itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const handleName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldHandleItem = itemProps.childrenProps.find(
              (item) => item.name === handleName
            )

            const handleItemProps = oldHandleItem
              ? clone(oldHandleItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'center',
            }
            handleItemProps.name = handleName
            handleItemProps.render = true

            handleItemProps.matrix = this.calculateLiftUpDoorHandleMatrix(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              itemProps.props.width,
              this.configs.handleConfig
            )

            itemProps.childrenProps = [handleItemProps]
            itemProps.name = `Lift Up Door ${doorProps.sectionNumber}`
          }
        } else {
          if (doorProps.type === 'double') {
            const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Left Handle`
            const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Right Handle`

            const rOldItem = itemProps.childrenProps.find(
              (item) => item.name === rName
            )
            const lOldItem = itemProps.childrenProps.find(
              (item) => item.name === lName
            )

            const lHandleItemProps = lOldItem
              ? clone(lOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            const rHandleItemProps = rOldItem
              ? clone(rOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            lHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'left',
            }
            rHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'right',
            }

            lHandleItemProps.name = lName
            rHandleItemProps.name = rName

            lHandleItemProps.render = true
            rHandleItemProps.render = true

            lHandleItemProps.matrix = this.calculateHandlePosition(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              lHandleItemProps.props.orientation === 'vertical',
              itemProps.props,
              itemProps.matrix[13],
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              'left',
              doorProps.handleProps.positionFromGroundValue
            )
            rHandleItemProps.matrix = this.calculateHandlePosition(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              rHandleItemProps.props.orientation === 'vertical',
              itemProps.props,
              itemProps.matrix[13],
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              'right',
              doorProps.handleProps.positionFromGroundValue
            )

            itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const name = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldItem = itemProps.childrenProps.find(
              (item) => item.name === name
            )

            const handleItemProps = oldItem
              ? clone(oldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: doorProps.type === 'left' ? 'right' : 'left',
            }
            handleItemProps.name = `${handleItemProps.props.subType[0].toUpperCase()}${handleItemProps.props.subType.slice(
              1
            )} ${handleItemProps.props.subType2} Handle`
            handleItemProps.render = true
            handleItemProps.matrix = this.calculateHandlePosition(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              handleItemProps.props.orientation === 'vertical',
              itemProps.props,
              itemProps.matrix[13],
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              undefined,
              doorProps.handleProps.positionFromGroundValue
            )

            itemProps.childrenProps = [handleItemProps]
          }
        }

        this.itemsPropsList.push(itemProps)
      }

    // =================Drawers==================

    //clear drawers

    const drawerItem = this.itemsPropsList.find(
      (props) => props.name === 'drawer'
    )
    const fivePiecesDrawerItem = this.itemsPropsList.find(
      (props) => props.name === 'fivePiecesDrawer'
    )
    const shakerDrawerItem = this.itemsPropsList.find(
      (props) => props.name === 'shakerDrawer'
    )

    if (
      drawerItem &&
      fivePiecesDrawerItem &&
      shakerDrawerItem &&
      handleItems &&
      newDoorOneItems
    )
      for (const drawerProps of this.cabinetProps.sectionProps.drawersProps) {
        const oldItem = removableItems.find(
          (item) => item.uuid === drawerProps.uuid
        )

        const itemProps = oldItem
          ? clone(oldItem)
          : clone(
              drawerProps.visualType?.startsWith('#')
                ? this.chooseNewDoorDefaultItem(
                    newDoorOneItems,
                    drawerProps.visualType as DoorNewVisualTypes,
                    'drawer'
                  )
                : drawerProps.visualType === 'fivePieces'
                  ? fivePiecesDrawerItem
                  : drawerProps.visualType?.startsWith('shaker')
                    ? shakerDrawerItem
                    : drawerItem
            )

        itemProps.uuid = drawerProps.uuid

        const sectionType =
          drawerProps.sectionNumber !== 1
            ? drawerProps.sectionNumber ===
              this.cabinetProps.sectionProps.dividersProps.length + 1
              ? 'last'
              : 'middle'
            : this.cabinetProps.sectionProps.dividersProps.length === 0
              ? 'single'
              : 'first'

        let drawerHeight =
          drawerProps.sectionHeight +
          (drawerProps.sectionNumber === 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? thickness
              : this.cabinetProps.sectionProps.dividersProps[0].type ===
                  'visible' //if first divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the first
          (drawerProps.sectionNumber ===
          this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? thickness
              : this.cabinetProps.sectionProps.dividersProps[
                    this.cabinetProps.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                drawerProps.sectionNumber - 2
              ].type === 'visible' //if top divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) + //If section is not first or last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                drawerProps.sectionNumber - 1
              ].type === 'visible' //if bottom divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) //If section is not first or last

        const drawerActualHeight =
          drawerHeight -
          (sectionType !== 'middle'
            ? sectionType === 'single'
              ? doorConfig.topReveal + doorConfig.bottomReveal
              : sectionType === 'first'
                ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
                : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
            : doorConfig.horizontalGap) //middle

        itemProps.name = `Drawer ${drawerProps.sectionNumber}`

        let temp = drawerActualHeight - drawerConfig.boxHeightBottomMargin
        let possibleBoxHeight =
          temp - drawerConfig.boxHeights[1].minimumTopMargin

        if (possibleBoxHeight < drawerConfig.boxHeights[0].value) {
          possibleBoxHeight = temp - drawerConfig.boxHeights[0].minimumTopMargin
        }

        const boxHeight =
          possibleBoxHeight >= drawerConfig.boxHeights[5].value
            ? drawerConfig.boxHeights[5].value
            : possibleBoxHeight >= drawerConfig.boxHeights[4].value
              ? drawerConfig.boxHeights[4].value
              : possibleBoxHeight >= drawerConfig.boxHeights[3].value
                ? drawerConfig.boxHeights[3].value
                : possibleBoxHeight >= drawerConfig.boxHeights[2].value
                  ? drawerConfig.boxHeights[2].value
                  : possibleBoxHeight >= drawerConfig.boxHeights[1].value
                    ? drawerConfig.boxHeights[1].value
                    : drawerConfig.boxHeights[0].value

        let cabinetInsideDepth =
          this.cabinetProps.depth - drawerConfig.boxDepthMargin

        const boxDepth =
          cabinetInsideDepth >= drawerConfig.boxDepths[5]
            ? drawerConfig.boxDepths[5]
            : cabinetInsideDepth >= drawerConfig.boxDepths[4]
              ? drawerConfig.boxDepths[4]
              : cabinetInsideDepth >= drawerConfig.boxDepths[3]
                ? drawerConfig.boxDepths[3]
                : cabinetInsideDepth >= drawerConfig.boxDepths[2]
                  ? drawerConfig.boxDepths[2]
                  : cabinetInsideDepth >= drawerConfig.boxDepths[1]
                    ? drawerConfig.boxDepths[1]
                    : drawerConfig.boxDepths[0]

        const drawerSlideTypeProps = drawerSlideProps[this.drawerSlideType]
        const slideProps =
          [...drawerSlideTypeProps]
            .reverse()
            .find((sp) => cabinetInsideDepth >= sp.value) ??
          drawerSlideTypeProps[0]

        // itemProps.props = {
        //   type: 'drawer',
        //   visualType: drawerProps.visualType || 'standard',
        //   sectionType,
        //   width:
        //     this.cabinetProps.width -
        //     doorConfig.leftReveal -
        //     doorConfig.rightReveal,
        //   height: drawerActualHeight,
        //   depth: this.cabinetProps.depth,
        //   boxHeight,
        //   boxDepth,
        //   boxWidth:
        //     this.cabinetProps.width -
        //     thickness * 2 -
        //     drawerConfig.boxWidthMargin * 2,
        // }
        if (drawerProps.visualType === 'fivePieces') {
          const dWidth =
            this.cabinetProps.width -
            doorConfig.leftReveal -
            doorConfig.rightReveal
          const drawerMaxHeight = 7.25 * 2.54
          const _props = getFivePiecesDrawerProps(
            dWidth,
            drawerActualHeight,
            this.configs.fivePiecesConfig.pieceWidth,
            this.configs.fivePiecesConfig.pieceWidth /
              (drawerActualHeight < drawerMaxHeight ? 2 : 1)
          )
          itemProps.props = {
            type: 'fivePiecesDrawer',
            visualType: 'fivePieces',
            sectionType,
            width:
              this.cabinetProps.width -
              doorConfig.leftReveal -
              doorConfig.rightReveal,
            height: drawerActualHeight,
            centerWidth: _props.centerWidth,
            centerHeight: _props.centerHeight,
            piecesArea: _props.piecesArea,
            boxHeight,
            boxDepth,
            boxWidth:
              this.cabinetProps.width -
              thickness * 2 -
              drawerConfig.boxWidthMargin * 2,
            depth: this.cabinetProps.depth,
          }
        } else {
          itemProps.props = {
            type: 'drawer',
            visualType: drawerProps.visualType || 'standard',
            sectionType,
            width:
              this.cabinetProps.width -
              doorConfig.leftReveal -
              doorConfig.rightReveal,
            height: drawerActualHeight,
            depth: this.cabinetProps.depth,
            boxHeight,
            boxDepth,
            boxWidth:
              this.cabinetProps.width -
              thickness * 2 -
              drawerConfig.boxWidthMargin * 2,
          }
        }

        //add drawer box hardware and links
        const index = drawerConfig.boxHeights.findIndex(
          (b) => b.value === boxHeight
        )

        if (index !== -1) {
          const drawerBoxHardwareId = drawerConfig.boxHeights[index].hardwareId

          const hIndex = itemProps.hardwaresProps.findIndex((hProps) =>
            drawerConfig.boxHeights.map((b) => b.hardwareId).includes(hProps.id)
          )

          if (hIndex === -1) {
            const localId =
              Math.max(...itemProps.hardwaresProps.map((id) => id.localId), 0) +
              1
            itemProps.hardwaresProps.push({
              id: drawerBoxHardwareId,
              localId,
              count: 1,
            })

            itemProps.links.push(
              ...[
                {
                  hId: localId.toString(),
                  hProp: 'height',
                  itemProp: 'boxHeight',
                },
                {
                  hId: localId.toString(),
                  hProp: 'width',
                  itemProp: 'boxWidth',
                },
                {
                  hId: localId.toString(),
                  hProp: 'depth',
                  itemProp: 'boxDepth',
                },
              ]
            )
          } else {
            itemProps.hardwaresProps[hIndex] = {
              ...itemProps.hardwaresProps[hIndex],
              id: drawerBoxHardwareId,
            }
          }

          // Add slide hardware
          const drawerSlideHardwareId = slideProps.hardwareId

          const shIndex = itemProps.hardwaresProps.findIndex((hProps) =>
            drawerSlideAllHardwareIds.includes(hProps.id)
          )

          if (shIndex === -1) {
            const localId =
              Math.max(...itemProps.hardwaresProps.map((id) => id.localId), 0) +
              1
            itemProps.hardwaresProps.push({
              id: drawerSlideHardwareId,
              localId,
              count: 1,
            })
          } else {
            itemProps.hardwaresProps[shIndex] = {
              ...itemProps.hardwaresProps[shIndex],
              id: drawerSlideHardwareId,
            }
          }
        }

        itemProps.matrix[13] =
          drawerProps.sectionY +
          (drawerProps.sectionNumber === 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? 0
              : this.cabinetProps.sectionProps.dividersProps[0].type ===
                  'visible' //if first divider is fixed shelf
                ? thickness / 4
                : thickness / 2
            : 0) + //If section is the first
          (drawerProps.sectionNumber ===
          this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps.length === 0
              ? 0
              : this.cabinetProps.sectionProps.dividersProps[
                    this.cabinetProps.sectionProps.dividersProps.length - 1
                  ].type === 'visible' //if last divider is fixed shelf
                ? -thickness / 4
                : -thickness / 2
            : 0) + //If section is the last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                drawerProps.sectionNumber - 2
              ].type === 'visible' //if top divider is fixed shelf
              ? thickness / 4
              : 0
            : 0) + //If section is not first or last
          (drawerProps.sectionNumber !== 1 &&
          drawerProps.sectionNumber !==
            this.cabinetProps.sectionProps.dividersProps.length + 1
            ? this.cabinetProps.sectionProps.dividersProps[
                drawerProps.sectionNumber - 1
              ].type === 'visible' //if bottom divider is fixed shelf
              ? -thickness / 4
              : 0
            : 0) //If section is not first or last

        if (sectionType === 'first') {
          const deltaY =
            drawerHeight / 2 - (doorConfig.topReveal + drawerActualHeight / 2)
          itemProps.matrix[13] += deltaY
        } else if (sectionType === 'last') {
          const deltaY =
            doorConfig.bottomReveal + drawerActualHeight / 2 - drawerHeight / 2
          itemProps.matrix[13] += deltaY
        }

        itemProps.matrix[14] = this.cabinetProps.depth / 2 + thickness / 2
        itemProps.matrix[12] = doorConfig.leftReveal - doorConfig.rightReveal
        itemProps.render = true

        //  Handle part

        if (drawerProps.handleProps.orientation === 'double_horizontal') {
          const lName = `${drawerProps.handleProps.type[0].toUpperCase()}${drawerProps.handleProps.type.slice(
            1
          )} ${drawerProps.handleProps.subtype} Left Handle`
          const rName = `${drawerProps.handleProps.type[0].toUpperCase()}${drawerProps.handleProps.type.slice(
            1
          )} ${drawerProps.handleProps.subtype} Right Handle`

          const rOldItem = itemProps.childrenProps.find(
            (item) => item.name === rName
          )
          const lOldItem = itemProps.childrenProps.find(
            (item) => item.name === lName
          )

          const lHandleItemProps = lOldItem
            ? clone(lOldItem)
            : clone(
                this.chooseHandleDefaultItem(
                  handleItems,
                  drawerProps.handleProps.type,
                  drawerProps.handleProps.subtype,
                  'drawer'
                )
              )

          const rHandleItemProps = rOldItem
            ? clone(rOldItem)
            : clone(
                this.chooseHandleDefaultItem(
                  handleItems,
                  drawerProps.handleProps.type,
                  drawerProps.handleProps.subtype,
                  'drawer'
                )
              )

          lHandleItemProps.props = {
            type: 'handle',
            subType: drawerProps.handleProps.type,
            subType2: drawerProps.handleProps.subtype,
            position: drawerProps.handleProps.position,
            orientation: drawerProps.handleProps.orientation,
            hPosition: 'left',
          }
          rHandleItemProps.props = {
            type: 'handle',
            subType: drawerProps.handleProps.type,
            subType2: drawerProps.handleProps.subtype,
            position: drawerProps.handleProps.position,
            orientation: drawerProps.handleProps.orientation,
            hPosition: 'right',
          }

          lHandleItemProps.name = lName
          rHandleItemProps.name = rName

          lHandleItemProps.render = true
          rHandleItemProps.render = true

          lHandleItemProps.matrix = this.calculateDrawerDoubleHandleMatrix(
            drawerProps.visualType || 'standard',
            drawerProps.handleProps.position,
            drawerProps.handleProps.positionX,
            drawerProps.handleProps.type,
            drawerProps.handleProps.subtype,
            itemProps.props.height,
            itemProps.props.width,
            true,
            this.configs.handleConfig
          )

          rHandleItemProps.matrix = this.calculateDrawerDoubleHandleMatrix(
            drawerProps.visualType || 'standard',
            drawerProps.handleProps.position,
            drawerProps.handleProps.positionX,
            drawerProps.handleProps.type,
            drawerProps.handleProps.subtype,
            itemProps.props.height,
            itemProps.props.width,
            false,
            this.configs.handleConfig
          )

          itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
        } else {
          const handleName = `${drawerProps.handleProps.type[0].toUpperCase()}${drawerProps.handleProps.type.slice(
            1
          )} ${drawerProps.handleProps.subtype} Handle`

          const oldHandleItem = itemProps.childrenProps.find(
            (item) => item.name === handleName
          )
          const handleItemProps = oldHandleItem
            ? clone(oldHandleItem)
            : clone(
                this.chooseHandleDefaultItem(
                  handleItems,
                  drawerProps.handleProps.type,
                  drawerProps.handleProps.subtype,
                  'drawer'
                )
              )

          handleItemProps.props = {
            type: 'handle',
            subType: drawerProps.handleProps.type,
            subType2: drawerProps.handleProps.subtype,
            position: drawerProps.handleProps.position,
            orientation: drawerProps.handleProps.orientation || 'horizontal',
            hPosition: 'center',
          }
          handleItemProps.name = handleName
          handleItemProps.render = true

          handleItemProps.matrix = this.calculateDrawerHandleMatrix(
            drawerProps.visualType || 'standard',
            drawerProps.handleProps.position,
            drawerProps.handleProps.type,
            drawerProps.handleProps.subtype,
            itemProps.props.height,
            drawerProps.handleProps.positionX,
            itemProps.props.width,
            this.configs.handleConfig
          )

          itemProps.childrenProps = [handleItemProps]
        }

        this.itemsPropsList.push(itemProps)
      }

    // =================Legs==================

    const legsItem = this.itemsPropsList.find((props) => props.name === 'legs')
    const sheetItem = this.itemsPropsList.find(
      (props) => props.name === 'shelf'
    )
    const separateBaseItem = this.itemsPropsList.find(
      (props) => props.props.type === 'separateBase'
    )
    const legs2ShortItem = this.itemsPropsList.find(
      (props) => props.name === 'legs2Short'
    )
    const legs2TallItem = this.itemsPropsList.find(
      (props) => props.name === 'legs2Tall'
    )

    if (
      this.legProps.on &&
      legsItem &&
      sheetItem &&
      separateBaseItem &&
      legs2ShortItem &&
      legs2TallItem
    ) {
      if (this.legProps.type === 'standard') {
        if (
          this.itemsPropsList.findIndex(
            (item) => item.name === 'Standard Legs'
          ) === -1
        ) {
          const itemProps = clone(legsItem)

          itemProps.name = 'Standard Legs'

          itemProps.props = {
            type: 'leg',
            subType: 'standard',
            cabinetWidth: this.cabinetProps.width,
            cabinetDepth: this.cabinetProps.depth,
            height: this.cabinetProps.legHeight,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -this.cabinetProps.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      } else if (this.legProps.type === 'standard2_1') {
        if (
          this.itemsPropsList.findIndex(
            (item) => item.name === 'Standard Legs 2 Short'
          ) === -1
        ) {
          const itemProps = clone(legs2ShortItem)

          itemProps.name = 'Standard Legs 2 Short'

          itemProps.props = {
            type: 'leg2',
            subType: 'short',
            cabinetWidth: this.cabinetProps.width,
            cabinetDepth: this.cabinetProps.depth,
            height: this.cabinetProps.legHeight,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -this.cabinetProps.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      } else if (this.legProps.type === 'standard2_2') {
        if (
          this.itemsPropsList.findIndex(
            (item) => item.name === 'Standard Legs 2 Tall'
          ) === -1
        ) {
          const itemProps = clone(legs2TallItem)

          itemProps.name = 'Standard Legs 2 Tall'

          itemProps.props = {
            type: 'leg2',
            subType: 'tall',
            cabinetWidth: this.cabinetProps.width,
            cabinetDepth: this.cabinetProps.depth,
            height: this.cabinetProps.legHeight,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -this.cabinetProps.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      }
      // else if (this.legProps.type === 'noToeKick') {
      //     const itemProps = clone(sheetItem)

      //     itemProps.name = 'No Toe Kick Front'

      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'shelf',
      //         width: this.configs.noToeKickLegConfig.height,
      //         length: this.cabinetProps.width,
      //     }

      //     itemProps.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, (-this.cabinetProps.height - this.configs.noToeKickLegConfig.height) / 2, (this.cabinetProps.depth + thickness) / 2, 1]
      //     itemProps.render = true

      //     this.itemsPropsList.push(itemProps)
      // }
      // else if (this.legProps.type === 'base') {
      //     const itemProps = clone(sheetItem)

      //     itemProps.name = 'Base Leg Front'

      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'shelf',
      //         width: this.configs.baseLegConfig.height,
      //         length: this.cabinetProps.width,
      //     }

      //     itemProps.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, (-this.cabinetProps.height - this.configs.baseLegConfig.height) / 2, (this.cabinetProps.depth + thickness) / 2 - this.configs.baseLegConfig.cutLength, 1]
      //     itemProps.render = true

      //     this.itemsPropsList.push(itemProps)
      // }
      else if (this.legProps.type === 'separateBase') {
        const itemProps = clone(separateBaseItem)

        itemProps.name = 'Separate Base Platform'

        itemProps.props = {
          ...itemProps.props,
          type: 'separateBase',
          width:
            this.cabinetProps.width -
            2 * this.configs.separateBaseConfig.sideMargin,
          height: this.cabinetProps.legHeight,
          depth:
            this.cabinetProps.depth -
            this.configs.separateBaseConfig.frontMargin,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          (-this.cabinetProps.height - this.cabinetProps.legHeight) / 2,
          0,
          1,
        ]
        itemProps.render = true

        this.itemsPropsList.push(itemProps)
      }
    }
    // else if (!this.legProps.on) {
    //     const index = itemsPropsList.findIndex(itemProps => (itemProps.props.type === 'leg' && itemProps.render))
    //     if (index !== -1) {
    //         const sIndex = this.object.children.findIndex(ch => ch.name === itemsPropsList[index].name)
    //         if (sIndex !== -1)
    //             this.object.remove(this.object.children[sIndex])

    //         itemsPropsList.splice(index, 1)
    //     }
    // }

    // const sectionProps = clone(props.sectionProps)

    // sectionProps.width = props.width - thickness * 2
    // sectionProps.height = props.height - thickness * 2

    // this.props.setSectionProps(sectionProps)
    const additionalItem = this.itemsPropsList.find(
      (i) => i.name === 'Additional Item'
    )

    if (additionalItem) {
      const _props = {} as { [key: string]: number }

      for (const iProps of this.itemsPropsList.filter(
        (i) => i.name !== 'Additional Item' && i.render
      )) {
        for (const key in iProps.props) {
          // @ts-ignore
          if (typeof iProps.props[key] === 'number') {
            // @ts-ignore
            _props[iProps.name + '_' + key] = iProps.props[key]
          }
        }
      }

      additionalItem.props = {
        type: 'additional',
        cabinetWidth: this.cabinetProps.width,
        cabinetHeight: this.cabinetProps.height,
        cabinetDepth: this.cabinetProps.depth,
        ..._props,
      }
    }

    // console.timeEnd('createCabinet')

    this.visualizeItems()
  }

  visualizeCornerCabinetProps = (removableItems: ItemPropsType[]) => {
    // console.log('createCabinet')

    const doorConfig = this.configs.doorConfig
    const thickness = this.configs.thickness
    const isNewBase = this.legProps.baseSubType !== 'old'

    for (const itemProps of this.itemsPropsList) {
      if (itemProps.name === 'Front Left Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            this.cornerCabinetProps.height +
            (this.legProps.on && this.legProps.type === 'noToeKick'
              ? this.cornerCabinetProps.legHeight
              : 0),
          length: this.cornerCabinetProps.depth1,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          this.cornerCabinetProps.depth1 / 2,
          this.legProps.on && this.legProps.type === 'noToeKick'
            ? -this.cornerCabinetProps.legHeight / 2
            : 0, //y
          this.cornerCabinetProps.width1 - thickness / 2,
          1,
        ]

        if (this.legProps.on) {
          itemProps.render =
            this.legProps.type !== 'base' && this.legProps.type !== 'baseIsland'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Front Left Side Base Leg') {
        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: this.cornerCabinetProps.height,
          legHeight: this.cornerCabinetProps.legHeight,
          width: this.cornerCabinetProps.depth1,
          cutLength: this.baseLegCut,
          isNewBase: this.legProps.baseSubType !== 'old',
        }
        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          -1,
          1.2246467991473532e-16,
          0,
          0,
          -1.2246467991473532e-16,
          -1,
          0,
          0, //x
          this.cornerCabinetProps.height / 2,
          this.cornerCabinetProps.width1, //- thickness / 2, //z
          1,
        ]
        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' || this.legProps.type === 'baseIsland')
      } else if (itemProps.name === 'Back Left Side') {
        const sheetLength =
          this.legProps.on &&
          this.legProps.type === 'baseIsland' &&
          this.legProps.subType !== 'cornerRight'
            ? this.cornerCabinetProps.width1
            : this.cornerCabinetProps.width1 -
              this.cornerCabinetProps.backWidth1 -
              thickness

        const sheetHeight =
          this.cornerCabinetProps.height +
          (this.legProps.on &&
          (this.legProps.type === 'noToeKick' ||
            this.legProps.type === 'baseIsland')
            ? this.cornerCabinetProps.legHeight
            : 0)

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: sheetHeight,
          length: sheetLength,
        }

        let z =
          this.cornerCabinetProps.backWidth1 +
          (this.cornerCabinetProps.width1 -
            this.cornerCabinetProps.backWidth1) /
            2 -
          thickness / 2

        if (
          this.legProps.on &&
          this.legProps.type === 'baseIsland' &&
          this.legProps.subType !== 'cornerRight'
        ) {
          z = sheetLength / 2
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          thickness / 2,
          this.legProps.on &&
          (this.legProps.type === 'noToeKick' ||
            this.legProps.type === 'baseIsland')
            ? -this.cornerCabinetProps.legHeight / 2
            : 0, //y
          z,
          1,
        ]
      } else if (itemProps.name === 'Front Right Side') {
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width:
            this.cornerCabinetProps.height +
            (this.legProps.on && this.legProps.type === 'noToeKick'
              ? this.cornerCabinetProps.legHeight
              : 0),
          length: this.cornerCabinetProps.depth2,
        }

        itemProps.matrix = [
          2.220446049250313e-16,
          -0,
          -1,
          0,
          0,
          1,
          -0,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          this.cornerCabinetProps.width2 - thickness / 2,
          this.legProps.on && this.legProps.type === 'noToeKick'
            ? -this.cornerCabinetProps.legHeight / 2
            : 0,
          this.cornerCabinetProps.depth2 / 2,
          1,
        ]

        if (this.legProps.on) {
          itemProps.render =
            this.legProps.type !== 'base' && this.legProps.type !== 'baseIsland'
        } else {
          itemProps.render = true
        }
      } else if (itemProps.name === 'Front Right Side Base Leg') {
        itemProps.props = {
          ...itemProps.props,
          type: 'sideSheetBaseLeg',
          cabinetHeight: this.cornerCabinetProps.height,
          legHeight: this.cornerCabinetProps.legHeight,
          width: this.cornerCabinetProps.depth2,
          cutLength: this.baseLegCut,
          isNewBase: this.legProps.baseSubType !== 'old',
        }
        itemProps.matrix = [
          2.220446049250313e-16,
          1.2246467991473532e-16,
          1,
          0,
          0,
          -1,
          1.2246467991473532e-16,
          0,
          1,
          -2.465190328815662e-32,
          -2.220446049250313e-16,
          0,
          this.cornerCabinetProps.width2 - thickness,
          this.cornerCabinetProps.height / 2,
          0,
          1,
        ]
        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' || this.legProps.type === 'baseIsland')
      } else if (itemProps.name === 'Back Right Side') {
        const sheetLength =
          this.legProps.on &&
          this.legProps.type === 'baseIsland' &&
          this.legProps.subType !== 'cornerLeft'
            ? this.cornerCabinetProps.width2
            : this.cornerCabinetProps.width2 -
              this.cornerCabinetProps.backWidth2 -
              thickness

        const sheetHeight =
          this.cornerCabinetProps.height +
          (this.legProps.on &&
          (this.legProps.type === 'noToeKick' ||
            this.legProps.type === 'baseIsland')
            ? this.cornerCabinetProps.legHeight
            : 0)

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: sheetHeight,
          length: sheetLength,
        }

        let x =
          this.cornerCabinetProps.backWidth2 +
          (this.cornerCabinetProps.width2 -
            this.cornerCabinetProps.backWidth2) /
            2 -
          thickness / 2

        if (
          this.legProps.on &&
          this.legProps.type === 'baseIsland' &&
          this.legProps.subType !== 'cornerLeft'
        ) {
          x = sheetLength / 2
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          x,
          this.legProps.on &&
          (this.legProps.type === 'noToeKick' ||
            this.legProps.type === 'baseIsland')
            ? -this.cornerCabinetProps.legHeight / 2
            : 0,
          thickness / 2,
          1,
        ]
      } else if (
        itemProps.name === 'Top' &&
        itemProps.props.type === 'cornerHorizontalSheet'
      ) {
        itemProps.props = {
          ...itemProps.props,
          type: 'cornerHorizontalSheet',
          subType: this.cornerCabinetProps.type,
          width1: this.cornerCabinetProps.width1,
          width2: this.cornerCabinetProps.width2,
          backWidth1: this.cornerCabinetProps.backWidth1,
          backWidth2: this.cornerCabinetProps.backWidth2,
          depth1: this.cornerCabinetProps.depth1,
          depth2: this.cornerCabinetProps.depth2,
          thickness,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          this.cornerCabinetProps.height / 2,
          0,
          1,
        ]
      } else if (
        itemProps.name === 'Bottom' &&
        itemProps.props.type === 'cornerHorizontalSheet'
      ) {
        itemProps.props = {
          type: 'cornerHorizontalSheet',
          subType: this.cornerCabinetProps.type,
          width1: this.cornerCabinetProps.width1,
          width2: this.cornerCabinetProps.width2,
          backWidth1: this.cornerCabinetProps.backWidth1,
          backWidth2: this.cornerCabinetProps.backWidth2,
          depth1: this.cornerCabinetProps.depth1,
          depth2: this.cornerCabinetProps.depth2,
          thickness,
        }

        itemProps.matrix = [
          1,
          0,
          0,
          0,
          0,
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          -this.cornerCabinetProps.height / 2 + thickness,
          0,
          1,
        ]

        itemProps.render = this.type !== 'upperOpen'
      } else if (itemProps.name === 'Back') {
        //https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing

        const e1 = this.cornerCabinetProps.backWidth1 - thickness //edge
        const e2 = this.cornerCabinetProps.backWidth2 - thickness
        const hyp = (e1 ** 2 + e2 ** 2) ** 0.5 //hypotenuse

        const x1 = (thickness * hyp) / e2
        const x2 = (thickness * hyp) / e1
        const l1 = (thickness * e1) / e2 //length margin, == y
        const l2 = (thickness * e2) / e1

        const _e1 = e1 + thickness + l1
        const _e2 = e2 + thickness + l2
        const _hyp = hyp + x1 + x2
        const h = (_e1 * _e2) / _hyp // height of _triangle

        const z = (_e1 ** 2 - h ** 2) ** 0.5

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          width: this.cornerCabinetProps.height,
          length: hyp + l1 + l2,
        }

        const angle = Math.asin(e2 / hyp)

        const mesh = new THREE.Mesh()

        mesh.rotateY(Math.PI / 2 - angle)
        mesh.translateZ(h + thickness / 2)
        mesh.translateX(hyp / 2 - (z - x1))
        mesh.translateX((l2 - l1) / 2)

        mesh.updateMatrix()

        itemProps.matrix = [...mesh.matrix.elements]
      } else if (itemProps.name === 'Base Leg Front') {
        const cutLength =
          this.baseLegCut ?? this.configs.baseLegConfig.cutLength
        const e1 =
          this.cornerCabinetProps.width2 -
          this.cornerCabinetProps.depth1 +
          cutLength -
          thickness / 2 //edge
        const e2 =
          this.cornerCabinetProps.width1 -
          this.cornerCabinetProps.depth2 +
          cutLength -
          thickness / 2 //edge

        const hyp = (e1 ** 2 + e2 ** 2) ** 0.5 //hypotenuse
        const x = this.cornerCabinetProps.width1 - e1 / 2 - thickness
        const z = this.cornerCabinetProps.width2 - e2 / 2 - thickness
        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: this.cornerCabinetProps.legHeight, //this.props.configs.baseLegConfig.height,
          width: hyp, // + thickness,
        }
        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          -1.1102230246251565e-16,
          0,
          -0.7071067811865475,
          2.220446049250313e-16,
          0.7071067811865476,
          0,
          0.7071067811865476,
          0,
          0.7071067811865475,
          0,
          x,
          (-this.cornerCabinetProps.height -
            this.cornerCabinetProps.legHeight) /
            2,
          z,
          1,
        ]
        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' ||
            this.legProps.type === 'baseIsland') &&
          this.cornerCabinetProps.type === 'angled'
      } else if (itemProps.name === 'Base Leg Front 1') {
        const cutLength =
          this.baseLegCut ?? this.configs.baseLegConfig.cutLength
        const length =
          this.cornerCabinetProps.width1 -
          this.cornerCabinetProps.depth2 +
          cutLength -
          (isNewBase ? 0 : thickness)
        const x = this.cornerCabinetProps.depth1 - cutLength - thickness / 2
        const z =
          this.cornerCabinetProps.width1 -
          length / 2 -
          (isNewBase ? 0 : thickness)

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: this.cornerCabinetProps.legHeight, //this.props.configs.baseLegConfig.height,
          width: length, // + thickness,
        }
        itemProps.matrix = [
          0,
          1,
          -2.220446049250313e-16,
          0,
          -2.220446049250313e-16,
          2.220446049250313e-16,
          1,
          0,
          1,
          0,
          2.220446049250313e-16,
          0,
          x,
          (-this.cornerCabinetProps.height -
            this.cornerCabinetProps.legHeight) /
            2,
          z,
          1,
        ]
        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' ||
            this.legProps.type === 'baseIsland') &&
          this.cornerCabinetProps.type === '2door'
      } else if (itemProps.name === 'Base Leg Front 2') {
        const cutLength =
          this.baseLegCut ?? this.configs.baseLegConfig.cutLength
        const length =
          this.cornerCabinetProps.width2 -
          this.cornerCabinetProps.depth1 +
          cutLength +
          (isNewBase ? thickness : 0)
        const x =
          this.cornerCabinetProps.width2 -
          length / 2 -
          (isNewBase ? 0 : thickness)
        const z = this.cornerCabinetProps.depth2 - cutLength - thickness / 2

        itemProps.props = {
          ...itemProps.props,
          type: 'shelf',
          length: this.cornerCabinetProps.legHeight, //this.props.configs.baseLegConfig.height,
          width: length, // + thickness,
        }
        itemProps.matrix = [
          2.220446049250313e-16,
          1,
          0,
          0,
          -1,
          2.220446049250313e-16,
          0,
          0,
          0,
          0,
          1,
          0,
          x,
          (-this.cornerCabinetProps.height -
            this.cornerCabinetProps.legHeight) /
            2,
          z,
          1,
        ]
        itemProps.render =
          this.legProps.on &&
          (this.legProps.type === 'base' ||
            this.legProps.type === 'baseIsland') &&
          this.cornerCabinetProps.type === '2door'
      }
      // else if (itemProps.name.slice(0, 5) === 'Shelf') {
      //     itemProps.props = {
      //         ...itemProps.props,
      //         type: 'shelf',
      //         width: this.cornerCabinetProps.depth - thickness,
      //         length: this.cornerCabinetProps.width - thickness * 2
      //     }
      // }
    }

    const section = makeSection(this.cornerCabinetProps.sectionProps, thickness)

    // =================Fixed Shelves==================

    const fixedShelfItem = this.itemsPropsList.find(
      (props) => props.name === 'cornerFixed'
    )

    if (fixedShelfItem)
      for (const divider of section.dividers) {
        if (divider.type === 'visible') {
          const oldItem = removableItems.find(
            (item) => item.uuid === divider.uuid
          )

          const itemProps = oldItem ? clone(oldItem) : clone(fixedShelfItem)

          itemProps.uuid = divider.uuid
          itemProps.name = 'Fixed Shelf ' + divider.object.name.split('_')[1]
          itemProps.props = {
            type: 'cornerHorizontalSheet',
            subType: this.cornerCabinetProps.type,
            width1: this.cornerCabinetProps.width1,
            width2: this.cornerCabinetProps.width2,
            backWidth1: this.cornerCabinetProps.backWidth1,
            backWidth2: this.cornerCabinetProps.backWidth2,
            depth1: this.cornerCabinetProps.depth1,
            depth2: this.cornerCabinetProps.depth2,
            thickness,
          }

          itemProps.matrix[13] = divider.object.position.y + thickness / 2
          // itemProps.matrix[14] = thickness / 2
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      }

    // =================Adjustable Shelves==================

    const shelfItemProps = this.itemsPropsList.find(
      (props) => props.name === 'cornerShelf'
    )

    if (shelfItemProps) {
      for (const shelfProps of this.cornerCabinetProps.sectionProps
        .shelvesProps) {
        // debugger
        const ys = []

        let temp = shelfProps.sectionY - shelfProps.sectionHeight / 2
        for (let i = 0; i < shelfProps.count; i++) {
          temp += shelfProps.sectionHeight / (shelfProps.count + 1)
          ys.push(temp)
        }

        ys.reverse().forEach((y, i) => {
          const itemProps = clone(shelfItemProps)

          itemProps.name = `Shelf_${shelfProps.sectionNumber}_${i + 1}`

          itemProps.props = {
            type: 'cornerHorizontalSheet',
            subType: this.cornerCabinetProps.type,
            width1: this.cornerCabinetProps.width1,
            width2: this.cornerCabinetProps.width2,
            backWidth1: this.cornerCabinetProps.backWidth1,
            backWidth2: this.cornerCabinetProps.backWidth2,
            depth1: this.cornerCabinetProps.depth1,
            depth2: this.cornerCabinetProps.depth2,
            thickness,
          }

          const matrix = new THREE.Matrix4()
          matrix.makeRotationX(Math.PI / 2)
          matrix.setPosition(0, y, 0)

          itemProps.matrix = matrix.elements
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        })
      }
    }

    // =================Doors==================

    const vGrooveOneCornerItem = this.itemsPropsList.find(
      (props) => props.name === 'vGrooveOneCorner'
    )
    const cornerTwoDoorItem = this.itemsPropsList.find(
      (props) => props.name === 'corner2door'
    )
    const vGrooveLiftUpItem = this.itemsPropsList.find(
      (props) => props.name === 'vGrooveLiftUp'
    )

    const fivePiecesOneItem = this.itemsPropsList.find(
      (props) => props.name === 'fivePiecesOne'
    )
    const fivePiecesLiftUp = this.itemsPropsList.find(
      (props) => props.name === 'fivePiecesLiftUp'
    )
    const fivePiecesCornerItem = this.itemsPropsList.find(
      (props) => props.name === 'fivePiecesCorner'
    )
    const shakerOneItem = this.itemsPropsList.find(
      (props) => props.name === 'shakerOne'
    )
    const shakerLiftUpItem = this.itemsPropsList.find(
      (props) => props.name === 'shakerLiftUp'
    )
    const shakerCornerItem = this.itemsPropsList.find(
      (props) => props.name === 'shakerCorner'
    )
    const newDoorOneItems = this.getNewDoorDefaultItems(this.itemsPropsList)
    const handleItems = this.getHandleDefaultItems(this.itemsPropsList)

    if (
      cornerTwoDoorItem &&
      vGrooveOneCornerItem &&
      handleItems &&
      vGrooveLiftUpItem &&
      fivePiecesOneItem &&
      fivePiecesLiftUp &&
      fivePiecesCornerItem &&
      shakerOneItem &&
      shakerLiftUpItem &&
      shakerCornerItem &&
      newDoorOneItems
    ) {
      for (const doorProps of this.cornerCabinetProps.sectionProps.doorsProps) {
        //left <-> right
        const oldItem = this.object.userData.isCornerTypeChanged
          ? undefined
          : removableItems.find((item) => item.uuid === doorProps.uuid)

        const itemProps = oldItem
          ? clone(oldItem)
          : clone(
              this.cornerCabinetProps.type === '2door'
                ? doorProps.visualType === 'fivePieces'
                  ? fivePiecesCornerItem
                  : doorProps.visualType.startsWith('#')
                    ? this.chooseNewDoorDefaultItem(
                        newDoorOneItems,
                        doorProps.visualType as DoorNewVisualTypes,
                        'cornerTwoDoor'
                      )
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerLiftUpItem
                      : cornerTwoDoorItem
                : doorProps.type === 'liftUp'
                  ? doorProps.visualType === 'vGroove'
                    ? vGrooveLiftUpItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerLiftUpItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'liftUp'
                          )
                        : fivePiecesLiftUp
                  : doorProps.visualType === 'vGroove'
                    ? vGrooveOneCornerItem
                    : doorProps.visualType.startsWith('shaker')
                      ? shakerOneItem
                      : doorProps.visualType.startsWith('#')
                        ? this.chooseNewDoorDefaultItem(
                            newDoorOneItems,
                            doorProps.visualType as DoorNewVisualTypes,
                            'left'
                          )
                        : fivePiecesOneItem
            )
        // : clone(doorProps.type === 'double'
        //     ? this.doorVisualType === 'vGroove' ? vGrooveTwoItem : fivePiecesTwoItem
        //     : this.doorVisualType === 'vGroove' ? vGrooveOneItem : fivePiecesOneItem
        // )

        itemProps.uuid = doorProps.uuid

        const sectionType =
          doorProps.sectionNumber !== 1
            ? doorProps.sectionNumber ===
              this.cornerCabinetProps.sectionProps.dividersProps.length + 1
              ? 'last'
              : 'middle'
            : this.cornerCabinetProps.sectionProps.dividersProps.length === 0
              ? 'single'
              : 'first'

        let doorHeight =
          doorProps.sectionHeight +
          (doorProps.sectionNumber === 1
            ? this.cornerCabinetProps.sectionProps.dividersProps.length === 0
              ? thickness
              : this.cornerCabinetProps.sectionProps.dividersProps[0].type ===
                  'visible' //if first divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          this.cornerCabinetProps.sectionProps.dividersProps.length + 1
            ? this.cornerCabinetProps.sectionProps.dividersProps.length === 0
              ? thickness
              : this.cornerCabinetProps.sectionProps.dividersProps[
                    this.cornerCabinetProps.sectionProps.dividersProps.length -
                      1
                  ].type === 'visible' //if last divider is fixed shelf
                ? thickness * 1.5
                : thickness
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cornerCabinetProps.sectionProps.dividersProps.length + 1
            ? this.cornerCabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 2
              ].type === 'visible' //if top divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cornerCabinetProps.sectionProps.dividersProps.length + 1
            ? this.cornerCabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 1
              ].type === 'visible' //if bottom divider is fixed shelf
              ? thickness / 2
              : 0
            : 0) //If section is not first or last

        const doorActualHeight =
          doorHeight -
          (sectionType !== 'middle'
            ? sectionType === 'single'
              ? doorConfig.topReveal + doorConfig.bottomReveal
              : sectionType === 'first'
                ? doorConfig.topReveal + doorConfig.horizontalGap / 2 //first
                : doorConfig.bottomReveal + doorConfig.horizontalGap / 2 //last
            : doorConfig.horizontalGap) //middle

        // itemProps.name = `${doorProps.type === 'left' ? 'Left' : doorProps.type === 'right' ? 'Right' : 'Double'} Door ${doorProps.sectionNumber}`
        itemProps.name = `${
          doorProps.type === 'left' ? 'Left' : 'Right'
        } Corner Door ${doorProps.sectionNumber}`

        const sideGap = 0.3175 //.125"
        const dThickness = thickness

        const resolvedSplitter =
          this.resolveSplitter(
            doorProps.normalMapSplitter,
            doorActualHeight,
            doorProps.sectionY,
            this.cornerCabinetProps.height,
            this.cornerCabinetProps.legHeight
          ) || ''

        if (this.cornerCabinetProps.type === '2door') {
          const width1 =
            this.cornerCabinetProps.width1 -
            this.cornerCabinetProps.depth2 -
            dThickness -
            sideGap -
            doorConfig.leftReveal
          const width2 =
            this.cornerCabinetProps.width2 -
            this.cornerCabinetProps.depth1 -
            dThickness -
            sideGap -
            doorConfig.rightReveal

          if (doorProps.visualType === 'fivePieces') {
            const _props = getFivePiecesCornerTwoDoorProps(
              width1,
              width2,
              doorActualHeight,
              resolvedSplitter,
              this.configs.fivePiecesConfig.pieceWidth
            )

            itemProps.props = {
              type: 'cornerTwoDoorFivePieces',
              visualType: doorProps.visualType,
              subType:
                doorProps.type === 'double' || doorProps.type === 'liftUp'
                  ? 'left'
                  : doorProps.type,
              sectionType,
              width1,
              width2,
              height: doorActualHeight,
              thickness: dThickness,
              splitters: resolvedSplitter,
              piecesLength: _props.piecesLength,
              holeWidth: _props.holeWidth,
              piecesWidth: this.configs.fivePiecesConfig.pieceWidth,
              sheetHeight: _props.sheetHeight,
              cleanHeight: _props.cleanHeight,
              frostedHeight: _props.frostedHeight,
              glassHeight: _props.glassHeight,
              mirrorHeight: _props.mirrorHeight,
            }
          } else if (doorProps.visualType.startsWith('#')) {
            const vType = doorProps.visualType as DoorNewVisualTypes

            const holeSizes = getNewDoorHoleSizes(
              doorProps.type === 'double',
              vType,
              width1,
              doorActualHeight,
              resolvedSplitter
            )

            const holeSizes2 = getNewDoorHoleSizes(
              doorProps.type === 'double',
              vType,
              width2,
              doorActualHeight,
              resolvedSplitter
            )

            const holeWidth = holeSizes.width + holeSizes2.width
            // console.log(holeSizes)

            itemProps.props = {
              type: 'cornerNewDoor',
              visualType: vType,
              subType:
                doorProps.type === 'double' || doorProps.type === 'liftUp'
                  ? 'left'
                  : doorProps.type,
              sectionType,
              width: width1 + width2,
              width1,
              width2,
              height: doorActualHeight,
              splitters: resolvedSplitter,
              holeWidth,
              glassHeight: holeSizes.glassHeight,
              cleanHeight: holeSizes.cleanHeight,
              mirrorHeight: holeSizes.mirrorHeight,
              frostedHeight: holeSizes.frostedHeight,
              thickness: this.configs.thickness,
            }
          } else {
            itemProps.props = {
              type: 'cornerTwoDoor',
              visualType: doorProps.visualType,
              subType:
                doorProps.type === 'double' || doorProps.type === 'liftUp'
                  ? 'left'
                  : doorProps.type,
              sectionType,
              width1,
              width2,
              width: width1 + width2,
              height: doorActualHeight,
              thickness: dThickness,
              splitters: doorProps.normalMapSplitter,
            }
          }

          itemProps.matrix = [...new THREE.Matrix4().elements]
          itemProps.matrix[12] =
            this.cornerCabinetProps.depth1 +
            (this.cornerCabinetProps.width2 - this.cornerCabinetProps.depth1) /
              2 +
            sideGap / 2 -
            doorConfig.rightReveal / 2 //+ dThickness
          itemProps.matrix[14] =
            this.cornerCabinetProps.depth2 +
            (this.cornerCabinetProps.width1 - this.cornerCabinetProps.depth2) /
              2 +
            sideGap / 2 -
            doorConfig.leftReveal / 2
        } else {
          //angled
          const width = calculateCornerSectionSize(
            this.cornerCabinetProps.width1,
            this.cornerCabinetProps.width2,
            this.cornerCabinetProps.depth1,
            this.cornerCabinetProps.depth2,
            this.cornerCabinetProps.thickness
          )

          if (doorProps.visualType.startsWith('#')) {
            const vType = doorProps.visualType as DoorNewVisualTypes
            const dWidth = width //- doorConfig.leftReveal - doorConfig.rightReveal
            const holeSizes = getNewDoorHoleSizes(
              doorProps.type === 'double',
              vType,
              dWidth,
              doorActualHeight,
              resolvedSplitter
            )
            // console.log(holeSizes)

            itemProps.props = {
              type: 'newDoor',
              visualType: vType,
              subType: doorProps.type,
              sectionType,
              width: dWidth,
              height: doorActualHeight,
              splitters: resolvedSplitter,
              holeWidth: holeSizes.width,
              glassHeight: holeSizes.glassHeight,
              cleanHeight: holeSizes.cleanHeight,
              mirrorHeight: holeSizes.mirrorHeight,
              frostedHeight: holeSizes.frostedHeight,
            }
          } else {
            if (doorProps.visualType === 'fivePieces') {
              const dWidth = width // - doorConfig.leftReveal - doorConfig.rightReveal

              const _props = getFivePiecesDoorProps(
                doorProps.type === 'double',
                dWidth,
                doorActualHeight,
                resolvedSplitter,
                this.configs.fivePiecesConfig.pieceWidth,
                this.configs.doorConfig
              )

              itemProps.props = {
                type: 'fivePiecesDoor',
                visualType: doorProps.visualType || this.doorVisualType,
                subType: doorProps.type,
                sectionType,
                width: width, // - doorConfig.leftReveal - doorConfig.rightReveal,
                height: doorActualHeight,
                splitters: resolvedSplitter,
                holeWidth: _props.holeWidth,
                cleanHeight: _props.cleanHeight,
                glassHeight: _props.glassHeight,
                mirrorHeight: _props.mirrorHeight,
                frostedHeight: _props.frostedHeight,
                sheetHeight: _props.sheetHeight,
                piecesLength: _props.piecesLength,
                piecesWidth: this.configs.fivePiecesConfig.pieceWidth,
              }
            } else {
              itemProps.props = {
                type: 'door',
                visualType: doorProps.visualType || this.doorVisualType,
                subType: doorProps.type === 'double' ? 'left' : doorProps.type,
                sectionType,
                width: width,
                height: doorActualHeight,
                // thickness: dThickness
              }
            }
          }

          const transform = calculateCornerSectionTransform(
            this.cornerCabinetProps.width1,
            this.cornerCabinetProps.width2,
            this.cornerCabinetProps.depth1,
            this.cornerCabinetProps.depth2,
            this.cornerCabinetProps.thickness,
            true
          )
          const matrix = new THREE.Matrix4()
          matrix.makeRotationY(transform.angle)
          matrix.setPosition(transform.x, 0, transform.z)
          itemProps.matrix = clone(matrix.elements)
          // itemProps.matrix[12] = props.depth1 + (props.width2 - props.depth1) / 2 + sideGap / 2 - doorConfig.rightReveal / 2//+ dThickness
          // itemProps.matrix[14] = props.depth2 + (props.width1 - props.depth2) / 2 + sideGap / 2 - doorConfig.leftReveal / 2
        }

        itemProps.matrix[13] =
          doorProps.sectionY +
          (doorProps.sectionNumber === 1
            ? this.cornerCabinetProps.sectionProps.dividersProps.length === 0
              ? 0
              : this.cornerCabinetProps.sectionProps.dividersProps[0].type ===
                  'visible' //if first divider is fixed shelf
                ? thickness / 4
                : thickness / 2
            : 0) + //If section is the first
          (doorProps.sectionNumber ===
          this.cornerCabinetProps.sectionProps.dividersProps.length + 1
            ? this.cornerCabinetProps.sectionProps.dividersProps.length === 0
              ? 0
              : this.cornerCabinetProps.sectionProps.dividersProps[
                    this.cornerCabinetProps.sectionProps.dividersProps.length -
                      1
                  ].type === 'visible' //if last divider is fixed shelf
                ? -thickness / 4
                : -thickness / 2
            : 0) + //If section is the last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cornerCabinetProps.sectionProps.dividersProps.length + 1
            ? this.cornerCabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 2
              ].type === 'visible' //if top divider is fixed shelf
              ? thickness / 4
              : 0
            : 0) + //If section is not first or last
          (doorProps.sectionNumber !== 1 &&
          doorProps.sectionNumber !==
            this.cornerCabinetProps.sectionProps.dividersProps.length + 1
            ? this.cornerCabinetProps.sectionProps.dividersProps[
                doorProps.sectionNumber - 1
              ].type === 'visible' //if bottom divider is fixed shelf
              ? -thickness / 4
              : 0
            : 0) //If section is not first or last

        if (sectionType === 'first') {
          const deltaY =
            doorHeight / 2 - (doorConfig.topReveal + doorActualHeight / 2)
          itemProps.matrix[13] += deltaY
        } else if (sectionType === 'last') {
          const deltaY =
            doorConfig.bottomReveal + doorActualHeight / 2 - doorHeight / 2
          itemProps.matrix[13] += deltaY
        }

        itemProps.render = true

        if (doorProps.type === 'liftUp') {
          const dWidth = calculateCornerSectionSize(
            this.cornerCabinetProps.width1,
            this.cornerCabinetProps.width2,
            this.cornerCabinetProps.depth1,
            this.cornerCabinetProps.depth2,
            this.cornerCabinetProps.thickness
          )

          if (doorProps.handleProps.orientation === 'double_horizontal') {
            const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Left Handle`
            const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Right Handle`

            const rOldItem = itemProps.childrenProps.find(
              (item) => item.name === rName
            )
            const lOldItem = itemProps.childrenProps.find(
              (item) => item.name === lName
            )

            const lHandleItemProps = lOldItem
              ? clone(lOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'drawer'
                  )
                )
            const rHandleItemProps = rOldItem
              ? clone(rOldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'drawer'
                  )
                )

            lHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'left',
            }
            rHandleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'right',
            }

            lHandleItemProps.name = lName
            rHandleItemProps.name = rName

            lHandleItemProps.render = true
            rHandleItemProps.render = true

            lHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              dWidth,
              true,
              this.configs.handleConfig
            )

            rHandleItemProps.matrix = this.calculateLiftUpDoubleHandleMatrix(
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              itemProps.props.height,
              dWidth,
              false,
              this.configs.handleConfig
            )

            itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const handleName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldHandleItem = itemProps.childrenProps.find(
              (item) => item.name === handleName
            )

            const handleItemProps = oldHandleItem
              ? clone(oldHandleItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'drawer'
                  )
                )

            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation,
              hPosition: 'center',
            }
            handleItemProps.name = handleName
            handleItemProps.render = true

            handleItemProps.matrix = this.calculateLiftUpDoorHandleMatrix(
              doorProps.handleProps.type,
              doorProps.handleProps.subtype,
              (itemProps.props as DoorItemPropsType).height,
              doorProps.handleProps.position,
              doorProps.handleProps.positionX,
              doorProps.visualType,
              dWidth,
              this.configs.handleConfig
            )

            itemProps.childrenProps = [handleItemProps]
            itemProps.name = `Lift Up Door ${doorProps.sectionNumber}`
          }
        } else {
          if (doorProps.type === 'double') {
            // const lName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(1)} Left Handle`
            // const rName = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(1)} Right Handle`
            // const rOldItem = itemProps.childrenProps.find(item => item.name === rName)
            // const lOldItem = itemProps.childrenProps.find(item => item.name === lName)
            // const lHandleItemProps = lOldItem ? clone(lOldItem) : clone(handleItem)
            // const rHandleItemProps = rOldItem ? clone(rOldItem) : clone(handleItem)
            // lHandleItemProps.props = {
            //     type: 'handle',
            //     subType: doorProps.handleProps.type,
            //     position: doorProps.handleProps.position
            // }
            // rHandleItemProps.props = {
            //     type: 'handle',
            //     subType: doorProps.handleProps.type,
            //     position: doorProps.handleProps.position
            // }
            // lHandleItemProps.name = lName
            // rHandleItemProps.name = rName
            // lHandleItemProps.render = true
            // rHandleItemProps.render = true
            // lHandleItemProps.matrix = this.calculateHandlePosition(itemProps.props, itemProps.matrix[13], doorProps.handleProps.position, 'left')
            // rHandleItemProps.matrix = this.calculateHandlePosition(itemProps.props, itemProps.matrix[13], doorProps.handleProps.position, 'right')
            // itemProps.childrenProps = [lHandleItemProps, rHandleItemProps]
          } else {
            const name = `${doorProps.handleProps.type[0].toUpperCase()}${doorProps.handleProps.type.slice(
              1
            )} ${doorProps.handleProps.subtype} Handle`

            const oldItem = itemProps.childrenProps.find(
              (item) => item.name === name
            )

            const handleItemProps = oldItem
              ? clone(oldItem)
              : clone(
                  this.chooseHandleDefaultItem(
                    handleItems,
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    'door'
                  )
                )

            handleItemProps.props = {
              type: 'handle',
              subType: doorProps.handleProps.type,
              subType2: doorProps.handleProps.subtype,
              position: doorProps.handleProps.position,
              orientation: doorProps.handleProps.orientation || 'vertical',
              hPosition:
                typeof doorProps.handleProps.positionX === 'number'
                  ? 'left'
                  : doorProps.handleProps.positionX === 'left'
                    ? 'left'
                    : 'right',
            }
            handleItemProps.name = `${handleItemProps.props.subType[0].toUpperCase()}${handleItemProps.props.subType.slice(
              1
            )} ${handleItemProps.props.subType2} Handle`
            handleItemProps.render = true
            handleItemProps.matrix =
              this.cornerCabinetProps.type === '2door'
                ? this.calculateCornerTwoDoorHandlePosition(
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    doorProps.visualType,
                    itemProps.props as CornerTwoDoorItemPropsType,
                    new THREE.Vector3(
                      itemProps.matrix[12],
                      itemProps.matrix[13],
                      itemProps.matrix[14]
                    ),
                    doorProps.handleProps.position,
                    doorProps.handleProps.positionX,
                    handleItemProps.props.orientation === 'vertical'
                  )
                : this.calculateHandlePosition(
                    doorProps.handleProps.type,
                    doorProps.handleProps.subtype,
                    handleItemProps.props.orientation === 'vertical',
                    itemProps.props as DoorItemPropsType,
                    itemProps.matrix[13],
                    doorProps.handleProps.position,
                    doorProps.handleProps.positionX,
                    undefined,
                    doorProps.handleProps.positionFromGroundValue
                  )

            itemProps.childrenProps = [handleItemProps]
          }
        }

        section.hideSection(doorProps.sectionNumber)

        this.itemsPropsList.push(itemProps)
      }
    }

    // =================Legs==================
    const legItem = this.itemsPropsList.find(
      (props) => props.name === 'cornerOneLeg'
    )

    const legsItem = this.itemsPropsList.find(
      (props) => props.props.type === 'cornerLegs'
    )
    const legs2ShortItem = this.itemsPropsList.find(
      (props) => props.name === 'cornerLegs2Short'
    )
    const legs2TallItem = this.itemsPropsList.find(
      (props) => props.name === 'cornerLegs2Tall'
    )
    // const separateBaseItem = this.itemsPropsList.find(this.cornerCabinetProps => this.cornerCabinetProps.this.cornerCabinetProps.type === 'separateBase')

    if (
      this.legProps.on &&
      legsItem &&
      legs2ShortItem &&
      legs2TallItem &&
      legItem
    ) {
      if (
        this.legProps.type === 'base' ||
        this.legProps.type === 'baseIsland'
      ) {
        if (
          this.itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Leg Short'
          ) === -1
        ) {
          const itemProps = clone(legItem)
          itemProps.name = 'Corner Standard Leg Short'
          itemProps.props = {
            type: 'cornerOneLeg',
            height: this.cornerCabinetProps.legHeight,
            width1: this.cornerCabinetProps.width1,
            width2: this.cornerCabinetProps.width2,
            backWidth1: this.cornerCabinetProps.backWidth1,
            backWidth2: this.cornerCabinetProps.backWidth2,
            depth1: this.cornerCabinetProps.depth1,
            depth2: this.cornerCabinetProps.depth2,
            thickness,
          }
          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -this.cornerCabinetProps.height / 2,
            0,
            1,
          ]
          itemProps.render = true
          this.itemsPropsList.push(itemProps)
        }
      } else if (this.legProps.type === 'standard') {
        if (
          this.itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Legs'
          ) === -1
        ) {
          const itemProps = clone(legsItem)

          itemProps.name = 'Corner Standard Legs'

          itemProps.props = {
            type: 'cornerLegs',
            height: this.cornerCabinetProps.legHeight,
            width1: this.cornerCabinetProps.width1,
            width2: this.cornerCabinetProps.width2,
            backWidth1: this.cornerCabinetProps.backWidth1,
            backWidth2: this.cornerCabinetProps.backWidth2,
            depth1: this.cornerCabinetProps.depth1,
            depth2: this.cornerCabinetProps.depth2,
            thickness,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -this.cornerCabinetProps.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      } else if (this.legProps.type === 'standard2_1') {
        if (
          this.itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Legs 2 Short'
          ) === -1
        ) {
          const itemProps = clone(legs2ShortItem)

          itemProps.name = 'Corner Standard Legs 2 Short'

          itemProps.props = {
            type: 'cornerLegs2',
            subType: 'short',
            height: this.cornerCabinetProps.legHeight,
            width1: this.cornerCabinetProps.width1,
            width2: this.cornerCabinetProps.width2,
            backWidth1: this.cornerCabinetProps.backWidth1,
            backWidth2: this.cornerCabinetProps.backWidth2,
            depth1: this.cornerCabinetProps.depth1,
            depth2: this.cornerCabinetProps.depth2,
            thickness,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -this.cornerCabinetProps.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      } else if (this.legProps.type === 'standard2_2') {
        if (
          this.itemsPropsList.findIndex(
            (item) => item.name === 'Corner Standard Legs 2 Tall'
          ) === -1
        ) {
          const itemProps = clone(legs2TallItem)

          itemProps.name = 'Corner Standard Legs 2 Tall'

          itemProps.props = {
            type: 'cornerLegs2',
            subType: 'tall',
            height: this.cornerCabinetProps.legHeight,
            width1: this.cornerCabinetProps.width1,
            width2: this.cornerCabinetProps.width2,
            backWidth1: this.cornerCabinetProps.backWidth1,
            backWidth2: this.cornerCabinetProps.backWidth2,
            depth1: this.cornerCabinetProps.depth1,
            depth2: this.cornerCabinetProps.depth2,
            thickness,
          }

          itemProps.matrix = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            -this.cornerCabinetProps.height / 2,
            0,
            1,
          ]
          itemProps.render = true

          this.itemsPropsList.push(itemProps)
        }
      }
    }

    const additionalItem = this.itemsPropsList.find(
      (i) => i.name === 'Additional Item'
    )

    // if (additionalItem) {
    //     const _props = {} as { [key: string]: number }

    //     for (const iProps of this.itemsPropsList.filter(i => (i.name !== 'Additional Item' && i.render))) {
    //         for (const key in iProps.this.cornerCabinetProps) {
    //             // @ts-ignore
    //             if (typeof iProps.this.cornerCabinetProps[key] === 'number') {
    //                 // @ts-ignore
    //                 _props[iProps.name + '_' + key] = iProps.this.cornerCabinetProps[key]
    //             }
    //         }
    //     }

    //     additionalItem.this.cornerCabinetProps = {
    //         type: 'additional',
    //         cabinetWidth: this.cornerCabinetProps.width,
    //         cabinetHeight: this.cornerCabinetProps.height,
    //         cabinetDepth: this.cornerCabinetProps.depth,
    //         ..._props
    //     }
    // }

    if (this.object.userData.isCornerTypeChanged)
      this.object.userData.isCornerTypeChanged = false

    this.visualizeItems()
    // console.timeEnd('createCabinet')
  }

  isPanelsOpen = false
  animatingPanels = false

  togglePanelsOpen = (
    sectionNumber?: number,
    cascadeAnimation?: boolean,
    animate: boolean = false,
    reverseCascade: boolean = false,
    deg: number = 110
  ) => {
    if (this.animatingPanels) return

    this.isPanelsOpen = !this.isPanelsOpen
    this.animatingPanels = true

    const deltaAngle = this.isPanelsOpen
      ? deg * (Math.PI / 180)
      : -deg * (Math.PI / 180)

    const deltaPos = this.isPanelsOpen
      ? this.cabinetProps.depth * 0.7
      : -this.cabinetProps.depth * 0.7

    const duration = 500
    const startTime = performance.now()

    interface AnimData {
      wrapper: THREE.Group
      targetRot?: number
      startRot?: number
      targetPosVec?: THREE.Vector3
      startPosVec?: THREE.Vector3
      objs: THREE.Object3D[]
      axis: 'x' | 'y' | 'z'
      originalParent: THREE.Object3D
      delay: number
    }
    const animData: AnimData[] = []

    const createTempWrapper = (
      objs: THREE.Object3D[],
      wrapperParent: THREE.Object3D,
      originalParent: THREE.Object3D,
      pivotPoint: THREE.Vector3,
      baseRotation: THREE.Euler,
      delay: number,
      dir?: number,
      axis: 'x' | 'y' | 'z' = 'y',
      isTranslate?: boolean
    ) => {
      const wrapper = new THREE.Group()
      wrapper.position.copy(pivotPoint)
      wrapper.rotation.copy(baseRotation)
      wrapperParent.add(wrapper)
      objs.forEach((o) => {
        if (o) wrapper.attach(o)
      })

      const data: AnimData = {
        wrapper,
        objs,
        axis,
        originalParent,
        delay,
      }

      if (isTranslate) {
        const localDelta = new THREE.Vector3(0, 0, 0)
        localDelta[axis] = (dir || 1) * deltaPos
        localDelta.applyEuler(baseRotation)
        data.startPosVec = wrapper.position.clone()
        data.targetPosVec = wrapper.position.clone().add(localDelta)
      } else {
        data.startRot = wrapper.rotation[axis]
        data.targetRot = data.startRot + (dir || 1) * deltaAngle
      }

      animData.push(data)
    }

    let maxSecNum = 1
    if (this.isPanelsOpen && cascadeAnimation && reverseCascade) {
      this.items.forEach((item) => {
        const isDoor =
          item.props.type === 'door' ||
          item.props.type === 'fivePiecesDoor' ||
          item.props.type === 'newDoor' ||
          item.props.type === 'cornerTwoDoor' ||
          item.props.type === 'cornerTwoDoorFivePieces' ||
          item.props.type === 'cornerNewDoor'
        const isDrawer =
          item.props.type === 'drawer' || item.props.type === 'fivePiecesDrawer'

        if (isDoor || isDrawer) {
          const secNumStr = item.name.split(' ').pop() || '1'
          const secNum = parseInt(secNumStr, 10)
          if (secNum > maxSecNum) maxSecNum = secNum
        }
      })
    }

    this.items.forEach((item) => {
      const isDoor =
        item.props.type === 'door' ||
        item.props.type === 'fivePiecesDoor' ||
        item.props.type === 'newDoor' ||
        item.props.type === 'cornerTwoDoor' ||
        item.props.type === 'cornerTwoDoorFivePieces' ||
        item.props.type === 'cornerNewDoor'
      const isDrawer =
        item.props.type === 'drawer' || item.props.type === 'fivePiecesDrawer'

      if (isDoor || isDrawer) {
        const secNumStr = item.name.split(' ').pop() || '1'
        const secNum = parseInt(secNumStr, 10)

        if (sectionNumber !== undefined) {
          if (secNum !== sectionNumber) return
        }

        let delay = 0
        if (this.isPanelsOpen && cascadeAnimation) {
          if (reverseCascade) {
            delay = (maxSecNum - secNum) * 150
          } else {
            delay = (secNum - 1) * 150
          }
        }

        const wrapperParent = this.object
        
        if (!item.object3D.userData.originalRotation) {
          item.object3D.userData.originalRotation = item.object3D.rotation.clone()
        }
        const baseRot = item.object3D.userData.originalRotation

        if (isDrawer) {
          if (!item.object3D.userData.originalPivot) {
            item.object3D.userData.originalPivot =
              item.object3D.position.clone()
          }
          createTempWrapper(
            [item.object3D],
            wrapperParent,
            wrapperParent,
            item.object3D.userData.originalPivot,
            baseRot,
            delay,
            1,
            'z',
            true
          )
        } else {
          const isLeft = item.name.startsWith('Left')
          const isLiftUp = item.props.subType === 'liftUp'
          const isDouble = item.name.startsWith('Double')

          const width = item.props.width2 || item.props.width
          const height = item.props.height

          if (isLiftUp) {
            if (!item.object3D.userData.originalPivot) {
              const offset = new THREE.Vector3(0, height / 2, 0)
              offset.applyEuler(baseRot)
              item.object3D.userData.originalPivot = item.object3D.position
                .clone()
                .add(offset)
            }
            createTempWrapper(
              [item.object3D],
              wrapperParent,
              wrapperParent,
              item.object3D.userData.originalPivot,
              baseRot,
              delay,
              -1,
              'x'
            )
          } else if (isDouble) {
            if (!item.object3D.userData.leftPivot) {
              const lOffset = new THREE.Vector3(-width / 2, 0, 0)
              lOffset.applyEuler(baseRot)
              item.object3D.userData.leftPivot = item.object3D.position
                .clone()
                .add(lOffset)

              const rOffset = new THREE.Vector3(width / 2, 0, 0)
              rOffset.applyEuler(baseRot)
              item.object3D.userData.rightPivot = item.object3D.position
                .clone()
                .add(rOffset)
            }

            const leftObjs: THREE.Object3D[] = []
            const rightObjs: THREE.Object3D[] = []
            item.object3D.children.slice().forEach((c) => {
              if (c.name.includes('Left Handle')) leftObjs.push(c)
              else if (c.name.includes('Right Handle')) rightObjs.push(c)
              else if (c.position.x < 0) leftObjs.push(c)
              else rightObjs.push(c)
            })

            createTempWrapper(
              leftObjs,
              wrapperParent,
              item.object3D,
              item.object3D.userData.leftPivot,
              baseRot,
              delay,
              -1,
              'y'
            )
            createTempWrapper(
              rightObjs,
              wrapperParent,
              item.object3D,
              item.object3D.userData.rightPivot,
              baseRot,
              delay,
              1,
              'y'
            )
          } else {
            let dir = isLeft ? -1 : 1
            const isCornerTwoDoor =
              item.props.type === 'cornerTwoDoor' ||
              item.props.type === 'cornerTwoDoorFivePieces' ||
              item.props.type === 'cornerNewDoor'

            if (!item.object3D.userData.originalPivot) {
              let hingeOffsetX = isLeft ? -width / 2 : width / 2
              let hingeOffsetZ = 0

              if (isCornerTwoDoor) {
                const w1 = (item.props as any).width1 || width / 2
                const w2 = (item.props as any).width2 || width / 2
                const th = (item.props as any).thickness || 0
                if (!isLeft) {
                  hingeOffsetX = w2 / 2 + th / 2
                  hingeOffsetZ = -w1 / 2 - th / 2
                } else {
                  hingeOffsetX = -w2 / 2 - th / 2
                  hingeOffsetZ = w1 / 2 + th / 2
                }
              }

              const offset = new THREE.Vector3(hingeOffsetX, 0, hingeOffsetZ)
              offset.applyEuler(baseRot)
              item.object3D.userData.originalPivot = item.object3D.position
                .clone()
                .add(offset)
            }
            createTempWrapper(
              [item.object3D],
              wrapperParent,
              wrapperParent,
              item.object3D.userData.originalPivot,
              baseRot,
              delay,
              dir,
              'y'
            )
          }
        }
      }
    })

    const doAnimate = () => {
      const now = performance.now()
      let allFinished = true

      animData.forEach((d) => {
        const elapsed = Math.max(0, now - startTime - d.delay)
        const progress = Math.min(elapsed / duration, 1)

        if (progress < 1) {
          allFinished = false
        }

        const easeProgress = progress * (2 - progress)

        if (d.startRot !== undefined && d.targetRot !== undefined) {
          d.wrapper.rotation[d.axis] =
            d.startRot + (d.targetRot - d.startRot) * easeProgress
        }
        if (d.startPosVec && d.targetPosVec) {
          d.wrapper.position.lerpVectors(d.startPosVec, d.targetPosVec, easeProgress)
        }
      })

      if (!allFinished) {
        requestAnimationFrame(doAnimate)
      } else {
        animData.forEach((d) => {
          d.objs.forEach((o) => {
            if (o) d.originalParent.attach(o)
          })
          d.wrapper.parent?.remove(d.wrapper)
        })
        this.animatingPanels = false
      }
    }

    if (animate) {
      requestAnimationFrame(doAnimate)
    } else {
      animData.forEach((d) => {
        if (d.startRot !== undefined && d.targetRot !== undefined) {
          d.wrapper.rotation[d.axis] = d.targetRot
        }
        if (d.startPosVec && d.targetPosVec) {
          d.wrapper.position.copy(d.targetPosVec)
        }
      })
      animData.forEach((d) => {
        d.objs.forEach((o) => {
          if (o) d.originalParent.attach(o)
        })
        d.wrapper.parent?.remove(d.wrapper)
      })
      this.animatingPanels = false
    }
  }
}
